var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key2, value) => key2 in obj ? __defProp(obj, key2, { enumerable: true, configurable: true, writable: true, value }) : obj[key2] = value;
var __spreadValues = (a, b2) => {
  for (var prop2 in b2 || (b2 = {}))
    if (__hasOwnProp.call(b2, prop2))
      __defNormalProp(a, prop2, b2[prop2]);
  if (__getOwnPropSymbols)
    for (var prop2 of __getOwnPropSymbols(b2)) {
      if (__propIsEnum.call(b2, prop2))
        __defNormalProp(a, prop2, b2[prop2]);
    }
  return a;
};
var __spreadProps = (a, b2) => __defProps(a, __getOwnPropDescs(b2));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop2 in source)
    if (__hasOwnProp.call(source, prop2) && exclude.indexOf(prop2) < 0)
      target[prop2] = source[prop2];
  if (source != null && __getOwnPropSymbols)
    for (var prop2 of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop2) < 0 && __propIsEnum.call(source, prop2))
        target[prop2] = source[prop2];
    }
  return target;
};
var __publicField = (obj, key2, value) => {
  __defNormalProp(obj, typeof key2 !== "symbol" ? key2 + "" : key2, value);
  return value;
};
import * as React from "react";
import React__default, { createElement, createFactory, Component, createContext as createContext$1, forwardRef, Fragment as Fragment$2, useRef, useCallback, useEffect, useMemo, cloneElement, useLayoutEffect, useReducer, useState, Children, useContext, isValidElement } from "react";
import { withEmotionCache as withEmotionCache$1, ThemeContext as ThemeContext$1, css, keyframes, ClassNames, Global } from "@emotion/core";
import { withTheme, useTheme, ThemeProvider } from "emotion-theming";
export { withTheme } from "emotion-theming";
import { Link as Link$1, withRouter, NavLink } from "react-router-dom";
import require$$2, { createPortal } from "react-dom";
import ReactDropzone from "react-dropzone";
import "@emotion/styled";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
(function(module2, exports) {
  (function(global2, factory) {
    factory();
  })(commonjsGlobal, function() {
    function applyFocusVisiblePolyfill(scope) {
      var hadKeyboardEvent = true;
      var hadFocusVisibleRecently = false;
      var hadFocusVisibleRecentlyTimeout = null;
      var inputTypesAllowlist = {
        text: true,
        search: true,
        url: true,
        tel: true,
        email: true,
        password: true,
        number: true,
        date: true,
        month: true,
        week: true,
        time: true,
        datetime: true,
        "datetime-local": true
      };
      function isValidFocusTarget(el) {
        if (el && el !== document && el.nodeName !== "HTML" && el.nodeName !== "BODY" && "classList" in el && "contains" in el.classList) {
          return true;
        }
        return false;
      }
      function focusTriggersKeyboardModality(el) {
        var type = el.type;
        var tagName = el.tagName;
        if (tagName === "INPUT" && inputTypesAllowlist[type] && !el.readOnly) {
          return true;
        }
        if (tagName === "TEXTAREA" && !el.readOnly) {
          return true;
        }
        if (el.isContentEditable) {
          return true;
        }
        return false;
      }
      function addFocusVisibleClass(el) {
        if (el.classList.contains("focus-visible")) {
          return;
        }
        el.classList.add("focus-visible");
        el.setAttribute("data-focus-visible-added", "");
      }
      function removeFocusVisibleClass(el) {
        if (!el.hasAttribute("data-focus-visible-added")) {
          return;
        }
        el.classList.remove("focus-visible");
        el.removeAttribute("data-focus-visible-added");
      }
      function onKeyDown(e2) {
        if (e2.metaKey || e2.altKey || e2.ctrlKey) {
          return;
        }
        if (isValidFocusTarget(scope.activeElement)) {
          addFocusVisibleClass(scope.activeElement);
        }
        hadKeyboardEvent = true;
      }
      function onPointerDown(e2) {
        hadKeyboardEvent = false;
      }
      function onFocus(e2) {
        if (!isValidFocusTarget(e2.target)) {
          return;
        }
        if (hadKeyboardEvent || focusTriggersKeyboardModality(e2.target)) {
          addFocusVisibleClass(e2.target);
        }
      }
      function onBlur(e2) {
        if (!isValidFocusTarget(e2.target)) {
          return;
        }
        if (e2.target.classList.contains("focus-visible") || e2.target.hasAttribute("data-focus-visible-added")) {
          hadFocusVisibleRecently = true;
          window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
            hadFocusVisibleRecently = false;
          }, 100);
          removeFocusVisibleClass(e2.target);
        }
      }
      function onVisibilityChange(e2) {
        if (document.visibilityState === "hidden") {
          if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
          }
          addInitialPointerMoveListeners();
        }
      }
      function addInitialPointerMoveListeners() {
        document.addEventListener("mousemove", onInitialPointerMove);
        document.addEventListener("mousedown", onInitialPointerMove);
        document.addEventListener("mouseup", onInitialPointerMove);
        document.addEventListener("pointermove", onInitialPointerMove);
        document.addEventListener("pointerdown", onInitialPointerMove);
        document.addEventListener("pointerup", onInitialPointerMove);
        document.addEventListener("touchmove", onInitialPointerMove);
        document.addEventListener("touchstart", onInitialPointerMove);
        document.addEventListener("touchend", onInitialPointerMove);
      }
      function removeInitialPointerMoveListeners() {
        document.removeEventListener("mousemove", onInitialPointerMove);
        document.removeEventListener("mousedown", onInitialPointerMove);
        document.removeEventListener("mouseup", onInitialPointerMove);
        document.removeEventListener("pointermove", onInitialPointerMove);
        document.removeEventListener("pointerdown", onInitialPointerMove);
        document.removeEventListener("pointerup", onInitialPointerMove);
        document.removeEventListener("touchmove", onInitialPointerMove);
        document.removeEventListener("touchstart", onInitialPointerMove);
        document.removeEventListener("touchend", onInitialPointerMove);
      }
      function onInitialPointerMove(e2) {
        if (e2.target.nodeName && e2.target.nodeName.toLowerCase() === "html") {
          return;
        }
        hadKeyboardEvent = false;
        removeInitialPointerMoveListeners();
      }
      document.addEventListener("keydown", onKeyDown, true);
      document.addEventListener("mousedown", onPointerDown, true);
      document.addEventListener("pointerdown", onPointerDown, true);
      document.addEventListener("touchstart", onPointerDown, true);
      document.addEventListener("visibilitychange", onVisibilityChange, true);
      addInitialPointerMoveListeners();
      scope.addEventListener("focus", onFocus, true);
      scope.addEventListener("blur", onBlur, true);
      if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
        scope.host.setAttribute("data-js-focus-visible", "");
      } else if (scope.nodeType === Node.DOCUMENT_NODE) {
        document.documentElement.classList.add("js-focus-visible");
        document.documentElement.setAttribute("data-js-focus-visible", "");
      }
    }
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;
      var event;
      try {
        event = new CustomEvent("focus-visible-polyfill-ready");
      } catch (error) {
        event = document.createEvent("CustomEvent");
        event.initCustomEvent("focus-visible-polyfill-ready", false, false, {});
      }
      window.dispatchEvent(event);
    }
    if (typeof document !== "undefined") {
      applyFocusVisiblePolyfill(document);
    }
  });
})();
function _defineProperty(obj, key2, value) {
  if (key2 in obj) {
    Object.defineProperty(obj, key2, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key2] = value;
  }
  return obj;
}
var defineProperty$1 = _defineProperty;
function memoize$3(fn2) {
  var cache = {};
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn2(arg);
    return cache[arg];
  };
}
var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
var index$2 = memoize$3(function(prop2) {
  return reactPropsRegex.test(prop2) || prop2.charCodeAt(0) === 111 && prop2.charCodeAt(1) === 110 && prop2.charCodeAt(2) < 91;
});
var isBrowser = true;
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = "";
  classNames.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles2(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;
  if ((isStringTag === false || isBrowser === false) && cache.registered[className] === void 0) {
    cache.registered[className] = serialized.styles;
  }
  if (cache.inserted[serialized.name] === void 0) {
    var current = serialized;
    do {
      cache.insert("." + className, current, cache.sheet, true);
      current = current.next;
    } while (current !== void 0);
  }
};
function murmur2(str) {
  var h2 = 0;
  var k2, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k2 = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16);
    k2 ^= k2 >>> 24;
    h2 = (k2 & 65535) * 1540483477 + ((k2 >>> 16) * 59797 << 16) ^ (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h2 ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h2 ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h2 ^= str.charCodeAt(i) & 255;
      h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  }
  h2 ^= h2 >>> 13;
  h2 = (h2 & 65535) * 1540483477 + ((h2 >>> 16) * 59797 << 16);
  return ((h2 ^ h2 >>> 15) >>> 0).toString(36);
}
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var isCustomProperty = function isCustomProperty2(property) {
  return property.charCodeAt(1) === 45;
};
var isProcessableValue = function isProcessableValue2(value) {
  return value != null && typeof value !== "boolean";
};
var processStyleName = memoize$3(function(styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
});
var processStyleValue = function processStyleValue2(key2, value) {
  switch (key2) {
    case "animation":
    case "animationName": {
      if (typeof value === "string") {
        return value.replace(animationRegex, function(match, p1, p2) {
          cursor = {
            name: p1,
            styles: p2,
            next: cursor
          };
          return p1;
        });
      }
    }
  }
  if (unitlessKeys[key2] !== 1 && !isCustomProperty(key2) && typeof value === "number" && value !== 0) {
    return value + "px";
  }
  return value;
};
function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next = interpolation.next;
        if (next !== void 0) {
          while (next !== void 0) {
            cursor = {
              name: next.name,
              styles: next.styles,
              next: cursor
            };
            next = next.next;
          }
        }
        var styles2 = interpolation.styles + ";";
        return styles2;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
      }
      break;
    }
  }
  if (registered == null) {
    return interpolation;
  }
  var cached = registered[interpolation];
  return cached !== void 0 && !couldBeSelectorInterpolation ? cached : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string = "";
  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);
          switch (_key) {
            case "animation":
            case "animationName": {
              string += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              string += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string;
}
var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var cursor;
var serializeStyles = function serializeStyles2(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
    return args[0];
  }
  var stringMode = true;
  var styles2 = "";
  cursor = void 0;
  var strings = args[0];
  if (strings == null || strings.raw === void 0) {
    stringMode = false;
    styles2 += handleInterpolation(mergedProps, registered, strings, false);
  } else {
    styles2 += strings[0];
  }
  for (var i = 1; i < args.length; i++) {
    styles2 += handleInterpolation(mergedProps, registered, args[i], styles2.charCodeAt(styles2.length - 1) === 46);
    if (stringMode) {
      styles2 += strings[i];
    }
  }
  labelPattern.lastIndex = 0;
  var identifierName = "";
  var match;
  while ((match = labelPattern.exec(styles2)) !== null) {
    identifierName += "-" + match[1];
  }
  var name = murmur2(styles2) + identifierName;
  return {
    name,
    styles: styles2,
    next: cursor
  };
};
var testOmitPropsOnStringTag = index$2;
var testOmitPropsOnComponent = function testOmitPropsOnComponent2(key2) {
  return key2 !== "theme" && key2 !== "innerRef";
};
var getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag) {
  return typeof tag === "string" && tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function(key2) {
        defineProperty$1(target, key2, source[key2]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function(key2) {
        Object.defineProperty(target, key2, Object.getOwnPropertyDescriptor(source, key2));
      });
    }
  }
  return target;
}
var createStyled = function createStyled2(tag, options) {
  var identifierName;
  var shouldForwardProp;
  var targetClassName;
  if (options !== void 0) {
    identifierName = options.label;
    targetClassName = options.target;
    shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function(propName) {
      return tag.__emotion_forwardProp(propName) && options.shouldForwardProp(propName);
    } : options.shouldForwardProp;
  }
  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  if (typeof shouldForwardProp !== "function" && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp("as");
  return function() {
    var args = arguments;
    var styles2 = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
    if (identifierName !== void 0) {
      styles2.push("label:" + identifierName + ";");
    }
    if (args[0] == null || args[0].raw === void 0) {
      styles2.push.apply(styles2, args);
    } else {
      styles2.push(args[0][0]);
      var len = args.length;
      var i = 1;
      for (; i < len; i++) {
        styles2.push(args[i], args[0][i]);
      }
    }
    var Styled = withEmotionCache$1(function(props, context, ref) {
      return createElement(ThemeContext$1.Consumer, null, function(theme) {
        var finalTag = shouldUseAs && props.as || baseTag;
        var className = "";
        var classInterpolations = [];
        var mergedProps = props;
        if (props.theme == null) {
          mergedProps = {};
          for (var key2 in props) {
            mergedProps[key2] = props[key2];
          }
          mergedProps.theme = theme;
        }
        if (typeof props.className === "string") {
          className = getRegisteredStyles(context.registered, classInterpolations, props.className);
        } else if (props.className != null) {
          className = props.className + " ";
        }
        var serialized = serializeStyles(styles2.concat(classInterpolations), context.registered, mergedProps);
        insertStyles(context, serialized, typeof finalTag === "string");
        className += context.key + "-" + serialized.name;
        if (targetClassName !== void 0) {
          className += " " + targetClassName;
        }
        var finalShouldForwardProp = shouldUseAs && shouldForwardProp === void 0 ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
        var newProps = {};
        for (var _key in props) {
          if (shouldUseAs && _key === "as")
            continue;
          if (finalShouldForwardProp(_key)) {
            newProps[_key] = props[_key];
          }
        }
        newProps.className = className;
        newProps.ref = ref || props.innerRef;
        var ele = createElement(finalTag, newProps);
        return ele;
      });
    });
    Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles2;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, "toString", {
      value: function value() {
        if (targetClassName === void 0 && false) {
          return "NO_COMPONENT_SELECTOR";
        }
        return "." + targetClassName;
      }
    });
    Styled.withComponent = function(nextTag, nextOptions) {
      return createStyled2(nextTag, nextOptions !== void 0 ? _objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles2);
    };
    return Styled;
  };
};
var curry = (fn2) => {
  const curried = (...args) => {
    if (args.length >= fn2.length) {
      return fn2(...args);
    }
    return (...args2) => curried(...args.concat(args2));
  };
  return curried;
};
const BREAKPOINTS = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200
};
const mediaUp = (size2) => `@media (min-width: ${BREAKPOINTS[size2]}px)`;
const mediaDn = (size2) => `@media (max-width: ${BREAKPOINTS[size2]}px)`;
function endsWith(string, suffix2) {
  return string.substr(-suffix2.length) === suffix2;
}
function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue))
    return value;
  return unitlessValue;
}
var pxtoFactory = function pxtoFactory2(to) {
  return function(pxval) {
    var base2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "16px";
    var newPxval = pxval;
    var newBase = base2;
    if (typeof pxval === "string") {
      if (!endsWith(pxval, "px")) {
        throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
      }
      newPxval = stripUnit(pxval);
    }
    if (typeof base2 === "string") {
      if (!endsWith(base2, "px")) {
        throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base2 + '" instead.');
      }
      newBase = stripUnit(base2);
    }
    if (typeof newPxval === "string") {
      throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }
    if (typeof newBase === "string") {
      throw new Error('Passed invalid base value ("' + base2 + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }
    return "" + newPxval / newBase + to;
  };
};
var rem$1 = /* @__PURE__ */ pxtoFactory("rem");
var _opinionatedRules;
var _abbrTitle;
var _unopinionatedRules;
_opinionatedRules = {
  html: {
    fontFamily: "sans-serif"
  },
  body: {
    margin: "0"
  }
}, _opinionatedRules["a:active,\n  a:hover"] = {
  outlineWidth: "0"
}, _opinionatedRules["button,\n  input,\n  optgroup,\n  select,\n  textarea"] = {
  fontFamily: "sans-serif",
  fontSize: "100%",
  lineHeight: "1.15"
}, _opinionatedRules;
_unopinionatedRules = {
  html: {
    lineHeight: "1.15",
    textSizeAdjust: "100%"
  }
}, _unopinionatedRules["article,\n  aside,\n  footer,\n  header,\n  nav,\n  section"] = {
  display: "block"
}, _unopinionatedRules.h1 = {
  fontSize: "2em",
  margin: "0.67em 0"
}, _unopinionatedRules["figcaption,\n  figure,\n  main"] = {
  display: "block"
}, _unopinionatedRules.figure = {
  margin: "1em 40px"
}, _unopinionatedRules.hr = {
  boxSizing: "content-box",
  height: "0",
  overflow: "visible"
}, _unopinionatedRules.pre = {
  fontFamily: "monospace, monospace",
  fontSize: "1em"
}, _unopinionatedRules.a = {
  "background-color": "transparent",
  "-webkit-text-decoration-skip": "objects"
}, _unopinionatedRules["abbr[title]"] = (_abbrTitle = {
  borderBottom: "none",
  textDecoration: "underline"
}, _abbrTitle["textDecoration"] = "underline dotted", _abbrTitle), _unopinionatedRules["b,\n  strong"] = {
  fontWeight: "inherit"
}, _unopinionatedRules["code,\n  kbd,\n  samp"] = {
  fontFamily: "monospace, monospace",
  fontSize: "1em"
}, _unopinionatedRules.dfn = {
  fontStyle: "italic"
}, _unopinionatedRules.mark = {
  backgroundColor: "#ff0",
  color: "#000"
}, _unopinionatedRules.small = {
  fontSize: "80%"
}, _unopinionatedRules["sub,\n  sup"] = {
  fontSize: "75%",
  lineHeight: "0",
  position: "relative",
  verticalAlign: "baseline"
}, _unopinionatedRules.sub = {
  bottom: "-0.25em"
}, _unopinionatedRules.sup = {
  top: "-0.5em"
}, _unopinionatedRules["audio,\n  video"] = {
  display: "inline-block"
}, _unopinionatedRules["audio:not([controls])"] = {
  display: "none",
  height: "0"
}, _unopinionatedRules.img = {
  borderStyle: "none"
}, _unopinionatedRules["svg:not(:root)"] = {
  overflow: "hidden"
}, _unopinionatedRules["button,\n  input,\n  optgroup,\n  select,\n  textarea"] = {
  margin: "0"
}, _unopinionatedRules["button,\n  input"] = {
  overflow: "visible"
}, _unopinionatedRules["button,\n  select"] = {
  textTransform: "none"
}, _unopinionatedRules['button,\n  html [type="button"],\n  [type="reset"],\n  [type="submit"]'] = {
  "-webkit-appearance": "button"
}, _unopinionatedRules['button::-moz-focus-inner,\n  [type="button"]::-moz-focus-inner,\n  [type="reset"]::-moz-focus-inner,\n  [type="submit"]::-moz-focus-inner'] = {
  borderStyle: "none",
  padding: "0"
}, _unopinionatedRules['button:-moz-focusring,\n  [type="button"]:-moz-focusring,\n  [type="reset"]:-moz-focusring,\n  [type="submit"]:-moz-focusring'] = {
  outline: "1px dotted ButtonText"
}, _unopinionatedRules.fieldset = {
  border: "1px solid #c0c0c0",
  margin: "0 2px",
  padding: "0.35em 0.625em 0.75em"
}, _unopinionatedRules.legend = {
  boxSizing: "border-box",
  color: "inherit",
  display: "table",
  maxWidth: "100%",
  padding: "0",
  whiteSpace: "normal"
}, _unopinionatedRules.progress = {
  display: "inline-block",
  verticalAlign: "baseline"
}, _unopinionatedRules.textarea = {
  overflow: "auto"
}, _unopinionatedRules['[type="checkbox"],\n  [type="radio"]'] = {
  boxSizing: "border-box",
  padding: "0"
}, _unopinionatedRules['[type="number"]::-webkit-inner-spin-button,\n  [type="number"]::-webkit-outer-spin-button'] = {
  height: "auto"
}, _unopinionatedRules['[type="search"]'] = {
  "-webkit-appearance": "textfield",
  outlineOffset: "-2px"
}, _unopinionatedRules['[type="search"]::-webkit-search-cancel-button,\n  [type="search"]::-webkit-search-decoration'] = {
  "-webkit-appearance": "none"
}, _unopinionatedRules["::-webkit-file-upload-button"] = {
  "-webkit-appearance": "button",
  font: "inherit"
}, _unopinionatedRules["details,\n  menu"] = {
  display: "block"
}, _unopinionatedRules.summary = {
  display: "list-item"
}, _unopinionatedRules.canvas = {
  display: "inline-block"
}, _unopinionatedRules.template = {
  display: "none"
}, _unopinionatedRules["[hidden]"] = {
  display: "none"
}, _unopinionatedRules;
function colorToInt(color2) {
  return Math.round(color2 * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness) {
  var convert = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : convertToInt;
  if (saturation === 0) {
    return convert(lightness, lightness, lightness);
  }
  var huePrime = hue % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
var namedColorMap = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "00ffff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "0000ff",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "00ffff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "ff00ff",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "639",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};
function nameToHex(color2) {
  if (typeof color2 !== "string")
    return color2;
  var normalizedColorName = color2.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color2;
}
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var hslRegex = /^hsl\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var hslaRegex = /^hsla\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
function parseToRgb(color2) {
  if (typeof color2 !== "string") {
    throw new Error("Passed an incorrect argument to a color function, please pass a string representation of a color.");
  }
  var normalizedColor = nameToHex(color2);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor);
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor);
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4])
    };
  }
  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}
var reduceHexValue = function reduceHexValue2(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
function rgb(value, green, blue) {
  if (typeof value === "number" && typeof green === "number" && typeof blue === "number") {
    return reduceHexValue("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === "object" && green === void 0 && blue === void 0) {
    return reduceHexValue("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new Error("Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).");
}
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === "string" && typeof secondValue === "number") {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === "number" && typeof secondValue === "number" && typeof thirdValue === "number" && typeof fourthValue === "number") {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === "object" && secondValue === void 0 && thirdValue === void 0 && fourthValue === void 0) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new Error("Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).");
}
var isArray$5 = Array.isArray;
var isArray_1 = isArray$5;
var freeGlobal$2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$2;
var freeGlobal$1 = _freeGlobal;
var freeSelf$1 = typeof self == "object" && self && self.Object === Object && self;
var root$6 = freeGlobal$1 || freeSelf$1 || Function("return this")();
var _root = root$6;
var root$5 = _root;
var Symbol$5 = root$5.Symbol;
var _Symbol = Symbol$5;
var Symbol$4 = _Symbol;
var objectProto$5 = Object.prototype;
var hasOwnProperty$6 = objectProto$5.hasOwnProperty;
var nativeObjectToString$1 = objectProto$5.toString;
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$6.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e2) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$4 = Object.prototype;
var nativeObjectToString = objectProto$4.toString;
function objectToString$2(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$2;
var Symbol$3 = _Symbol, getRawTag = _getRawTag, objectToString$1 = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : void 0;
function baseGetTag$2(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString$1(value);
}
var _baseGetTag = baseGetTag$2;
function isObjectLike$2(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$2;
var baseGetTag$1 = _baseGetTag, isObjectLike$1 = isObjectLike_1;
var symbolTag$1 = "[object Symbol]";
function isSymbol$4(value) {
  return typeof value == "symbol" || isObjectLike$1(value) && baseGetTag$1(value) == symbolTag$1;
}
var isSymbol_1 = isSymbol$4;
var isArray$4 = isArray_1, isSymbol$3 = isSymbol_1;
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
function isKey$1(value, object) {
  if (isArray$4(value)) {
    return false;
  }
  var type = typeof value;
  if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
var _isKey = isKey$1;
function isObject$4(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$4;
var baseGetTag = _baseGetTag, isObject$3 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag$1 = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$3(value) {
  if (!isObject$3(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == funcTag$1 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$3;
var root$4 = _root;
var coreJsData$2 = root$4["__core-js_shared__"];
var _coreJsData = coreJsData$2;
var coreJsData$1 = _coreJsData;
var maskSrcKey$1 = function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$2(func) {
  return !!maskSrcKey$1 && maskSrcKey$1 in func;
}
var _isMasked = isMasked$2;
var funcProto$2 = Function.prototype;
var funcToString$2 = funcProto$2.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$2.call(func);
    } catch (e2) {
    }
    try {
      return func + "";
    } catch (e2) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$2 = isFunction_1, isMasked$1 = _isMasked, isObject$2 = isObject_1, toSource$1 = _toSource;
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;
var funcProto$1 = Function.prototype, objectProto$3 = Object.prototype;
var funcToString$1 = funcProto$1.toString;
var hasOwnProperty$5 = objectProto$3.hasOwnProperty;
var reIsNative$1 = RegExp("^" + funcToString$1.call(hasOwnProperty$5).replace(reRegExpChar$1, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function baseIsNative$2(value) {
  if (!isObject$2(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$2(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$2;
function getValue$2(object, key2) {
  return object == null ? void 0 : object[key2];
}
var _getValue = getValue$2;
var baseIsNative$1 = _baseIsNative, getValue$1 = _getValue;
function getNative$3(object, key2) {
  var value = getValue$1(object, key2);
  return baseIsNative$1(value) ? value : void 0;
}
var _getNative = getNative$3;
var getNative$2 = _getNative;
var nativeCreate$5 = getNative$2(Object, "create");
var _nativeCreate = nativeCreate$5;
var nativeCreate$4 = _nativeCreate;
function hashClear$2() {
  this.__data__ = nativeCreate$4 ? nativeCreate$4(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$2;
function hashDelete$2(key2) {
  var result = this.has(key2) && delete this.__data__[key2];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$2;
var nativeCreate$3 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$2 = Object.prototype;
var hasOwnProperty$4 = objectProto$2.hasOwnProperty;
function hashGet$2(key2) {
  var data = this.__data__;
  if (nativeCreate$3) {
    var result = data[key2];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$4.call(data, key2) ? data[key2] : void 0;
}
var _hashGet = hashGet$2;
var nativeCreate$2 = _nativeCreate;
var objectProto$1 = Object.prototype;
var hasOwnProperty$3 = objectProto$1.hasOwnProperty;
function hashHas$2(key2) {
  var data = this.__data__;
  return nativeCreate$2 ? data[key2] !== void 0 : hasOwnProperty$3.call(data, key2);
}
var _hashHas = hashHas$2;
var nativeCreate$1 = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$2(key2, value) {
  var data = this.__data__;
  this.size += this.has(key2) ? 0 : 1;
  data[key2] = nativeCreate$1 && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$2;
var hashClear$1 = _hashClear, hashDelete$1 = _hashDelete, hashGet$1 = _hashGet, hashHas$1 = _hashHas, hashSet$1 = _hashSet;
function Hash$3(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
Hash$3.prototype.clear = hashClear$1;
Hash$3.prototype["delete"] = hashDelete$1;
Hash$3.prototype.get = hashGet$1;
Hash$3.prototype.has = hashHas$1;
Hash$3.prototype.set = hashSet$1;
var _Hash = Hash$3;
function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$2;
function eq$2(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$2;
var eq$1 = eq_1;
function assocIndexOf$5(array, key2) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key2)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$5;
var assocIndexOf$4 = _assocIndexOf;
var arrayProto$1 = Array.prototype;
var splice$1 = arrayProto$1.splice;
function listCacheDelete$2(key2) {
  var data = this.__data__, index2 = assocIndexOf$4(data, key2);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index2, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$2;
var assocIndexOf$3 = _assocIndexOf;
function listCacheGet$2(key2) {
  var data = this.__data__, index2 = assocIndexOf$3(data, key2);
  return index2 < 0 ? void 0 : data[index2][1];
}
var _listCacheGet = listCacheGet$2;
var assocIndexOf$2 = _assocIndexOf;
function listCacheHas$2(key2) {
  return assocIndexOf$2(this.__data__, key2) > -1;
}
var _listCacheHas = listCacheHas$2;
var assocIndexOf$1 = _assocIndexOf;
function listCacheSet$2(key2, value) {
  var data = this.__data__, index2 = assocIndexOf$1(data, key2);
  if (index2 < 0) {
    ++this.size;
    data.push([key2, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$2;
var listCacheClear$1 = _listCacheClear, listCacheDelete$1 = _listCacheDelete, listCacheGet$1 = _listCacheGet, listCacheHas$1 = _listCacheHas, listCacheSet$1 = _listCacheSet;
function ListCache$2(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
ListCache$2.prototype.clear = listCacheClear$1;
ListCache$2.prototype["delete"] = listCacheDelete$1;
ListCache$2.prototype.get = listCacheGet$1;
ListCache$2.prototype.has = listCacheHas$1;
ListCache$2.prototype.set = listCacheSet$1;
var _ListCache = ListCache$2;
var getNative$1 = _getNative, root$3 = _root;
var Map$3 = getNative$1(root$3, "Map");
var _Map = Map$3;
var Hash$2 = _Hash, ListCache$1 = _ListCache, Map$2 = _Map;
function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash$2(),
    "map": new (Map$2 || ListCache$1)(),
    "string": new Hash$2()
  };
}
var _mapCacheClear = mapCacheClear$2;
function isKeyable$2(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$2;
var isKeyable$1 = _isKeyable;
function getMapData$5(map, key2) {
  var data = map.__data__;
  return isKeyable$1(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$5;
var getMapData$4 = _getMapData;
function mapCacheDelete$2(key2) {
  var result = getMapData$4(this, key2)["delete"](key2);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$2;
var getMapData$3 = _getMapData;
function mapCacheGet$2(key2) {
  return getMapData$3(this, key2).get(key2);
}
var _mapCacheGet = mapCacheGet$2;
var getMapData$2 = _getMapData;
function mapCacheHas$2(key2) {
  return getMapData$2(this, key2).has(key2);
}
var _mapCacheHas = mapCacheHas$2;
var getMapData$1 = _getMapData;
function mapCacheSet$2(key2, value) {
  var data = getMapData$1(this, key2), size2 = data.size;
  data.set(key2, value);
  this.size += data.size == size2 ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$2;
var mapCacheClear$1 = _mapCacheClear, mapCacheDelete$1 = _mapCacheDelete, mapCacheGet$1 = _mapCacheGet, mapCacheHas$1 = _mapCacheHas, mapCacheSet$1 = _mapCacheSet;
function MapCache$2(entries) {
  var index2 = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
MapCache$2.prototype.clear = mapCacheClear$1;
MapCache$2.prototype["delete"] = mapCacheDelete$1;
MapCache$2.prototype.get = mapCacheGet$1;
MapCache$2.prototype.has = mapCacheHas$1;
MapCache$2.prototype.set = mapCacheSet$1;
var _MapCache = MapCache$2;
var MapCache$1 = _MapCache;
var FUNC_ERROR_TEXT$1 = "Expected a function";
function memoize$2(func, resolver) {
  if (typeof func != "function" || resolver != null && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments, key2 = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key2)) {
      return cache.get(key2);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key2, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache$1)();
  return memoized;
}
memoize$2.Cache = MapCache$1;
var memoize_1 = memoize$2;
var memoize$1 = memoize_1;
var MAX_MEMOIZE_SIZE = 500;
function memoizeCapped$1(func) {
  var result = memoize$1(func, function(key2) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key2;
  });
  var cache = result.cache;
  return result;
}
var _memoizeCapped = memoizeCapped$1;
var memoizeCapped = _memoizeCapped;
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reEscapeChar$1 = /\\(\\)?/g;
var stringToPath$2 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46) {
    result.push("");
  }
  string.replace(rePropName$1, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, "$1") : number || match);
  });
  return result;
});
var _stringToPath = stringToPath$2;
function arrayMap$2(array, iteratee) {
  var index2 = -1, length = array == null ? 0 : array.length, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array[index2], index2, array);
  }
  return result;
}
var _arrayMap = arrayMap$2;
var Symbol$2 = _Symbol, arrayMap$1 = _arrayMap, isArray$3 = isArray_1, isSymbol$2 = isSymbol_1;
var INFINITY$2 = 1 / 0;
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : void 0, symbolToString$1 = symbolProto$1 ? symbolProto$1.toString : void 0;
function baseToString$2(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isArray$3(value)) {
    return arrayMap$1(value, baseToString$2) + "";
  }
  if (isSymbol$2(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$2 ? "-0" : result;
}
var _baseToString = baseToString$2;
var baseToString$1 = _baseToString;
function toString$2(value) {
  return value == null ? "" : baseToString$1(value);
}
var toString_1 = toString$2;
var isArray$2 = isArray_1, isKey = _isKey, stringToPath$1 = _stringToPath, toString$1 = toString_1;
function castPath$1(value, object) {
  if (isArray$2(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath$1(toString$1(value));
}
var _castPath = castPath$1;
var isSymbol$1 = isSymbol_1;
var INFINITY$1 = 1 / 0;
function toKey$2(value) {
  if (typeof value == "string" || isSymbol$1(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY$1 ? "-0" : result;
}
var _toKey = toKey$2;
var castPath = _castPath, toKey$1 = _toKey;
function baseGet$1(object, path) {
  path = castPath(path, object);
  var index2 = 0, length = path.length;
  while (object != null && index2 < length) {
    object = object[toKey$1(path[index2++])];
  }
  return index2 && index2 == length ? object : void 0;
}
var _baseGet = baseGet$1;
var baseGet = _baseGet;
function get(object, path, defaultValue) {
  var result = object == null ? void 0 : baseGet(object, path);
  return result === void 0 ? defaultValue : result;
}
var get_1 = get;
const borderRadiusProperty = curry((property, size2, {
  theme
}) => /* @__PURE__ */ css(property, ":", theme.borderRadius[size2], ";"));
const borderRadius$1 = borderRadiusProperty("border-radius");
const borderTopLeftRadius = borderRadiusProperty("border-top-left-radius");
const borderTopRightRadius = borderRadiusProperty("border-top-right-radius");
const borderBottomRightRadius = borderRadiusProperty("border-bottom-right-radius");
const borderBottomLeftRadius = borderRadiusProperty("border-bottom-left-radius");
const color = curry((name, {
  theme
}) => theme.brand[name]);
const gradientStart = curry((name, {
  theme
}) => theme.brand[`${name}Gradient`].start);
const gradientEnd = curry((name, {
  theme
}) => theme.brand[`${name}Gradient`].end);
const rem = curry((px, {
  theme
}) => rem$1(px, theme.font.base));
const fontSize = curry((size2, {
  theme
}) => /* @__PURE__ */ css("font-size:", theme.font.size[size2], ";line-height:", theme.font.lineHeight[size2], ";"));
const fontWeight = curry((weight2, {
  theme
}) => /* @__PURE__ */ css("font-weight:", theme.font.weight[weight2], ";"));
const margin$1 = curry((size2, {
  theme
}) => /* @__PURE__ */ css("margin:", theme.spacing[size2].y, " ", theme.spacing[size2].x, ";"));
const padding = curry((size2, {
  theme
}) => /* @__PURE__ */ css("padding:", theme.spacing[size2].y, " ", theme.spacing[size2].x, ";"));
const shadow$1 = curry((kind2, {
  theme
}) => /* @__PURE__ */ css("box-shadow:", theme.shadow[kind2], ";"));
const spacer = curry((variant2, {
  theme
}) => theme.spacing.size[`spacer${variant2}`]);
const transparentize = curry((colorName, amount, {
  theme
}) => {
  const colorString = color(colorName, {
    theme
  });
  if (!colorString)
    return;
  return rgba(colorString, amount);
});
const typography$1 = curry((style2, {
  theme
}) => /* @__PURE__ */ css(theme.typography[style2], ""));
var _ref$i = {
  name: "8atqhb",
  styles: "width:100%;"
};
const responsiveContainer = ({
  fluid
}) => fluid ? _ref$i : /* @__PURE__ */ css(mediaUp("xl"), "{width:", BREAKPOINTS.xl, "px;}", mediaDn("xl"), "{width:", BREAKPOINTS.lg, "px;}", mediaDn("lg"), "{width:", BREAKPOINTS.md, "px;}", mediaDn("md"), "{width:", BREAKPOINTS.sm, "px;}", mediaDn("sm"), "{width:100%;}");
const style = curry((styleName, {
  theme
}) => get_1(theme.styles, styleName));
var lib$1 = {};
Object.defineProperty(lib$1, "__esModule", {
  value: true
});
lib$1.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  function listen(listener) {
    if (typeof listener !== "function") {
      throw new Error("Expected listener to be a function.");
    }
    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function() {
      if (!isSubscribed) {
        return;
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index2 = nextListeners.indexOf(listener);
      nextListeners.splice(index2, 1);
    };
  }
  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }
  return {
    listen,
    emit
  };
};
function symbolObservablePonyfill(root2) {
  var result;
  var Symbol2 = root2.Symbol;
  if (typeof Symbol2 === "function") {
    if (Symbol2.observable) {
      result = Symbol2.observable;
    } else {
      result = Symbol2("observable");
      Symbol2.observable = result;
    }
  } else {
    result = "@@observable";
  }
  return result;
}
var root$2;
if (typeof self !== "undefined") {
  root$2 = self;
} else if (typeof window !== "undefined") {
  root$2 = window;
} else if (typeof global !== "undefined") {
  root$2 = global;
} else if (typeof module !== "undefined") {
  root$2 = module;
} else {
  root$2 = Function("return this")();
}
symbolObservablePonyfill(root$2);
var mapProps$2 = function mapProps(propsMapper) {
  return function(BaseComponent) {
    var factory = createFactory(BaseComponent);
    var MapProps = function MapProps2(props) {
      return factory(propsMapper(props));
    };
    return MapProps;
  };
};
var classCallCheck$1 = function(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var _extends$3 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key2 in source) {
      if (Object.prototype.hasOwnProperty.call(source, key2)) {
        target[key2] = source[key2];
      }
    }
  }
  return target;
};
var inherits$1 = function(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn$1 = function(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
};
var withProps$1 = function withProps(input) {
  var hoc = mapProps$2(function(props) {
    return _extends$3({}, props, typeof input === "function" ? input(props) : input);
  });
  return hoc;
};
var defaultProps$4 = function defaultProps(props) {
  return function(BaseComponent) {
    var factory = createFactory(BaseComponent);
    var DefaultProps = function DefaultProps2(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    return DefaultProps;
  };
};
(function(_Component) {
  inherits$1(Nothing, _Component);
  function Nothing() {
    classCallCheck$1(this, Nothing);
    return possibleConstructorReturn$1(this, _Component.apply(this, arguments));
  }
  Nothing.prototype.render = function render3() {
    return null;
  };
  return Nothing;
})(Component);
function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }
  if (funcs.length === 0) {
    return function(arg) {
      return arg;
    };
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce(function(a, b2) {
    return function() {
      return a(b2.apply(void 0, arguments));
    };
  });
}
const prop = curry((name, obj) => obj[name]);
const defaultTo = curry((fallback, obj) => obj == null ? fallback : obj);
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      return document.styleSheets[i];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  return tag;
}
var StyleSheet = /* @__PURE__ */ function() {
  function StyleSheet2(options) {
    this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce;
    this.key = options.key;
    this.container = options.container;
    this.before = null;
  }
  var _proto = StyleSheet2.prototype;
  _proto.insert = function insert2(rule) {
    if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
      var _tag = createStyleElement(this);
      var before;
      if (this.tags.length === 0) {
        before = this.before;
      } else {
        before = this.tags[this.tags.length - 1].nextSibling;
      }
      this.container.insertBefore(_tag, before);
      this.tags.push(_tag);
    }
    var tag = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);
      try {
        var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64;
        sheet.insertRule(rule, isImportRule ? 0 : sheet.cssRules.length);
      } catch (e2) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }
    this.ctr++;
  };
  _proto.flush = function flush() {
    this.tags.forEach(function(tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };
  return StyleSheet2;
}();
function stylis_min(W) {
  function M(d2, c2, e2, h2, a) {
    for (var m2 = 0, b2 = 0, v2 = 0, n2 = 0, q2, g2, x = 0, K = 0, k2, u2 = k2 = q2 = 0, l2 = 0, r2 = 0, I2 = 0, t2 = 0, B3 = e2.length, J = B3 - 1, y2, f2 = "", p2 = "", F3 = "", G3 = "", C2; l2 < B3; ) {
      g2 = e2.charCodeAt(l2);
      l2 === J && b2 + n2 + v2 + m2 !== 0 && (b2 !== 0 && (g2 = b2 === 47 ? 10 : 47), n2 = v2 = m2 = 0, B3++, J++);
      if (b2 + n2 + v2 + m2 === 0) {
        if (l2 === J && (0 < r2 && (f2 = f2.replace(N, "")), 0 < f2.trim().length)) {
          switch (g2) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f2 += e2.charAt(l2);
          }
          g2 = 59;
        }
        switch (g2) {
          case 123:
            f2 = f2.trim();
            q2 = f2.charCodeAt(0);
            k2 = 1;
            for (t2 = ++l2; l2 < B3; ) {
              switch (g2 = e2.charCodeAt(l2)) {
                case 123:
                  k2++;
                  break;
                case 125:
                  k2--;
                  break;
                case 47:
                  switch (g2 = e2.charCodeAt(l2 + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u2 = l2 + 1; u2 < J; ++u2) {
                          switch (e2.charCodeAt(u2)) {
                            case 47:
                              if (g2 === 42 && e2.charCodeAt(u2 - 1) === 42 && l2 + 2 !== u2) {
                                l2 = u2 + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (g2 === 47) {
                                l2 = u2 + 1;
                                break a;
                              }
                          }
                        }
                        l2 = u2;
                      }
                  }
                  break;
                case 91:
                  g2++;
                case 40:
                  g2++;
                case 34:
                case 39:
                  for (; l2++ < J && e2.charCodeAt(l2) !== g2; ) {
                  }
              }
              if (k2 === 0)
                break;
              l2++;
            }
            k2 = e2.substring(t2, l2);
            q2 === 0 && (q2 = (f2 = f2.replace(ca, "").trim()).charCodeAt(0));
            switch (q2) {
              case 64:
                0 < r2 && (f2 = f2.replace(N, ""));
                g2 = f2.charCodeAt(1);
                switch (g2) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r2 = c2;
                    break;
                  default:
                    r2 = O;
                }
                k2 = M(c2, r2, k2, g2, a + 1);
                t2 = k2.length;
                0 < A2 && (r2 = X(O, f2, I2), C2 = H2(3, k2, r2, c2, D2, z2, t2, g2, a, h2), f2 = r2.join(""), C2 !== void 0 && (t2 = (k2 = C2.trim()).length) === 0 && (g2 = 0, k2 = ""));
                if (0 < t2)
                  switch (g2) {
                    case 115:
                      f2 = f2.replace(da, ea);
                    case 100:
                    case 109:
                    case 45:
                      k2 = f2 + "{" + k2 + "}";
                      break;
                    case 107:
                      f2 = f2.replace(fa, "$1 $2");
                      k2 = f2 + "{" + k2 + "}";
                      k2 = w2 === 1 || w2 === 2 && L("@" + k2, 3) ? "@-webkit-" + k2 + "@" + k2 : "@" + k2;
                      break;
                    default:
                      k2 = f2 + k2, h2 === 112 && (k2 = (p2 += k2, ""));
                  }
                else
                  k2 = "";
                break;
              default:
                k2 = M(c2, X(c2, f2, I2), k2, h2, a + 1);
            }
            F3 += k2;
            k2 = I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e2.charCodeAt(++l2);
            break;
          case 125:
          case 59:
            f2 = (0 < r2 ? f2.replace(N, "") : f2).trim();
            if (1 < (t2 = f2.length))
              switch (u2 === 0 && (q2 = f2.charCodeAt(0), q2 === 45 || 96 < q2 && 123 > q2) && (t2 = (f2 = f2.replace(" ", ":")).length), 0 < A2 && (C2 = H2(1, f2, c2, d2, D2, z2, p2.length, h2, a, h2)) !== void 0 && (t2 = (f2 = C2.trim()).length) === 0 && (f2 = "\0\0"), q2 = f2.charCodeAt(0), g2 = f2.charCodeAt(1), q2) {
                case 0:
                  break;
                case 64:
                  if (g2 === 105 || g2 === 99) {
                    G3 += f2 + e2.charAt(l2);
                    break;
                  }
                default:
                  f2.charCodeAt(t2 - 1) !== 58 && (p2 += P(f2, q2, g2, f2.charCodeAt(2)));
              }
            I2 = r2 = u2 = q2 = 0;
            f2 = "";
            g2 = e2.charCodeAt(++l2);
        }
      }
      switch (g2) {
        case 13:
        case 10:
          b2 === 47 ? b2 = 0 : 1 + q2 === 0 && h2 !== 107 && 0 < f2.length && (r2 = 1, f2 += "\0");
          0 < A2 * Y && H2(0, f2, c2, d2, D2, z2, p2.length, h2, a, h2);
          z2 = 1;
          D2++;
          break;
        case 59:
        case 125:
          if (b2 + n2 + v2 + m2 === 0) {
            z2++;
            break;
          }
        default:
          z2++;
          y2 = e2.charAt(l2);
          switch (g2) {
            case 9:
            case 32:
              if (n2 + m2 + b2 === 0)
                switch (x) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y2 = "";
                    break;
                  default:
                    g2 !== 32 && (y2 = " ");
                }
              break;
            case 0:
              y2 = "\\0";
              break;
            case 12:
              y2 = "\\f";
              break;
            case 11:
              y2 = "\\v";
              break;
            case 38:
              n2 + b2 + m2 === 0 && (r2 = I2 = 1, y2 = "\f" + y2);
              break;
            case 108:
              if (n2 + b2 + m2 + E2 === 0 && 0 < u2)
                switch (l2 - u2) {
                  case 2:
                    x === 112 && e2.charCodeAt(l2 - 3) === 58 && (E2 = x);
                  case 8:
                    K === 111 && (E2 = K);
                }
              break;
            case 58:
              n2 + b2 + m2 === 0 && (u2 = l2);
              break;
            case 44:
              b2 + v2 + n2 + m2 === 0 && (r2 = 1, y2 += "\r");
              break;
            case 34:
            case 39:
              b2 === 0 && (n2 = n2 === g2 ? 0 : n2 === 0 ? g2 : n2);
              break;
            case 91:
              n2 + b2 + v2 === 0 && m2++;
              break;
            case 93:
              n2 + b2 + v2 === 0 && m2--;
              break;
            case 41:
              n2 + b2 + m2 === 0 && v2--;
              break;
            case 40:
              if (n2 + b2 + m2 === 0) {
                if (q2 === 0)
                  switch (2 * x + 3 * K) {
                    case 533:
                      break;
                    default:
                      q2 = 1;
                  }
                v2++;
              }
              break;
            case 64:
              b2 + v2 + n2 + m2 + u2 + k2 === 0 && (k2 = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n2 + m2 + v2))
                switch (b2) {
                  case 0:
                    switch (2 * g2 + 3 * e2.charCodeAt(l2 + 1)) {
                      case 235:
                        b2 = 47;
                        break;
                      case 220:
                        t2 = l2, b2 = 42;
                    }
                    break;
                  case 42:
                    g2 === 47 && x === 42 && t2 + 2 !== l2 && (e2.charCodeAt(t2 + 2) === 33 && (p2 += e2.substring(t2, l2 + 1)), y2 = "", b2 = 0);
                }
          }
          b2 === 0 && (f2 += y2);
      }
      K = x;
      x = g2;
      l2++;
    }
    t2 = p2.length;
    if (0 < t2) {
      r2 = c2;
      if (0 < A2 && (C2 = H2(2, p2, r2, d2, D2, z2, t2, h2, a, h2), C2 !== void 0 && (p2 = C2).length === 0))
        return G3 + p2 + F3;
      p2 = r2.join(",") + "{" + p2 + "}";
      if (w2 * E2 !== 0) {
        w2 !== 2 || L(p2, 2) || (E2 = 0);
        switch (E2) {
          case 111:
            p2 = p2.replace(ha, ":-moz-$1") + p2;
            break;
          case 112:
            p2 = p2.replace(Q, "::-webkit-input-$1") + p2.replace(Q, "::-moz-$1") + p2.replace(Q, ":-ms-input-$1") + p2;
        }
        E2 = 0;
      }
    }
    return G3 + p2 + F3;
  }
  function X(d2, c2, e2) {
    var h2 = c2.trim().split(ia);
    c2 = h2;
    var a = h2.length, m2 = d2.length;
    switch (m2) {
      case 0:
      case 1:
        var b2 = 0;
        for (d2 = m2 === 0 ? "" : d2[0] + " "; b2 < a; ++b2) {
          c2[b2] = Z(d2, c2[b2], e2).trim();
        }
        break;
      default:
        var v2 = b2 = 0;
        for (c2 = []; b2 < a; ++b2) {
          for (var n2 = 0; n2 < m2; ++n2) {
            c2[v2++] = Z(d2[n2] + " ", h2[b2], e2).trim();
          }
        }
    }
    return c2;
  }
  function Z(d2, c2, e2) {
    var h2 = c2.charCodeAt(0);
    33 > h2 && (h2 = (c2 = c2.trim()).charCodeAt(0));
    switch (h2) {
      case 38:
        return c2.replace(F2, "$1" + d2.trim());
      case 58:
        return d2.trim() + c2.replace(F2, "$1" + d2.trim());
      default:
        if (0 < 1 * e2 && 0 < c2.indexOf("\f"))
          return c2.replace(F2, (d2.charCodeAt(0) === 58 ? "" : "$1") + d2.trim());
    }
    return d2 + c2;
  }
  function P(d2, c2, e2, h2) {
    var a = d2 + ";", m2 = 2 * c2 + 3 * e2 + 4 * h2;
    if (m2 === 944) {
      d2 = a.indexOf(":", 9) + 1;
      var b2 = a.substring(d2, a.length - 1).trim();
      b2 = a.substring(0, d2).trim() + b2 + ";";
      return w2 === 1 || w2 === 2 && L(b2, 1) ? "-webkit-" + b2 + b2 : b2;
    }
    if (w2 === 0 || w2 === 2 && !L(a, 1))
      return a;
    switch (m2) {
      case 1015:
        return a.charCodeAt(10) === 97 ? "-webkit-" + a + a : a;
      case 951:
        return a.charCodeAt(3) === 116 ? "-webkit-" + a + a : a;
      case 963:
        return a.charCodeAt(5) === 110 ? "-webkit-" + a + a : a;
      case 1009:
        if (a.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (a.charCodeAt(8) === 45)
          return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11))
          return a.replace(ja, "$1-webkit-$2") + a;
        break;
      case 932:
        if (a.charCodeAt(4) === 45)
          switch (a.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
            case 115:
              return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
            case 98:
              return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
          }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (a.charCodeAt(8) !== 99)
          break;
        b2 = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b2 + "-webkit-" + a + "-ms-flex-pack" + b2 + a;
      case 1005:
        return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
      case 1e3:
        b2 = a.substring(13).trim();
        c2 = b2.indexOf("-") + 1;
        switch (b2.charCodeAt(0) + b2.charCodeAt(c2)) {
          case 226:
            b2 = a.replace(G2, "tb");
            break;
          case 232:
            b2 = a.replace(G2, "tb-rl");
            break;
          case 220:
            b2 = a.replace(G2, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + b2 + a;
      case 1017:
        if (a.indexOf("sticky", 9) === -1)
          break;
      case 975:
        c2 = (a = d2).length - 10;
        b2 = (a.charCodeAt(c2) === 33 ? a.substring(0, c2) : a).substring(d2.indexOf(":", 7) + 1).trim();
        switch (m2 = b2.charCodeAt(0) + (b2.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b2.charCodeAt(8))
              break;
          case 115:
            a = a.replace(b2, "-webkit-" + b2) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(b2, "-webkit-" + (102 < m2 ? "inline-" : "") + "box") + ";" + a.replace(b2, "-webkit-" + b2) + ";" + a.replace(b2, "-ms-" + b2 + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (a.charCodeAt(5) === 45)
          switch (a.charCodeAt(6)) {
            case 105:
              return b2 = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b2 + "-ms-flex-" + b2 + a;
            case 115:
              return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
            default:
              return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
          }
        break;
      case 973:
      case 989:
        if (a.charCodeAt(3) !== 45 || a.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (la.test(d2) === true)
          return (b2 = d2.substring(d2.indexOf(":") + 1)).charCodeAt(0) === 115 ? P(d2.replace("stretch", "fill-available"), c2, e2, h2).replace(":fill-available", ":stretch") : a.replace(b2, "-webkit-" + b2) + a.replace(b2, "-moz-" + b2.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (a.charCodeAt(5) === 102 ? "-ms-" + a : "") + a, e2 + h2 === 211 && a.charCodeAt(13) === 105 && 0 < a.indexOf("transform", 10))
          return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
    }
    return a;
  }
  function L(d2, c2) {
    var e2 = d2.indexOf(c2 === 1 ? ":" : "{"), h2 = d2.substring(0, c2 !== 3 ? e2 : 10);
    e2 = d2.substring(e2 + 1, d2.length - 1);
    return R(c2 !== 2 ? h2 : h2.replace(na, "$1"), e2, c2);
  }
  function ea(d2, c2) {
    var e2 = P(c2, c2.charCodeAt(0), c2.charCodeAt(1), c2.charCodeAt(2));
    return e2 !== c2 + ";" ? e2.replace(oa, " or ($1)").substring(4) : "(" + c2 + ")";
  }
  function H2(d2, c2, e2, h2, a, m2, b2, v2, n2, q2) {
    for (var g2 = 0, x = c2, w3; g2 < A2; ++g2) {
      switch (w3 = S[g2].call(B2, d2, x, e2, h2, a, m2, b2, v2, n2, q2)) {
        case void 0:
        case false:
        case true:
        case null:
          break;
        default:
          x = w3;
      }
    }
    if (x !== c2)
      return x;
  }
  function T(d2) {
    switch (d2) {
      case void 0:
      case null:
        A2 = S.length = 0;
        break;
      default:
        if (typeof d2 === "function")
          S[A2++] = d2;
        else if (typeof d2 === "object")
          for (var c2 = 0, e2 = d2.length; c2 < e2; ++c2) {
            T(d2[c2]);
          }
        else
          Y = !!d2 | 0;
    }
    return T;
  }
  function U(d2) {
    d2 = d2.prefix;
    d2 !== void 0 && (R = null, d2 ? typeof d2 !== "function" ? w2 = 1 : (w2 = 2, R = d2) : w2 = 0);
    return U;
  }
  function B2(d2, c2) {
    var e2 = d2;
    33 > e2.charCodeAt(0) && (e2 = e2.trim());
    V = e2;
    e2 = [V];
    if (0 < A2) {
      var h2 = H2(-1, c2, e2, e2, D2, z2, 0, 0, 0, 0);
      h2 !== void 0 && typeof h2 === "string" && (c2 = h2);
    }
    var a = M(O, e2, c2, 0, 0);
    0 < A2 && (h2 = H2(-2, a, e2, e2, D2, z2, a.length, 0, 0, 0), h2 !== void 0 && (a = h2));
    V = "";
    E2 = 0;
    z2 = D2 = 1;
    return a;
  }
  var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F2 = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G2 = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z2 = 1, D2 = 1, E2 = 0, w2 = 1, O = [], S = [], A2 = 0, R = null, Y = 0, V = "";
  B2.use = T;
  B2.set = U;
  W !== void 0 && U(W);
  return B2;
}
var delimiter = "/*|*/";
var needle = delimiter + "}";
function toSheet(block2) {
  if (block2) {
    Sheet.current.insert(block2 + "}");
  }
}
var Sheet = {
  current: null
};
var ruleSheet = function ruleSheet2(context, content, selectors, parents, line, column, length, ns, depth, at) {
  switch (context) {
    case 1: {
      switch (content.charCodeAt(0)) {
        case 64: {
          Sheet.current.insert(content + ";");
          return "";
        }
        case 108: {
          if (content.charCodeAt(2) === 98) {
            return "";
          }
        }
      }
      break;
    }
    case 2: {
      if (ns === 0)
        return content + delimiter;
      break;
    }
    case 3: {
      switch (ns) {
        case 102:
        case 112: {
          Sheet.current.insert(selectors[0] + content);
          return "";
        }
        default: {
          return content + (at === 0 ? delimiter : "");
        }
      }
    }
    case -2: {
      content.split(needle).forEach(toSheet);
    }
  }
};
var createCache = function createCache2(options) {
  if (options === void 0)
    options = {};
  var key2 = options.key || "css";
  var stylisOptions;
  if (options.prefix !== void 0) {
    stylisOptions = {
      prefix: options.prefix
    };
  }
  var stylis = new stylis_min(stylisOptions);
  var inserted = {};
  var container;
  {
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key2 + "]");
    Array.prototype.forEach.call(nodes, function(node) {
      var attrib = node.getAttribute("data-emotion-" + key2);
      attrib.split(" ").forEach(function(id) {
        inserted[id] = true;
      });
      if (node.parentNode !== container) {
        container.appendChild(node);
      }
    });
  }
  var _insert;
  {
    stylis.use(options.stylisPlugins)(ruleSheet);
    _insert = function insert2(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      Sheet.current = sheet;
      stylis(selector, serialized.styles);
      if (shouldCache) {
        cache.inserted[name] = true;
      }
    };
  }
  var cache = {
    key: key2,
    sheet: new StyleSheet({
      key: key2,
      container,
      nonce: options.nonce,
      speedy: options.speedy
    }),
    nonce: options.nonce,
    inserted,
    registered: {},
    insert: _insert
  };
  return cache;
};
var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
var EmotionCacheContext = /* @__PURE__ */ createContext$1(typeof HTMLElement !== "undefined" ? createCache() : null);
var ThemeContext = /* @__PURE__ */ createContext$1({});
EmotionCacheContext.Provider;
var withEmotionCache = function withEmotionCache2(func) {
  var render3 = function render4(props, ref) {
    return /* @__PURE__ */ createElement(EmotionCacheContext.Consumer, null, function(cache) {
      return func(props, cache, ref);
    });
  };
  return /* @__PURE__ */ forwardRef(render3);
};
var typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var createEmotionProps = function createEmotionProps2(type, props) {
  var newProps = {};
  for (var key2 in props) {
    if (hasOwnProperty$2.call(props, key2)) {
      newProps[key2] = props[key2];
    }
  }
  newProps[typePropName] = type;
  return newProps;
};
var render = function render2(cache, props, theme, ref) {
  var cssProp = theme === null ? props.css : props.css(theme);
  if (typeof cssProp === "string" && cache.registered[cssProp] !== void 0) {
    cssProp = cache.registered[cssProp];
  }
  var type = props[typePropName];
  var registeredStyles = [cssProp];
  var className = "";
  if (typeof props.className === "string") {
    className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
  } else if (props.className != null) {
    className = props.className + " ";
  }
  var serialized = serializeStyles(registeredStyles);
  insertStyles(cache, serialized, typeof type === "string");
  className += cache.key + "-" + serialized.name;
  var newProps = {};
  for (var key2 in props) {
    if (hasOwnProperty$2.call(props, key2) && key2 !== "css" && key2 !== typePropName && true) {
      newProps[key2] = props[key2];
    }
  }
  newProps.ref = ref;
  newProps.className = className;
  var ele = /* @__PURE__ */ createElement(type, newProps);
  return ele;
};
var Emotion = /* @__PURE__ */ withEmotionCache(function(props, cache, ref) {
  if (typeof props.css === "function") {
    return /* @__PURE__ */ createElement(ThemeContext.Consumer, null, function(theme) {
      return render(cache, props, theme, ref);
    });
  }
  return render(cache, props, null, ref);
});
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$1 = React__default, g$1 = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h$1 = Symbol.for;
  g$1 = h$1("react.element");
  reactJsxRuntime_production_min.Fragment = h$1("react.fragment");
}
var m$1 = f$1.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n$2 = Object.prototype.hasOwnProperty, p$1 = { key: true, ref: true, __self: true, __source: true };
function q$1(c2, a, k2) {
  var b2, d2 = {}, e2 = null, l2 = null;
  k2 !== void 0 && (e2 = "" + k2);
  a.key !== void 0 && (e2 = "" + a.key);
  a.ref !== void 0 && (l2 = a.ref);
  for (b2 in a)
    n$2.call(a, b2) && !p$1.hasOwnProperty(b2) && (d2[b2] = a[b2]);
  if (c2 && c2.defaultProps)
    for (b2 in a = c2.defaultProps, a)
      d2[b2] === void 0 && (d2[b2] = a[b2]);
  return { $$typeof: g$1, type: c2, key: e2, ref: l2, props: d2, _owner: m$1.current };
}
reactJsxRuntime_production_min.jsx = q$1;
reactJsxRuntime_production_min.jsxs = q$1;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx$1 = jsxRuntime.exports.jsx;
const jsxs$1 = jsxRuntime.exports.jsxs;
const Fragment$1 = jsxRuntime.exports.Fragment;
var Fragment = Fragment$1;
function jsx(type, props, key2) {
  if (!hasOwnProperty$2.call(props, "css")) {
    return jsx$1(type, props, key2);
  }
  return jsx$1(Emotion, createEmotionProps(type, props), key2);
}
function jsxs(type, props, key2) {
  if (!hasOwnProperty$2.call(props, "css")) {
    return jsxs$1(type, props, key2);
  }
  return jsxs$1(Emotion, createEmotionProps(type, props), key2);
}
const FILTERED_PROPS = ["size", "ref"];
const namedColor = (colorName, fallback) => (_a2) => {
  var _b = _a2, {
    theme
  } = _b, props = __objRest(_b, [
    "theme"
  ]);
  return color(props[colorName], {
    theme
  }) || props[colorName] || fallback;
};
const size$c = ({
  theme,
  size: size2
}) => theme.font.size[size2] || size2 || "1.5rem";
const SVGIcon = /* @__PURE__ */ createStyled("svg", {
  shouldForwardProp: (prop2) => FILTERED_PROPS.indexOf(prop2) === -1,
  target: "ezyrtnl0"
})("color:", namedColor("color", "currentColor"), ";fill:", namedColor("fill", "none"), ";width:", size$c, ";height:", size$c, ";cursor:", prop("cursor"), ";stroke:currentColor;pointer-events:", prop("pointerEvents"), ";vertical-align:middle;");
const SVGIconWithDefaults = (_a2) => {
  var _b = _a2, {
    viewBox: viewBox2 = "0 0 24 24",
    xmlns = "http://www.w3.org/2000/svg"
  } = _b, props = __objRest(_b, [
    "viewBox",
    "xmlns"
  ]);
  return /* @__PURE__ */ jsx(SVGIcon, __spreadProps(__spreadValues({}, props), {
    viewBox: viewBox2,
    xmlns
  }));
};
const FeatherSVG = /* @__PURE__ */ createStyled(SVGIconWithDefaults, {
  target: "e1r10n8r0"
})("stroke-width:", compose(defaultTo(2), prop("strokeWidth")), ";stroke-linecap:round;stroke-linejoin:round;");
const AlertCircle = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "alert-circle"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "12"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "16"
  })]
}));
const AlertTriangle = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "warning"
  }), /* @__PURE__ */ jsx("path", {
    d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "9",
    x2: "12",
    y2: "13"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "17"
  })]
}));
const Archive = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "archive"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "21 8 21 21 3 21 3 8"
  }), /* @__PURE__ */ jsx("rect", {
    x: "1",
    y: "3",
    width: "22",
    height: "5"
  }), /* @__PURE__ */ jsx("line", {
    x1: "10",
    y1: "12",
    x2: "14",
    y2: "12"
  })]
}));
const DIRECTIONS$1 = {
  up: /* @__PURE__ */ jsxs(Fragment$2, {
    children: [/* @__PURE__ */ jsx("line", {
      x1: "12",
      y1: "19",
      x2: "12",
      y2: "5"
    }), /* @__PURE__ */ jsx("polyline", {
      points: "5 12 12 5 19 12"
    })]
  }),
  down: /* @__PURE__ */ jsxs(Fragment$2, {
    children: [/* @__PURE__ */ jsx("line", {
      x1: "12",
      y1: "5",
      x2: "12",
      y2: "19"
    }), /* @__PURE__ */ jsx("polyline", {
      points: "19 12 12 19 5 12"
    })]
  }),
  left: /* @__PURE__ */ jsxs(Fragment$2, {
    children: [/* @__PURE__ */ jsx("line", {
      x1: "19",
      y1: "12",
      x2: "5",
      y2: "12"
    }), /* @__PURE__ */ jsx("polyline", {
      points: "12 19 5 12 12 5"
    })]
  }),
  right: /* @__PURE__ */ jsxs(Fragment$2, {
    children: [/* @__PURE__ */ jsx("line", {
      x1: "5",
      y1: "12",
      x2: "19",
      y2: "12"
    }), /* @__PURE__ */ jsx("polyline", {
      points: "12 5 19 12 12 19"
    })]
  })
};
const Arrow = (_c) => {
  var _d = _c, {
    direction
  } = _d, props = __objRest(_d, [
    "direction"
  ]);
  return /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsxs("title", {
      children: ["arrow-", direction]
    }), DIRECTIONS$1[direction]]
  }));
};
const Bookmark = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "bookmark"
  }), /* @__PURE__ */ jsx("path", {
    d: "M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"
  })]
}));
const Calendar = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ jsx("line", {
    x1: "16",
    y1: "2",
    x2: "16",
    y2: "6"
  }), /* @__PURE__ */ jsx("line", {
    x1: "8",
    y1: "2",
    x2: "8",
    y2: "6"
  }), /* @__PURE__ */ jsx("line", {
    x1: "3",
    y1: "10",
    x2: "21",
    y2: "10"
  })]
}));
const Cancel$2 = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "cancel"
  }), /* @__PURE__ */ jsx("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }), /* @__PURE__ */ jsx("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })]
}));
const Caret$2 = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({
  fill: "currentColor",
  strokeWidth: 0
}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "caret"
  }), /* @__PURE__ */ jsx("path", {
    d: "M0 6h24L12 18z"
  })]
}));
const Chat = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "chat"
  }), /* @__PURE__ */ jsx("path", {
    d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
  })]
}));
const CheckCircle = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "check-circle"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "17 9 11 16.01 8 13.01"
  })]
}));
const Check = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "check"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "20 6 9 17 4 12"
  })]
}));
const pathFor$1 = (direction) => {
  switch (direction) {
    case "down":
      return /* @__PURE__ */ jsx("polyline", {
        points: "6 9 12 15 18 9"
      });
    case "left":
      return /* @__PURE__ */ jsx("polyline", {
        points: "15 18 9 12 15 6"
      });
    case "up":
      return /* @__PURE__ */ jsx("polyline", {
        points: "18 15 12 9 6 15"
      });
    case "right":
      return /* @__PURE__ */ jsx("polyline", {
        points: "9 18 15 12 9 6"
      });
    default:
      throw new Error("invalid direction");
  }
};
const Chevron$1 = (_e) => {
  var _f = _e, {
    direction
  } = _f, props = __objRest(_f, [
    "direction"
  ]);
  return /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsxs("title", {
      children: ["chevron-", direction]
    }), pathFor$1(direction)]
  }));
};
const Copy = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "copy"
  }), /* @__PURE__ */ jsx("rect", {
    x: "9",
    y: "9",
    width: "13",
    height: "13",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ jsx("path", {
    d: "M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
  })]
}));
const Disc = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "disc"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  })]
}));
const Download = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "download"
  }), /* @__PURE__ */ jsx("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "7 10 12 15 17 10"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "15",
    x2: "12",
    y2: "3"
  })]
}));
const Edit = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "edit"
  }), /* @__PURE__ */ jsx("polygon", {
    points: "16 3 21 8 8 21 3 21 3 16 16 3"
  })]
}));
const ExternalLink = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "external-link"
  }), /* @__PURE__ */ jsx("path", {
    d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "15 3 21 3 21 9"
  }), /* @__PURE__ */ jsx("line", {
    x1: "10",
    y1: "14",
    x2: "21",
    y2: "3"
  })]
}));
const File = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "file"
  }), /* @__PURE__ */ jsx("path", {
    d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "13 2 13 9 20 9"
  })]
}));
const FilePlus = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "file-plus"
  }), /* @__PURE__ */ jsx("path", {
    d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "14 2 14 8 20 8"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "18",
    x2: "12",
    y2: "12"
  }), /* @__PURE__ */ jsx("line", {
    x1: "9",
    y1: "15",
    x2: "15",
    y2: "15"
  })]
}));
const Hamburger = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "hamburger"
  }), /* @__PURE__ */ jsx("line", {
    x1: "3",
    y1: "12",
    x2: "21",
    y2: "12"
  }), /* @__PURE__ */ jsx("line", {
    x1: "3",
    y1: "6",
    x2: "21",
    y2: "6"
  }), /* @__PURE__ */ jsx("line", {
    x1: "3",
    y1: "18",
    x2: "21",
    y2: "18"
  })]
}));
Hamburger.defaultProps = {
  cursor: "pointer"
};
const Hash$1 = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "hash"
  }), /* @__PURE__ */ jsx("line", {
    x1: "4",
    y1: "9",
    x2: "20",
    y2: "9"
  }), /* @__PURE__ */ jsx("line", {
    x1: "4",
    y1: "15",
    x2: "20",
    y2: "15"
  }), /* @__PURE__ */ jsx("line", {
    x1: "10",
    y1: "3",
    x2: "8",
    y2: "21"
  }), /* @__PURE__ */ jsx("line", {
    x1: "16",
    y1: "3",
    x2: "14",
    y2: "21"
  })]
}));
const Help = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "help"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ jsx("path", {
    d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "17",
    x2: "12",
    y2: "17"
  })]
}));
const Home = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "home"
  }), /* @__PURE__ */ jsx("path", {
    d: "M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "9 22 9 12 15 12 15 22"
  })]
}));
const Image$1 = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "image"
  }), /* @__PURE__ */ jsx("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "18",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "8.5",
    cy: "8.5",
    r: "1.5"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "21 15 16 10 5 21"
  })]
}));
const Info = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "info"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "16",
    x2: "12",
    y2: "12"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "8",
    x2: "12",
    y2: "8"
  })]
}));
const Lock$1 = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "lock"
  }), /* @__PURE__ */ jsx("rect", {
    x: "3",
    y: "11",
    width: "18",
    height: "11",
    rx: "2",
    ry: "2"
  }), /* @__PURE__ */ jsx("path", {
    d: "M7 11V7a5 5 0 0 1 10 0v4"
  })]
}));
const Maximize = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "maximize"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "15 3 21 3 21 9"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "9 21 3 21 3 15"
  }), /* @__PURE__ */ jsx("line", {
    x1: "21",
    y1: "3",
    x2: "14",
    y2: "10"
  }), /* @__PURE__ */ jsx("line", {
    x1: "3",
    y1: "21",
    x2: "10",
    y2: "14"
  })]
}));
const Minimize = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "minimize"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "4 14 10 14 10 20"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "20 10 14 10 14 4"
  }), /* @__PURE__ */ jsx("line", {
    x1: "14",
    y1: "10",
    x2: "21",
    y2: "3"
  }), /* @__PURE__ */ jsx("line", {
    x1: "3",
    y1: "21",
    x2: "10",
    y2: "14"
  })]
}));
const DIRECTIONS = {
  horizontal: /* @__PURE__ */ jsxs(Fragment$2, {
    children: [/* @__PURE__ */ jsx("circle", {
      cx: "12",
      cy: "12",
      r: "1"
    }), /* @__PURE__ */ jsx("circle", {
      cx: "19",
      cy: "12",
      r: "1"
    }), /* @__PURE__ */ jsx("circle", {
      cx: "5",
      cy: "12",
      r: "1"
    })]
  }),
  vertical: /* @__PURE__ */ jsxs(Fragment$2, {
    children: [/* @__PURE__ */ jsx("circle", {
      cx: "12",
      cy: "12",
      r: "1"
    }), /* @__PURE__ */ jsx("circle", {
      cx: "12",
      cy: "5",
      r: "1"
    }), /* @__PURE__ */ jsx("circle", {
      cx: "12",
      cy: "19",
      r: "1"
    })]
  })
};
const More = (_g) => {
  var _h = _g, {
    direction,
    title
  } = _h, props = __objRest(_h, [
    "direction",
    "title"
  ]);
  return /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), DIRECTIONS[direction]]
  }));
};
More.defaultProps = {
  direction: "horizontal",
  title: "More"
};
const Play = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "play"
  }), /* @__PURE__ */ jsx("polygon", {
    points: "5 3 19 12 5 21 5 3"
  })]
}));
const Plus = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "plus"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "5",
    x2: "12",
    y2: "19"
  }), /* @__PURE__ */ jsx("line", {
    x1: "5",
    y1: "12",
    x2: "19",
    y2: "12"
  })]
}));
const svgFor$1 = (direction) => {
  switch (direction) {
    case "cw":
      return /* @__PURE__ */ jsxs(Fragment$2, {
        children: [/* @__PURE__ */ jsx("polyline", {
          points: "23 4 23 10 17 10"
        }), /* @__PURE__ */ jsx("polyline", {
          points: "1 20 1 14 7 14"
        }), /* @__PURE__ */ jsx("path", {
          d: "M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
        })]
      });
    case "ccw":
      return /* @__PURE__ */ jsxs(Fragment$2, {
        children: [/* @__PURE__ */ jsx("polyline", {
          points: "1 4 1 10 7 10"
        }), /* @__PURE__ */ jsx("polyline", {
          points: "23 20 23 14 17 14"
        }), /* @__PURE__ */ jsx("path", {
          d: "M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"
        })]
      });
    default:
      throw new Error("invalid direction. Valid options are 'cw', 'ccw'");
  }
};
const Refresh = (_i) => {
  var _j = _i, {
    direction
  } = _j, props = __objRest(_j, [
    "direction"
  ]);
  return /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsxs("title", {
      children: ["refresh-", direction]
    }), svgFor$1(direction)]
  }));
};
const svgFor = (direction) => {
  switch (direction) {
    case "cw":
      return /* @__PURE__ */ jsxs(Fragment$2, {
        children: [/* @__PURE__ */ jsx("polyline", {
          points: "23 4 23 10 17 10"
        }), /* @__PURE__ */ jsx("path", {
          d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10"
        })]
      });
    case "ccw":
      return /* @__PURE__ */ jsxs(Fragment$2, {
        children: [/* @__PURE__ */ jsx("polyline", {
          points: "1 4 1 10 7 10"
        }), /* @__PURE__ */ jsx("path", {
          d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
        })]
      });
    default:
      throw new Error("invalid direction. Valid options are 'cw', 'ccw'");
  }
};
const Rotate = (_k) => {
  var _l = _k, {
    direction
  } = _l, props = __objRest(_l, [
    "direction"
  ]);
  return /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsxs("title", {
      children: ["rotate-", direction]
    }), svgFor(direction)]
  }));
};
const Save = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "save"
  }), /* @__PURE__ */ jsx("path", {
    d: "M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "17 21 17 13 7 13 7 21"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "7 3 7 8 15 8"
  })]
}));
const Search = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "search"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "11",
    cy: "11",
    r: "8"
  }), /* @__PURE__ */ jsx("line", {
    x1: "21",
    y1: "21",
    x2: "16.65",
    y2: "16.65"
  })]
}));
const Settings = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "settings"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), /* @__PURE__ */ jsx("path", {
    d: "M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
  })]
}));
const Share = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "share"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "18",
    cy: "5",
    r: "3"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "6",
    cy: "12",
    r: "3"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "18",
    cy: "19",
    r: "3"
  }), /* @__PURE__ */ jsx("line", {
    x1: "8.59",
    y1: "13.51",
    x2: "15.42",
    y2: "17.49"
  }), /* @__PURE__ */ jsx("line", {
    x1: "15.41",
    y1: "6.51",
    x2: "8.59",
    y2: "10.49"
  })]
}));
const Slash = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "slash"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ jsx("line", {
    x1: "4.93",
    y1: "4.93",
    x2: "19.07",
    y2: "19.07"
  })]
}));
const Sort = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "sort"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "10 6 6 2 2 6"
  }), /* @__PURE__ */ jsx("line", {
    x1: "6",
    y1: "2",
    x2: "6",
    y2: "18"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "22 18 18 22 14 18"
  }), /* @__PURE__ */ jsx("line", {
    x1: "18",
    y1: "22",
    x2: "18",
    y2: "6"
  })]
}));
const Star = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "star"
  }), /* @__PURE__ */ jsx("polygon", {
    points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"
  })]
}));
const pathFor = (direction) => {
  switch (direction) {
    case "up":
      return "M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3";
    case "down":
      return "M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17";
    default:
      throw new Error('invalid direction. Supported values are ["up", "down"]');
  }
};
const Thumb = (_m) => {
  var _n = _m, {
    direction
  } = _n, props = __objRest(_n, [
    "direction"
  ]);
  return /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsxs("title", {
      children: ["thumbs-", direction]
    }), /* @__PURE__ */ jsx("path", {
      d: pathFor(direction)
    })]
  }));
};
const Trash = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "trash"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "3 6 5 6 21 6"
  }), /* @__PURE__ */ jsx("path", {
    d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
  }), /* @__PURE__ */ jsx("line", {
    x1: "10",
    y1: "11",
    x2: "10",
    y2: "17"
  }), /* @__PURE__ */ jsx("line", {
    x1: "14",
    y1: "11",
    x2: "14",
    y2: "17"
  })]
}));
const Upload = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "upload"
  }), /* @__PURE__ */ jsx("path", {
    d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"
  }), /* @__PURE__ */ jsx("polyline", {
    points: "17 8 12 3 7 8"
  }), /* @__PURE__ */ jsx("line", {
    x1: "12",
    y1: "3",
    x2: "12",
    y2: "15"
  })]
}));
const User = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "user"
  }), /* @__PURE__ */ jsx("path", {
    d: "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "12",
    cy: "7",
    r: "4"
  })]
}));
const UserPlus = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "user-plus"
  }), /* @__PURE__ */ jsx("path", {
    d: "M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "8.5",
    cy: "7",
    r: "4"
  }), /* @__PURE__ */ jsx("line", {
    x1: "20",
    y1: "8",
    x2: "20",
    y2: "14"
  }), /* @__PURE__ */ jsx("line", {
    x1: "23",
    y1: "11",
    x2: "17",
    y2: "11"
  })]
}));
const Users = (props) => /* @__PURE__ */ jsxs(FeatherSVG, __spreadProps(__spreadValues({}, props), {
  children: [/* @__PURE__ */ jsx("title", {
    children: "users"
  }), /* @__PURE__ */ jsx("path", {
    d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
  }), /* @__PURE__ */ jsx("circle", {
    cx: "9",
    cy: "7",
    r: "4"
  }), /* @__PURE__ */ jsx("path", {
    d: "M23 21v-2a4 4 0 0 0-3-3.87"
  }), /* @__PURE__ */ jsx("path", {
    d: "M16 3.13a4 4 0 0 1 0 7.75"
  })]
}));
const SVGIconV2 = /* @__PURE__ */ createStyled(SVGIconWithDefaults, {
  target: "eo2ba600"
})("fill:initial;", ({
  fill
}) => fill && `
  fill: ${fill} !important;
`, " stroke:initial;");
const AlertCircleV2 = (_o) => {
  var _p = _o, {
    title = "alert-circle"
  } = _p, props = __objRest(_p, [
    "title"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z",
      fill: "#16263B"
    })]
  }));
};
const AppSelect = (_q) => {
  var _r = _q, {
    title = "app-select"
  } = _r, props = __objRest(_r, [
    "title"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z",
      fill: "#16263B"
    })]
  }));
};
var _ref$h = {
  name: "1qx34im",
  styles: "transform:rotate(90deg);"
};
var _ref2$b = {
  name: "4ky835",
  styles: "transform:rotate(180deg);"
};
var _ref3$2 = {
  name: "jbc4oa",
  styles: "transform:rotate(270deg);"
};
const directionCss = ({
  direction
}) => {
  switch (direction) {
    case "left":
      return _ref$h;
    case "up":
      return _ref2$b;
    case "right":
      return _ref3$2;
    case "down":
    default:
      return null;
  }
};
const RotatedSvg = /* @__PURE__ */ createStyled(SVGIconV2, {
  target: "e1e7a5860"
})(directionCss, ";");
const Chevron = (_s) => {
  var _t = _s, {
    title = "chevron"
  } = _t, props = __objRest(_t, [
    "title"
  ]);
  return /* @__PURE__ */ jsxs(RotatedSvg, __spreadProps(__spreadValues({}, props), {
    viewBox: "0 0 8 6",
    size: "8px",
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M7.06 0.726685L4 3.78002L0.94 0.726685L0 1.66668L4 5.66668L8 1.66668L7.06 0.726685Z"
    })]
  }));
};
const BellFill = (_u) => {
  var _v = _u, {
    title = "bell-fill"
  } = _v, props = __objRest(_v, [
    "title"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.89 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z"
    })]
  }));
};
const ExternalLinkIconV2 = (_w) => {
  var _x = _w, {
    title = "external-link"
  } = _x, props = __objRest(_x, [
    "title"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M19 19H5V5H12V3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V12H19V19ZM14 3V5H17.59L7.76 14.83L9.17 16.24L19 6.41V10H21V3H14Z"
    })]
  }));
};
const HelpIconV2 = (_y) => {
  var _z = _y, {
    title = "help-icon"
  } = _z, props = __objRest(_z, [
    "title"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 19H11V17H13V19ZM15.07 11.25L14.17 12.17C13.45 12.9 13 13.5 13 15H11V14.5C11 13.4 11.45 12.4 12.17 11.67L13.41 10.41C13.78 10.05 14 9.55 14 9C14 7.9 13.1 7 12 7C10.9 7 10 7.9 10 9H8C8 6.79 9.79 5 12 5C14.21 5 16 6.79 16 9C16 9.88 15.64 10.68 15.07 11.25Z",
      fill: "#16263B"
    })]
  }));
};
const QuestionMarkCircleIcon = (_A) => {
  var _B = _A, {
    title = "question-mark-circle",
    viewBox: viewBox2 = "0 0 20 20",
    size: size2 = "1.25rem"
  } = _B, props = __objRest(_B, [
    "title",
    "viewBox",
    "size"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({
    viewBox: viewBox2,
    size: size2
  }, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M9 16H11V14H9V16ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C7.79 4 6 5.79 6 8H8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8C12 10 9 9.75 9 13H11C11 10.75 14 10.5 14 8C14 5.79 12.21 4 10 4Z"
    })]
  }));
};
const Bell = (_C) => {
  var _D = _C, {
    title = "bell",
    viewBox: viewBox2 = "0 0 40 40",
    size: size2 = "2.5rem"
  } = _D, props = __objRest(_D, [
    "title",
    "viewBox",
    "size"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({
    viewBox: viewBox2,
    size: size2
  }, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M20 30C21.1 30 22 29.1 22 28H18C18 29.1 18.9 30 20 30ZM26 24V19C26 15.93 24.37 13.36 21.5 12.68V12C21.5 11.17 20.83 10.5 20 10.5C19.17 10.5 18.5 11.17 18.5 12V12.68C15.64 13.36 14 15.92 14 19V24L12 26V27H28V26L26 24ZM24 25H16V19C16 16.52 17.51 14.5 20 14.5C22.49 14.5 24 16.52 24 19V25Z"
    })]
  }));
};
const Key = (_E) => {
  var _F = _E, {
    title = "key"
  } = _F, props = __objRest(_F, [
    "title"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    })]
  }));
};
const Lock = (_G) => {
  var _H = _G, {
    title = "lock"
  } = _H, props = __objRest(_H, [
    "title"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
    })]
  }));
};
const MobileFiendly = (_I) => {
  var _J = _I, {
    title = "mobile-friendly"
  } = _J, props = __objRest(_J, [
    "title"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({}, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM7.01 13.47l-2.55-2.55-1.27 1.27L7 16l7.19-7.19-1.27-1.27-5.91 5.93z",
      fill: "#16263B"
    })]
  }));
};
const COLORS = {
  success: "lightGreen",
  error: "lightRed",
  warning: "lightOrange",
  info: "lightBlue"
};
const Container$k = createStyled("div", {
  target: "ezofa9h0"
})("display:flex;align-items:center;color:", color("slate"), ";background:", ({
  kind: kind2,
  theme
}) => color(COLORS[kind2], {
  theme
}), ";", padding("xs"), ";", borderRadius$1("sm"), ";svg{margin-right:", spacer(3), ";vertical-align:middle;width:1.5rem;height:1.5rem;}");
Container$k.displayName = "Alert.Container";
const Icon$2 = ({
  kind: kind2
}) => {
  switch (kind2) {
    case "error":
      return /* @__PURE__ */ jsx(AlertCircle, {
        color: "red"
      });
    case "info":
      return /* @__PURE__ */ jsx(Info, {
        color: "blue"
      });
    case "success":
      return /* @__PURE__ */ jsx(CheckCircle, {
        color: "green"
      });
    case "warning":
      return /* @__PURE__ */ jsx(AlertTriangle, {
        color: "orange"
      });
    default:
      return null;
  }
};
Icon$2.displayName = "Alert.Icon";
const Message$1 = createStyled("span", {
  target: "eya5dlj0"
})(typography$1("body2Medium"), ";");
Message$1.displayName = "Alert.Message";
const Alert = ({
  className,
  kind: kind2,
  message,
  hideIcon
}) => /* @__PURE__ */ jsxs(Container$k, {
  className,
  kind: kind2,
  role: "alert",
  children: [!hideIcon && /* @__PURE__ */ jsx(Icon$2, {
    kind: kind2
  }), /* @__PURE__ */ jsx(Message$1, {
    children: message
  })]
});
const size$b = ({
  size: size2,
  theme
}) => {
  switch (size2) {
    case "lg":
      return /* @__PURE__ */ css("right:", spacer(4, {
        theme
      }), ";");
    default:
      return /* @__PURE__ */ css("right:", spacer(3, {
        theme
      }), ";");
  }
};
const Caret$1 = /* @__PURE__ */ createStyled(Caret$2, {
  target: "e146npfq0"
})("position:absolute;top:50%;transform:translateY(-50%);pointer-events:none;", size$b, ";");
const Container$j = createStyled("div", {
  target: "e107w2xj0"
})("position:relative;width:", ({
  width
}) => width, ";");
Container$j.displayName = "Dropdown.Container";
Container$j.defaultProps = {
  width: "auto"
};
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key2, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key2 = sourceKeys[i];
    if (excluded.indexOf(key2) >= 0)
      continue;
    target[key2] = source[key2];
  }
  return target;
}
function _extends$2() {
  _extends$2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  return _extends$2.apply(this, arguments);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}
var propTypes$3 = { exports: {} };
var ReactPropTypesSecret$6 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1$3 = ReactPropTypesSecret$6;
var ReactPropTypesSecret$5 = ReactPropTypesSecret_1$3;
function emptyFunction$5() {
}
function emptyFunctionWithReset$1() {
}
emptyFunctionWithReset$1.resetWarningCache = emptyFunction$5;
var factoryWithThrowingShims$3 = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$5) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset$1,
    resetWarningCache: emptyFunction$5
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes$3.exports = factoryWithThrowingShims$3();
}
var PropTypes$3 = propTypes$3.exports;
var reactIs_production_min = {};
/** @license React v17.0.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b = 60103, c = 60106, d = 60107, e$1 = 60108, f = 60114, g = 60109, h = 60110, k = 60112, l = 60113, m = 60120, n$1 = 60115, p = 60116, q = 60121, r$1 = 60122, u = 60117, v = 60129, w = 60131;
if (typeof Symbol === "function" && Symbol.for) {
  var x = Symbol.for;
  b = x("react.element");
  c = x("react.portal");
  d = x("react.fragment");
  e$1 = x("react.strict_mode");
  f = x("react.profiler");
  g = x("react.provider");
  h = x("react.context");
  k = x("react.forward_ref");
  l = x("react.suspense");
  m = x("react.suspense_list");
  n$1 = x("react.memo");
  p = x("react.lazy");
  q = x("react.block");
  r$1 = x("react.server.block");
  u = x("react.fundamental");
  v = x("react.debug_trace_mode");
  w = x("react.legacy_hidden");
}
function y(a) {
  if (typeof a === "object" && a !== null) {
    var t2 = a.$$typeof;
    switch (t2) {
      case b:
        switch (a = a.type, a) {
          case d:
          case f:
          case e$1:
          case l:
          case m:
            return a;
          default:
            switch (a = a && a.$$typeof, a) {
              case h:
              case k:
              case p:
              case n$1:
              case g:
                return a;
              default:
                return t2;
            }
        }
      case c:
        return t2;
    }
  }
}
var z = g, A = b, B = k, C = d, D = p, E = n$1, F = c, G = f, H = e$1, I = l;
reactIs_production_min.ContextConsumer = h;
reactIs_production_min.ContextProvider = z;
reactIs_production_min.Element = A;
reactIs_production_min.ForwardRef = B;
reactIs_production_min.Fragment = C;
reactIs_production_min.Lazy = D;
reactIs_production_min.Memo = E;
reactIs_production_min.Portal = F;
reactIs_production_min.Profiler = G;
reactIs_production_min.StrictMode = H;
reactIs_production_min.Suspense = I;
reactIs_production_min.isAsyncMode = function() {
  return false;
};
reactIs_production_min.isConcurrentMode = function() {
  return false;
};
reactIs_production_min.isContextConsumer = function(a) {
  return y(a) === h;
};
reactIs_production_min.isContextProvider = function(a) {
  return y(a) === g;
};
reactIs_production_min.isElement = function(a) {
  return typeof a === "object" && a !== null && a.$$typeof === b;
};
reactIs_production_min.isForwardRef = function(a) {
  return y(a) === k;
};
reactIs_production_min.isFragment = function(a) {
  return y(a) === d;
};
reactIs_production_min.isLazy = function(a) {
  return y(a) === p;
};
reactIs_production_min.isMemo = function(a) {
  return y(a) === n$1;
};
reactIs_production_min.isPortal = function(a) {
  return y(a) === c;
};
reactIs_production_min.isProfiler = function(a) {
  return y(a) === f;
};
reactIs_production_min.isStrictMode = function(a) {
  return y(a) === e$1;
};
reactIs_production_min.isSuspense = function(a) {
  return y(a) === l;
};
reactIs_production_min.isValidElementType = function(a) {
  return typeof a === "string" || typeof a === "function" || a === d || a === f || a === v || a === e$1 || a === l || a === m || a === w || typeof a === "object" && a !== null && (a.$$typeof === p || a.$$typeof === n$1 || a.$$typeof === g || a.$$typeof === h || a.$$typeof === k || a.$$typeof === u || a.$$typeof === q || a[0] === r$1) ? true : false;
};
reactIs_production_min.typeOf = y;
function t(t2) {
  return t2 != null && typeof t2 == "object" && t2.nodeType === 1;
}
function e(t2, e2) {
  return (!e2 || t2 !== "hidden") && t2 !== "visible" && t2 !== "clip";
}
function n(t2, n2) {
  if (t2.clientHeight < t2.scrollHeight || t2.clientWidth < t2.scrollWidth) {
    var r2 = getComputedStyle(t2, null);
    return e(r2.overflowY, n2) || e(r2.overflowX, n2) || function(t3) {
      var e2 = function(t4) {
        if (!t4.ownerDocument || !t4.ownerDocument.defaultView)
          return null;
        try {
          return t4.ownerDocument.defaultView.frameElement;
        } catch (t5) {
          return null;
        }
      }(t3);
      return !!e2 && (e2.clientHeight < t3.scrollHeight || e2.clientWidth < t3.scrollWidth);
    }(t2);
  }
  return false;
}
function r(t2, e2, n2, r2, i, o, l2, d2) {
  return o < t2 && l2 > e2 || o > t2 && l2 < e2 ? 0 : o <= t2 && d2 <= n2 || l2 >= e2 && d2 >= n2 ? o - t2 - r2 : l2 > e2 && d2 < n2 || o < t2 && d2 > n2 ? l2 - e2 + i : 0;
}
function computeScrollIntoView(e2, i) {
  var o = window, l2 = i.scrollMode, d2 = i.block, u2 = i.inline, h2 = i.boundary, a = i.skipOverflowHiddenElements, c2 = typeof h2 == "function" ? h2 : function(t2) {
    return t2 !== h2;
  };
  if (!t(e2))
    throw new TypeError("Invalid target");
  for (var f2 = document.scrollingElement || document.documentElement, s = [], p2 = e2; t(p2) && c2(p2); ) {
    if ((p2 = p2.parentNode) === f2) {
      s.push(p2);
      break;
    }
    p2 === document.body && n(p2) && !n(document.documentElement) || n(p2, a) && s.push(p2);
  }
  for (var g2 = o.visualViewport ? o.visualViewport.width : innerWidth, m2 = o.visualViewport ? o.visualViewport.height : innerHeight, w2 = window.scrollX || pageXOffset, v2 = window.scrollY || pageYOffset, W = e2.getBoundingClientRect(), b2 = W.height, H2 = W.width, y2 = W.top, M = W.right, E2 = W.bottom, V = W.left, x = d2 === "start" || d2 === "nearest" ? y2 : d2 === "end" ? E2 : y2 + b2 / 2, I2 = u2 === "center" ? V + H2 / 2 : u2 === "end" ? M : V, C2 = [], T = 0; T < s.length; T++) {
    var k2 = s[T], B2 = k2.getBoundingClientRect(), D2 = B2.height, O = B2.width, R = B2.top, X = B2.right, Y = B2.bottom, L = B2.left;
    if (l2 === "if-needed" && y2 >= 0 && V >= 0 && E2 <= m2 && M <= g2 && y2 >= R && E2 <= Y && V >= L && M <= X)
      return C2;
    var S = getComputedStyle(k2), j = parseInt(S.borderLeftWidth, 10), N = parseInt(S.borderTopWidth, 10), q2 = parseInt(S.borderRightWidth, 10), z2 = parseInt(S.borderBottomWidth, 10), A2 = 0, F2 = 0, G2 = "offsetWidth" in k2 ? k2.offsetWidth - k2.clientWidth - j - q2 : 0, J = "offsetHeight" in k2 ? k2.offsetHeight - k2.clientHeight - N - z2 : 0;
    if (f2 === k2)
      A2 = d2 === "start" ? x : d2 === "end" ? x - m2 : d2 === "nearest" ? r(v2, v2 + m2, m2, N, z2, v2 + x, v2 + x + b2, b2) : x - m2 / 2, F2 = u2 === "start" ? I2 : u2 === "center" ? I2 - g2 / 2 : u2 === "end" ? I2 - g2 : r(w2, w2 + g2, g2, j, q2, w2 + I2, w2 + I2 + H2, H2), A2 = Math.max(0, A2 + v2), F2 = Math.max(0, F2 + w2);
    else {
      A2 = d2 === "start" ? x - R - N : d2 === "end" ? x - Y + z2 + J : d2 === "nearest" ? r(R, Y, D2, N, z2 + J, x, x + b2, b2) : x - (R + D2 / 2) + J / 2, F2 = u2 === "start" ? I2 - L - j : u2 === "center" ? I2 - (L + O / 2) + G2 / 2 : u2 === "end" ? I2 - X + q2 + G2 : r(L, X, O, j, q2 + G2, I2, I2 + H2, H2);
      var K = k2.scrollLeft, P = k2.scrollTop;
      x += P - (A2 = Math.max(0, Math.min(P + A2, k2.scrollHeight - D2 + J))), I2 += K - (F2 = Math.max(0, Math.min(K + F2, k2.scrollWidth - O + G2)));
    }
    C2.push({ el: k2, top: A2, left: F2 });
  }
  return C2;
}
var idCounter = 0;
function cbToCb(cb) {
  return typeof cb === "function" ? cb : noop$2;
}
function noop$2() {
}
function scrollIntoView(node, menuNode) {
  if (!node) {
    return;
  }
  var actions = computeScrollIntoView(node, {
    boundary: menuNode,
    block: "nearest",
    scrollMode: "if-needed"
  });
  actions.forEach(function(_ref6) {
    var el = _ref6.el, top2 = _ref6.top, left2 = _ref6.left;
    el.scrollTop = top2;
    el.scrollLeft = left2;
  });
}
function isOrContainsNode(parent, child) {
  return parent === child || child instanceof Node && parent.contains && parent.contains(child);
}
function debounce$1(fn2, time) {
  var timeoutId;
  function cancel() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }
  function wrapper() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    cancel();
    timeoutId = setTimeout(function() {
      timeoutId = null;
      fn2.apply(void 0, args);
    }, time);
  }
  wrapper.cancel = cancel;
  return wrapper;
}
function callAllEventHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }
  return function(event) {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }
    return fns.some(function(fn2) {
      if (fn2) {
        fn2.apply(void 0, [event].concat(args));
      }
      return event.preventDownshiftDefault || event.hasOwnProperty("nativeEvent") && event.nativeEvent.preventDownshiftDefault;
    });
  };
}
function handleRefs() {
  for (var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    refs[_key4] = arguments[_key4];
  }
  return function(node) {
    refs.forEach(function(ref) {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    });
  };
}
function generateId$2() {
  return String(idCounter++);
}
function getA11yStatusMessage(_ref22) {
  var isOpen = _ref22.isOpen, resultCount = _ref22.resultCount, previousResultCount = _ref22.previousResultCount;
  if (!isOpen) {
    return "";
  }
  if (!resultCount) {
    return "No results are available.";
  }
  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select.";
  }
  return "";
}
function unwrapArray$1(arg, defaultValue) {
  arg = Array.isArray(arg) ? arg[0] : arg;
  if (!arg && defaultValue) {
    return defaultValue;
  } else {
    return arg;
  }
}
function isDOMElement(element) {
  return typeof element.type === "string";
}
function getElementProps(element) {
  return element.props;
}
var stateKeys = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function pickState(state) {
  if (state === void 0) {
    state = {};
  }
  var result = {};
  stateKeys.forEach(function(k2) {
    if (state.hasOwnProperty(k2)) {
      result[k2] = state[k2];
    }
  });
  return result;
}
function getState(state, props) {
  return Object.keys(state).reduce(function(prevState, key2) {
    prevState[key2] = isControlledProp(props, key2) ? props[key2] : state[key2];
    return prevState;
  }, {});
}
function isControlledProp(props, key2) {
  return props[key2] !== void 0;
}
function normalizeArrowKey(event) {
  var key2 = event.key, keyCode = event.keyCode;
  if (keyCode >= 37 && keyCode <= 40 && key2.indexOf("Arrow") !== 0) {
    return "Arrow" + key2;
  }
  return key2;
}
function getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  if (circular === void 0) {
    circular = true;
  }
  if (itemCount === 0) {
    return -1;
  }
  var itemsLastIndex = itemCount - 1;
  if (typeof baseIndex !== "number" || baseIndex < 0 || baseIndex >= itemCount) {
    baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
  }
  var newIndex = baseIndex + moveAmount;
  if (newIndex < 0) {
    newIndex = circular ? itemsLastIndex : 0;
  } else if (newIndex > itemsLastIndex) {
    newIndex = circular ? 0 : itemsLastIndex;
  }
  var nonDisabledNewIndex = getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);
  if (nonDisabledNewIndex === -1) {
    return baseIndex >= itemCount ? -1 : baseIndex;
  }
  return nonDisabledNewIndex;
}
function getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
  var currentElementNode = getItemNodeFromIndex(baseIndex);
  if (!currentElementNode || !currentElementNode.hasAttribute("disabled")) {
    return baseIndex;
  }
  if (moveAmount > 0) {
    for (var index2 = baseIndex + 1; index2 < itemCount; index2++) {
      if (!getItemNodeFromIndex(index2).hasAttribute("disabled")) {
        return index2;
      }
    }
  } else {
    for (var _index = baseIndex - 1; _index >= 0; _index--) {
      if (!getItemNodeFromIndex(_index).hasAttribute("disabled")) {
        return _index;
      }
    }
  }
  if (circular) {
    return moveAmount > 0 ? getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
  }
  return -1;
}
function targetWithinDownshift(target, downshiftElements, document2, checkActiveElement) {
  if (checkActiveElement === void 0) {
    checkActiveElement = true;
  }
  return downshiftElements.some(function(contextNode) {
    return contextNode && (isOrContainsNode(contextNode, target) || checkActiveElement && isOrContainsNode(contextNode, document2.activeElement));
  });
}
var cleanupStatus = debounce$1(function(documentProp) {
  getStatusDiv(documentProp).textContent = "";
}, 500);
function setStatus(status, documentProp) {
  var div = getStatusDiv(documentProp);
  if (!status) {
    return;
  }
  div.textContent = status;
  cleanupStatus(documentProp);
}
function getStatusDiv(documentProp) {
  if (documentProp === void 0) {
    documentProp = document;
  }
  var statusDiv = documentProp.getElementById("a11y-status-message");
  if (statusDiv) {
    return statusDiv;
  }
  statusDiv = documentProp.createElement("div");
  statusDiv.setAttribute("id", "a11y-status-message");
  statusDiv.setAttribute("role", "status");
  statusDiv.setAttribute("aria-live", "polite");
  statusDiv.setAttribute("aria-relevant", "additions text");
  Object.assign(statusDiv.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  });
  documentProp.body.appendChild(statusDiv);
  return statusDiv;
}
var unknown = 0;
var mouseUp = 1;
var itemMouseEnter = 2;
var keyDownArrowUp = 3;
var keyDownArrowDown = 4;
var keyDownEscape = 5;
var keyDownEnter = 6;
var keyDownHome = 7;
var keyDownEnd = 8;
var clickItem = 9;
var blurInput = 10;
var changeInput = 11;
var keyDownSpaceButton = 12;
var clickButton = 13;
var blurButton = 14;
var controlledPropUpdatedSelectedItem = 15;
var touchEnd = 16;
var stateChangeTypes = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown,
  mouseUp,
  itemMouseEnter,
  keyDownArrowUp,
  keyDownArrowDown,
  keyDownEscape,
  keyDownEnter,
  keyDownHome,
  keyDownEnd,
  clickItem,
  blurInput,
  changeInput,
  keyDownSpaceButton,
  clickButton,
  blurButton,
  controlledPropUpdatedSelectedItem,
  touchEnd
});
var Downshift = /* @__PURE__ */ function() {
  var Downshift2 = /* @__PURE__ */ function(_Component) {
    _inheritsLoose(Downshift3, _Component);
    function Downshift3(_props) {
      var _this;
      _this = _Component.call(this, _props) || this;
      _this.id = _this.props.id || "downshift-" + generateId$2();
      _this.menuId = _this.props.menuId || _this.id + "-menu";
      _this.labelId = _this.props.labelId || _this.id + "-label";
      _this.inputId = _this.props.inputId || _this.id + "-input";
      _this.getItemId = _this.props.getItemId || function(index2) {
        return _this.id + "-item-" + index2;
      };
      _this.input = null;
      _this.items = [];
      _this.itemCount = null;
      _this.previousResultCount = 0;
      _this.timeoutIds = [];
      _this.internalSetTimeout = function(fn2, time) {
        var id = setTimeout(function() {
          _this.timeoutIds = _this.timeoutIds.filter(function(i) {
            return i !== id;
          });
          fn2();
        }, time);
        _this.timeoutIds.push(id);
      };
      _this.setItemCount = function(count) {
        _this.itemCount = count;
      };
      _this.unsetItemCount = function() {
        _this.itemCount = null;
      };
      _this.setHighlightedIndex = function(highlightedIndex, otherStateToSet) {
        if (highlightedIndex === void 0) {
          highlightedIndex = _this.props.defaultHighlightedIndex;
        }
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(_extends$2({
          highlightedIndex
        }, otherStateToSet));
      };
      _this.clearSelection = function(cb) {
        _this.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: _this.props.defaultHighlightedIndex,
          isOpen: _this.props.defaultIsOpen
        }, cb);
      };
      _this.selectItem = function(item, otherStateToSet, cb) {
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(_extends$2({
          isOpen: _this.props.defaultIsOpen,
          highlightedIndex: _this.props.defaultHighlightedIndex,
          selectedItem: item,
          inputValue: _this.props.itemToString(item)
        }, otherStateToSet), cb);
      };
      _this.selectItemAtIndex = function(itemIndex, otherStateToSet, cb) {
        var item = _this.items[itemIndex];
        if (item == null) {
          return;
        }
        _this.selectItem(item, otherStateToSet, cb);
      };
      _this.selectHighlightedItem = function(otherStateToSet, cb) {
        return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
      };
      _this.internalSetState = function(stateToSet, cb) {
        var isItemSelected, onChangeArg;
        var onStateChangeArg = {};
        var isStateToSetFunction = typeof stateToSet === "function";
        if (!isStateToSetFunction && stateToSet.hasOwnProperty("inputValue")) {
          _this.props.onInputValueChange(stateToSet.inputValue, _extends$2({}, _this.getStateAndHelpers(), stateToSet));
        }
        return _this.setState(function(state) {
          state = _this.getState(state);
          var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;
          newStateToSet = _this.props.stateReducer(state, newStateToSet);
          isItemSelected = newStateToSet.hasOwnProperty("selectedItem");
          var nextState = {};
          if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) {
            onChangeArg = newStateToSet.selectedItem;
          }
          newStateToSet.type = newStateToSet.type || unknown;
          Object.keys(newStateToSet).forEach(function(key2) {
            if (state[key2] !== newStateToSet[key2]) {
              onStateChangeArg[key2] = newStateToSet[key2];
            }
            if (key2 === "type") {
              return;
            }
            newStateToSet[key2];
            if (!isControlledProp(_this.props, key2)) {
              nextState[key2] = newStateToSet[key2];
            }
          });
          if (isStateToSetFunction && newStateToSet.hasOwnProperty("inputValue")) {
            _this.props.onInputValueChange(newStateToSet.inputValue, _extends$2({}, _this.getStateAndHelpers(), newStateToSet));
          }
          return nextState;
        }, function() {
          cbToCb(cb)();
          var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
          if (hasMoreStateThanType) {
            _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
          }
          if (isItemSelected) {
            _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
          }
          if (onChangeArg !== void 0) {
            _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
          }
          _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
        });
      };
      _this.rootRef = function(node) {
        return _this._rootNode = node;
      };
      _this.getRootProps = function(_temp, _temp2) {
        var _extends2;
        var _ref6 = _temp === void 0 ? {} : _temp, _ref$refKey = _ref6.refKey, refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey, ref = _ref6.ref, rest = _objectWithoutPropertiesLoose(_ref6, ["refKey", "ref"]);
        var _ref22 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref22.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
        _this.getRootProps.called = true;
        _this.getRootProps.refKey = refKey;
        _this.getRootProps.suppressRefError = suppressRefError;
        var _this$getState = _this.getState(), isOpen = _this$getState.isOpen;
        return _extends$2((_extends2 = {}, _extends2[refKey] = handleRefs(ref, _this.rootRef), _extends2.role = "combobox", _extends2["aria-expanded"] = isOpen, _extends2["aria-haspopup"] = "listbox", _extends2["aria-owns"] = isOpen ? _this.menuId : null, _extends2["aria-labelledby"] = _this.labelId, _extends2), rest);
      };
      _this.keyDownHandlers = {
        ArrowDown: function ArrowDown(event) {
          var _this2 = this;
          event.preventDefault();
          if (this.getState().isOpen) {
            var amount = event.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowDown
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowDown
            }, function() {
              var itemCount = _this2.getItemCount();
              if (itemCount > 0) {
                var _this2$getState = _this2.getState(), highlightedIndex = _this2$getState.highlightedIndex;
                var nextHighlightedIndex = getNextWrappingIndex(1, highlightedIndex, itemCount, function(index2) {
                  return _this2.getItemNodeFromIndex(index2);
                });
                _this2.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowDown
                });
              }
            });
          }
        },
        ArrowUp: function ArrowUp(event) {
          var _this3 = this;
          event.preventDefault();
          if (this.getState().isOpen) {
            var amount = event.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(amount, {
              type: keyDownArrowUp
            });
          } else {
            this.internalSetState({
              isOpen: true,
              type: keyDownArrowUp
            }, function() {
              var itemCount = _this3.getItemCount();
              if (itemCount > 0) {
                var _this3$getState = _this3.getState(), highlightedIndex = _this3$getState.highlightedIndex;
                var nextHighlightedIndex = getNextWrappingIndex(-1, highlightedIndex, itemCount, function(index2) {
                  return _this3.getItemNodeFromIndex(index2);
                });
                _this3.setHighlightedIndex(nextHighlightedIndex, {
                  type: keyDownArrowUp
                });
              }
            });
          }
        },
        Enter: function Enter(event) {
          if (event.which === 229) {
            return;
          }
          var _this$getState2 = this.getState(), isOpen = _this$getState2.isOpen, highlightedIndex = _this$getState2.highlightedIndex;
          if (isOpen && highlightedIndex != null) {
            event.preventDefault();
            var item = this.items[highlightedIndex];
            var itemNode = this.getItemNodeFromIndex(highlightedIndex);
            if (item == null || itemNode && itemNode.hasAttribute("disabled")) {
              return;
            }
            this.selectHighlightedItem({
              type: keyDownEnter
            });
          }
        },
        Escape: function Escape(event) {
          event.preventDefault();
          this.reset(_extends$2({
            type: keyDownEscape
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      };
      _this.buttonKeyDownHandlers = _extends$2({}, _this.keyDownHandlers, {
        " ": function _(event) {
          event.preventDefault();
          this.toggleMenu({
            type: keyDownSpaceButton
          });
        }
      });
      _this.inputKeyDownHandlers = _extends$2({}, _this.keyDownHandlers, {
        Home: function Home2(event) {
          var _this4 = this;
          var _this$getState3 = this.getState(), isOpen = _this$getState3.isOpen;
          if (!isOpen) {
            return;
          }
          event.preventDefault();
          var itemCount = this.getItemCount();
          if (itemCount <= 0 || !isOpen) {
            return;
          }
          var newHighlightedIndex = getNextNonDisabledIndex(1, 0, itemCount, function(index2) {
            return _this4.getItemNodeFromIndex(index2);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownHome
          });
        },
        End: function End(event) {
          var _this5 = this;
          var _this$getState4 = this.getState(), isOpen = _this$getState4.isOpen;
          if (!isOpen) {
            return;
          }
          event.preventDefault();
          var itemCount = this.getItemCount();
          if (itemCount <= 0 || !isOpen) {
            return;
          }
          var newHighlightedIndex = getNextNonDisabledIndex(-1, itemCount - 1, itemCount, function(index2) {
            return _this5.getItemNodeFromIndex(index2);
          }, false);
          this.setHighlightedIndex(newHighlightedIndex, {
            type: keyDownEnd
          });
        }
      });
      _this.getToggleButtonProps = function(_temp3) {
        var _ref32 = _temp3 === void 0 ? {} : _temp3, onClick = _ref32.onClick;
        _ref32.onPress;
        var onKeyDown = _ref32.onKeyDown, onKeyUp = _ref32.onKeyUp, onBlur = _ref32.onBlur, rest = _objectWithoutPropertiesLoose(_ref32, ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"]);
        var _this$getState5 = _this.getState(), isOpen = _this$getState5.isOpen;
        var enabledEventHandlers = {
          onClick: callAllEventHandlers(onClick, _this.buttonHandleClick),
          onKeyDown: callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
          onKeyUp: callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
          onBlur: callAllEventHandlers(onBlur, _this.buttonHandleBlur)
        };
        var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
        return _extends$2({
          type: "button",
          role: "button",
          "aria-label": isOpen ? "close menu" : "open menu",
          "aria-haspopup": true,
          "data-toggle": true
        }, eventHandlers, rest);
      };
      _this.buttonHandleKeyUp = function(event) {
        event.preventDefault();
      };
      _this.buttonHandleKeyDown = function(event) {
        var key2 = normalizeArrowKey(event);
        if (_this.buttonKeyDownHandlers[key2]) {
          _this.buttonKeyDownHandlers[key2].call(_assertThisInitialized(_this), event);
        }
      };
      _this.buttonHandleClick = function(event) {
        event.preventDefault();
        if (_this.props.environment.document.activeElement === _this.props.environment.document.body) {
          event.target.focus();
        }
        {
          _this.internalSetTimeout(function() {
            return _this.toggleMenu({
              type: clickButton
            });
          });
        }
      };
      _this.buttonHandleBlur = function(event) {
        var blurTarget = event.target;
        _this.internalSetTimeout(function() {
          if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget) {
            _this.reset({
              type: blurButton
            });
          }
        });
      };
      _this.getLabelProps = function(props) {
        return _extends$2({
          htmlFor: _this.inputId,
          id: _this.labelId
        }, props);
      };
      _this.getInputProps = function(_temp4) {
        var _ref42 = _temp4 === void 0 ? {} : _temp4, onKeyDown = _ref42.onKeyDown, onBlur = _ref42.onBlur, onChange = _ref42.onChange, onInput = _ref42.onInput;
        _ref42.onChangeText;
        var rest = _objectWithoutPropertiesLoose(_ref42, ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"]);
        var onChangeKey;
        var eventHandlers = {};
        {
          onChangeKey = "onChange";
        }
        var _this$getState6 = _this.getState(), inputValue = _this$getState6.inputValue, isOpen = _this$getState6.isOpen, highlightedIndex = _this$getState6.highlightedIndex;
        if (!rest.disabled) {
          var _eventHandlers;
          eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
        }
        return _extends$2({
          "aria-autocomplete": "list",
          "aria-activedescendant": isOpen && typeof highlightedIndex === "number" && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
          "aria-controls": isOpen ? _this.menuId : null,
          "aria-labelledby": _this.labelId,
          autoComplete: "off",
          value: inputValue,
          id: _this.inputId
        }, eventHandlers, rest);
      };
      _this.inputHandleKeyDown = function(event) {
        var key2 = normalizeArrowKey(event);
        if (key2 && _this.inputKeyDownHandlers[key2]) {
          _this.inputKeyDownHandlers[key2].call(_assertThisInitialized(_this), event);
        }
      };
      _this.inputHandleChange = function(event) {
        _this.internalSetState({
          type: changeInput,
          isOpen: true,
          inputValue: event.target.value,
          highlightedIndex: _this.props.defaultHighlightedIndex
        });
      };
      _this.inputHandleBlur = function() {
        _this.internalSetTimeout(function() {
          var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);
          if (!_this.isMouseDown && !downshiftButtonIsActive) {
            _this.reset({
              type: blurInput
            });
          }
        });
      };
      _this.menuRef = function(node) {
        _this._menuNode = node;
      };
      _this.getMenuProps = function(_temp5, _temp6) {
        var _extends3;
        var _ref52 = _temp5 === void 0 ? {} : _temp5, _ref5$refKey = _ref52.refKey, refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey, ref = _ref52.ref, props = _objectWithoutPropertiesLoose(_ref52, ["refKey", "ref"]);
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$suppressRefErro = _ref6.suppressRefError, suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;
        _this.getMenuProps.called = true;
        _this.getMenuProps.refKey = refKey;
        _this.getMenuProps.suppressRefError = suppressRefError;
        return _extends$2((_extends3 = {}, _extends3[refKey] = handleRefs(ref, _this.menuRef), _extends3.role = "listbox", _extends3["aria-labelledby"] = props && props["aria-label"] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
      };
      _this.getItemProps = function(_temp7) {
        var _enabledEventHandlers;
        var _ref7 = _temp7 === void 0 ? {} : _temp7, onMouseMove = _ref7.onMouseMove, onMouseDown = _ref7.onMouseDown, onClick = _ref7.onClick;
        _ref7.onPress;
        var index2 = _ref7.index, _ref7$item = _ref7.item, item = _ref7$item === void 0 ? void 0 : _ref7$item, rest = _objectWithoutPropertiesLoose(_ref7, ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"]);
        if (index2 === void 0) {
          _this.items.push(item);
          index2 = _this.items.indexOf(item);
        } else {
          _this.items[index2] = item;
        }
        var onSelectKey = "onClick";
        var customClickHandler = onClick;
        var enabledEventHandlers = (_enabledEventHandlers = {
          onMouseMove: callAllEventHandlers(onMouseMove, function() {
            if (index2 === _this.getState().highlightedIndex) {
              return;
            }
            _this.setHighlightedIndex(index2, {
              type: itemMouseEnter
            });
            _this.avoidScrolling = true;
            _this.internalSetTimeout(function() {
              return _this.avoidScrolling = false;
            }, 250);
          }),
          onMouseDown: callAllEventHandlers(onMouseDown, function(event) {
            event.preventDefault();
          })
        }, _enabledEventHandlers[onSelectKey] = callAllEventHandlers(customClickHandler, function() {
          _this.selectItemAtIndex(index2, {
            type: clickItem
          });
        }), _enabledEventHandlers);
        var eventHandlers = rest.disabled ? {
          onMouseDown: enabledEventHandlers.onMouseDown
        } : enabledEventHandlers;
        return _extends$2({
          id: _this.getItemId(index2),
          role: "option",
          "aria-selected": _this.getState().highlightedIndex === index2
        }, eventHandlers, rest);
      };
      _this.clearItems = function() {
        _this.items = [];
      };
      _this.reset = function(otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(function(_ref8) {
          var selectedItem = _ref8.selectedItem;
          return _extends$2({
            isOpen: _this.props.defaultIsOpen,
            highlightedIndex: _this.props.defaultHighlightedIndex,
            inputValue: _this.props.itemToString(selectedItem)
          }, otherStateToSet);
        }, cb);
      };
      _this.toggleMenu = function(otherStateToSet, cb) {
        if (otherStateToSet === void 0) {
          otherStateToSet = {};
        }
        otherStateToSet = pickState(otherStateToSet);
        _this.internalSetState(function(_ref9) {
          var isOpen = _ref9.isOpen;
          return _extends$2({
            isOpen: !isOpen
          }, isOpen && {
            highlightedIndex: _this.props.defaultHighlightedIndex
          }, otherStateToSet);
        }, function() {
          var _this$getState7 = _this.getState(), isOpen = _this$getState7.isOpen, highlightedIndex = _this$getState7.highlightedIndex;
          if (isOpen) {
            if (_this.getItemCount() > 0 && typeof highlightedIndex === "number") {
              _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
            }
          }
          cbToCb(cb)();
        });
      };
      _this.openMenu = function(cb) {
        _this.internalSetState({
          isOpen: true
        }, cb);
      };
      _this.closeMenu = function(cb) {
        _this.internalSetState({
          isOpen: false
        }, cb);
      };
      _this.updateStatus = debounce$1(function() {
        var state = _this.getState();
        var item = _this.items[state.highlightedIndex];
        var resultCount = _this.getItemCount();
        var status = _this.props.getA11yStatusMessage(_extends$2({
          itemToString: _this.props.itemToString,
          previousResultCount: _this.previousResultCount,
          resultCount,
          highlightedItem: item
        }, state));
        _this.previousResultCount = resultCount;
        setStatus(status, _this.props.environment.document);
      }, 200);
      var _this$props = _this.props, defaultHighlightedIndex = _this$props.defaultHighlightedIndex, _this$props$initialHi = _this$props.initialHighlightedIndex, _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi, defaultIsOpen = _this$props.defaultIsOpen, _this$props$initialIs = _this$props.initialIsOpen, _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs, _this$props$initialIn = _this$props.initialInputValue, _inputValue = _this$props$initialIn === void 0 ? "" : _this$props$initialIn, _this$props$initialSe = _this$props.initialSelectedItem, _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;
      var _state = _this.getState({
        highlightedIndex: _highlightedIndex,
        isOpen: _isOpen,
        inputValue: _inputValue,
        selectedItem: _selectedItem
      });
      if (_state.selectedItem != null && _this.props.initialInputValue === void 0) {
        _state.inputValue = _this.props.itemToString(_state.selectedItem);
      }
      _this.state = _state;
      return _this;
    }
    var _proto = Downshift3.prototype;
    _proto.internalClearTimeouts = function internalClearTimeouts() {
      this.timeoutIds.forEach(function(id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    };
    _proto.getState = function getState$1(stateToMerge) {
      if (stateToMerge === void 0) {
        stateToMerge = this.state;
      }
      return getState(stateToMerge, this.props);
    };
    _proto.getItemCount = function getItemCount() {
      var itemCount = this.items.length;
      if (this.itemCount != null) {
        itemCount = this.itemCount;
      } else if (this.props.itemCount !== void 0) {
        itemCount = this.props.itemCount;
      }
      return itemCount;
    };
    _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index2) {
      return this.props.environment.document.getElementById(this.getItemId(index2));
    };
    _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
      {
        var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(node, this._menuNode);
      }
    };
    _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
      var _this6 = this;
      var itemCount = this.getItemCount();
      var _this$getState8 = this.getState(), highlightedIndex = _this$getState8.highlightedIndex;
      if (itemCount > 0) {
        var nextHighlightedIndex = getNextWrappingIndex(amount, highlightedIndex, itemCount, function(index2) {
          return _this6.getItemNodeFromIndex(index2);
        });
        this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
      }
    };
    _proto.getStateAndHelpers = function getStateAndHelpers() {
      var _this$getState9 = this.getState(), highlightedIndex = _this$getState9.highlightedIndex, inputValue = _this$getState9.inputValue, selectedItem = _this$getState9.selectedItem, isOpen = _this$getState9.isOpen;
      var itemToString2 = this.props.itemToString;
      var id = this.id;
      var getRootProps = this.getRootProps, getToggleButtonProps = this.getToggleButtonProps, getLabelProps = this.getLabelProps, getMenuProps = this.getMenuProps, getInputProps = this.getInputProps, getItemProps = this.getItemProps, openMenu = this.openMenu, closeMenu = this.closeMenu, toggleMenu = this.toggleMenu, selectItem = this.selectItem, selectItemAtIndex = this.selectItemAtIndex, selectHighlightedItem = this.selectHighlightedItem, setHighlightedIndex = this.setHighlightedIndex, clearSelection = this.clearSelection, clearItems = this.clearItems, reset = this.reset, setItemCount = this.setItemCount, unsetItemCount = this.unsetItemCount, setState = this.internalSetState;
      return {
        getRootProps,
        getToggleButtonProps,
        getLabelProps,
        getMenuProps,
        getInputProps,
        getItemProps,
        reset,
        openMenu,
        closeMenu,
        toggleMenu,
        selectItem,
        selectItemAtIndex,
        selectHighlightedItem,
        setHighlightedIndex,
        clearSelection,
        clearItems,
        setItemCount,
        unsetItemCount,
        setState,
        itemToString: itemToString2,
        id,
        highlightedIndex,
        inputValue,
        isOpen,
        selectedItem
      };
    };
    _proto.componentDidMount = function componentDidMount() {
      var _this7 = this;
      {
        var onMouseDown = function onMouseDown2() {
          _this7.isMouseDown = true;
        };
        var onMouseUp = function onMouseUp2(event) {
          _this7.isMouseDown = false;
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment.document);
          if (!contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: mouseUp
            }, function() {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        };
        var onTouchStart = function onTouchStart2() {
          _this7.isTouchMove = false;
        };
        var onTouchMove = function onTouchMove2() {
          _this7.isTouchMove = true;
        };
        var onTouchEnd = function onTouchEnd2(event) {
          var contextWithinDownshift = targetWithinDownshift(event.target, [_this7._rootNode, _this7._menuNode], _this7.props.environment.document, false);
          if (!_this7.isTouchMove && !contextWithinDownshift && _this7.getState().isOpen) {
            _this7.reset({
              type: touchEnd
            }, function() {
              return _this7.props.onOuterClick(_this7.getStateAndHelpers());
            });
          }
        };
        var environment = this.props.environment;
        environment.addEventListener("mousedown", onMouseDown);
        environment.addEventListener("mouseup", onMouseUp);
        environment.addEventListener("touchstart", onTouchStart);
        environment.addEventListener("touchmove", onTouchMove);
        environment.addEventListener("touchend", onTouchEnd);
        this.cleanup = function() {
          _this7.internalClearTimeouts();
          _this7.updateStatus.cancel();
          environment.removeEventListener("mousedown", onMouseDown);
          environment.removeEventListener("mouseup", onMouseUp);
          environment.removeEventListener("touchstart", onTouchStart);
          environment.removeEventListener("touchmove", onTouchMove);
          environment.removeEventListener("touchend", onTouchEnd);
        };
      }
    };
    _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
      var _ref10 = this.props.highlightedIndex === void 0 ? this.getState() : this.props, currentHighlightedIndex = _ref10.highlightedIndex;
      var _ref11 = prevProps.highlightedIndex === void 0 ? prevState : prevProps, prevHighlightedIndex = _ref11.highlightedIndex;
      var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
      var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
      return scrollWhenOpen || scrollWhenNavigating;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
      if (isControlledProp(this.props, "selectedItem") && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) {
        this.internalSetState({
          type: controlledPropUpdatedSelectedItem,
          inputValue: this.props.itemToString(this.props.selectedItem)
        });
      }
      if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) {
        this.scrollHighlightedItemIntoView();
      }
      {
        this.updateStatus();
      }
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cleanup();
    };
    _proto.render = function render3() {
      var children = unwrapArray$1(this.props.children, noop$2);
      this.clearItems();
      this.getRootProps.called = false;
      this.getRootProps.refKey = void 0;
      this.getRootProps.suppressRefError = void 0;
      this.getMenuProps.called = false;
      this.getMenuProps.refKey = void 0;
      this.getMenuProps.suppressRefError = void 0;
      this.getLabelProps.called = false;
      this.getInputProps.called = false;
      var element = unwrapArray$1(children(this.getStateAndHelpers()));
      if (!element) {
        return null;
      }
      if (this.getRootProps.called || this.props.suppressRefError) {
        return element;
      } else if (isDOMElement(element)) {
        return /* @__PURE__ */ cloneElement(element, this.getRootProps(getElementProps(element)));
      }
      return void 0;
    };
    return Downshift3;
  }(Component);
  Downshift2.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: false,
    getA11yStatusMessage,
    itemToString: function itemToString2(i) {
      if (i == null) {
        return "";
      }
      return String(i);
    },
    onStateChange: noop$2,
    onInputValueChange: noop$2,
    onUserAction: noop$2,
    onChange: noop$2,
    onSelect: noop$2,
    onOuterClick: noop$2,
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
      return prevItem !== item;
    },
    environment: typeof window === "undefined" ? {} : window,
    stateReducer: function stateReducer2(state, stateToSet) {
      return stateToSet;
    },
    suppressRefError: false,
    scrollIntoView
  };
  Downshift2.stateChangeTypes = stateChangeTypes;
  return Downshift2;
}();
var dropdownDefaultStateValues = {
  highlightedIndex: -1,
  isOpen: false,
  selectedItem: null,
  inputValue: ""
};
function callOnChangeProps(action, state, newState) {
  var props = action.props, type = action.type;
  var changes = {};
  Object.keys(state).forEach(function(key2) {
    invokeOnChangeHandler(key2, action, state, newState);
    if (newState[key2] !== state[key2]) {
      changes[key2] = newState[key2];
    }
  });
  if (props.onStateChange && Object.keys(changes).length) {
    props.onStateChange(_extends$2({
      type
    }, changes));
  }
}
function invokeOnChangeHandler(key2, action, state, newState) {
  var props = action.props, type = action.type;
  var handler = "on" + capitalizeString(key2) + "Change";
  if (props[handler] && newState[key2] !== void 0 && newState[key2] !== state[key2]) {
    props[handler](_extends$2({
      type
    }, newState));
  }
}
function stateReducer(s, a) {
  return a.changes;
}
function getA11ySelectionMessage(selectionParameters) {
  var selectedItem = selectionParameters.selectedItem, itemToStringLocal = selectionParameters.itemToString;
  return selectedItem ? itemToStringLocal(selectedItem) + " has been selected." : "";
}
var updateA11yStatus = debounce$1(function(getA11yMessage, document2) {
  setStatus(getA11yMessage(), document2);
}, 200);
var useIsomorphicLayoutEffect$1 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? useLayoutEffect : useEffect;
function useElementIds(_ref6) {
  var _ref$id = _ref6.id, id = _ref$id === void 0 ? "downshift-" + generateId$2() : _ref$id, labelId = _ref6.labelId, menuId = _ref6.menuId, getItemId = _ref6.getItemId, toggleButtonId = _ref6.toggleButtonId, inputId = _ref6.inputId;
  var elementIdsRef = useRef({
    labelId: labelId || id + "-label",
    menuId: menuId || id + "-menu",
    getItemId: getItemId || function(index2) {
      return id + "-item-" + index2;
    },
    toggleButtonId: toggleButtonId || id + "-toggle-button",
    inputId: inputId || id + "-input"
  });
  return elementIdsRef.current;
}
function getItemIndex(index2, item, items) {
  if (index2 !== void 0) {
    return index2;
  }
  if (items.length === 0) {
    return -1;
  }
  return items.indexOf(item);
}
function itemToString(item) {
  return item ? String(item) : "";
}
function isAcceptedCharacterKey(key2) {
  return /^\S{1}$/.test(key2);
}
function capitalizeString(string) {
  return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}
function useLatestRef(val) {
  var ref = useRef(val);
  ref.current = val;
  return ref;
}
function useEnhancedReducer(reducer2, initialState, props) {
  var prevStateRef = useRef();
  var actionRef = useRef();
  var enhancedReducer = useCallback(function(state2, action2) {
    actionRef.current = action2;
    state2 = getState(state2, action2.props);
    var changes = reducer2(state2, action2);
    var newState = action2.props.stateReducer(state2, _extends$2({}, action2, {
      changes
    }));
    return newState;
  }, [reducer2]);
  var _useReducer = useReducer(enhancedReducer, initialState), state = _useReducer[0], dispatch2 = _useReducer[1];
  var propsRef = useLatestRef(props);
  var dispatchWithProps = useCallback(function(action2) {
    return dispatch2(_extends$2({
      props: propsRef.current
    }, action2));
  }, [propsRef]);
  var action = actionRef.current;
  useEffect(function() {
    if (action && prevStateRef.current && prevStateRef.current !== state) {
      callOnChangeProps(action, getState(prevStateRef.current, action.props), state);
    }
    prevStateRef.current = state;
  }, [state, props, action]);
  return [state, dispatchWithProps];
}
function useControlledReducer(reducer2, initialState, props) {
  var _useEnhancedReducer = useEnhancedReducer(reducer2, initialState, props), state = _useEnhancedReducer[0], dispatch2 = _useEnhancedReducer[1];
  return [getState(state, props), dispatch2];
}
var defaultProps2 = {
  itemToString,
  stateReducer,
  getA11ySelectionMessage,
  scrollIntoView,
  circularNavigation: false,
  environment: typeof window === "undefined" ? {} : window
};
function getDefaultValue(props, propKey, defaultStateValues2) {
  if (defaultStateValues2 === void 0) {
    defaultStateValues2 = dropdownDefaultStateValues;
  }
  var defaultPropKey = "default" + capitalizeString(propKey);
  if (defaultPropKey in props) {
    return props[defaultPropKey];
  }
  return defaultStateValues2[propKey];
}
function getInitialValue(props, propKey, defaultStateValues2) {
  if (defaultStateValues2 === void 0) {
    defaultStateValues2 = dropdownDefaultStateValues;
  }
  if (propKey in props) {
    return props[propKey];
  }
  var initialPropKey = "initial" + capitalizeString(propKey);
  if (initialPropKey in props) {
    return props[initialPropKey];
  }
  return getDefaultValue(props, propKey, defaultStateValues2);
}
function getInitialState(props) {
  var selectedItem = getInitialValue(props, "selectedItem");
  var isOpen = getInitialValue(props, "isOpen");
  var highlightedIndex = getInitialValue(props, "highlightedIndex");
  var inputValue = getInitialValue(props, "inputValue");
  return {
    highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
    isOpen,
    selectedItem,
    inputValue
  };
}
function getHighlightedIndexOnOpen(props, state, offset2, getItemNodeFromIndex) {
  var items = props.items, initialHighlightedIndex = props.initialHighlightedIndex, defaultHighlightedIndex = props.defaultHighlightedIndex;
  var selectedItem = state.selectedItem, highlightedIndex = state.highlightedIndex;
  if (items.length === 0) {
    return -1;
  }
  if (initialHighlightedIndex !== void 0 && highlightedIndex === initialHighlightedIndex) {
    return initialHighlightedIndex;
  }
  if (defaultHighlightedIndex !== void 0) {
    return defaultHighlightedIndex;
  }
  if (selectedItem) {
    if (offset2 === 0) {
      return items.indexOf(selectedItem);
    }
    return getNextWrappingIndex(offset2, items.indexOf(selectedItem), items.length, getItemNodeFromIndex, false);
  }
  if (offset2 === 0) {
    return -1;
  }
  return offset2 < 0 ? items.length - 1 : 0;
}
function useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
  var mouseAndTouchTrackersRef = useRef({
    isMouseDown: false,
    isTouchMove: false
  });
  useEffect(function() {
    var onMouseDown = function onMouseDown2() {
      mouseAndTouchTrackersRef.current.isMouseDown = true;
    };
    var onMouseUp = function onMouseUp2(event) {
      mouseAndTouchTrackersRef.current.isMouseDown = false;
      if (isOpen && !targetWithinDownshift(event.target, downshiftElementRefs.map(function(ref) {
        return ref.current;
      }), environment.document)) {
        handleBlur();
      }
    };
    var onTouchStart = function onTouchStart2() {
      mouseAndTouchTrackersRef.current.isTouchMove = false;
    };
    var onTouchMove = function onTouchMove2() {
      mouseAndTouchTrackersRef.current.isTouchMove = true;
    };
    var onTouchEnd = function onTouchEnd2(event) {
      if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !targetWithinDownshift(event.target, downshiftElementRefs.map(function(ref) {
        return ref.current;
      }), environment.document, false)) {
        handleBlur();
      }
    };
    environment.addEventListener("mousedown", onMouseDown);
    environment.addEventListener("mouseup", onMouseUp);
    environment.addEventListener("touchstart", onTouchStart);
    environment.addEventListener("touchmove", onTouchMove);
    environment.addEventListener("touchend", onTouchEnd);
    return function cleanup() {
      environment.removeEventListener("mousedown", onMouseDown);
      environment.removeEventListener("mouseup", onMouseUp);
      environment.removeEventListener("touchstart", onTouchStart);
      environment.removeEventListener("touchmove", onTouchMove);
      environment.removeEventListener("touchend", onTouchEnd);
    };
  }, [isOpen, environment]);
  return mouseAndTouchTrackersRef;
}
var useGetterPropsCalledChecker = function useGetterPropsCalledChecker2() {
  return noop$2;
};
function useA11yMessageSetter(getA11yMessage, dependencyArray, _ref22) {
  var isInitialMount = _ref22.isInitialMount, highlightedIndex = _ref22.highlightedIndex, items = _ref22.items, environment = _ref22.environment, rest = _objectWithoutPropertiesLoose(_ref22, ["isInitialMount", "highlightedIndex", "items", "environment"]);
  useEffect(function() {
    if (isInitialMount) {
      return;
    }
    updateA11yStatus(function() {
      return getA11yMessage(_extends$2({
        highlightedIndex,
        highlightedItem: items[highlightedIndex],
        resultCount: items.length
      }, rest));
    }, environment.document);
  }, dependencyArray);
}
function useScrollIntoView(_ref32) {
  var highlightedIndex = _ref32.highlightedIndex, isOpen = _ref32.isOpen, itemRefs = _ref32.itemRefs, getItemNodeFromIndex = _ref32.getItemNodeFromIndex, menuElement = _ref32.menuElement, scrollIntoViewProp = _ref32.scrollIntoView;
  var shouldScrollRef = useRef(true);
  useIsomorphicLayoutEffect$1(function() {
    if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) {
      return;
    }
    if (shouldScrollRef.current === false) {
      shouldScrollRef.current = true;
    } else {
      scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    }
  }, [highlightedIndex]);
  return shouldScrollRef;
}
var useControlPropsValidator = noop$2;
function downshiftCommonReducer(state, action, stateChangeTypes2) {
  var type = action.type, props = action.props;
  var changes;
  switch (type) {
    case stateChangeTypes2.ItemMouseMove:
      changes = {
        highlightedIndex: action.index
      };
      break;
    case stateChangeTypes2.MenuMouseLeave:
      changes = {
        highlightedIndex: -1
      };
      break;
    case stateChangeTypes2.ToggleButtonClick:
    case stateChangeTypes2.FunctionToggleMenu:
      changes = {
        isOpen: !state.isOpen,
        highlightedIndex: state.isOpen ? -1 : getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes2.FunctionOpenMenu:
      changes = {
        isOpen: true,
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 0)
      };
      break;
    case stateChangeTypes2.FunctionCloseMenu:
      changes = {
        isOpen: false
      };
      break;
    case stateChangeTypes2.FunctionSetHighlightedIndex:
      changes = {
        highlightedIndex: action.highlightedIndex
      };
      break;
    case stateChangeTypes2.FunctionSetInputValue:
      changes = {
        inputValue: action.inputValue
      };
      break;
    case stateChangeTypes2.FunctionReset:
      changes = {
        highlightedIndex: getDefaultValue(props, "highlightedIndex"),
        isOpen: getDefaultValue(props, "isOpen"),
        selectedItem: getDefaultValue(props, "selectedItem"),
        inputValue: getDefaultValue(props, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return _extends$2({}, state, changes);
}
function getItemIndexByCharacterKey(keysSoFar, highlightedIndex, items, itemToString2, getItemNodeFromIndex) {
  var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
  for (var index2 = 0; index2 < items.length; index2++) {
    var offsetIndex = (index2 + highlightedIndex + 1) % items.length;
    if (itemToString2(items[offsetIndex]).toLowerCase().startsWith(lowerCasedKeysSoFar)) {
      var element = getItemNodeFromIndex(offsetIndex);
      if (!(element && element.hasAttribute("disabled"))) {
        return offsetIndex;
      }
    }
  }
  return highlightedIndex;
}
({
  items: PropTypes$3.array.isRequired,
  itemToString: PropTypes$3.func,
  getA11yStatusMessage: PropTypes$3.func,
  getA11ySelectionMessage: PropTypes$3.func,
  circularNavigation: PropTypes$3.bool,
  highlightedIndex: PropTypes$3.number,
  defaultHighlightedIndex: PropTypes$3.number,
  initialHighlightedIndex: PropTypes$3.number,
  isOpen: PropTypes$3.bool,
  defaultIsOpen: PropTypes$3.bool,
  initialIsOpen: PropTypes$3.bool,
  selectedItem: PropTypes$3.any,
  initialSelectedItem: PropTypes$3.any,
  defaultSelectedItem: PropTypes$3.any,
  id: PropTypes$3.string,
  labelId: PropTypes$3.string,
  menuId: PropTypes$3.string,
  getItemId: PropTypes$3.func,
  toggleButtonId: PropTypes$3.string,
  stateReducer: PropTypes$3.func,
  onSelectedItemChange: PropTypes$3.func,
  onHighlightedIndexChange: PropTypes$3.func,
  onStateChange: PropTypes$3.func,
  onIsOpenChange: PropTypes$3.func,
  environment: PropTypes$3.shape({
    addEventListener: PropTypes$3.func,
    removeEventListener: PropTypes$3.func,
    document: PropTypes$3.shape({
      getElementById: PropTypes$3.func,
      activeElement: PropTypes$3.any,
      body: PropTypes$3.any
    })
  })
});
function getA11yStatusMessage$1(_ref6) {
  var isOpen = _ref6.isOpen, resultCount = _ref6.resultCount, previousResultCount = _ref6.previousResultCount;
  if (!isOpen) {
    return "";
  }
  if (!resultCount) {
    return "No results are available.";
  }
  if (resultCount !== previousResultCount) {
    return resultCount + " result" + (resultCount === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.";
  }
  return "";
}
var defaultProps$1 = _extends$2({}, defaultProps2, {
  getA11yStatusMessage: getA11yStatusMessage$1
});
var MenuKeyDownArrowDown = 0;
var MenuKeyDownArrowUp = 1;
var MenuKeyDownEscape = 2;
var MenuKeyDownHome = 3;
var MenuKeyDownEnd = 4;
var MenuKeyDownEnter = 5;
var MenuKeyDownSpaceButton = 6;
var MenuKeyDownCharacter = 7;
var MenuBlur = 8;
var MenuMouseLeave = 9;
var ItemMouseMove = 10;
var ItemClick = 11;
var ToggleButtonClick = 12;
var ToggleButtonKeyDownArrowDown = 13;
var ToggleButtonKeyDownArrowUp = 14;
var ToggleButtonKeyDownCharacter = 15;
var FunctionToggleMenu = 16;
var FunctionOpenMenu = 17;
var FunctionCloseMenu = 18;
var FunctionSetHighlightedIndex = 19;
var FunctionSelectItem = 20;
var FunctionSetInputValue = 21;
var FunctionReset = 22;
var stateChangeTypes$1 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MenuKeyDownArrowDown,
  MenuKeyDownArrowUp,
  MenuKeyDownEscape,
  MenuKeyDownHome,
  MenuKeyDownEnd,
  MenuKeyDownEnter,
  MenuKeyDownSpaceButton,
  MenuKeyDownCharacter,
  MenuBlur,
  MenuMouseLeave,
  ItemMouseMove,
  ItemClick,
  ToggleButtonClick,
  ToggleButtonKeyDownArrowDown,
  ToggleButtonKeyDownArrowUp,
  ToggleButtonKeyDownCharacter,
  FunctionToggleMenu,
  FunctionOpenMenu,
  FunctionCloseMenu,
  FunctionSetHighlightedIndex,
  FunctionSelectItem,
  FunctionSetInputValue,
  FunctionReset
});
function downshiftSelectReducer(state, action) {
  var type = action.type, props = action.props, shiftKey = action.shiftKey;
  var changes;
  switch (type) {
    case ItemClick:
      changes = {
        isOpen: getDefaultValue(props, "isOpen"),
        highlightedIndex: getDefaultValue(props, "highlightedIndex"),
        selectedItem: props.items[action.index]
      };
      break;
    case ToggleButtonKeyDownCharacter:
      {
        var lowercasedKey = action.key;
        var inputValue = "" + state.inputValue + lowercasedKey;
        var itemIndex = getItemIndexByCharacterKey(inputValue, state.selectedItem ? props.items.indexOf(state.selectedItem) : -1, props.items, props.itemToString, action.getItemNodeFromIndex);
        changes = _extends$2({
          inputValue
        }, itemIndex >= 0 && {
          selectedItem: props.items[itemIndex]
        });
      }
      break;
    case ToggleButtonKeyDownArrowDown:
      changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
        isOpen: true
      };
      break;
    case ToggleButtonKeyDownArrowUp:
      changes = {
        highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
        isOpen: true
      };
      break;
    case MenuKeyDownEnter:
    case MenuKeyDownSpaceButton:
      changes = _extends$2({
        isOpen: getDefaultValue(props, "isOpen"),
        highlightedIndex: getDefaultValue(props, "highlightedIndex")
      }, state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex]
      });
      break;
    case MenuKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case MenuKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case MenuKeyDownEscape:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;
    case MenuBlur:
      changes = {
        isOpen: false,
        highlightedIndex: -1
      };
      break;
    case MenuKeyDownCharacter:
      {
        var _lowercasedKey = action.key;
        var _inputValue = "" + state.inputValue + _lowercasedKey;
        var highlightedIndex = getItemIndexByCharacterKey(_inputValue, state.highlightedIndex, props.items, props.itemToString, action.getItemNodeFromIndex);
        changes = _extends$2({
          inputValue: _inputValue
        }, highlightedIndex >= 0 && {
          highlightedIndex
        });
      }
      break;
    case MenuKeyDownArrowDown:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;
    case MenuKeyDownArrowUp:
      changes = {
        highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
      };
      break;
    case FunctionSelectItem:
      changes = {
        selectedItem: action.selectedItem
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$1);
  }
  return _extends$2({}, state, changes);
}
useSelect.stateChangeTypes = stateChangeTypes$1;
function useSelect(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  var props = _extends$2({}, defaultProps$1, userProps);
  var items = props.items, scrollIntoView2 = props.scrollIntoView, environment = props.environment, initialIsOpen = props.initialIsOpen, defaultIsOpen = props.defaultIsOpen, itemToString2 = props.itemToString, getA11ySelectionMessage2 = props.getA11ySelectionMessage, getA11yStatusMessage2 = props.getA11yStatusMessage;
  var initialState = getInitialState(props);
  var _useControlledReducer = useControlledReducer(downshiftSelectReducer, initialState, props), state = _useControlledReducer[0], dispatch2 = _useControlledReducer[1];
  var isOpen = state.isOpen, highlightedIndex = state.highlightedIndex, selectedItem = state.selectedItem, inputValue = state.inputValue;
  var toggleButtonRef = useRef(null);
  var menuRef = useRef(null);
  var itemRefs = useRef({});
  var shouldBlurRef = useRef(true);
  var clearTimeoutRef = useRef(null);
  var elementIds = useElementIds(props);
  var previousResultCountRef = useRef();
  var isInitialMountRef = useRef(true);
  var latest = useLatestRef({
    state,
    props
  });
  var getItemNodeFromIndex = useCallback(function(index2) {
    return itemRefs.current[elementIds.getItemId(index2)];
  }, [elementIds]);
  useA11yMessageSetter(getA11yStatusMessage2, [isOpen, highlightedIndex, inputValue, items], _extends$2({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state));
  useA11yMessageSetter(getA11ySelectionMessage2, [selectedItem], _extends$2({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state));
  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex,
    isOpen,
    itemRefs,
    scrollIntoView: scrollIntoView2,
    getItemNodeFromIndex
  });
  useEffect(function() {
    if (isInitialMountRef.current) {
      clearTimeoutRef.current = debounce$1(function(outerDispatch) {
        outerDispatch({
          type: FunctionSetInputValue,
          inputValue: ""
        });
      }, 500);
    }
    if (!inputValue) {
      return;
    }
    clearTimeoutRef.current(dispatch2);
  }, [dispatch2, inputValue]);
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props,
    state
  });
  useEffect(function() {
    if (isInitialMountRef.current) {
      if ((initialIsOpen || defaultIsOpen || isOpen) && menuRef.current) {
        menuRef.current.focus();
      }
      return;
    }
    if (isOpen) {
      if (menuRef.current) {
        menuRef.current.focus();
      }
      return;
    }
    if (environment.document.activeElement === menuRef.current) {
      if (toggleButtonRef.current) {
        shouldBlurRef.current = false;
        toggleButtonRef.current.focus();
      }
    }
  }, [isOpen]);
  useEffect(function() {
    if (isInitialMountRef.current) {
      return;
    }
    previousResultCountRef.current = items.length;
  });
  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [menuRef, toggleButtonRef], environment, function() {
    dispatch2({
      type: MenuBlur
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker();
  useEffect(function() {
    isInitialMountRef.current = false;
  }, []);
  useEffect(function() {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]);
  var toggleButtonKeyDownHandlers = useMemo(function() {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch2({
          type: ToggleButtonKeyDownArrowDown,
          getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch2({
          type: ToggleButtonKeyDownArrowUp,
          getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      }
    };
  }, [dispatch2, getItemNodeFromIndex]);
  var menuKeyDownHandlers = useMemo(function() {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch2({
          type: MenuKeyDownArrowDown,
          getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch2({
          type: MenuKeyDownArrowUp,
          getItemNodeFromIndex,
          shiftKey: event.shiftKey
        });
      },
      Home: function Home2(event) {
        event.preventDefault();
        dispatch2({
          type: MenuKeyDownHome,
          getItemNodeFromIndex
        });
      },
      End: function End(event) {
        event.preventDefault();
        dispatch2({
          type: MenuKeyDownEnd,
          getItemNodeFromIndex
        });
      },
      Escape: function Escape() {
        dispatch2({
          type: MenuKeyDownEscape
        });
      },
      Enter: function Enter(event) {
        event.preventDefault();
        dispatch2({
          type: MenuKeyDownEnter
        });
      },
      " ": function _(event) {
        event.preventDefault();
        dispatch2({
          type: MenuKeyDownSpaceButton
        });
      }
    };
  }, [dispatch2, getItemNodeFromIndex]);
  var toggleMenu = useCallback(function() {
    dispatch2({
      type: FunctionToggleMenu
    });
  }, [dispatch2]);
  var closeMenu = useCallback(function() {
    dispatch2({
      type: FunctionCloseMenu
    });
  }, [dispatch2]);
  var openMenu = useCallback(function() {
    dispatch2({
      type: FunctionOpenMenu
    });
  }, [dispatch2]);
  var setHighlightedIndex = useCallback(function(newHighlightedIndex) {
    dispatch2({
      type: FunctionSetHighlightedIndex,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch2]);
  var selectItem = useCallback(function(newSelectedItem) {
    dispatch2({
      type: FunctionSelectItem,
      selectedItem: newSelectedItem
    });
  }, [dispatch2]);
  var reset = useCallback(function() {
    dispatch2({
      type: FunctionReset
    });
  }, [dispatch2]);
  var setInputValue = useCallback(function(newInputValue) {
    dispatch2({
      type: FunctionSetInputValue,
      inputValue: newInputValue
    });
  }, [dispatch2]);
  var getLabelProps = useCallback(function(labelProps) {
    return _extends$2({
      id: elementIds.labelId,
      htmlFor: elementIds.toggleButtonId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = useCallback(function(_temp, _temp2) {
    var _extends2;
    var _ref6 = _temp === void 0 ? {} : _temp, onMouseLeave = _ref6.onMouseLeave, _ref$refKey = _ref6.refKey, refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey, onKeyDown = _ref6.onKeyDown, onBlur = _ref6.onBlur, ref = _ref6.ref, rest = _objectWithoutPropertiesLoose(_ref6, ["onMouseLeave", "refKey", "onKeyDown", "onBlur", "ref"]);
    var _ref22 = _temp2 === void 0 ? {} : _temp2;
    _ref22.suppressRefError;
    var latestState = latest.current.state;
    var menuHandleKeyDown = function menuHandleKeyDown2(event) {
      var key2 = normalizeArrowKey(event);
      if (key2 && menuKeyDownHandlers[key2]) {
        menuKeyDownHandlers[key2](event);
      } else if (isAcceptedCharacterKey(key2)) {
        dispatch2({
          type: MenuKeyDownCharacter,
          key: key2,
          getItemNodeFromIndex
        });
      }
    };
    var menuHandleBlur = function menuHandleBlur2() {
      if (shouldBlurRef.current === false) {
        shouldBlurRef.current = true;
        return;
      }
      var shouldBlur = !mouseAndTouchTrackersRef.current.isMouseDown;
      if (shouldBlur) {
        dispatch2({
          type: MenuBlur
        });
      }
    };
    var menuHandleMouseLeave = function menuHandleMouseLeave2() {
      dispatch2({
        type: MenuMouseLeave
      });
    };
    return _extends$2((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function(menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = "listbox", _extends2["aria-labelledby"] = elementIds.labelId, _extends2.tabIndex = -1, _extends2), latestState.isOpen && latestState.highlightedIndex > -1 && {
      "aria-activedescendant": elementIds.getItemId(latestState.highlightedIndex)
    }, {
      onMouseLeave: callAllEventHandlers(onMouseLeave, menuHandleMouseLeave),
      onKeyDown: callAllEventHandlers(onKeyDown, menuHandleKeyDown),
      onBlur: callAllEventHandlers(onBlur, menuHandleBlur)
    }, rest);
  }, [dispatch2, latest, menuKeyDownHandlers, mouseAndTouchTrackersRef, setGetterPropCallInfo, elementIds, getItemNodeFromIndex]);
  var getToggleButtonProps = useCallback(function(_temp3, _temp4) {
    var _extends3;
    var _ref32 = _temp3 === void 0 ? {} : _temp3, onClick = _ref32.onClick, onKeyDown = _ref32.onKeyDown, _ref3$refKey = _ref32.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, ref = _ref32.ref, rest = _objectWithoutPropertiesLoose(_ref32, ["onClick", "onKeyDown", "refKey", "ref"]);
    var _ref42 = _temp4 === void 0 ? {} : _temp4;
    _ref42.suppressRefError;
    var toggleButtonHandleClick = function toggleButtonHandleClick2() {
      dispatch2({
        type: ToggleButtonClick
      });
    };
    var toggleButtonHandleKeyDown = function toggleButtonHandleKeyDown2(event) {
      var key2 = normalizeArrowKey(event);
      if (key2 && toggleButtonKeyDownHandlers[key2]) {
        toggleButtonKeyDownHandlers[key2](event);
      } else if (isAcceptedCharacterKey(key2)) {
        dispatch2({
          type: ToggleButtonKeyDownCharacter,
          key: key2,
          getItemNodeFromIndex
        });
      }
    };
    var toggleProps = _extends$2((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function(toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends3.id = elementIds.toggleButtonId, _extends3["aria-haspopup"] = "listbox", _extends3["aria-expanded"] = latest.current.state.isOpen, _extends3["aria-labelledby"] = elementIds.labelId + " " + elementIds.toggleButtonId, _extends3), rest);
    if (!rest.disabled) {
      toggleProps.onClick = callAllEventHandlers(onClick, toggleButtonHandleClick);
      toggleProps.onKeyDown = callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
    }
    return toggleProps;
  }, [dispatch2, latest, toggleButtonKeyDownHandlers, setGetterPropCallInfo, elementIds, getItemNodeFromIndex]);
  var getItemProps = useCallback(function(_temp5) {
    var _extends4;
    var _ref52 = _temp5 === void 0 ? {} : _temp5, item = _ref52.item, index2 = _ref52.index, onMouseMove = _ref52.onMouseMove, onClick = _ref52.onClick, _ref5$refKey = _ref52.refKey, refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey, ref = _ref52.ref, rest = _objectWithoutPropertiesLoose(_ref52, ["item", "index", "onMouseMove", "onClick", "refKey", "ref"]);
    var _latest$current = latest.current, latestState = _latest$current.state, latestProps = _latest$current.props;
    var itemHandleMouseMove = function itemHandleMouseMove2() {
      if (index2 === latestState.highlightedIndex) {
        return;
      }
      shouldScrollRef.current = false;
      dispatch2({
        type: ItemMouseMove,
        index: index2
      });
    };
    var itemHandleClick = function itemHandleClick2() {
      dispatch2({
        type: ItemClick,
        index: index2
      });
    };
    var itemIndex = getItemIndex(index2, item, latestProps.items);
    if (itemIndex < 0) {
      throw new Error("Pass either item or item index in getItemProps!");
    }
    var itemProps = _extends$2((_extends4 = {
      role: "option",
      "aria-selected": "" + (itemIndex === latestState.highlightedIndex),
      id: elementIds.getItemId(itemIndex)
    }, _extends4[refKey] = handleRefs(ref, function(itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
      }
    }), _extends4), rest);
    if (!rest.disabled) {
      itemProps.onMouseMove = callAllEventHandlers(onMouseMove, itemHandleMouseMove);
      itemProps.onClick = callAllEventHandlers(onClick, itemHandleClick);
    }
    return itemProps;
  }, [dispatch2, latest, shouldScrollRef, elementIds]);
  return {
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    getItemProps,
    toggleMenu,
    openMenu,
    closeMenu,
    setHighlightedIndex,
    selectItem,
    reset,
    setInputValue,
    highlightedIndex,
    isOpen,
    selectedItem,
    inputValue
  };
}
var InputKeyDownArrowDown = 0;
var InputKeyDownArrowUp = 1;
var InputKeyDownEscape = 2;
var InputKeyDownHome = 3;
var InputKeyDownEnd = 4;
var InputKeyDownEnter = 5;
var InputChange = 6;
var InputBlur = 7;
var MenuMouseLeave$1 = 8;
var ItemMouseMove$1 = 9;
var ItemClick$1 = 10;
var ToggleButtonClick$1 = 11;
var FunctionToggleMenu$1 = 12;
var FunctionOpenMenu$1 = 13;
var FunctionCloseMenu$1 = 14;
var FunctionSetHighlightedIndex$1 = 15;
var FunctionSelectItem$1 = 16;
var FunctionSetInputValue$1 = 17;
var FunctionReset$1 = 18;
var ControlledPropUpdatedSelectedItem = 19;
var stateChangeTypes$2 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown,
  InputKeyDownArrowUp,
  InputKeyDownEscape,
  InputKeyDownHome,
  InputKeyDownEnd,
  InputKeyDownEnter,
  InputChange,
  InputBlur,
  MenuMouseLeave: MenuMouseLeave$1,
  ItemMouseMove: ItemMouseMove$1,
  ItemClick: ItemClick$1,
  ToggleButtonClick: ToggleButtonClick$1,
  FunctionToggleMenu: FunctionToggleMenu$1,
  FunctionOpenMenu: FunctionOpenMenu$1,
  FunctionCloseMenu: FunctionCloseMenu$1,
  FunctionSetHighlightedIndex: FunctionSetHighlightedIndex$1,
  FunctionSelectItem: FunctionSelectItem$1,
  FunctionSetInputValue: FunctionSetInputValue$1,
  FunctionReset: FunctionReset$1,
  ControlledPropUpdatedSelectedItem
});
function getInitialState$1(props) {
  var initialState = getInitialState(props);
  var selectedItem = initialState.selectedItem;
  var inputValue = initialState.inputValue;
  if (inputValue === "" && selectedItem && props.defaultInputValue === void 0 && props.initialInputValue === void 0 && props.inputValue === void 0) {
    inputValue = props.itemToString(selectedItem);
  }
  return _extends$2({}, initialState, {
    inputValue
  });
}
({
  items: PropTypes$3.array.isRequired,
  itemToString: PropTypes$3.func,
  getA11yStatusMessage: PropTypes$3.func,
  getA11ySelectionMessage: PropTypes$3.func,
  circularNavigation: PropTypes$3.bool,
  highlightedIndex: PropTypes$3.number,
  defaultHighlightedIndex: PropTypes$3.number,
  initialHighlightedIndex: PropTypes$3.number,
  isOpen: PropTypes$3.bool,
  defaultIsOpen: PropTypes$3.bool,
  initialIsOpen: PropTypes$3.bool,
  selectedItem: PropTypes$3.any,
  initialSelectedItem: PropTypes$3.any,
  defaultSelectedItem: PropTypes$3.any,
  inputValue: PropTypes$3.string,
  defaultInputValue: PropTypes$3.string,
  initialInputValue: PropTypes$3.string,
  id: PropTypes$3.string,
  labelId: PropTypes$3.string,
  menuId: PropTypes$3.string,
  getItemId: PropTypes$3.func,
  inputId: PropTypes$3.string,
  toggleButtonId: PropTypes$3.string,
  stateReducer: PropTypes$3.func,
  onSelectedItemChange: PropTypes$3.func,
  onHighlightedIndexChange: PropTypes$3.func,
  onStateChange: PropTypes$3.func,
  onIsOpenChange: PropTypes$3.func,
  onInputValueChange: PropTypes$3.func,
  environment: PropTypes$3.shape({
    addEventListener: PropTypes$3.func,
    removeEventListener: PropTypes$3.func,
    document: PropTypes$3.shape({
      getElementById: PropTypes$3.func,
      activeElement: PropTypes$3.any,
      body: PropTypes$3.any
    })
  })
});
function useControlledReducer$1(reducer2, initialState, props) {
  var previousSelectedItemRef = useRef();
  var _useEnhancedReducer = useEnhancedReducer(reducer2, initialState, props), state = _useEnhancedReducer[0], dispatch2 = _useEnhancedReducer[1];
  useEffect(function() {
    if (isControlledProp(props, "selectedItem")) {
      if (previousSelectedItemRef.current !== props.selectedItem) {
        dispatch2({
          type: ControlledPropUpdatedSelectedItem,
          inputValue: props.itemToString(props.selectedItem)
        });
      }
      previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
    }
  });
  return [getState(state, props), dispatch2];
}
var defaultProps$2 = _extends$2({}, defaultProps2, {
  getA11yStatusMessage,
  circularNavigation: true
});
function downshiftUseComboboxReducer(state, action) {
  var type = action.type, props = action.props, shiftKey = action.shiftKey;
  var changes;
  switch (type) {
    case ItemClick$1:
      changes = {
        isOpen: getDefaultValue(props, "isOpen"),
        highlightedIndex: getDefaultValue(props, "highlightedIndex"),
        selectedItem: props.items[action.index],
        inputValue: props.itemToString(props.items[action.index])
      };
      break;
    case InputKeyDownArrowDown:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }
      break;
    case InputKeyDownArrowUp:
      if (state.isOpen) {
        changes = {
          highlightedIndex: getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
        };
      } else {
        changes = {
          highlightedIndex: getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
          isOpen: props.items.length >= 0
        };
      }
      break;
    case InputKeyDownEnter:
      changes = _extends$2({}, state.isOpen && state.highlightedIndex >= 0 && {
        selectedItem: props.items[state.highlightedIndex],
        isOpen: getDefaultValue(props, "isOpen"),
        highlightedIndex: getDefaultValue(props, "highlightedIndex"),
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;
    case InputKeyDownEscape:
      changes = _extends$2({
        isOpen: false,
        highlightedIndex: -1
      }, !state.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case InputKeyDownHome:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputKeyDownEnd:
      changes = {
        highlightedIndex: getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
      };
      break;
    case InputBlur:
      changes = _extends$2({
        isOpen: false,
        highlightedIndex: -1
      }, state.highlightedIndex >= 0 && action.selectItem && {
        selectedItem: props.items[state.highlightedIndex],
        inputValue: props.itemToString(props.items[state.highlightedIndex])
      });
      break;
    case InputChange:
      changes = {
        isOpen: true,
        highlightedIndex: getDefaultValue(props, "highlightedIndex"),
        inputValue: action.inputValue
      };
      break;
    case FunctionSelectItem$1:
      changes = {
        selectedItem: action.selectedItem,
        inputValue: props.itemToString(action.selectedItem)
      };
      break;
    case ControlledPropUpdatedSelectedItem:
      changes = {
        inputValue: action.inputValue
      };
      break;
    default:
      return downshiftCommonReducer(state, action, stateChangeTypes$2);
  }
  return _extends$2({}, state, changes);
}
useCombobox.stateChangeTypes = stateChangeTypes$2;
function useCombobox(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  var props = _extends$2({}, defaultProps$2, userProps);
  var initialIsOpen = props.initialIsOpen, defaultIsOpen = props.defaultIsOpen, items = props.items, scrollIntoView2 = props.scrollIntoView, environment = props.environment, getA11yStatusMessage2 = props.getA11yStatusMessage, getA11ySelectionMessage2 = props.getA11ySelectionMessage, itemToString2 = props.itemToString;
  var initialState = getInitialState$1(props);
  var _useControlledReducer = useControlledReducer$1(downshiftUseComboboxReducer, initialState, props), state = _useControlledReducer[0], dispatch2 = _useControlledReducer[1];
  var isOpen = state.isOpen, highlightedIndex = state.highlightedIndex, selectedItem = state.selectedItem, inputValue = state.inputValue;
  var menuRef = useRef(null);
  var itemRefs = useRef({});
  var inputRef = useRef(null);
  var toggleButtonRef = useRef(null);
  var comboboxRef = useRef(null);
  var isInitialMountRef = useRef(true);
  var elementIds = useElementIds(props);
  var previousResultCountRef = useRef();
  var latest = useLatestRef({
    state,
    props
  });
  var getItemNodeFromIndex = useCallback(function(index2) {
    return itemRefs.current[elementIds.getItemId(index2)];
  }, [elementIds]);
  useA11yMessageSetter(getA11yStatusMessage2, [isOpen, highlightedIndex, inputValue, items], _extends$2({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state));
  useA11yMessageSetter(getA11ySelectionMessage2, [selectedItem], _extends$2({
    isInitialMount: isInitialMountRef.current,
    previousResultCount: previousResultCountRef.current,
    items,
    environment,
    itemToString: itemToString2
  }, state));
  var shouldScrollRef = useScrollIntoView({
    menuElement: menuRef.current,
    highlightedIndex,
    isOpen,
    itemRefs,
    scrollIntoView: scrollIntoView2,
    getItemNodeFromIndex
  });
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props,
    state
  });
  useEffect(function() {
    var focusOnOpen = initialIsOpen || defaultIsOpen || isOpen;
    if (focusOnOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  useEffect(function() {
    if (isInitialMountRef.current) {
      return;
    }
    previousResultCountRef.current = items.length;
  });
  var mouseAndTouchTrackersRef = useMouseAndTouchTracker(isOpen, [comboboxRef, menuRef, toggleButtonRef], environment, function() {
    dispatch2({
      type: InputBlur,
      selectItem: false
    });
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker();
  useEffect(function() {
    isInitialMountRef.current = false;
  }, []);
  useEffect(function() {
    if (!isOpen) {
      itemRefs.current = {};
    }
  }, [isOpen]);
  var inputKeyDownHandlers = useMemo(function() {
    return {
      ArrowDown: function ArrowDown(event) {
        event.preventDefault();
        dispatch2({
          type: InputKeyDownArrowDown,
          shiftKey: event.shiftKey,
          getItemNodeFromIndex
        });
      },
      ArrowUp: function ArrowUp(event) {
        event.preventDefault();
        dispatch2({
          type: InputKeyDownArrowUp,
          shiftKey: event.shiftKey,
          getItemNodeFromIndex
        });
      },
      Home: function Home2(event) {
        if (!latest.current.state.isOpen) {
          return;
        }
        event.preventDefault();
        dispatch2({
          type: InputKeyDownHome,
          getItemNodeFromIndex
        });
      },
      End: function End(event) {
        if (!latest.current.state.isOpen) {
          return;
        }
        event.preventDefault();
        dispatch2({
          type: InputKeyDownEnd,
          getItemNodeFromIndex
        });
      },
      Escape: function Escape() {
        var latestState = latest.current.state;
        if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
          dispatch2({
            type: InputKeyDownEscape
          });
        }
      },
      Enter: function Enter(event) {
        var latestState = latest.current.state;
        if (!latestState.isOpen || latestState.highlightedIndex < 0 || event.which === 229) {
          return;
        }
        event.preventDefault();
        dispatch2({
          type: InputKeyDownEnter,
          getItemNodeFromIndex
        });
      }
    };
  }, [dispatch2, latest, getItemNodeFromIndex]);
  var getLabelProps = useCallback(function(labelProps) {
    return _extends$2({
      id: elementIds.labelId,
      htmlFor: elementIds.inputId
    }, labelProps);
  }, [elementIds]);
  var getMenuProps = useCallback(function(_temp, _temp2) {
    var _extends2;
    var _ref6 = _temp === void 0 ? {} : _temp, onMouseLeave = _ref6.onMouseLeave, _ref$refKey = _ref6.refKey, refKey = _ref$refKey === void 0 ? "ref" : _ref$refKey, ref = _ref6.ref, rest = _objectWithoutPropertiesLoose(_ref6, ["onMouseLeave", "refKey", "ref"]);
    var _ref22 = _temp2 === void 0 ? {} : _temp2;
    _ref22.suppressRefError;
    return _extends$2((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function(menuNode) {
      menuRef.current = menuNode;
    }), _extends2.id = elementIds.menuId, _extends2.role = "listbox", _extends2["aria-labelledby"] = elementIds.labelId, _extends2.onMouseLeave = callAllEventHandlers(onMouseLeave, function() {
      dispatch2({
        type: MenuMouseLeave$1
      });
    }), _extends2), rest);
  }, [dispatch2, setGetterPropCallInfo, elementIds]);
  var getItemProps = useCallback(function(_temp3) {
    var _extends3, _ref42;
    var _ref32 = _temp3 === void 0 ? {} : _temp3, item = _ref32.item, index2 = _ref32.index, _ref3$refKey = _ref32.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, ref = _ref32.ref, onMouseMove = _ref32.onMouseMove, onClick = _ref32.onClick;
    _ref32.onPress;
    var rest = _objectWithoutPropertiesLoose(_ref32, ["item", "index", "refKey", "ref", "onMouseMove", "onClick", "onPress"]);
    var _latest$current = latest.current, latestProps = _latest$current.props, latestState = _latest$current.state;
    var itemIndex = getItemIndex(index2, item, latestProps.items);
    if (itemIndex < 0) {
      throw new Error("Pass either item or item index in getItemProps!");
    }
    var onSelectKey = "onClick";
    var customClickHandler = onClick;
    var itemHandleMouseMove = function itemHandleMouseMove2() {
      if (index2 === latestState.highlightedIndex) {
        return;
      }
      shouldScrollRef.current = false;
      dispatch2({
        type: ItemMouseMove$1,
        index: index2
      });
    };
    var itemHandleClick = function itemHandleClick2() {
      dispatch2({
        type: ItemClick$1,
        index: index2
      });
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };
    return _extends$2((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function(itemNode) {
      if (itemNode) {
        itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
      }
    }), _extends3.role = "option", _extends3["aria-selected"] = "" + (itemIndex === latestState.highlightedIndex), _extends3.id = elementIds.getItemId(itemIndex), _extends3), !rest.disabled && (_ref42 = {
      onMouseMove: callAllEventHandlers(onMouseMove, itemHandleMouseMove)
    }, _ref42[onSelectKey] = callAllEventHandlers(customClickHandler, itemHandleClick), _ref42), rest);
  }, [dispatch2, latest, shouldScrollRef, elementIds]);
  var getToggleButtonProps = useCallback(function(_temp4) {
    var _extends4;
    var _ref52 = _temp4 === void 0 ? {} : _temp4, onClick = _ref52.onClick;
    _ref52.onPress;
    var _ref5$refKey = _ref52.refKey, refKey = _ref5$refKey === void 0 ? "ref" : _ref5$refKey, ref = _ref52.ref, rest = _objectWithoutPropertiesLoose(_ref52, ["onClick", "onPress", "refKey", "ref"]);
    var toggleButtonHandleClick = function toggleButtonHandleClick2() {
      dispatch2({
        type: ToggleButtonClick$1
      });
      if (!latest.current.state.isOpen && inputRef.current) {
        inputRef.current.focus();
      }
    };
    return _extends$2((_extends4 = {}, _extends4[refKey] = handleRefs(ref, function(toggleButtonNode) {
      toggleButtonRef.current = toggleButtonNode;
    }), _extends4.id = elementIds.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && _extends$2({}, {
      onClick: callAllEventHandlers(onClick, toggleButtonHandleClick)
    }), rest);
  }, [dispatch2, latest, elementIds]);
  var getInputProps = useCallback(function(_temp5, _temp6) {
    var _extends5;
    var _ref6 = _temp5 === void 0 ? {} : _temp5, onKeyDown = _ref6.onKeyDown, onChange = _ref6.onChange, onInput = _ref6.onInput, onBlur = _ref6.onBlur;
    _ref6.onChangeText;
    var _ref6$refKey = _ref6.refKey, refKey = _ref6$refKey === void 0 ? "ref" : _ref6$refKey, ref = _ref6.ref, rest = _objectWithoutPropertiesLoose(_ref6, ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "refKey", "ref"]);
    var _ref7 = _temp6 === void 0 ? {} : _temp6;
    _ref7.suppressRefError;
    var latestState = latest.current.state;
    var inputHandleKeyDown = function inputHandleKeyDown2(event) {
      var key2 = normalizeArrowKey(event);
      if (key2 && inputKeyDownHandlers[key2]) {
        inputKeyDownHandlers[key2](event);
      }
    };
    var inputHandleChange = function inputHandleChange2(event) {
      dispatch2({
        type: InputChange,
        inputValue: event.target.value
      });
    };
    var inputHandleBlur = function inputHandleBlur2() {
      if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) {
        dispatch2({
          type: InputBlur,
          selectItem: true
        });
      }
    };
    var onChangeKey = "onChange";
    var eventHandlers = {};
    if (!rest.disabled) {
      var _eventHandlers;
      eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers);
    }
    return _extends$2((_extends5 = {}, _extends5[refKey] = handleRefs(ref, function(inputNode) {
      inputRef.current = inputNode;
    }), _extends5.id = elementIds.inputId, _extends5["aria-autocomplete"] = "list", _extends5["aria-controls"] = elementIds.menuId, _extends5), latestState.isOpen && latestState.highlightedIndex > -1 && {
      "aria-activedescendant": elementIds.getItemId(latestState.highlightedIndex)
    }, {
      "aria-labelledby": elementIds.labelId,
      autoComplete: "off",
      value: latestState.inputValue
    }, eventHandlers, rest);
  }, [dispatch2, inputKeyDownHandlers, latest, mouseAndTouchTrackersRef, setGetterPropCallInfo, elementIds]);
  var getComboboxProps = useCallback(function(_temp7, _temp8) {
    var _extends6;
    var _ref8 = _temp7 === void 0 ? {} : _temp7, _ref8$refKey = _ref8.refKey, refKey = _ref8$refKey === void 0 ? "ref" : _ref8$refKey, ref = _ref8.ref, rest = _objectWithoutPropertiesLoose(_ref8, ["refKey", "ref"]);
    var _ref9 = _temp8 === void 0 ? {} : _temp8;
    _ref9.suppressRefError;
    return _extends$2((_extends6 = {}, _extends6[refKey] = handleRefs(ref, function(comboboxNode) {
      comboboxRef.current = comboboxNode;
    }), _extends6.role = "combobox", _extends6["aria-haspopup"] = "listbox", _extends6["aria-owns"] = elementIds.menuId, _extends6["aria-expanded"] = latest.current.state.isOpen, _extends6), rest);
  }, [latest, setGetterPropCallInfo, elementIds]);
  var toggleMenu = useCallback(function() {
    dispatch2({
      type: FunctionToggleMenu$1
    });
  }, [dispatch2]);
  var closeMenu = useCallback(function() {
    dispatch2({
      type: FunctionCloseMenu$1
    });
  }, [dispatch2]);
  var openMenu = useCallback(function() {
    dispatch2({
      type: FunctionOpenMenu$1
    });
  }, [dispatch2]);
  var setHighlightedIndex = useCallback(function(newHighlightedIndex) {
    dispatch2({
      type: FunctionSetHighlightedIndex$1,
      highlightedIndex: newHighlightedIndex
    });
  }, [dispatch2]);
  var selectItem = useCallback(function(newSelectedItem) {
    dispatch2({
      type: FunctionSelectItem$1,
      selectedItem: newSelectedItem
    });
  }, [dispatch2]);
  var setInputValue = useCallback(function(newInputValue) {
    dispatch2({
      type: FunctionSetInputValue$1,
      inputValue: newInputValue
    });
  }, [dispatch2]);
  var reset = useCallback(function() {
    dispatch2({
      type: FunctionReset$1
    });
  }, [dispatch2]);
  return {
    getItemProps,
    getLabelProps,
    getMenuProps,
    getInputProps,
    getComboboxProps,
    getToggleButtonProps,
    toggleMenu,
    openMenu,
    closeMenu,
    setHighlightedIndex,
    setInputValue,
    selectItem,
    reset,
    highlightedIndex,
    isOpen,
    selectedItem,
    inputValue
  };
}
var defaultStateValues = {
  activeIndex: -1,
  selectedItems: []
};
function getInitialValue$1(props, propKey) {
  return getInitialValue(props, propKey, defaultStateValues);
}
function getDefaultValue$1(props, propKey) {
  return getDefaultValue(props, propKey, defaultStateValues);
}
function getInitialState$2(props) {
  var activeIndex = getInitialValue$1(props, "activeIndex");
  var selectedItems = getInitialValue$1(props, "selectedItems");
  return {
    activeIndex,
    selectedItems
  };
}
function isKeyDownOperationPermitted(event) {
  if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
    return false;
  }
  var element = event.target;
  if (element instanceof HTMLInputElement && element.value !== "" && (element.selectionStart !== 0 || element.selectionEnd !== 0)) {
    return false;
  }
  return true;
}
function getA11yRemovalMessage(selectionParameters) {
  var removedSelectedItem = selectionParameters.removedSelectedItem, itemToStringLocal = selectionParameters.itemToString;
  return itemToStringLocal(removedSelectedItem) + " has been removed.";
}
({
  selectedItems: PropTypes$3.array,
  initialSelectedItems: PropTypes$3.array,
  defaultSelectedItems: PropTypes$3.array,
  itemToString: PropTypes$3.func,
  getA11yRemovalMessage: PropTypes$3.func,
  stateReducer: PropTypes$3.func,
  activeIndex: PropTypes$3.number,
  initialActiveIndex: PropTypes$3.number,
  defaultActiveIndex: PropTypes$3.number,
  onActiveIndexChange: PropTypes$3.func,
  onSelectedItemsChange: PropTypes$3.func,
  keyNavigationNext: PropTypes$3.string,
  keyNavigationPrevious: PropTypes$3.string,
  environment: PropTypes$3.shape({
    addEventListener: PropTypes$3.func,
    removeEventListener: PropTypes$3.func,
    document: PropTypes$3.shape({
      getElementById: PropTypes$3.func,
      activeElement: PropTypes$3.any,
      body: PropTypes$3.any
    })
  })
});
var defaultProps$3 = {
  itemToString: defaultProps2.itemToString,
  stateReducer: defaultProps2.stateReducer,
  environment: defaultProps2.environment,
  getA11yRemovalMessage,
  keyNavigationNext: "ArrowRight",
  keyNavigationPrevious: "ArrowLeft"
};
var SelectedItemClick = 0;
var SelectedItemKeyDownDelete = 1;
var SelectedItemKeyDownBackspace = 2;
var SelectedItemKeyDownNavigationNext = 3;
var SelectedItemKeyDownNavigationPrevious = 4;
var DropdownKeyDownNavigationPrevious = 5;
var DropdownKeyDownBackspace = 6;
var DropdownClick = 7;
var FunctionAddSelectedItem = 8;
var FunctionRemoveSelectedItem = 9;
var FunctionSetSelectedItems = 10;
var FunctionSetActiveIndex = 11;
var FunctionReset$2 = 12;
var stateChangeTypes$3 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  SelectedItemClick,
  SelectedItemKeyDownDelete,
  SelectedItemKeyDownBackspace,
  SelectedItemKeyDownNavigationNext,
  SelectedItemKeyDownNavigationPrevious,
  DropdownKeyDownNavigationPrevious,
  DropdownKeyDownBackspace,
  DropdownClick,
  FunctionAddSelectedItem,
  FunctionRemoveSelectedItem,
  FunctionSetSelectedItems,
  FunctionSetActiveIndex,
  FunctionReset: FunctionReset$2
});
function downshiftMultipleSelectionReducer(state, action) {
  var type = action.type, index2 = action.index, props = action.props, selectedItem = action.selectedItem;
  var activeIndex = state.activeIndex, selectedItems = state.selectedItems;
  var changes;
  switch (type) {
    case SelectedItemClick:
      changes = {
        activeIndex: index2
      };
      break;
    case SelectedItemKeyDownNavigationPrevious:
      changes = {
        activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
      };
      break;
    case SelectedItemKeyDownNavigationNext:
      changes = {
        activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
      };
      break;
    case SelectedItemKeyDownBackspace:
    case SelectedItemKeyDownDelete: {
      var newActiveIndex = activeIndex;
      if (selectedItems.length === 1) {
        newActiveIndex = -1;
      } else if (activeIndex === selectedItems.length - 1) {
        newActiveIndex = selectedItems.length - 2;
      }
      changes = _extends$2({
        selectedItems: [].concat(selectedItems.slice(0, activeIndex), selectedItems.slice(activeIndex + 1))
      }, {
        activeIndex: newActiveIndex
      });
      break;
    }
    case DropdownKeyDownNavigationPrevious:
      changes = {
        activeIndex: selectedItems.length - 1
      };
      break;
    case DropdownKeyDownBackspace:
      changes = {
        selectedItems: selectedItems.slice(0, selectedItems.length - 1)
      };
      break;
    case FunctionAddSelectedItem:
      changes = {
        selectedItems: [].concat(selectedItems, [selectedItem])
      };
      break;
    case DropdownClick:
      changes = {
        activeIndex: -1
      };
      break;
    case FunctionRemoveSelectedItem: {
      var _newActiveIndex = activeIndex;
      var selectedItemIndex = selectedItems.indexOf(selectedItem);
      if (selectedItems.length === 1) {
        _newActiveIndex = -1;
      } else if (selectedItemIndex === selectedItems.length - 1) {
        _newActiveIndex = selectedItems.length - 2;
      }
      changes = _extends$2({
        selectedItems: [].concat(selectedItems.slice(0, selectedItemIndex), selectedItems.slice(selectedItemIndex + 1))
      }, {
        activeIndex: _newActiveIndex
      });
      break;
    }
    case FunctionSetSelectedItems: {
      var newSelectedItems = action.selectedItems;
      changes = {
        selectedItems: newSelectedItems
      };
      break;
    }
    case FunctionSetActiveIndex: {
      var _newActiveIndex2 = action.activeIndex;
      changes = {
        activeIndex: _newActiveIndex2
      };
      break;
    }
    case FunctionReset$2:
      changes = {
        activeIndex: getDefaultValue$1(props, "activeIndex"),
        selectedItems: getDefaultValue$1(props, "selectedItems")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return _extends$2({}, state, changes);
}
useMultipleSelection.stateChangeTypes = stateChangeTypes$3;
function useMultipleSelection(userProps) {
  if (userProps === void 0) {
    userProps = {};
  }
  var props = _extends$2({}, defaultProps$3, userProps);
  var getA11yRemovalMessage2 = props.getA11yRemovalMessage, itemToString2 = props.itemToString, environment = props.environment, keyNavigationNext = props.keyNavigationNext, keyNavigationPrevious = props.keyNavigationPrevious;
  var _useControlledReducer = useControlledReducer(downshiftMultipleSelectionReducer, getInitialState$2(props), props), state = _useControlledReducer[0], dispatch2 = _useControlledReducer[1];
  var activeIndex = state.activeIndex, selectedItems = state.selectedItems;
  var isInitialMountRef = useRef(true);
  var dropdownRef = useRef(null);
  var previousSelectedItemsRef = useRef(selectedItems);
  var selectedItemRefs = useRef();
  selectedItemRefs.current = [];
  var latest = useLatestRef({
    state,
    props
  });
  useEffect(function() {
    if (isInitialMountRef.current) {
      return;
    }
    if (selectedItems.length < previousSelectedItemsRef.current.length) {
      var removedSelectedItem = previousSelectedItemsRef.current.find(function(item) {
        return selectedItems.indexOf(item) < 0;
      });
      setStatus(getA11yRemovalMessage2({
        itemToString: itemToString2,
        resultCount: selectedItems.length,
        removedSelectedItem,
        activeIndex,
        activeSelectedItem: selectedItems[activeIndex]
      }), environment.document);
    }
    previousSelectedItemsRef.current = selectedItems;
  }, [selectedItems.length]);
  useEffect(function() {
    if (isInitialMountRef.current) {
      return;
    }
    if (activeIndex === -1 && dropdownRef.current) {
      dropdownRef.current.focus();
    } else if (selectedItemRefs.current[activeIndex]) {
      selectedItemRefs.current[activeIndex].focus();
    }
  }, [activeIndex]);
  useControlPropsValidator({
    isInitialMount: isInitialMountRef.current,
    props,
    state
  });
  var setGetterPropCallInfo = useGetterPropsCalledChecker();
  useEffect(function() {
    isInitialMountRef.current = false;
  }, []);
  var selectedItemKeyDownHandlers = useMemo(function() {
    var _ref6;
    return _ref6 = {}, _ref6[keyNavigationPrevious] = function() {
      dispatch2({
        type: SelectedItemKeyDownNavigationPrevious
      });
    }, _ref6[keyNavigationNext] = function() {
      dispatch2({
        type: SelectedItemKeyDownNavigationNext
      });
    }, _ref6.Delete = function Delete() {
      dispatch2({
        type: SelectedItemKeyDownDelete
      });
    }, _ref6.Backspace = function Backspace() {
      dispatch2({
        type: SelectedItemKeyDownBackspace
      });
    }, _ref6;
  }, [dispatch2, keyNavigationNext, keyNavigationPrevious]);
  var dropdownKeyDownHandlers = useMemo(function() {
    var _ref22;
    return _ref22 = {}, _ref22[keyNavigationPrevious] = function(event) {
      if (isKeyDownOperationPermitted(event)) {
        dispatch2({
          type: DropdownKeyDownNavigationPrevious
        });
      }
    }, _ref22.Backspace = function Backspace(event) {
      if (isKeyDownOperationPermitted(event)) {
        dispatch2({
          type: DropdownKeyDownBackspace
        });
      }
    }, _ref22;
  }, [dispatch2, keyNavigationPrevious]);
  var getSelectedItemProps = useCallback(function(_temp) {
    var _extends2;
    var _ref32 = _temp === void 0 ? {} : _temp, _ref3$refKey = _ref32.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, ref = _ref32.ref, onClick = _ref32.onClick, onKeyDown = _ref32.onKeyDown, selectedItem = _ref32.selectedItem, index2 = _ref32.index, rest = _objectWithoutPropertiesLoose(_ref32, ["refKey", "ref", "onClick", "onKeyDown", "selectedItem", "index"]);
    var latestState = latest.current.state;
    var itemIndex = getItemIndex(index2, selectedItem, latestState.selectedItems);
    if (itemIndex < 0) {
      throw new Error("Pass either selectedItem or index in getSelectedItemProps!");
    }
    var selectedItemHandleClick = function selectedItemHandleClick2() {
      dispatch2({
        type: SelectedItemClick,
        index: index2
      });
    };
    var selectedItemHandleKeyDown = function selectedItemHandleKeyDown2(event) {
      var key2 = normalizeArrowKey(event);
      if (key2 && selectedItemKeyDownHandlers[key2]) {
        selectedItemKeyDownHandlers[key2](event);
      }
    };
    return _extends$2((_extends2 = {}, _extends2[refKey] = handleRefs(ref, function(selectedItemNode) {
      if (selectedItemNode) {
        selectedItemRefs.current.push(selectedItemNode);
      }
    }), _extends2.tabIndex = index2 === latestState.activeIndex ? 0 : -1, _extends2.onClick = callAllEventHandlers(onClick, selectedItemHandleClick), _extends2.onKeyDown = callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown), _extends2), rest);
  }, [dispatch2, latest, selectedItemKeyDownHandlers]);
  var getDropdownProps = useCallback(function(_temp2, _temp3) {
    var _extends3;
    var _ref42 = _temp2 === void 0 ? {} : _temp2, _ref4$refKey = _ref42.refKey, refKey = _ref4$refKey === void 0 ? "ref" : _ref4$refKey, ref = _ref42.ref, onKeyDown = _ref42.onKeyDown, onClick = _ref42.onClick, _ref4$preventKeyActio = _ref42.preventKeyAction, preventKeyAction = _ref4$preventKeyActio === void 0 ? false : _ref4$preventKeyActio, rest = _objectWithoutPropertiesLoose(_ref42, ["refKey", "ref", "onKeyDown", "onClick", "preventKeyAction"]);
    var _ref52 = _temp3 === void 0 ? {} : _temp3;
    _ref52.suppressRefError;
    var dropdownHandleKeyDown = function dropdownHandleKeyDown2(event) {
      var key2 = normalizeArrowKey(event);
      if (key2 && dropdownKeyDownHandlers[key2]) {
        dropdownKeyDownHandlers[key2](event);
      }
    };
    var dropdownHandleClick = function dropdownHandleClick2() {
      dispatch2({
        type: DropdownClick
      });
    };
    return _extends$2((_extends3 = {}, _extends3[refKey] = handleRefs(ref, function(dropdownNode) {
      if (dropdownNode) {
        dropdownRef.current = dropdownNode;
      }
    }), _extends3), !preventKeyAction && {
      onKeyDown: callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
      onClick: callAllEventHandlers(onClick, dropdownHandleClick)
    }, rest);
  }, [dispatch2, dropdownKeyDownHandlers, setGetterPropCallInfo]);
  var addSelectedItem = useCallback(function(selectedItem) {
    dispatch2({
      type: FunctionAddSelectedItem,
      selectedItem
    });
  }, [dispatch2]);
  var removeSelectedItem = useCallback(function(selectedItem) {
    dispatch2({
      type: FunctionRemoveSelectedItem,
      selectedItem
    });
  }, [dispatch2]);
  var setSelectedItems = useCallback(function(newSelectedItems) {
    dispatch2({
      type: FunctionSetSelectedItems,
      selectedItems: newSelectedItems
    });
  }, [dispatch2]);
  var setActiveIndex = useCallback(function(newActiveIndex) {
    dispatch2({
      type: FunctionSetActiveIndex,
      activeIndex: newActiveIndex
    });
  }, [dispatch2]);
  var reset = useCallback(function() {
    dispatch2({
      type: FunctionReset$2
    });
  }, [dispatch2]);
  return {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    setSelectedItems,
    setActiveIndex,
    reset,
    selectedItems,
    activeIndex
  };
}
const size$a = ({
  size: size2,
  theme
}) => {
  switch (size2) {
    case "lg":
      return /* @__PURE__ */ css(typography$1("body3", {
        theme
      }), ";", padding("xs", {
        theme
      }), ";");
    default:
      return /* @__PURE__ */ css(typography$1("body2", {
        theme
      }), ";", padding("xxs", {
        theme
      }), ";");
  }
};
const kind$5 = ({
  kind: kind2,
  theme,
  valid: valid2
}) => {
  switch (kind2) {
    case "ghost":
      return /* @__PURE__ */ css("border:none;color:", color("pewter", {
        theme
      }), ";", fontWeight("medium", {
        theme
      }), ";&:hover{background-color:", transparentize("slate", 0.08, {
        theme
      }), ";}");
    default:
      return /* @__PURE__ */ css("border:1px solid ", color(valid2 ? "silver" : "red", {
        theme
      }), ";[aria-expanded='true'] &{border:1px solid ", color("slate", {
        theme
      }), ";}");
  }
};
const Input$2 = createStyled("input", {
  target: "euyrevo0"
})("width:100%;transition:all 0.3s ease 0s;outline-color:", color("slate"), ";", borderRadius$1("default"), ";", typography$1("body2"), ";", size$a, ";", kind$5, ";[aria-expanded='true'] &{color:", color("white"), ";background-color:", color("slate"), ";outline:none;&::placeholder{color:", color("white"), ";}}&:active{border-color:", color("slate"), ";}&:focus{outline-color:", color("slate"), ";outline-offset:-2px;}&:not([disabled]){cursor:pointer;&:focus{cursor:text;}}&[disabled]{cursor:not-allowed;color:", color("cadet"), ";background:", color("offWhite"), ";border:1px solid ", color("paleGrey"), ";}&::placeholder{color:", color("cadet"), ";opacity:1;", fontWeight("regular"), ";}");
const InputContainer = createStyled("div", {
  target: "eltkgwi0"
})({
  name: "79elbk",
  styles: "position:relative;"
});
const stopStart = ({
  dark: dark2,
  size: size2,
  theme
}) => {
  switch (size2) {
    case "sm":
      return {
        stopColor: color(dark2 ? "white" : "pewter", {
          theme
        })
      };
    default:
      return {
        stopColor: gradientEnd("green", {
          theme
        })
      };
  }
};
const stopEnd = ({
  dark: dark2,
  size: size2,
  theme
}) => {
  switch (size2) {
    case "sm":
      return {
        stopColor: color(dark2 ? "white" : "pewter", {
          theme
        }),
        stopOpacity: 0.75
      };
    default:
      return {
        stopColor: gradientStart("green", {
          theme
        })
      };
  }
};
const properties = (bar) => bar ? {
  x1: "0%",
  y1: "0%",
  x2: "100%",
  y2: "0%",
  gradientUnits: "userSpaceOnUse"
} : {
  x1: "15.996%",
  y1: "100%",
  y2: "15.004%"
};
const Gradient = (_K) => {
  var _L = _K, {
    dark: dark2,
    size: size2,
    bar,
    theme
  } = _L, rest = __objRest(_L, [
    "dark",
    "size",
    "bar",
    "theme"
  ]);
  return /* @__PURE__ */ jsxs("linearGradient", __spreadProps(__spreadValues(__spreadValues({}, properties(bar)), rest), {
    children: [/* @__PURE__ */ jsx("stop", __spreadValues({
      offset: "0%"
    }, stopStart({
      dark: dark2,
      size: size2,
      theme
    }))), /* @__PURE__ */ jsx("stop", __spreadValues({
      offset: "100%"
    }, stopEnd({
      dark: dark2,
      size: size2,
      theme
    })))]
  }));
};
Gradient.displayName = "Loader.Gradient";
const dimensions = ({
  size: size2,
  bar
}) => {
  if (bar) {
    return {
      preserveAspectRatio: "none",
      width: "100%"
    };
  }
  switch (size2) {
    case "sm":
      return {
        width: 24,
        height: 24
      };
    case "lg":
      return {
        width: 56,
        height: 56
      };
    default:
      return {
        width: 36,
        height: 36
      };
  }
};
const viewBox = (bar) => bar ? "0 0 100 1" : "0 0 36 36";
const SVG = (_M) => {
  var _N = _M, {
    children,
    size: size2,
    bar
  } = _N, props = __objRest(_N, [
    "children",
    "size",
    "bar"
  ]);
  return /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues(__spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: viewBox(bar)
  }, dimensions({
    size: size2,
    bar
  })), props), {
    children
  }));
};
SVG.displayName = "Loader.SVG";
const BarRail = (props) => /* @__PURE__ */ jsx("path", __spreadValues({
  d: "M 0,0.5 L 100,0.5",
  strokeWidth: "1"
}, props));
const RadialRail = (props) => /* @__PURE__ */ jsx("circle", __spreadValues({
  cx: "18",
  cy: "18",
  r: "16.5",
  strokeWidth: "3"
}, props));
const Rail = ({
  dark: dark2,
  size: size2,
  bar,
  theme
}) => {
  const props = {};
  if (size2 === "sm") {
    props.stroke = color(dark2 ? "white" : "pewter", {
      theme
    });
    props.opacity = 0.3;
  } else {
    props.stroke = color(dark2 ? "slate" : "paleGrey", {
      theme
    });
  }
  return bar ? /* @__PURE__ */ jsx(BarRail, __spreadValues({}, props)) : /* @__PURE__ */ jsx(RadialRail, __spreadValues({}, props));
};
Rail.displayName = "Loader.Rail";
const Indefinite = (_O) => {
  var _P = _O, {
    bar
  } = _P, rest = __objRest(_P, [
    "bar"
  ]);
  return bar ? /* @__PURE__ */ jsxs("path", __spreadProps(__spreadValues({
    d: "M 0,0.5 L 100,0.5",
    strokeWidth: "3"
  }, rest), {
    children: [/* @__PURE__ */ jsx("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "translate",
      dur: "1.2s",
      values: "0,0.5; 25,0.5; 100,0.5",
      repeatCount: "indefinite"
    }), /* @__PURE__ */ jsx("animateTransform", {
      attributeType: "xml",
      attributeName: "transform",
      type: "scale",
      dur: "1.2s",
      values: "0.1;0.75;0.1",
      repeatCount: "indefinite",
      additive: "sum"
    })]
  })) : /* @__PURE__ */ jsx("path", __spreadProps(__spreadValues({
    d: "M 18,18 m 0,-16.5 a 16.5,16.5 0 1 1 0,33",
    strokeWidth: "3"
  }, rest), {
    children: /* @__PURE__ */ jsx("animateTransform", {
      attributeName: "transform",
      type: "rotate",
      dur: "1.4s",
      repeatCount: "indefinite",
      from: "0 18 18",
      to: "360 18 18"
    })
  }));
};
const radialLength = 104;
const Percentage = (_Q) => {
  var _R = _Q, {
    bar,
    percentage
  } = _R, rest = __objRest(_R, [
    "bar",
    "percentage"
  ]);
  const ratio = percentage / 100;
  const dashLength = bar ? 100 : radialLength;
  const path = bar ? "M 0,0.5 L 100,0.5" : "M 18,18 m 0,-16.5 a 16.5,16.5 0 1 1 0,33 a 16.5,16.5 0 1 1 0,-33";
  return /* @__PURE__ */ jsx("path", __spreadValues({
    d: path,
    strokeWidth: "3",
    strokeDasharray: dashLength,
    strokeDashoffset: dashLength - dashLength * ratio
  }, rest));
};
let counter = 0;
const LoaderImage = (_S) => {
  var _T = _S, {
    dark: dark2,
    theme,
    size: size2,
    bar,
    percentage = null
  } = _T, props = __objRest(_T, [
    "dark",
    "theme",
    "size",
    "bar",
    "percentage"
  ]);
  const loaderGradientId = `stylist-loader-gradient-${++counter}`;
  return /* @__PURE__ */ jsxs(SVG, __spreadProps(__spreadValues({
    size: size2,
    bar,
    role: "img",
    "data-testid": "loader"
  }, props), {
    children: [/* @__PURE__ */ jsx(Gradient, {
      id: loaderGradientId,
      dark: dark2,
      size: size2,
      bar,
      theme
    }), /* @__PURE__ */ jsxs("g", {
      fill: "none",
      children: [/* @__PURE__ */ jsx(Rail, {
        theme,
        dark: dark2,
        size: size2,
        bar
      }), percentage !== null ? /* @__PURE__ */ jsx(Percentage, {
        stroke: `url(#${loaderGradientId})`,
        bar,
        percentage
      }) : /* @__PURE__ */ jsx(Indefinite, {
        stroke: `url(#${loaderGradientId})`,
        bar
      })]
    })]
  }));
};
const CenteredContainer = createStyled("div", {
  target: "e1j8kq5w0"
})({
  name: "r20d3a",
  styles: "height:100%;display:flex;align-items:center;justify-content:center;"
});
const Loader$1 = (_U) => {
  var _V = _U, {
    centered
  } = _V, props = __objRest(_V, [
    "centered"
  ]);
  return centered ? /* @__PURE__ */ jsx(CenteredContainer, {
    children: /* @__PURE__ */ jsx(LoaderImage, __spreadValues({}, props))
  }) : /* @__PURE__ */ jsx(LoaderImage, __spreadValues({}, props));
};
var Loader$2 = withTheme(Loader$1);
var _ref$g = {
  name: "1rgczi2",
  styles: "width:24px;height:24px;right:2.5rem;"
};
var _ref2$a = {
  name: "1it4r02",
  styles: "width:20px;height:20px;right:2rem;"
};
const size$9 = ({
  loaderSize,
  theme
}) => {
  switch (loaderSize) {
    case "lg":
      return _ref$g;
    default:
      return _ref2$a;
  }
};
const AutocompleteLoader = /* @__PURE__ */ createStyled((_W) => {
  var _X = _W, {
    loaderSize
  } = _X, props = __objRest(_X, [
    "loaderSize"
  ]);
  return /* @__PURE__ */ jsx(Loader$2, __spreadValues({}, props));
}, {
  target: "eimawdo0"
})("position:absolute;top:50%;transform:translateY(-50%);", size$9, ";");
var Loader = withProps$1(({
  size: size2
}) => ({
  loaderSize: size2,
  size: "sm"
}))(AutocompleteLoader);
const selectedCss = ({
  selected,
  theme
}) => selected && /* @__PURE__ */ css("background-color:", style("listbox.selectedBackground", {
  theme
}), ";", fontWeight("medium", {
  theme
}), "");
const focusedCss = ({
  focused,
  theme
}) => focused && /* @__PURE__ */ css("background-color:", style("listbox.focusedBackground", {
  theme
}), ";");
const disabledCss = ({
  disabled,
  theme
}) => disabled && /* @__PURE__ */ css("pointer-events:none;color:", style("listbox.disabledColor", {
  theme
}), ";");
var _ref$f = {
  name: "4g6ai3",
  styles: "cursor:pointer;"
};
const pointerCss = ({
  pointer
}) => pointer && _ref$f;
const sizeCss = ({
  size: size2,
  theme
}) => {
  switch (size2) {
    case "lg":
      return /* @__PURE__ */ css(typography$1("body3", {
        theme
      }), ";", padding("xs", {
        theme
      }), ";");
    default:
      return /* @__PURE__ */ css(padding("xxs", {
        theme
      }), ";");
  }
};
const Item$4 = /* @__PURE__ */ createStyled("li", {
  target: "ez8x3c80"
})("display:block;padding:", spacer(2), " ", spacer(3), ";&:hover{background-color:", style("listbox.hoverBackground"), ";}", selectedCss, " ", focusedCss, " ", disabledCss, " ", pointerCss, " ", sizeCss, "");
const maxHeightCss = ({
  maxHeight
}) => /* @__PURE__ */ css("max-height:", maxHeight || "275px", ";");
const minWidthCss = ({
  minWidth
}) => /* @__PURE__ */ css("min-width:", minWidth || "200px", ";");
var _ref$e = {
  name: "gyp8mm",
  styles: "visibility:hidden;"
};
const closedCss = ({
  closed
}) => closed && _ref$e;
const ListBox = /* @__PURE__ */ createStyled("ul", {
  target: "e1dy2ip70"
})("list-style:none;background-color:", color("white"), ";margin:", spacer(1), " 0 0 0;padding:", spacer(1), " 0;overflow-y:auto;", maxHeightCss, " ", minWidthCss, " ", closedCss, " ", shadow$1("distant"), ";", borderRadius$1("default"), ";");
ListBox.Item = Item$4;
const Item$3 = /* @__PURE__ */ createStyled(ListBox.Item, {
  target: "e2v1xsz0"
})({
  name: "1lekzkb",
  styles: "display:flex;align-items:center;justify-content:space-between;"
});
const iconSize = (size2) => {
  switch (size2) {
    case "lg":
      return "25px";
    default:
      return "16px";
  }
};
const Option = React__default.forwardRef((_Y, ref) => {
  var _Z = _Y, {
    children,
    selected,
    size: size2
  } = _Z, props = __objRest(_Z, [
    "children",
    "selected",
    "size"
  ]);
  const theme = useTheme();
  return /* @__PURE__ */ jsxs(Item$3, __spreadProps(__spreadValues({
    ref,
    selected,
    size: size2,
    pointer: true
  }, props), {
    children: [children, selected && /* @__PURE__ */ jsx(Check, {
      style: {
        flexShrink: 0
      },
      size: iconSize(size2),
      color: style("dropdown.checkIconColor", {
        theme
      })
    })]
  }));
});
Option.displayName = "Dropdown.Option";
const Autocomplete = ({
  dataSource: DataSource,
  disabled,
  idValue,
  kind: kind2,
  name,
  onChange,
  formatItem,
  placeholder,
  size: size2,
  valid: valid2,
  value,
  width
}) => /* @__PURE__ */ jsx(Downshift, {
  itemToString: (item) => item ? formatItem(item) : "",
  onChange,
  selectedItem: value,
  inputId: name,
  children: ({
    getRootProps,
    getInputProps,
    getItemProps,
    getMenuProps,
    highlightedIndex,
    isOpen,
    inputValue,
    openMenu,
    selectedItem
  }) => /* @__PURE__ */ jsx(Container$j, __spreadProps(__spreadValues({
    width
  }, getRootProps()), {
    children: /* @__PURE__ */ jsx(DataSource, {
      inputValue,
      children: ({
        loading,
        items
      }) => /* @__PURE__ */ jsxs(Fragment$2, {
        children: [/* @__PURE__ */ jsxs(InputContainer, {
          children: [/* @__PURE__ */ jsx(Input$2, __spreadValues({
            type: "text",
            placeholder,
            size: size2,
            kind: kind2,
            valid: valid2
          }, getInputProps({
            disabled,
            autoComplete: "off",
            onFocus: openMenu
          }))), loading && /* @__PURE__ */ jsx(Loader, {
            dark: isOpen,
            size: size2
          }), /* @__PURE__ */ jsx(Caret$1, {
            size: "8px",
            fill: "cadet"
          })]
        }), isOpen && /* @__PURE__ */ jsx(ListBox, __spreadProps(__spreadValues({
          "data-testid": "autocomplete-menu"
        }, getMenuProps()), {
          children: loading ? /* @__PURE__ */ jsx(Option, {
            disabled: true,
            size: size2,
            children: "Loading..."
          }) : !inputValue && items.length === 0 ? /* @__PURE__ */ jsx(Option, {
            disabled: true,
            size: size2,
            children: "Type to search"
          }) : inputValue && items.length === 0 ? /* @__PURE__ */ jsx(Option, {
            disabled: true,
            size: size2,
            children: "No items"
          }) : items.map((item, idx) => /* @__PURE__ */ jsx(Option, __spreadProps(__spreadValues({
            size: size2,
            selected: selectedItem === item,
            focused: highlightedIndex === idx
          }, getItemProps({
            key: idValue(item),
            item
          })), {
            children: formatItem(item)
          }), idx))
        }))]
      })
    })
  }))
});
Autocomplete.defaultProps = {
  idValue: (item) => item.id,
  placeholder: "Select...",
  valid: true
};
const size$8 = "29px";
const avatarUrlCss = ({
  avatarUrl
}) => avatarUrl ? /* @__PURE__ */ css("background:url(", avatarUrl, ");background-repeat:no-repeat;background-size:cover;") : null;
const Container$i = createStyled("div", {
  target: "evg9tqh0"
})("display:flex;justify-content:center;align-items:center;border-radius:50%;width:", size$8, ";height:", size$8, ";", typography$1("body2Medium"), ";", ({
  light,
  theme
}) => /* @__PURE__ */ css("background-color:", light ? color("paleGrey", {
  theme
}) : color("slate", {
  theme
}), ";color:", light ? transparentize("cadet", 0.5, {
  theme
}) : color("cadet", {
  theme
}), ";border:1px solid ", light ? color("paleGrey", {
  theme
}) : color("slate", {
  theme
}), ";"), ";", avatarUrlCss, ";");
Container$i.displayName = "Avatar.Container";
var propTypes$2 = { exports: {} };
function makeEmptyFunction$1(arg) {
  return function() {
    return arg;
  };
}
var emptyFunction$4 = function emptyFunction() {
};
emptyFunction$4.thatReturns = makeEmptyFunction$1;
emptyFunction$4.thatReturnsFalse = makeEmptyFunction$1(false);
emptyFunction$4.thatReturnsTrue = makeEmptyFunction$1(true);
emptyFunction$4.thatReturnsNull = makeEmptyFunction$1(null);
emptyFunction$4.thatReturnsThis = function() {
  return this;
};
emptyFunction$4.thatReturnsArgument = function(arg) {
  return arg;
};
var emptyFunction_1$1 = emptyFunction$4;
function invariant$4(condition, format, a, b2, c2, d2, e2, f2) {
  if (!condition) {
    var error;
    if (format === void 0) {
      error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    } else {
      var args = [a, b2, c2, d2, e2, f2];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function() {
        return args[argIndex++];
      }));
      error.name = "Invariant Violation";
    }
    error.framesToPop = 1;
    throw error;
  }
}
var invariant_1$1 = invariant$4;
var ReactPropTypesSecret$4 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1$2 = ReactPropTypesSecret$4;
var emptyFunction$3 = emptyFunction_1$1;
var invariant$2 = invariant_1$1;
var ReactPropTypesSecret$3 = ReactPropTypesSecret_1$2;
var factoryWithThrowingShims$2 = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$3) {
      return;
    }
    invariant$2(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };
  ReactPropTypes.checkPropTypes = emptyFunction$3;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes$2.exports = factoryWithThrowingShims$2();
}
var PropTypes$2 = propTypes$2.exports;
const nameOrEmailInitials = ({
  firstName,
  lastName,
  email
}) => {
  if (firstName || lastName) {
    return [firstName, lastName].filter((val) => Boolean(val)).map((val) => val[0]).join("").toUpperCase();
  }
  if (email) {
    return email[0].toUpperCase();
  }
  return "?";
};
const Avatar$1 = ({
  firstName,
  lastName,
  email,
  light,
  avatarUrl
}) => /* @__PURE__ */ jsx(Container$i, {
  light,
  avatarUrl,
  children: avatarUrl ? null : nameOrEmailInitials({
    firstName,
    lastName,
    email
  })
});
Avatar$1.propTypes = {
  firstName: PropTypes$2.string,
  lastName: PropTypes$2.string,
  light: PropTypes$2.bool,
  email: PropTypes$2.string,
  avatarUrl: PropTypes$2.string
};
Avatar$1.defaultProps = {
  firstName: "",
  lastName: "",
  email: "",
  light: false,
  avatarUrl: ""
};
const variant = (colorName, theme) => /* @__PURE__ */ css("color:", color(colorName, {
  theme
}), ";background-color:", transparentize(colorName, 0.1, {
  theme
}), ";");
const solidVariant = (colorName, theme) => /* @__PURE__ */ css("color:", color("white", {
  theme
}), ";background-color:", color(colorName, {
  theme
}), ";");
const kind$4 = ({
  kind: kind2,
  theme
}) => {
  switch (kind2) {
    case "draft":
      return variant("darkPurple", theme);
    case "live":
      return variant("forest", theme);
    case "closed":
      return variant("ocean", theme);
    case "archived":
      return variant("pewter", theme);
    case "pro":
      return solidVariant("darkOcean", theme);
  }
};
const colorStyles = ({
  kind: kind2,
  color: color2,
  solid,
  theme
}) => kind2 ? "" : solid ? solidVariant(color2, theme) : variant(color2, theme);
const Badge$1 = createStyled("span", {
  target: "e1f9b1kq0"
})("display:inline-block;border-radius:10rem;vertical-align:middle;", padding("xxxs"), ";", typography$1("subheading1"), ";", colorStyles, ";", kind$4, ";");
Badge$1.defaultProps = {
  color: "slate"
};
const kind$3 = ({
  dark: dark2,
  kind: kind2,
  theme
}) => {
  let styles2;
  if (dark2) {
    styles2 = style(`button.${kind2}Dark`, {
      theme
    });
  }
  if (!styles2) {
    styles2 = style(`button.${kind2}`, {
      theme
    });
  }
  if (!styles2)
    return;
  return /* @__PURE__ */ css("color:", styles2.color, ";background:", styles2.background, ";border-color:", styles2.border, ";&:hover,&:focus-visible,&.focus-visible{color:", styles2.hoverColor, ";background:", styles2.hoverBackground, ";border-color:", styles2.hoverBorder, ";}&:active{color:", styles2.activeColor, ";background:", styles2.activeBackground, ";border-color:", styles2.activeBorder, ";}&:disabled{color:", styles2.disabledColor, ";background:", styles2.disabledBackground, ";border-color:", styles2.disabledBorder, ";}");
};
const size$7 = ({
  size: size2,
  theme
}) => {
  switch (size2) {
    case "lg":
      return /* @__PURE__ */ css(padding("xs", {
        theme
      }), ";", fontSize("s", {
        theme
      }), ";");
    case "sm":
      return /* @__PURE__ */ css(padding("xxxs", {
        theme
      }), ";", fontSize("xxs", {
        theme
      }), ";");
    default:
      return /* @__PURE__ */ css(padding("xxs", {
        theme
      }), ";", fontSize("xs", {
        theme
      }), ";");
  }
};
var _ref$d = {
  name: "8atqhb",
  styles: "width:100%;"
};
const block = ({
  block: block2
}) => block2 && _ref$d;
const margin = ({
  marginLeft,
  marginRight,
  marginTop,
  marginBottom,
  withMargins,
  theme
}) => /* @__PURE__ */ css((marginLeft || withMargins) && `margin-left: ${spacer(2, {
  theme
})}`, ";", (marginRight || withMargins) && `margin-right: ${spacer(2, {
  theme
})}`, ";", (marginTop || withMargins) && `margin-top: ${spacer(2, {
  theme
})}`, ";", (marginBottom || withMargins) && `margin-bottom: ${spacer(2, {
  theme
})}`, ";");
const Button$1 = createStyled("button", {
  target: "e16kt4pu0"
})("display:inline-block;text-align:center;white-space:nowrap;vertical-align:middle;user-select:none;color:currentColor;font-family:inherit;border-width:1px;border-style:solid;flex-shrink:0;transition:color 0.1s ease-in-out,background-color 0.1s ease-in-out,border-color 0.1s ease-in-out,box-shadow 0.1s ease-in-out 0s;", fontWeight("bold"), ";", borderRadius$1("default"), ";&:enabled{cursor:pointer;}&:hover,&:focus{text-decoration:none;outline:0;}&:hover,&:focus{cursor:pointer;}&:disabled{cursor:not-allowed;}", kind$3, ";", size$7, ";", block, ";", margin, ";");
const ButtonLink = Button$1.withComponent((__) => {
  var _$ = __, {
    block: block2,
    dark: dark2,
    withMargins,
    marginLeft,
    marginRight,
    marginTop,
    marginBottom
  } = _$, rest = __objRest(_$, [
    "block",
    "dark",
    "withMargins",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
  ]);
  return /* @__PURE__ */ jsx(Link$1, __spreadValues({}, rest));
}, {
  target: "eztjwjm0"
});
const CheckboxHidden = withProps$1({
  type: "checkbox"
})(createStyled("input", {
  target: "e1gydqdp0"
})({
  name: "sz9j72",
  styles: "opacity:0;position:absolute;z-index:-1;"
}));
const checkboxBackgroundStyle = ({
  checked,
  disabled
}) => {
  if (disabled) {
    return checked ? "checkedDisabledBackground" : "disabledBackground";
  }
  return checked && "checkedBackground";
};
const checkboxBorderStyle = ({
  checked,
  disabled,
  valid: valid2
}) => {
  if (disabled) {
    return "disabledBorder";
  } else if (!valid2) {
    return "invalidBorder";
  }
  return !checked && "border";
};
const findStyle$1 = (props, fn2 = (key2) => key2) => {
  const stylePath = fn2(props);
  if (stylePath) {
    return style(`checkbox.${stylePath}`)({
      theme: props.theme
    });
  }
  return "transparent";
};
const CheckboxDisplay = createStyled("div", {
  target: "esu9zsz0"
})("background-color:", (props) => findStyle$1(props, checkboxBackgroundStyle), ";border:solid 0.0675rem ", (props) => findStyle$1(props, checkboxBorderStyle), ";border-radius:0.125rem;height:", spacer(4), ";width:", spacer(4), ";display:inline-block;margin-right:", spacer(3), ";margin-left:-1px;vertical-align:middle;");
const Label$3 = createStyled("label", {
  target: "e1omu0vk0"
})("display:flex;align-items:center;margin-bottom:0;cursor:", ({
  disabled
}) => disabled ? "not-allowed" : "pointer", ";");
const LabelText$1 = createStyled("span", {
  target: "e1omu0vk1"
})("margin-bottom:0;color:", color("slate"), ";vertical-align:middle;");
const CheckboxContainer = createStyled("div", {
  target: "e1omu0vk2"
})({
  name: "79elbk",
  styles: "position:relative;"
});
const Checkbox = (_aa) => {
  var _ba = _aa, {
    checked,
    label,
    disabled,
    valid: valid2,
    id,
    theme
  } = _ba, rest = __objRest(_ba, [
    "checked",
    "label",
    "disabled",
    "valid",
    "id",
    "theme"
  ]);
  return /* @__PURE__ */ jsxs(CheckboxContainer, {
    children: [/* @__PURE__ */ jsx(CheckboxHidden, __spreadValues({
      checked,
      disabled,
      id
    }, rest)), /* @__PURE__ */ jsxs(Label$3, {
      disabled,
      htmlFor: id,
      children: [/* @__PURE__ */ jsx(CheckboxDisplay, {
        checked,
        disabled,
        valid: valid2,
        children: /* @__PURE__ */ jsx("svg", {
          viewBox: "-4 -6 20 20",
          children: /* @__PURE__ */ jsx("g", {
            fill: "none",
            children: checked && /* @__PURE__ */ jsx("path", {
              stroke: color("white")({
                theme
              }),
              strokeWidth: "2",
              d: "M1.5 3.75l3 3 6-6"
            })
          })
        })
      }), /* @__PURE__ */ jsx(LabelText$1, {
        children: label
      })]
    })]
  });
};
Checkbox.propTypes = {
  checked: PropTypes$2.bool,
  disabled: PropTypes$2.bool,
  label: PropTypes$2.node,
  valid: PropTypes$2.bool,
  id: PropTypes$2.string.isRequired,
  onChange: PropTypes$2.func
};
Checkbox.defaultProps = {
  onChange: () => {
  },
  checked: false,
  disabled: false,
  valid: true
};
var Checkbox$1 = withTheme(Checkbox);
const sizeWithDefault = compose(defaultTo("1.75rem"), prop("size"));
const CloseButton = /* @__PURE__ */ createStyled(withProps$1({
  kind: "ghost",
  size: "sm",
  children: /* @__PURE__ */ jsx(Cancel$2, {
    size: "80%"
  })
})(Button$1), {
  target: "e5w0i0o0"
})("padding:0;display:flex;align-items:center;justify-content:center;border-radius:50%;width:", sizeWithDefault, ";height:", sizeWithDefault, ";svg{fill:", transparentize("slate", 0.5), ";transition:fill 0.1s ease-out;}&:hover{svg{opacity:1;fill:", color("slate"), ";}}");
const Code = createStyled("code", {
  target: "e1d25doh0"
})("background:", color("paleGrey"), ";padding:0.1rem ", spacer(1), ";");
const Container$h = createStyled("div", {
  target: "eqbar9n0"
})("padding-left:", spacer(4), ";padding-right:", spacer(4), ";", responsiveContainer, ";");
const PolicyContainer = createStyled("div", {
  target: "e1hzgnqp0"
})("position:fixed;bottom:0;left:0;width:100%;background:", style("cookieBanner.background"), ";z-index:9999;");
const PolicyText = createStyled("div", {
  target: "e1hzgnqp1"
})("flex:1;color:", color("white"), ";padding-right:", spacer(3), ";", fontSize("xs"), ";", mediaDn("sm"), "{padding-right:0;margin-bottom:", spacer(3), ";}");
const Content$3 = /* @__PURE__ */ createStyled(Container$h, {
  target: "e1hzgnqp2"
})("display:flex;justify-content:center;margin:0 auto;", padding("md"), ";", mediaUp("sm"), "{align-items:center;}", mediaDn("sm"), "{flex-direction:column;}");
const shake = keyframes`
  0%, 24% {
    transform: rotate(0deg) scale(1);
  }
  3% {
    transform: rotate(8deg) scale(1.12);
  }
  9% {
    transform: rotate(-8deg) scale(1.16);
  }
  15% {
    transform: rotate(8deg) scale(1.16);
  }
  21% {
    transform: rotate(-8deg) scale(1.12);
  }
`;
const shakeAnimation = /* @__PURE__ */ css("animation:", shake, " 5s ease-in-out;transform-origin:center;animation-iteration-count:infinite;");
const AcceptButton = /* @__PURE__ */ createStyled(Button$1, {
  target: "e1hzgnqp3"
})(({
  highlighted
}) => highlighted && shakeAnimation, ";");
const CookieBanner = ({
  children,
  onAccept,
  highlighted
}) => /* @__PURE__ */ jsx(PolicyContainer, {
  children: /* @__PURE__ */ jsxs(Content$3, {
    children: [/* @__PURE__ */ jsx(PolicyText, {
      children
    }), /* @__PURE__ */ jsx(AcceptButton, {
      kind: "primary",
      onClick: onAccept,
      highlighted,
      dark: true,
      children: "Accept"
    })]
  })
});
var _ref$c = {
  name: "r2ff5g",
  styles: "visibility:visible;opacity:1;"
};
var _ref2$9 = {
  name: "ge94et",
  styles: "visibility:hidden;opacity:0;"
};
const Backdrop$2 = createStyled("div", {
  target: "e7dcb8b0"
})("position:fixed;left:0;right:0;bottom:0;background:", transparentize("pewter", 0.6), ";transition:all 0.3s;z-index:1049;", ({
  top: top2 = "0"
}) => /* @__PURE__ */ css("top:", top2, ";"), " ", ({
  open
}) => open ? _ref$c : _ref2$9, "");
Backdrop$2.displayName = "Drawer.Backdrop";
const MenuItem = createStyled("li", {
  target: "e394io00"
})("display:block;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;width:100%;", padding("xxs"), ";", typography$1("body2"), ";&:hover{background-color:", transparentize("green", 0.15), ";}");
const Menu$1 = createStyled("ul", {
  target: "e66316c0"
})("list-style:none;margin:0;padding:", spacer(1), " 0;color:", color("black"), ";background-color:", color("white"), ";overflow:hidden;width:100%;");
const Section$1 = createStyled("div", {
  target: "ee3e8x80"
})("&:not(:last-of-type){margin-bottom:", spacer(1), ";padding-bottom:", spacer(1), ";border-bottom:1px solid ", color("paleGrey"), ";}");
Section$1.displayName = "Drawer.Section";
var _ref$b = {
  name: "19zs6va",
  styles: "right:0;"
};
var _ref2$8 = {
  name: "260zpl",
  styles: "left:0;"
};
var _ref3$1 = {
  name: "ws9i0x",
  styles: "transform:translate(0);"
};
var _ref4$1 = {
  name: "1wognfu",
  styles: "transform:translate(100%);"
};
var _ref5 = {
  name: "ehbdog",
  styles: "transform:translate(-100%);"
};
const StyledDrawer = createStyled("div", {
  target: "e5kffte0"
})("transition:all 0.3s ease-in-out;position:fixed;box-shadow:0 3px 8px 0 rgba(22,38,59,0.2);z-index:1015;overflow:hidden;background:white;", ({
  width = "200px"
}) => /* @__PURE__ */ css("width:", width, ";"), " ", ({
  height = "100vh"
}) => /* @__PURE__ */ css("height:", height, ";"), " ", ({
  top: top2 = "0"
}) => /* @__PURE__ */ css("top:", top2, ";"), " ", ({
  side
}) => side === "right" ? _ref$b : _ref2$8, " ", ({
  open,
  side
}) => open ? _ref3$1 : side === "right" ? _ref4$1 : _ref5, "");
const Drawer = (_ca) => {
  var _da = _ca, {
    open: openProp
  } = _da, props = __objRest(_da, [
    "open"
  ]);
  const drawerRef = useRef(null);
  const [open, setOpen] = useState(openProp);
  useEffect(() => {
    setOpen(openProp);
  }, [openProp]);
  return /* @__PURE__ */ jsx(StyledDrawer, __spreadValues({
    ref: drawerRef,
    open
  }, props));
};
Drawer.Backdrop = Backdrop$2;
Drawer.MenuItem = MenuItem;
Drawer.Menu = Menu$1;
Drawer.Section = Section$1;
const SecondaryLink = /* @__PURE__ */ createStyled((_ea) => {
  var _fa = _ea, {
    dark: dark2,
    external,
    disabled
  } = _fa, rest = __objRest(_fa, [
    "dark",
    "external",
    "disabled"
  ]);
  return external ? /* @__PURE__ */ jsx("a", __spreadValues({}, rest)) : /* @__PURE__ */ jsx(Link$1, __spreadValues({}, rest));
}, {
  target: "e1rrd3l70"
})("text-decoration:underline;", typography$1("body2Medium"), ";", ({
  dark: dark2,
  disabled,
  theme
}) => /* @__PURE__ */ css("color:", color(disabled ? "silver" : dark2 ? "silver" : "pewter", {
  theme
}), ";cursor:", disabled ? "not-allowed" : "pointer", ";&:hover{color:", color(disabled ? "silver" : dark2 ? "white" : "black", {
  theme
}), ";}"), ";");
const DefaultCookiePolicy = () => /* @__PURE__ */ jsxs(Fragment$2, {
  children: ["This application uses cookies to store information on your computer. Some are essential for the session performance, others help us to improve your user experience. Click", " ", /* @__PURE__ */ jsx(SecondaryLink, {
    external: true,
    dark: true,
    href: "https://www.focusvision.com/privacy-statement/",
    target: "_blank",
    rel: "noopener noreferrer",
    children: "Privacy Policy"
  }), " ", "to learn more."]
});
var _ref$a = {
  name: "v2kfba",
  styles: "height:100%;width:100%;"
};
const size$6 = ({
  size: size2,
  theme
}) => {
  switch (size2) {
    case "fullscreen":
      return _ref$a;
    case "lg":
      return /* @__PURE__ */ css("margin-top:", spacer(5, {
        theme
      }), ";margin-bottom:", spacer(5, {
        theme
      }), ";width:720px;", borderRadius$1("default", {
        theme
      }), ";");
    default:
      return /* @__PURE__ */ css("margin-top:", spacer(5, {
        theme
      }), ";margin-bottom:", spacer(5, {
        theme
      }), ";width:480px;", borderRadius$1("default", {
        theme
      }), ";");
  }
};
var _ref2$7 = {
  name: "1uwx7m9",
  styles: "background:none;border-color:transparent;box-shadow:unset;"
};
const kind$2 = ({
  kind: kind2
}) => kind2 === "ghost" && _ref2$7;
const Content$2 = createStyled("div", {
  target: "e189eieg0"
})("background:", color("white"), ";display:flex;flex-direction:column;max-width:100%;", shadow$1("raised"), ";", size$6, ";", kind$2, ";");
Content$2.displayName = "Dialog.Content";
const Container$g = createStyled("header", {
  target: "etnk1780"
})("display:flex;justify-content:space-between;align-items:top;> h4:first-of-type{flex:1;margin-bottom:0;}", padding("md"), ";");
Container$g.displayName = "Dialog.Header.Container";
const Header$3 = ({
  children,
  onClose
}) => /* @__PURE__ */ jsxs(Container$g, {
  children: [children, onClose && /* @__PURE__ */ jsx(CloseButton, {
    onClick: onClose
  })]
});
Header$3.propTypes = {
  onClose: PropTypes$2.func
};
Header$3.displayName = "Dialog.Header";
const Title$3 = (props) => /* @__PURE__ */ jsx("h4", __spreadValues({}, props));
Title$3.displayName = "Dialog.Title";
const Body$2 = createStyled("div", {
  target: "e1uria470"
})("padding-left:", spacer(6), ";padding-right:", spacer(6), ";flex:1;");
Body$2.displayName = "Dialog.Body";
const Footer$3 = createStyled("footer", {
  target: "eimf8yy0"
})("display:flex;justify-content:flex-end;", padding("md"), ";", Button$1, " + ", Button$1, "{margin-left:", spacer(2), ";}");
Footer$3.displayName = "Dialog.Footer";
const CancelButton$1 = ({
  children,
  onClose
}) => /* @__PURE__ */ jsx(Button$1, {
  kind: "ghost",
  type: "button",
  onClick: onClose,
  children
});
CancelButton$1.defaultProps = {
  children: "Cancel"
};
const Dialog = (props) => /* @__PURE__ */ jsx(Content$2, __spreadValues({
  onClick: (e2) => e2.stopPropagation()
}, props));
Dialog.Body = Body$2;
Dialog.Footer = Footer$3;
Dialog.Header = Header$3;
Dialog.Title = Title$3;
Dialog.CancelButton = CancelButton$1;
const Placeholder = createStyled("span", {
  target: "e1317bf50"
})("color:", color("cadet"), ";", fontWeight("regular"), ";[aria-expanded='true'] &{color:", color("white"), ";}");
const TruncateText = createStyled("span", {
  target: "e1kjqdkw0"
})({
  name: "1h2ruwl",
  styles: "white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"
});
const size$5 = ({
  size: size2,
  theme
}) => {
  switch (size2) {
    case "lg":
      return /* @__PURE__ */ css(typography$1("body3", {
        theme
      }), ";", padding("xs", {
        theme
      }), ";");
    default:
      return /* @__PURE__ */ css(typography$1("body2", {
        theme
      }), ";", padding("xxs", {
        theme
      }), ";");
  }
};
const kind$1 = ({
  kind: kind2,
  theme,
  valid: valid2
}) => {
  switch (kind2) {
    case "ghost":
      return /* @__PURE__ */ css("border:none;color:", color("pewter", {
        theme
      }), ";", fontWeight("medium", {
        theme
      }), ";&:hover{background-color:", transparentize("slate", 0.08, {
        theme
      }), ";}");
    default:
      return /* @__PURE__ */ css("border:1px solid ", color(valid2 ? "silver" : "red", {
        theme
      }), ";[aria-expanded='true'] &{border:1px solid ", color("slate", {
        theme
      }), ";}");
  }
};
const Button = createStyled("button", {
  target: "e11vym1r0"
})("display:flex;justify-content:space-between;align-items:center;transition:all 0.3s ease 0s;outline-color:", color("slate"), ";width:100%;font-family:inherit;user-select:none;background-color:", color("white"), ";text-align:left;", borderRadius$1("default"), ";", size$5, ";", kind$1, ";&::-moz-focus-inner{border:0;}[aria-expanded='true'] &{color:", color("white"), ";background-color:", color("slate"), ";outline:none;}&:active{border-color:", color("slate"), ";}&:focus{outline-color:", color("slate"), ";outline-offset:-2px;}&:not([disabled]){cursor:pointer;}&[disabled]{cursor:not-allowed;color:", color("cadet"), ";background:", color("offWhite"), ";border:1px solid ", color("paleGrey"), ";}svg{&:first-of-type{margin-right:", spacer(2), ";}&:last-of-type{margin-left:", spacer(2), ";}}@supports (-moz-appearance:none){&:focus{outline-width:1px;outline-style:dotted;}}", TruncateText, ",", Placeholder, "{flex:1;}");
Button.displayName = "Dropdown.Button";
var ManagerReferenceNodeContext = React.createContext();
var ManagerReferenceNodeSetterContext = React.createContext();
function Manager(_ref6) {
  var children = _ref6.children;
  var _React$useState = React.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
  React.useEffect(function() {
    return function() {
      setReferenceNode(null);
    };
  }, [setReferenceNode]);
  return /* @__PURE__ */ React.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /* @__PURE__ */ React.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: setReferenceNode
  }, children));
}
var unwrapArray = function unwrapArray2(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
var safeInvoke = function safeInvoke2(fn2) {
  if (typeof fn2 === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return fn2.apply(void 0, args);
  }
};
var setRef = function setRef2(ref, node) {
  if (typeof ref === "function") {
    return safeInvoke(ref, node);
  } else if (ref != null) {
    ref.current = node;
  }
};
var fromEntries = function fromEntries2(entries) {
  return entries.reduce(function(acc, _ref6) {
    var key2 = _ref6[0], value = _ref6[1];
    acc[key2] = value;
    return acc;
  }, {});
};
var useIsomorphicLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;
function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    y: rect.top
  };
}
function getWindow(node) {
  if (node.toString() !== "[object Window]") {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
  }
  return node;
}
function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft,
    scrollTop
  };
}
function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}
function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}
function getNodeName(element) {
  return element ? (element.nodeName || "").toLowerCase() : null;
}
function getDocumentElement(element) {
  return (isElement(element) ? element.ownerDocument : element.document).documentElement;
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
function isScrollParent(element) {
  var _getComputedStyle = getComputedStyle$1(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}
function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement);
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
function getLayoutRect(element) {
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}
function getParentNode(element) {
  if (getNodeName(element) === "html") {
    return element;
  }
  return element.assignedSlot || element.parentNode || element.host || getDocumentElement(element);
}
function getScrollParent(node) {
  if (["html", "body", "#document"].indexOf(getNodeName(node)) >= 0) {
    return node.ownerDocument.body;
  }
  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }
  return getScrollParent(getParentNode(node));
}
function listScrollParents(element, list) {
  if (list === void 0) {
    list = [];
  }
  var scrollParent = getScrollParent(element);
  var isBody = getNodeName(scrollParent) === "body";
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : updatedList.concat(listScrollParents(getParentNode(target)));
}
function isTableElement(element) {
  return ["table", "td", "th"].indexOf(getNodeName(element)) >= 0;
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  var offsetParent = element.offsetParent;
  if (offsetParent) {
    var html = getDocumentElement(offsetParent);
    if (getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static" && getComputedStyle$1(html).position !== "static") {
      return html;
    }
  }
  return offsetParent;
}
function getContainingBlock(element) {
  var currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && ["html", "body"].indexOf(getNodeName(currentNode)) < 0) {
    var css2 = getComputedStyle$1(currentNode);
    if (css2.transform !== "none" || css2.perspective !== "none" || css2.willChange && css2.willChange !== "auto") {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }
  return null;
}
function getOffsetParent(element) {
  var window2 = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static") {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
var top = "top";
var bottom = "bottom";
var right = "right";
var left = "left";
var auto = "auto";
var basePlacements = [top, bottom, right, left];
var start = "start";
var end = "end";
var clippingParents = "clippingParents";
var viewport = "viewport";
var popper = "popper";
var reference = "reference";
var variationPlacements = /* @__PURE__ */ basePlacements.reduce(function(acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements$1 = /* @__PURE__ */ [].concat(basePlacements, [auto]).reduce(function(acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []);
var beforeRead = "beforeRead";
var read = "read";
var afterRead = "afterRead";
var beforeMain = "beforeMain";
var main = "main";
var afterMain = "afterMain";
var beforeWrite = "beforeWrite";
var write = "write";
var afterWrite = "afterWrite";
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];
function order(modifiers) {
  var map = /* @__PURE__ */ new Map();
  var visited = /* @__PURE__ */ new Set();
  var result = [];
  modifiers.forEach(function(modifier) {
    map.set(modifier.name, modifier);
  });
  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function(dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);
        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }
  modifiers.forEach(function(modifier) {
    if (!visited.has(modifier.name)) {
      sort(modifier);
    }
  });
  return result;
}
function orderModifiers(modifiers) {
  var orderedModifiers = order(modifiers);
  return modifierPhases.reduce(function(acc, phase) {
    return acc.concat(orderedModifiers.filter(function(modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}
function debounce(fn2) {
  var pending;
  return function() {
    if (!pending) {
      pending = new Promise(function(resolve) {
        Promise.resolve().then(function() {
          pending = void 0;
          resolve(fn2());
        });
      });
    }
    return pending;
  };
}
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function(merged2, current) {
    var existing = merged2[current.name];
    merged2[current.name] = existing ? Object.assign(Object.assign(Object.assign({}, existing), current), {}, {
      options: Object.assign(Object.assign({}, existing.options), current.options),
      data: Object.assign(Object.assign({}, existing.data), current.data)
    }) : current;
    return merged2;
  }, {});
  return Object.keys(merged).map(function(key2) {
    return merged[key2];
  });
}
function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x + getWindowScrollBarX(element),
    y: y2
  };
}
function getDocumentRect(element) {
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = element.ownerDocument.body;
  var width = Math.max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = Math.max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y2 = -winScroll.scrollTop;
  if (getComputedStyle$1(body || html).direction === "rtl") {
    x += Math.max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }
  return {
    width,
    height,
    x,
    y: y2
  };
}
function contains(parent, child) {
  var isShadow = Boolean(child.getRootNode && child.getRootNode().host);
  if (parent.contains(child)) {
    return true;
  } else if (isShadow) {
    var next = child;
    do {
      if (next && parent.isSameNode(next)) {
        return true;
      }
      next = next.parentNode || next.host;
    } while (next);
  }
  return false;
}
function rectToClientRect(rect) {
  return Object.assign(Object.assign({}, rect), {}, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}
function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}
function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingParents(element) {
  var clippingParents2 = listScrollParents(getParentNode(element));
  var canEscapeClipping = ["absolute", "fixed"].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;
  if (!isElement(clipperElement)) {
    return [];
  }
  return clippingParents2.filter(function(clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== "body";
  });
}
function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === "clippingParents" ? getClippingParents(element) : [].concat(boundary);
  var clippingParents2 = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents2[0];
  var clippingRect = clippingParents2.reduce(function(accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = Math.max(rect.top, accRect.top);
    accRect.right = Math.min(rect.right, accRect.right);
    accRect.bottom = Math.min(rect.bottom, accRect.bottom);
    accRect.left = Math.max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}
function getVariation(placement) {
  return placement.split("-")[1];
}
function getMainAxisFromPlacement(placement) {
  return ["top", "bottom"].indexOf(placement) >= 0 ? "x" : "y";
}
function computeOffsets(_ref6) {
  var reference2 = _ref6.reference, element = _ref6.element, placement = _ref6.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference2.x + reference2.width / 2 - element.width / 2;
  var commonY = reference2.y + reference2.height / 2 - element.height / 2;
  var offsets;
  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference2.y - element.height
      };
      break;
    case bottom:
      offsets = {
        x: commonX,
        y: reference2.y + reference2.height
      };
      break;
    case right:
      offsets = {
        x: reference2.x + reference2.width,
        y: commonY
      };
      break;
    case left:
      offsets = {
        x: reference2.x - element.width,
        y: commonY
      };
      break;
    default:
      offsets = {
        x: reference2.x,
        y: reference2.y
      };
  }
  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;
  if (mainAxis != null) {
    var len = mainAxis === "y" ? "height" : "width";
    switch (variation) {
      case start:
        offsets[mainAxis] = Math.floor(offsets[mainAxis]) - Math.floor(reference2[len] / 2 - element[len] / 2);
        break;
      case end:
        offsets[mainAxis] = Math.floor(offsets[mainAxis]) + Math.ceil(reference2[len] / 2 - element[len] / 2);
        break;
    }
  }
  return offsets;
}
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function mergePaddingObject(paddingObject) {
  return Object.assign(Object.assign({}, getFreshSideObject()), paddingObject);
}
function expandToHashMap(value, keys) {
  return keys.reduce(function(hashMap, key2) {
    hashMap[key2] = value;
    return hashMap;
  }, {});
}
function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? clippingParents : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? popper : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding2 = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var referenceElement = state.elements.reference;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(referenceElement);
  var popperOffsets2 = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: "absolute",
    placement
  });
  var popperClientRect = rectToClientRect(Object.assign(Object.assign({}, popperRect), popperOffsets2));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect;
  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset;
  if (elementContext === popper && offsetData) {
    var offset2 = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function(key2) {
      var multiply = [right, bottom].indexOf(key2) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key2) >= 0 ? "y" : "x";
      overflowOffsets[key2] += offset2[axis] * multiply;
    });
  }
  return overflowOffsets;
}
var DEFAULT_OPTIONS = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return !args.some(function(element) {
    return !(element && typeof element.getBoundingClientRect === "function");
  });
}
function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }
  var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers2 = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper2(reference2, popper2, options) {
    if (options === void 0) {
      options = defaultOptions;
    }
    var state = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign(Object.assign({}, DEFAULT_OPTIONS), defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference2,
        popper: popper2
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state,
      setOptions: function setOptions(options2) {
        cleanupModifierEffects();
        state.options = Object.assign(Object.assign(Object.assign({}, defaultOptions), state.options), options2);
        state.scrollParents = {
          reference: isElement(reference2) ? listScrollParents(reference2) : reference2.contextElement ? listScrollParents(reference2.contextElement) : [],
          popper: listScrollParents(popper2)
        };
        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers2, state.options.modifiers)));
        state.orderedModifiers = orderedModifiers.filter(function(m2) {
          return m2.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }
        var _state$elements = state.elements, reference3 = _state$elements.reference, popper3 = _state$elements.popper;
        if (!areValidElements(reference3, popper3)) {
          return;
        }
        state.rects = {
          reference: getCompositeRect(reference3, getOffsetParent(popper3), state.options.strategy === "fixed"),
          popper: getLayoutRect(popper3)
        };
        state.reset = false;
        state.placement = state.options.placement;
        state.orderedModifiers.forEach(function(modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        for (var index2 = 0; index2 < state.orderedModifiers.length; index2++) {
          if (state.reset === true) {
            state.reset = false;
            index2 = -1;
            continue;
          }
          var _state$orderedModifie = state.orderedModifiers[index2], fn2 = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
          if (typeof fn2 === "function") {
            state = fn2({
              state,
              options: _options,
              name,
              instance
            }) || state;
          }
        }
      },
      update: debounce(function() {
        return new Promise(function(resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };
    if (!areValidElements(reference2, popper2)) {
      return instance;
    }
    instance.setOptions(options).then(function(state2) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state2);
      }
    });
    function runModifierEffects() {
      state.orderedModifiers.forEach(function(_ref32) {
        var name = _ref32.name, _ref3$options = _ref32.options, options2 = _ref3$options === void 0 ? {} : _ref3$options, effect2 = _ref32.effect;
        if (typeof effect2 === "function") {
          var cleanupFn = effect2({
            state,
            name,
            instance,
            options: options2
          });
          var noopFn = function noopFn2() {
          };
          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }
    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function(fn2) {
        return fn2();
      });
      effectCleanupFns = [];
    }
    return instance;
  };
}
var passive = {
  passive: true
};
function effect$2(_ref6) {
  var state = _ref6.state, instance = _ref6.instance, options = _ref6.options;
  var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
  var window2 = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
  if (scroll) {
    scrollParents.forEach(function(scrollParent) {
      scrollParent.addEventListener("scroll", instance.update, passive);
    });
  }
  if (resize) {
    window2.addEventListener("resize", instance.update, passive);
  }
  return function() {
    if (scroll) {
      scrollParents.forEach(function(scrollParent) {
        scrollParent.removeEventListener("scroll", instance.update, passive);
      });
    }
    if (resize) {
      window2.removeEventListener("resize", instance.update, passive);
    }
  };
}
var eventListeners = {
  name: "eventListeners",
  enabled: true,
  phase: "write",
  fn: function fn() {
  },
  effect: effect$2,
  data: {}
};
function popperOffsets(_ref6) {
  var state = _ref6.state, name = _ref6.name;
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: "absolute",
    placement: state.placement
  });
}
var popperOffsets$1 = {
  name: "popperOffsets",
  enabled: true,
  phase: "read",
  fn: popperOffsets,
  data: {}
};
var unsetSides = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function roundOffsets(_ref6) {
  var x = _ref6.x, y2 = _ref6.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: Math.round(x * dpr) / dpr || 0,
    y: Math.round(y2 * dpr) / dpr || 0
  };
}
function mapToStyles(_ref22) {
  var _Object$assign2;
  var popper2 = _ref22.popper, popperRect = _ref22.popperRect, placement = _ref22.placement, offsets = _ref22.offsets, position2 = _ref22.position, gpuAcceleration = _ref22.gpuAcceleration, adaptive = _ref22.adaptive;
  var _roundOffsets = roundOffsets(offsets), x = _roundOffsets.x, y2 = _roundOffsets.y;
  var hasX = offsets.hasOwnProperty("x");
  var hasY = offsets.hasOwnProperty("y");
  var sideX = left;
  var sideY = top;
  var win = window;
  if (adaptive) {
    var offsetParent = getOffsetParent(popper2);
    if (offsetParent === getWindow(popper2)) {
      offsetParent = getDocumentElement(popper2);
    }
    if (placement === top) {
      sideY = bottom;
      y2 -= offsetParent.clientHeight - popperRect.height;
      y2 *= gpuAcceleration ? 1 : -1;
    }
    if (placement === left) {
      sideX = right;
      x -= offsetParent.clientWidth - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }
  var commonStyles2 = Object.assign({
    position: position2
  }, adaptive && unsetSides);
  if (gpuAcceleration) {
    var _Object$assign;
    return Object.assign(Object.assign({}, commonStyles2), {}, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y2 + "px)" : "translate3d(" + x + "px, " + y2 + "px, 0)", _Object$assign));
  }
  return Object.assign(Object.assign({}, commonStyles2), {}, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y2 + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function computeStyles(_ref32) {
  var state = _ref32.state, options = _ref32.options;
  var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive;
  var commonStyles2 = {
    placement: getBasePlacement(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration
  };
  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign(Object.assign({}, state.styles.popper), mapToStyles(Object.assign(Object.assign({}, commonStyles2), {}, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive
    })));
  }
  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign(Object.assign({}, state.styles.arrow), mapToStyles(Object.assign(Object.assign({}, commonStyles2), {}, {
      offsets: state.modifiersData.arrow,
      position: "absolute",
      adaptive: false
    })));
  }
  state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
    "data-popper-placement": state.placement
  });
}
var computeStyles$1 = {
  name: "computeStyles",
  enabled: true,
  phase: "beforeWrite",
  fn: computeStyles,
  data: {}
};
function applyStyles(_ref6) {
  var state = _ref6.state;
  Object.keys(state.elements).forEach(function(name) {
    var style2 = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name];
    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    }
    Object.assign(element.style, style2);
    Object.keys(attributes).forEach(function(name2) {
      var value = attributes[name2];
      if (value === false) {
        element.removeAttribute(name2);
      } else {
        element.setAttribute(name2, value === true ? "" : value);
      }
    });
  });
}
function effect$1(_ref22) {
  var state = _ref22.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }
  return function() {
    Object.keys(state.elements).forEach(function(name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
      var style2 = styleProperties.reduce(function(style3, property) {
        style3[property] = "";
        return style3;
      }, {});
      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }
      Object.assign(element.style, style2);
      Object.keys(attributes).forEach(function(attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
}
var applyStyles$1 = {
  name: "applyStyles",
  enabled: true,
  phase: "write",
  fn: applyStyles,
  effect: effect$1,
  requires: ["computeStyles"]
};
function distanceAndSkiddingToXY(placement, rects, offset2) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;
  var _ref6 = typeof offset2 === "function" ? offset2(Object.assign(Object.assign({}, rects), {}, {
    placement
  })) : offset2, skidding = _ref6[0], distance = _ref6[1];
  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}
function offset(_ref22) {
  var state = _ref22.state, options = _ref22.options, name = _ref22.name;
  var _options$offset = options.offset, offset2 = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements$1.reduce(function(acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset2);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement], x = _data$state$placement.x, y2 = _data$state$placement.y;
  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y2;
  }
  state.modifiersData[name] = data;
}
var offset$1 = {
  name: "offset",
  enabled: true,
  phase: "main",
  requires: ["popperOffsets"],
  fn: offset
};
var hash$1 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function(matched) {
    return hash$1[matched];
  });
}
var hash = {
  start: "end",
  end: "start"
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function(matched) {
    return hash[matched];
  });
}
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding2 = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements$1 : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements2 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function(placement2) {
    return getVariation(placement2) === variation;
  }) : basePlacements;
  var allowedPlacements = placements2.filter(function(placement2) {
    return allowedAutoPlacements.indexOf(placement2) >= 0;
  });
  if (allowedPlacements.length === 0) {
    allowedPlacements = placements2;
  }
  var overflows = allowedPlacements.reduce(function(acc, placement2) {
    acc[placement2] = detectOverflow(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2
    })[getBasePlacement(placement2)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function(a, b2) {
    return overflows[a] - overflows[b2];
  });
}
function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }
  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}
function flip(_ref6) {
  var state = _ref6.state, options = _ref6.options, name = _ref6.name;
  if (state.modifiersData[name]._skip) {
    return;
  }
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding2 = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements2 = [preferredPlacement].concat(fallbackPlacements).reduce(function(acc, placement2) {
    return acc.concat(getBasePlacement(placement2) === auto ? computeAutoPlacement(state, {
      placement: placement2,
      boundary,
      rootBoundary,
      padding: padding2,
      flipVariations,
      allowedAutoPlacements
    }) : placement2);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = /* @__PURE__ */ new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements2[0];
  for (var i = 0; i < placements2.length; i++) {
    var placement = placements2[i];
    var _basePlacement = getBasePlacement(placement);
    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? "width" : "height";
    var overflow = detectOverflow(state, {
      placement,
      boundary,
      rootBoundary,
      altBoundary,
      padding: padding2
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;
    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }
    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];
    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }
    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }
    if (checks.every(function(check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }
    checksMap.set(placement, checks);
  }
  if (makeFallbackChecks) {
    var numberOfChecks = flipVariations ? 3 : 1;
    var _loop = function _loop2(_i2) {
      var fittingPlacement = placements2.find(function(placement2) {
        var checks2 = checksMap.get(placement2);
        if (checks2) {
          return checks2.slice(0, _i2).every(function(check) {
            return check;
          });
        }
      });
      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };
    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);
      if (_ret === "break")
        break;
    }
  }
  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
}
var flip$1 = {
  name: "flip",
  enabled: true,
  phase: "main",
  fn: flip,
  requiresIfExists: ["offset"],
  data: {
    _skip: false
  }
};
function getAltAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function within(min, value, max) {
  return Math.max(min, Math.min(value, max));
}
function preventOverflow(_ref6) {
  var state = _ref6.state, options = _ref6.options, name = _ref6.name;
  var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding2 = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary,
    rootBoundary,
    padding: padding2,
    altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign(Object.assign({}, state.rects), {}, {
    placement: state.placement
  })) : tetherOffset;
  var data = {
    x: 0,
    y: 0
  };
  if (!popperOffsets2) {
    return;
  }
  if (checkMainAxis) {
    var mainSide = mainAxis === "y" ? top : left;
    var altSide = mainAxis === "y" ? bottom : right;
    var len = mainAxis === "y" ? "height" : "width";
    var offset2 = popperOffsets2[mainAxis];
    var min = popperOffsets2[mainAxis] + overflow[mainSide];
    var max = popperOffsets2[mainAxis] - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len];
    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide];
    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
    var tetherMin = popperOffsets2[mainAxis] + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = popperOffsets2[mainAxis] + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? Math.min(min, tetherMin) : min, offset2, tether ? Math.max(max, tetherMax) : max);
    popperOffsets2[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset2;
  }
  if (checkAltAxis) {
    var _mainSide = mainAxis === "x" ? top : left;
    var _altSide = mainAxis === "x" ? bottom : right;
    var _offset = popperOffsets2[altAxis];
    var _min = _offset + overflow[_mainSide];
    var _max = _offset - overflow[_altSide];
    var _preventedOffset = within(_min, _offset, _max);
    popperOffsets2[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }
  state.modifiersData[name] = data;
}
var preventOverflow$1 = {
  name: "preventOverflow",
  enabled: true,
  phase: "main",
  fn: preventOverflow,
  requiresIfExists: ["offset"]
};
function arrow(_ref6) {
  var _state$modifiersData$;
  var state = _ref6.state, name = _ref6.name;
  var arrowElement = state.elements.arrow;
  var popperOffsets2 = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? "height" : "width";
  if (!arrowElement || !popperOffsets2) {
    return;
  }
  var paddingObject = state.modifiersData[name + "#persistent"].padding;
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === "y" ? top : left;
  var maxProp = axis === "y" ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets2[axis] - state.rects.popper[len];
  var startDiff = popperOffsets2[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2;
  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset2 = within(min, center, max);
  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset2, _state$modifiersData$.centerOffset = offset2 - center, _state$modifiersData$);
}
function effect(_ref22) {
  var state = _ref22.state, options = _ref22.options, name = _ref22.name;
  var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element, _options$padding = options.padding, padding2 = _options$padding === void 0 ? 0 : _options$padding;
  if (arrowElement == null) {
    return;
  }
  if (typeof arrowElement === "string") {
    arrowElement = state.elements.popper.querySelector(arrowElement);
    if (!arrowElement) {
      return;
    }
  }
  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }
  state.elements.arrow = arrowElement;
  state.modifiersData[name + "#persistent"] = {
    padding: mergePaddingObject(typeof padding2 !== "number" ? padding2 : expandToHashMap(padding2, basePlacements))
  };
}
var arrow$1 = {
  name: "arrow",
  enabled: true,
  phase: "main",
  fn: arrow,
  effect,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }
  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}
function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function(side) {
    return overflow[side] >= 0;
  });
}
function hide(_ref6) {
  var state = _ref6.state, name = _ref6.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: "reference"
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets,
    popperEscapeOffsets,
    isReferenceHidden,
    hasPopperEscaped
  };
  state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
    "data-popper-reference-hidden": isReferenceHidden,
    "data-popper-escaped": hasPopperEscaped
  });
}
var hide$1 = {
  name: "hide",
  enabled: true,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: hide
};
var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /* @__PURE__ */ popperGenerator({
  defaultModifiers
});
var hasElementType = typeof Element !== "undefined";
var hasMap = typeof Map === "function";
var hasSet = typeof Set === "function";
var hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
function equal$1(a, b2) {
  if (a === b2)
    return true;
  if (a && b2 && typeof a == "object" && typeof b2 == "object") {
    if (a.constructor !== b2.constructor)
      return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b2.length)
        return false;
      for (i = length; i-- !== 0; )
        if (!equal$1(a[i], b2[i]))
          return false;
      return true;
    }
    var it;
    if (hasMap && a instanceof Map && b2 instanceof Map) {
      if (a.size !== b2.size)
        return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b2.has(i.value[0]))
          return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal$1(i.value[1], b2.get(i.value[0])))
          return false;
      return true;
    }
    if (hasSet && a instanceof Set && b2 instanceof Set) {
      if (a.size !== b2.size)
        return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b2.has(i.value[0]))
          return false;
      return true;
    }
    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b2)) {
      length = a.length;
      if (length != b2.length)
        return false;
      for (i = length; i-- !== 0; )
        if (a[i] !== b2[i])
          return false;
      return true;
    }
    if (a.constructor === RegExp)
      return a.source === b2.source && a.flags === b2.flags;
    if (a.valueOf !== Object.prototype.valueOf)
      return a.valueOf() === b2.valueOf();
    if (a.toString !== Object.prototype.toString)
      return a.toString() === b2.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b2).length)
      return false;
    for (i = length; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(b2, keys[i]))
        return false;
    if (hasElementType && a instanceof Element)
      return false;
    for (i = length; i-- !== 0; ) {
      if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) {
        continue;
      }
      if (!equal$1(a[keys[i]], b2[keys[i]]))
        return false;
    }
    return true;
  }
  return a !== a && b2 !== b2;
}
var reactFastCompare$1 = function isEqual(a, b2) {
  try {
    return equal$1(a, b2);
  } catch (error) {
    if ((error.message || "").match(/stack|recursion/i)) {
      console.warn("react-fast-compare cannot handle circular refs");
      return false;
    }
    throw error;
  }
};
var EMPTY_MODIFIERS$1 = [];
var usePopper$1 = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }
  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || "bottom",
    strategy: options.strategy || "absolute",
    modifiers: options.modifiers || EMPTY_MODIFIERS$1
  };
  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: "0",
        top: "0"
      }
    },
    attributes: {}
  }), state = _React$useState[0], setState = _React$useState[1];
  var updateStateModifier = React.useMemo(function() {
    return {
      name: "updateState",
      enabled: true,
      phase: "write",
      fn: function fn2(_ref6) {
        var state2 = _ref6.state;
        var elements = Object.keys(state2.elements);
        setState({
          styles: fromEntries(elements.map(function(element) {
            return [element, state2.styles[element] || {}];
          })),
          attributes: fromEntries(elements.map(function(element) {
            return [element, state2.attributes[element]];
          }))
        });
      },
      requires: ["computeStyles"]
    };
  }, []);
  var popperOptions = React.useMemo(function() {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: "applyStyles",
        enabled: false
      }])
    };
    if (reactFastCompare$1(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function() {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function() {
    if (referenceElement == null || popperElement == null) {
      return;
    }
    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function() {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};
var NOOP = function NOOP2() {
  return void 0;
};
var NOOP_PROMISE = function NOOP_PROMISE2() {
  return Promise.resolve(null);
};
var EMPTY_MODIFIERS = [];
function Popper(_ref6) {
  var _ref$placement = _ref6.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref6.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref6.modifiers, modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref6.referenceElement, onFirstUpdate = _ref6.onFirstUpdate, innerRef = _ref6.innerRef, children = _ref6.children;
  var referenceNode = React.useContext(ManagerReferenceNodeContext);
  var _React$useState = React.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
  var _React$useState2 = React.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
  React.useEffect(function() {
    return setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = React.useMemo(function() {
    return {
      placement,
      strategy,
      onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: "arrow",
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);
  var _usePopper = usePopper$1(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles2 = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
  var childrenProps = React.useMemo(function() {
    return {
      ref: setPopperElement,
      style: styles2.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles2.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles2, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}
function Reference(_ref6) {
  var children = _ref6.children, innerRef = _ref6.innerRef;
  var setReferenceNode = React.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = React.useCallback(function(node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]);
  React.useEffect(function() {
    return function() {
      return setRef(innerRef, null);
    };
  });
  React.useEffect(function() {
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}
function makeOptions(enableEvents) {
  return {
    placement: "bottom-start",
    modifiers: [
      {
        name: "eventListeners",
        enabled: enableEvents
      },
      {
        name: "sameWidth",
        enabled: true,
        phase: "beforeWrite",
        requires: ["computeStyles"],
        fn({
          state
        }) {
          state.styles.popper.width = `${state.rects.reference.width}px`;
        },
        effect({
          state
        }) {
          state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
        }
      }
    ]
  };
}
function usePopper2(referenceElement, popperElement, enableEvents) {
  const options = useMemo(() => makeOptions(enableEvents), [enableEvents]);
  return usePopper$1(referenceElement, popperElement, options);
}
var invariant$1 = function(condition, format, a, b2, c2, d2, e2, f2) {
  if (!condition) {
    var error;
    if (format === void 0) {
      error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    } else {
      var args = [a, b2, c2, d2, e2, f2];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function() {
        return args[argIndex++];
      }));
      error.name = "Invariant Violation";
    }
    error.framesToPop = 1;
    throw error;
  }
};
var browser$1 = invariant$1;
const getRoot$1 = (kind2) => {
  const root2 = document.getElementById(`${kind2}-root`);
  return root2;
};
var noop$1 = () => {
};
function useMultiDropdown(useMultipleSelectionOptions) {
  const {
    getSelectedItemProps,
    getDropdownProps,
    addSelectedItem,
    removeSelectedItem,
    setActiveIndex,
    selectedItems
  } = useMultipleSelection(useMultipleSelectionOptions);
  const stateReducer2 = (_state, changes) => {
    switch (changes.type) {
      case Downshift.stateChangeTypes.keyDownEnter:
      case Downshift.stateChangeTypes.clickItem:
        return __spreadProps(__spreadValues({}, changes), {
          highlightedIndex: _state.highlightedIndex,
          isOpen: true
        });
    }
    return changes;
  };
  const onStateChange = ({
    type,
    selectedItem
  }) => {
    switch (type) {
      case Downshift.stateChangeTypes.keyDownEnter:
      case Downshift.stateChangeTypes.keyDownSpaceButton:
      case Downshift.stateChangeTypes.clickItem:
        if (selectedItem) {
          if (selectedItems.includes(selectedItem)) {
            removeSelectedItem(selectedItem);
            setActiveIndex(-1);
          } else {
            addSelectedItem(selectedItem);
          }
        }
        break;
    }
  };
  return {
    getSelectedItemProps,
    getDropdownProps,
    selectedItems,
    stateReducer: stateReducer2,
    onStateChange
  };
}
const Dropdown = ({
  children,
  icon: Icon2,
  itemToString: itemToString2,
  disabled,
  kind: kind2,
  onChange,
  placeholder,
  size: size2,
  valid: valid2,
  value,
  width,
  portal,
  portalContainer,
  menuStyles,
  multi
}) => {
  const [buttonEl, setButtonEl] = useState(null);
  const [menuEl, setMenuEl] = useState(null);
  const [enableEvents, setEnableEvents] = useState(false);
  const {
    styles: styles2,
    attributes
  } = usePopper2(buttonEl, menuEl, enableEvents);
  const portalRoot = useMemo(() => {
    if (!portal)
      return null;
    return portalContainer ? portalContainer : getRoot$1("menu");
  }, [portal, portalContainer]);
  const {
    getSelectedItemProps,
    getDropdownProps,
    selectedItems,
    stateReducer: multiHookStateReducer,
    onStateChange: multiHookOnStateChange
  } = useMultiDropdown(multi ? {
    initialSelectedItems: value || []
  } : {});
  useEffect(() => {
    if (multi)
      onChange(selectedItems);
  }, [multi, selectedItems]);
  return /* @__PURE__ */ jsx(Downshift, {
    onChange: multi ? noop$1 : onChange,
    stateReducer: multi && multiHookStateReducer,
    onStateChange: (changes) => {
      if (changes.hasOwnProperty("isOpen"))
        setEnableEvents(changes.isOpen);
      if (multi)
        multiHookOnStateChange(changes);
    },
    selectedItem: multi ? null : value,
    itemToString: itemToString2,
    children: ({
      getToggleButtonProps,
      getItemProps,
      getMenuProps,
      getRootProps,
      highlightedIndex,
      isOpen,
      selectedItem
    }) => {
      const options = Children.toArray(children).filter(Boolean);
      const menu = /* @__PURE__ */ jsx(ListBox, __spreadProps(__spreadValues({
        "data-testid": "dropdown-menu"
      }, getMenuProps(__spreadValues({
        ref: setMenuEl,
        closed: !isOpen,
        style: __spreadValues(__spreadValues({}, styles2.popper), menuStyles)
      }, attributes.popper))), {
        children: isOpen && options.map((child, idx) => cloneElement(child, __spreadValues({}, getItemProps(__spreadValues({
          key: child.props.value,
          item: child.props.value,
          size: size2,
          focused: highlightedIndex === idx,
          selected: multi ? selectedItems.includes(child.props.value) : selectedItem === child.props.value
        }, multi && selectedItems.includes(child.props.value) && getSelectedItemProps({
          index: selectedItems.indexOf(child.props.value)
        }))))))
      }));
      return /* @__PURE__ */ jsxs(Container$j, __spreadProps(__spreadValues({
        width
      }, getRootProps()), {
        children: [/* @__PURE__ */ jsxs(Button, __spreadProps(__spreadValues({}, getToggleButtonProps(getDropdownProps({
          ref: setButtonEl,
          disabled,
          size: size2,
          kind: kind2,
          valid: valid2
        }))), {
          children: [Icon2 && /* @__PURE__ */ jsx(Icon2, {
            size: "m"
          }), selectedItem ? /* @__PURE__ */ jsx(TruncateText, {
            children: options.find(({
              props
            }) => props.value === selectedItem).props.children
          }) : selectedItems.length ? /* @__PURE__ */ jsxs(TruncateText, {
            children: [selectedItems.length, " selected"]
          }) : /* @__PURE__ */ jsx(Placeholder, {
            children: placeholder
          }), /* @__PURE__ */ jsx(Caret$2, {
            size: "8px",
            color: "cadet"
          })]
        })), portalRoot ? createPortal(menu, portalRoot) : menu]
      }));
    }
  });
};
Dropdown.propTypes = {
  children: PropTypes$2.node,
  kind: PropTypes$2.oneOf(["ghost"]),
  name: PropTypes$2.string.isRequired,
  onChange: PropTypes$2.func.isRequired,
  placeholder: PropTypes$2.string,
  size: PropTypes$2.oneOf(["lg"]),
  valid: PropTypes$2.bool,
  value: PropTypes$2.any,
  portal: PropTypes$2.bool,
  portalContainer: PropTypes$2.instanceOf(Element),
  menuStyles: PropTypes$2.object
};
Dropdown.defaultProps = {
  itemToString: (value) => value == null ? "" : value,
  placeholder: "Select...",
  valid: true
};
Dropdown.Option = Option;
const ExternalButtonLink = Button$1.withComponent("a", {
  target: "e11ttvn80"
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d2, b2) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d3, b3) {
    d3.__proto__ = b3;
  } || function(d3, b3) {
    for (var p2 in b3)
      if (b3.hasOwnProperty(p2))
        d3[p2] = b3[p2];
  };
  return extendStatics(d2, b2);
};
function __extends(d2, b2) {
  extendStatics(d2, b2);
  function __() {
    this.constructor = d2;
  }
  d2.prototype = b2 === null ? Object.create(b2) : (__.prototype = b2.prototype, new __());
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t2) {
    for (var s, i = 1, n2 = arguments.length; i < n2; i++) {
      s = arguments[i];
      for (var p2 in s)
        if (Object.prototype.hasOwnProperty.call(s, p2))
          t2[p2] = s[p2];
    }
    return t2;
  };
  return __assign.apply(this, arguments);
};
function __rest(s, e2) {
  var t2 = {};
  for (var p2 in s)
    if (Object.prototype.hasOwnProperty.call(s, p2) && e2.indexOf(p2) < 0)
      t2[p2] = s[p2];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") {
    for (var i = 0, p2 = Object.getOwnPropertySymbols(s); i < p2.length; i++)
      if (e2.indexOf(p2[i]) < 0)
        t2[p2[i]] = s[p2[i]];
  }
  return t2;
}
var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols$1 = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== "string") {
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);
      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }
    var keys = getOwnPropertyNames(sourceComponent);
    if (getOwnPropertySymbols$1) {
      keys = keys.concat(getOwnPropertySymbols$1(sourceComponent));
    }
    for (var i = 0; i < keys.length; ++i) {
      var key2 = keys[i];
      if (!REACT_STATICS[key2] && !KNOWN_STATICS[key2] && (!blacklist || !blacklist[key2])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key2);
        try {
          defineProperty(targetComponent, key2, descriptor);
        } catch (e2) {
        }
      }
    }
    return targetComponent;
  }
  return targetComponent;
}
var hoistNonReactStatics_cjs = hoistNonReactStatics;
var lib = { exports: {} };
var implementation = { exports: {} };
var propTypes$1 = { exports: {} };
var ReactPropTypesSecret$2 = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1$1 = ReactPropTypesSecret$2;
var ReactPropTypesSecret$1 = ReactPropTypesSecret_1$1;
function emptyFunction$2() {
}
function emptyFunctionWithReset() {
}
emptyFunctionWithReset.resetWarningCache = emptyFunction$2;
var factoryWithThrowingShims$1 = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      return;
    }
    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    err.name = "Invariant Violation";
    throw err;
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction$2
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
{
  propTypes$1.exports = factoryWithThrowingShims$1();
}
var key = "__global_unique_id__";
var gud = function() {
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
};
var emptyFunction$1 = emptyFunction_1$1;
var warning$1 = emptyFunction$1;
var warning_1 = warning$1;
(function(module2, exports) {
  exports.__esModule = true;
  var _react3 = React__default;
  _interopRequireDefault2(_react3);
  var _propTypes3 = propTypes$1.exports;
  var _propTypes22 = _interopRequireDefault2(_propTypes3);
  var _gud = gud;
  var _gud2 = _interopRequireDefault2(_gud);
  var _warning = warning_1;
  _interopRequireDefault2(_warning);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var MAX_SIGNED_31_BIT_INT = 1073741823;
  function objectIs(x, y2) {
    if (x === y2) {
      return x !== 0 || 1 / x === 1 / y2;
    } else {
      return x !== x && y2 !== y2;
    }
  }
  function createEventEmitter(value) {
    var handlers = [];
    return {
      on: function on(handler) {
        handlers.push(handler);
      },
      off: function off(handler) {
        handlers = handlers.filter(function(h2) {
          return h2 !== handler;
        });
      },
      get: function get2() {
        return value;
      },
      set: function set(newValue, changedBits) {
        value = newValue;
        handlers.forEach(function(handler) {
          return handler(value, changedBits);
        });
      }
    };
  }
  function onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
  }
  function createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + (0, _gud2.default)() + "__";
    var Provider2 = function(_Component) {
      _inherits2(Provider3, _Component);
      function Provider3() {
        var _temp, _this, _ret;
        _classCallCheck2(this, Provider3);
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        return _ret = (_temp = (_this = _possibleConstructorReturn2(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn2(_this, _ret);
      }
      Provider3.prototype.getChildContext = function getChildContext() {
        var _ref6;
        return _ref6 = {}, _ref6[contextProp] = this.emitter, _ref6;
      };
      Provider3.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.value !== nextProps.value) {
          var oldValue = this.props.value;
          var newValue = nextProps.value;
          var changedBits = void 0;
          if (objectIs(oldValue, newValue)) {
            changedBits = 0;
          } else {
            changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            changedBits |= 0;
            if (changedBits !== 0) {
              this.emitter.set(nextProps.value, changedBits);
            }
          }
        }
      };
      Provider3.prototype.render = function render3() {
        return this.props.children;
      };
      return Provider3;
    }(_react3.Component);
    Provider2.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes22.default.object.isRequired, _Provider$childContex);
    var Consumer2 = function(_Component2) {
      _inherits2(Consumer3, _Component2);
      function Consumer3() {
        var _temp2, _this2, _ret2;
        _classCallCheck2(this, Consumer3);
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
        return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn2(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
          value: _this2.getValue()
        }, _this2.onUpdate = function(newValue, changedBits) {
          var observedBits = _this2.observedBits | 0;
          if ((observedBits & changedBits) !== 0) {
            _this2.setState({ value: _this2.getValue() });
          }
        }, _temp2), _possibleConstructorReturn2(_this2, _ret2);
      }
      Consumer3.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var observedBits = nextProps.observedBits;
        this.observedBits = observedBits === void 0 || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
      };
      Consumer3.prototype.componentDidMount = function componentDidMount() {
        if (this.context[contextProp]) {
          this.context[contextProp].on(this.onUpdate);
        }
        var observedBits = this.props.observedBits;
        this.observedBits = observedBits === void 0 || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
      };
      Consumer3.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.context[contextProp]) {
          this.context[contextProp].off(this.onUpdate);
        }
      };
      Consumer3.prototype.getValue = function getValue2() {
        if (this.context[contextProp]) {
          return this.context[contextProp].get();
        } else {
          return defaultValue;
        }
      };
      Consumer3.prototype.render = function render3() {
        return onlyChild(this.props.children)(this.state.value);
      };
      return Consumer3;
    }(_react3.Component);
    Consumer2.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes22.default.object, _Consumer$contextType);
    return {
      Provider: Provider2,
      Consumer: Consumer2
    };
  }
  exports.default = createReactContext;
  module2.exports = exports["default"];
})(implementation, implementation.exports);
(function(module2, exports) {
  exports.__esModule = true;
  var _react3 = React__default;
  var _react22 = _interopRequireDefault2(_react3);
  var _implementation = implementation.exports;
  var _implementation2 = _interopRequireDefault2(_implementation);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  exports.default = _react22.default.createContext || _implementation2.default;
  module2.exports = exports["default"];
})(lib, lib.exports);
var createContext = /* @__PURE__ */ getDefaultExportFromCjs(lib.exports);
var lodash_clonedeep = { exports: {} };
(function(module2, exports) {
  var LARGE_ARRAY_SIZE = 200;
  var HASH_UNDEFINED2 = "__lodash_hash_undefined__";
  var MAX_SAFE_INTEGER = 9007199254740991;
  var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag2 = "[object Function]", genTag2 = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag2 = "[object Symbol]", weakMapTag = "[object WeakMap]";
  var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
  var reRegExpChar2 = /[\\^$.*+?()[\]{}|]/g;
  var reFlags = /\w*$/;
  var reIsHostCtor2 = /^\[object .+?Constructor\]$/;
  var reIsUint = /^(?:0|[1-9]\d*)$/;
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag2] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag2] = cloneableTags[weakMapTag] = false;
  var freeGlobal2 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
  var freeSelf2 = typeof self == "object" && self && self.Object === Object && self;
  var root2 = freeGlobal2 || freeSelf2 || Function("return this")();
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module2 && !module2.nodeType && module2;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  function addMapEntry(map, pair) {
    map.set(pair[0], pair[1]);
    return map;
  }
  function addSetEntry(set, value) {
    set.add(value);
    return set;
  }
  function arrayEach(array, iteratee) {
    var index2 = -1, length = array ? array.length : 0;
    while (++index2 < length) {
      if (iteratee(array[index2], index2, array) === false) {
        break;
      }
    }
    return array;
  }
  function arrayPush(array, values) {
    var index2 = -1, length = values.length, offset2 = array.length;
    while (++index2 < length) {
      array[offset2 + index2] = values[index2];
    }
    return array;
  }
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index2 = -1, length = array ? array.length : 0;
    if (initAccum && length) {
      accumulator = array[++index2];
    }
    while (++index2 < length) {
      accumulator = iteratee(accumulator, array[index2], index2, array);
    }
    return accumulator;
  }
  function baseTimes(n2, iteratee) {
    var index2 = -1, result = Array(n2);
    while (++index2 < n2) {
      result[index2] = iteratee(index2);
    }
    return result;
  }
  function getValue2(object, key2) {
    return object == null ? void 0 : object[key2];
  }
  function isHostObject2(value) {
    var result = false;
    if (value != null && typeof value.toString != "function") {
      try {
        result = !!(value + "");
      } catch (e2) {
      }
    }
    return result;
  }
  function mapToArray(map) {
    var index2 = -1, result = Array(map.size);
    map.forEach(function(value, key2) {
      result[++index2] = [key2, value];
    });
    return result;
  }
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }
  function setToArray(set) {
    var index2 = -1, result = Array(set.size);
    set.forEach(function(value) {
      result[++index2] = value;
    });
    return result;
  }
  var arrayProto2 = Array.prototype, funcProto2 = Function.prototype, objectProto2 = Object.prototype;
  var coreJsData2 = root2["__core-js_shared__"];
  var maskSrcKey2 = function() {
    var uid = /[^.]+$/.exec(coreJsData2 && coreJsData2.keys && coreJsData2.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
  }();
  var funcToString2 = funcProto2.toString;
  var hasOwnProperty2 = objectProto2.hasOwnProperty;
  var objectToString2 = objectProto2.toString;
  var reIsNative2 = RegExp("^" + funcToString2.call(hasOwnProperty2).replace(reRegExpChar2, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
  var Buffer2 = moduleExports ? root2.Buffer : void 0, Symbol2 = root2.Symbol, Uint8Array2 = root2.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto2.propertyIsEnumerable, splice2 = arrayProto2.splice;
  var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0, nativeKeys = overArg(Object.keys, Object);
  var DataView = getNative2(root2, "DataView"), Map2 = getNative2(root2, "Map"), Promise2 = getNative2(root2, "Promise"), Set2 = getNative2(root2, "Set"), WeakMap2 = getNative2(root2, "WeakMap"), nativeCreate2 = getNative2(Object, "create");
  var dataViewCtorString = toSource2(DataView), mapCtorString = toSource2(Map2), promiseCtorString = toSource2(Promise2), setCtorString = toSource2(Set2), weakMapCtorString = toSource2(WeakMap2);
  var symbolProto2 = Symbol2 ? Symbol2.prototype : void 0, symbolValueOf = symbolProto2 ? symbolProto2.valueOf : void 0;
  function Hash2(entries) {
    var index2 = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function hashClear2() {
    this.__data__ = nativeCreate2 ? nativeCreate2(null) : {};
  }
  function hashDelete2(key2) {
    return this.has(key2) && delete this.__data__[key2];
  }
  function hashGet2(key2) {
    var data = this.__data__;
    if (nativeCreate2) {
      var result = data[key2];
      return result === HASH_UNDEFINED2 ? void 0 : result;
    }
    return hasOwnProperty2.call(data, key2) ? data[key2] : void 0;
  }
  function hashHas2(key2) {
    var data = this.__data__;
    return nativeCreate2 ? data[key2] !== void 0 : hasOwnProperty2.call(data, key2);
  }
  function hashSet2(key2, value) {
    var data = this.__data__;
    data[key2] = nativeCreate2 && value === void 0 ? HASH_UNDEFINED2 : value;
    return this;
  }
  Hash2.prototype.clear = hashClear2;
  Hash2.prototype["delete"] = hashDelete2;
  Hash2.prototype.get = hashGet2;
  Hash2.prototype.has = hashHas2;
  Hash2.prototype.set = hashSet2;
  function ListCache2(entries) {
    var index2 = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function listCacheClear2() {
    this.__data__ = [];
  }
  function listCacheDelete2(key2) {
    var data = this.__data__, index2 = assocIndexOf2(data, key2);
    if (index2 < 0) {
      return false;
    }
    var lastIndex = data.length - 1;
    if (index2 == lastIndex) {
      data.pop();
    } else {
      splice2.call(data, index2, 1);
    }
    return true;
  }
  function listCacheGet2(key2) {
    var data = this.__data__, index2 = assocIndexOf2(data, key2);
    return index2 < 0 ? void 0 : data[index2][1];
  }
  function listCacheHas2(key2) {
    return assocIndexOf2(this.__data__, key2) > -1;
  }
  function listCacheSet2(key2, value) {
    var data = this.__data__, index2 = assocIndexOf2(data, key2);
    if (index2 < 0) {
      data.push([key2, value]);
    } else {
      data[index2][1] = value;
    }
    return this;
  }
  ListCache2.prototype.clear = listCacheClear2;
  ListCache2.prototype["delete"] = listCacheDelete2;
  ListCache2.prototype.get = listCacheGet2;
  ListCache2.prototype.has = listCacheHas2;
  ListCache2.prototype.set = listCacheSet2;
  function MapCache2(entries) {
    var index2 = -1, length = entries ? entries.length : 0;
    this.clear();
    while (++index2 < length) {
      var entry = entries[index2];
      this.set(entry[0], entry[1]);
    }
  }
  function mapCacheClear2() {
    this.__data__ = {
      "hash": new Hash2(),
      "map": new (Map2 || ListCache2)(),
      "string": new Hash2()
    };
  }
  function mapCacheDelete2(key2) {
    return getMapData2(this, key2)["delete"](key2);
  }
  function mapCacheGet2(key2) {
    return getMapData2(this, key2).get(key2);
  }
  function mapCacheHas2(key2) {
    return getMapData2(this, key2).has(key2);
  }
  function mapCacheSet2(key2, value) {
    getMapData2(this, key2).set(key2, value);
    return this;
  }
  MapCache2.prototype.clear = mapCacheClear2;
  MapCache2.prototype["delete"] = mapCacheDelete2;
  MapCache2.prototype.get = mapCacheGet2;
  MapCache2.prototype.has = mapCacheHas2;
  MapCache2.prototype.set = mapCacheSet2;
  function Stack(entries) {
    this.__data__ = new ListCache2(entries);
  }
  function stackClear() {
    this.__data__ = new ListCache2();
  }
  function stackDelete(key2) {
    return this.__data__["delete"](key2);
  }
  function stackGet(key2) {
    return this.__data__.get(key2);
  }
  function stackHas(key2) {
    return this.__data__.has(key2);
  }
  function stackSet(key2, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache2) {
      var pairs = cache.__data__;
      if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
        pairs.push([key2, value]);
        return this;
      }
      cache = this.__data__ = new MapCache2(pairs);
    }
    cache.set(key2, value);
    return this;
  }
  Stack.prototype.clear = stackClear;
  Stack.prototype["delete"] = stackDelete;
  Stack.prototype.get = stackGet;
  Stack.prototype.has = stackHas;
  Stack.prototype.set = stackSet;
  function arrayLikeKeys(value, inherited) {
    var result = isArray2(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for (var key2 in value) {
      if ((inherited || hasOwnProperty2.call(value, key2)) && !(skipIndexes && (key2 == "length" || isIndex(key2, length)))) {
        result.push(key2);
      }
    }
    return result;
  }
  function assignValue(object, key2, value) {
    var objValue = object[key2];
    if (!(hasOwnProperty2.call(object, key2) && eq2(objValue, value)) || value === void 0 && !(key2 in object)) {
      object[key2] = value;
    }
  }
  function assocIndexOf2(array, key2) {
    var length = array.length;
    while (length--) {
      if (eq2(array[length][0], key2)) {
        return length;
      }
    }
    return -1;
  }
  function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
  }
  function baseClone(value, isDeep, isFull, customizer, key2, object, stack) {
    var result;
    if (customizer) {
      result = object ? customizer(value, key2, object, stack) : customizer(value);
    }
    if (result !== void 0) {
      return result;
    }
    if (!isObject2(value)) {
      return value;
    }
    var isArr = isArray2(value);
    if (isArr) {
      result = initCloneArray(value);
      if (!isDeep) {
        return copyArray2(value, result);
      }
    } else {
      var tag = getTag(value), isFunc = tag == funcTag2 || tag == genTag2;
      if (isBuffer(value)) {
        return cloneBuffer(value, isDeep);
      }
      if (tag == objectTag || tag == argsTag || isFunc && !object) {
        if (isHostObject2(value)) {
          return object ? value : {};
        }
        result = initCloneObject(isFunc ? {} : value);
        if (!isDeep) {
          return copySymbols(value, baseAssign(result, value));
        }
      } else {
        if (!cloneableTags[tag]) {
          return object ? value : {};
        }
        result = initCloneByTag(value, tag, baseClone, isDeep);
      }
    }
    stack || (stack = new Stack());
    var stacked = stack.get(value);
    if (stacked) {
      return stacked;
    }
    stack.set(value, result);
    if (!isArr) {
      var props = isFull ? getAllKeys(value) : keys(value);
    }
    arrayEach(props || value, function(subValue, key3) {
      if (props) {
        key3 = subValue;
        subValue = value[key3];
      }
      assignValue(result, key3, baseClone(subValue, isDeep, isFull, customizer, key3, value, stack));
    });
    return result;
  }
  function baseCreate(proto) {
    return isObject2(proto) ? objectCreate(proto) : {};
  }
  function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray2(object) ? result : arrayPush(result, symbolsFunc(object));
  }
  function baseGetTag2(value) {
    return objectToString2.call(value);
  }
  function baseIsNative2(value) {
    if (!isObject2(value) || isMasked2(value)) {
      return false;
    }
    var pattern = isFunction2(value) || isHostObject2(value) ? reIsNative2 : reIsHostCtor2;
    return pattern.test(toSource2(value));
  }
  function baseKeys(object) {
    if (!isPrototype(object)) {
      return nativeKeys(object);
    }
    var result = [];
    for (var key2 in Object(object)) {
      if (hasOwnProperty2.call(object, key2) && key2 != "constructor") {
        result.push(key2);
      }
    }
    return result;
  }
  function cloneBuffer(buffer, isDeep) {
    if (isDeep) {
      return buffer.slice();
    }
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
  }
  function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
    return result;
  }
  function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
  }
  function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor());
  }
  function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
  }
  function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor());
  }
  function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
  }
  function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
  }
  function copyArray2(source, array) {
    var index2 = -1, length = source.length;
    array || (array = Array(length));
    while (++index2 < length) {
      array[index2] = source[index2];
    }
    return array;
  }
  function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index2 = -1, length = props.length;
    while (++index2 < length) {
      var key2 = props[index2];
      var newValue = customizer ? customizer(object[key2], source[key2], key2, object, source) : void 0;
      assignValue(object, key2, newValue === void 0 ? source[key2] : newValue);
    }
    return object;
  }
  function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
  }
  function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
  }
  function getMapData2(map, key2) {
    var data = map.__data__;
    return isKeyable2(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
  }
  function getNative2(object, key2) {
    var value = getValue2(object, key2);
    return baseIsNative2(value) ? value : void 0;
  }
  var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
  var getTag = baseGetTag2;
  if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
    getTag = function(value) {
      var result = objectToString2.call(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource2(Ctor) : void 0;
      if (ctorString) {
        switch (ctorString) {
          case dataViewCtorString:
            return dataViewTag;
          case mapCtorString:
            return mapTag;
          case promiseCtorString:
            return promiseTag;
          case setCtorString:
            return setTag;
          case weakMapCtorString:
            return weakMapTag;
        }
      }
      return result;
    };
  }
  function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    if (length && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
      result.index = array.index;
      result.input = array.input;
    }
    return result;
  }
  function initCloneObject(object) {
    return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
  }
  function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch (tag) {
      case arrayBufferTag:
        return cloneArrayBuffer(object);
      case boolTag:
      case dateTag:
        return new Ctor(+object);
      case dataViewTag:
        return cloneDataView(object, isDeep);
      case float32Tag:
      case float64Tag:
      case int8Tag:
      case int16Tag:
      case int32Tag:
      case uint8Tag:
      case uint8ClampedTag:
      case uint16Tag:
      case uint32Tag:
        return cloneTypedArray(object, isDeep);
      case mapTag:
        return cloneMap(object, isDeep, cloneFunc);
      case numberTag:
      case stringTag:
        return new Ctor(object);
      case regexpTag:
        return cloneRegExp(object);
      case setTag:
        return cloneSet(object, isDeep, cloneFunc);
      case symbolTag2:
        return cloneSymbol(object);
    }
  }
  function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
  }
  function isKeyable2(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
  }
  function isMasked2(func) {
    return !!maskSrcKey2 && maskSrcKey2 in func;
  }
  function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto2;
    return value === proto;
  }
  function toSource2(func) {
    if (func != null) {
      try {
        return funcToString2.call(func);
      } catch (e2) {
      }
      try {
        return func + "";
      } catch (e2) {
      }
    }
    return "";
  }
  function cloneDeep2(value) {
    return baseClone(value, true, true);
  }
  function eq2(value, other) {
    return value === other || value !== value && other !== other;
  }
  function isArguments(value) {
    return isArrayLikeObject(value) && hasOwnProperty2.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString2.call(value) == argsTag);
  }
  var isArray2 = Array.isArray;
  function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction2(value);
  }
  function isArrayLikeObject(value) {
    return isObjectLike2(value) && isArrayLike(value);
  }
  var isBuffer = nativeIsBuffer || stubFalse;
  function isFunction2(value) {
    var tag = isObject2(value) ? objectToString2.call(value) : "";
    return tag == funcTag2 || tag == genTag2;
  }
  function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
  }
  function isObject2(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
  }
  function isObjectLike2(value) {
    return !!value && typeof value == "object";
  }
  function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
  }
  function stubArray() {
    return [];
  }
  function stubFalse() {
    return false;
  }
  module2.exports = cloneDeep2;
})(lodash_clonedeep, lodash_clonedeep.exports);
var cloneDeep = lodash_clonedeep.exports;
var FUNC_ERROR_TEXT = "Expected a function";
var HASH_UNDEFINED = "__lodash_hash_undefined__";
var INFINITY = 1 / 0;
var funcTag = "[object Function]", genTag = "[object GeneratorFunction]", symbolTag = "[object Symbol]";
var reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reEscapeChar = /\\(\\)?/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var freeGlobal = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$1 = freeGlobal || freeSelf || Function("return this")();
function arrayMap(array, iteratee) {
  var index2 = -1, length = array ? array.length : 0, result = Array(length);
  while (++index2 < length) {
    result[index2] = iteratee(array[index2], index2, array);
  }
  return result;
}
function getValue(object, key2) {
  return object == null ? void 0 : object[key2];
}
function isHostObject(value) {
  var result = false;
  if (value != null && typeof value.toString != "function") {
    try {
      result = !!(value + "");
    } catch (e2) {
    }
  }
  return result;
}
var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
var coreJsData = root$1["__core-js_shared__"];
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
var funcToString = funcProto.toString;
var hasOwnProperty$1 = objectProto.hasOwnProperty;
var objectToString = objectProto.toString;
var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty$1).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
var Symbol$1 = root$1.Symbol, splice = arrayProto.splice;
var Map$1 = getNative(root$1, "Map"), nativeCreate = getNative(Object, "create");
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolToString = symbolProto ? symbolProto.toString : void 0;
function Hash(entries) {
  var index2 = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
function hashDelete(key2) {
  return this.has(key2) && delete this.__data__[key2];
}
function hashGet(key2) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key2];
    return result === HASH_UNDEFINED ? void 0 : result;
  }
  return hasOwnProperty$1.call(data, key2) ? data[key2] : void 0;
}
function hashHas(key2) {
  var data = this.__data__;
  return nativeCreate ? data[key2] !== void 0 : hasOwnProperty$1.call(data, key2);
}
function hashSet(key2, value) {
  var data = this.__data__;
  data[key2] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
  return this;
}
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
function ListCache(entries) {
  var index2 = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
function listCacheClear() {
  this.__data__ = [];
}
function listCacheDelete(key2) {
  var data = this.__data__, index2 = assocIndexOf(data, key2);
  if (index2 < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index2 == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index2, 1);
  }
  return true;
}
function listCacheGet(key2) {
  var data = this.__data__, index2 = assocIndexOf(data, key2);
  return index2 < 0 ? void 0 : data[index2][1];
}
function listCacheHas(key2) {
  return assocIndexOf(this.__data__, key2) > -1;
}
function listCacheSet(key2, value) {
  var data = this.__data__, index2 = assocIndexOf(data, key2);
  if (index2 < 0) {
    data.push([key2, value]);
  } else {
    data[index2][1] = value;
  }
  return this;
}
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
function MapCache(entries) {
  var index2 = -1, length = entries ? entries.length : 0;
  this.clear();
  while (++index2 < length) {
    var entry = entries[index2];
    this.set(entry[0], entry[1]);
  }
}
function mapCacheClear() {
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$1 || ListCache)(),
    "string": new Hash()
  };
}
function mapCacheDelete(key2) {
  return getMapData(this, key2)["delete"](key2);
}
function mapCacheGet(key2) {
  return getMapData(this, key2).get(key2);
}
function mapCacheHas(key2) {
  return getMapData(this, key2).has(key2);
}
function mapCacheSet(key2, value) {
  getMapData(this, key2).set(key2, value);
  return this;
}
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
function assocIndexOf(array, key2) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key2)) {
      return length;
    }
  }
  return -1;
}
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}
function baseToString(value) {
  if (typeof value == "string") {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : "";
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function copyArray(source, array) {
  var index2 = -1, length = source.length;
  array || (array = Array(length));
  while (++index2 < length) {
    array[index2] = source[index2];
  }
  return array;
}
function getMapData(map, key2) {
  var data = map.__data__;
  return isKeyable(key2) ? data[typeof key2 == "string" ? "string" : "hash"] : data.map;
}
function getNative(object, key2) {
  var value = getValue(object, key2);
  return baseIsNative(value) ? value : void 0;
}
function isKeyable(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var stringToPath = memoize(function(string) {
  string = toString(string);
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push("");
  }
  string.replace(rePropName, function(match, number, quote, string2) {
    result.push(quote ? string2.replace(reEscapeChar, "$1") : number || match);
  });
  return result;
});
function toKey(value) {
  if (typeof value == "string" || isSymbol(value)) {
    return value;
  }
  var result = value + "";
  return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e2) {
    }
    try {
      return func + "";
    } catch (e2) {
    }
  }
  return "";
}
function memoize(func, resolver) {
  if (typeof func != "function" || resolver && typeof resolver != "function") {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments, key2 = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
    if (cache.has(key2)) {
      return cache.get(key2);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key2, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache)();
  return memoized;
}
memoize.Cache = MapCache;
function eq(value, other) {
  return value === other || value !== value && other !== other;
}
var isArray$1 = Array.isArray;
function isFunction$1(value) {
  var tag = isObject$1(value) ? objectToString.call(value) : "";
  return tag == funcTag || tag == genTag;
}
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == "object" || type == "function");
}
function isObjectLike(value) {
  return !!value && typeof value == "object";
}
function isSymbol(value) {
  return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
function toString(value) {
  return value == null ? "" : baseToString(value);
}
function toPath(value) {
  if (isArray$1(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(value));
}
var lodash_topath = toPath;
var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
function equal(a, b2) {
  if (a === b2)
    return true;
  var arrA = isArray(a), arrB = isArray(b2), i, length, key2;
  if (arrA && arrB) {
    length = a.length;
    if (length != b2.length)
      return false;
    for (i = 0; i < length; i++)
      if (!equal(a[i], b2[i]))
        return false;
    return true;
  }
  if (arrA != arrB)
    return false;
  var dateA = a instanceof Date, dateB = b2 instanceof Date;
  if (dateA != dateB)
    return false;
  if (dateA && dateB)
    return a.getTime() == b2.getTime();
  var regexpA = a instanceof RegExp, regexpB = b2 instanceof RegExp;
  if (regexpA != regexpB)
    return false;
  if (regexpA && regexpB)
    return a.toString() == b2.toString();
  if (a instanceof Object && b2 instanceof Object) {
    var keys = keyList(a);
    length = keys.length;
    if (length !== keyList(b2).length)
      return false;
    for (i = 0; i < length; i++)
      if (!hasProp.call(b2, keys[i]))
        return false;
    for (i = 0; i < length; i++) {
      key2 = keys[i];
      if (key2 === "_owner" && a.$$typeof && a._store) {
        continue;
      } else {
        if (!equal(a[key2], b2[key2]))
          return false;
      }
    }
    return true;
  }
  return false;
}
var reactFastCompare = function exportedEqual(a, b2) {
  try {
    return equal(a, b2);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
      return false;
    }
    throw error;
  }
};
var warning = function() {
};
var browser = warning;
var isMergeableObject = function isMergeableObject2(value) {
  return isNonNullObject(value) && !isSpecial(value);
};
function isNonNullObject(value) {
  return !!value && typeof value === "object";
}
function isSpecial(value) {
  var stringValue = Object.prototype.toString.call(value);
  return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
}
var canUseSymbol = typeof Symbol === "function" && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 60103;
function isReactElement(value) {
  return value.$$typeof === REACT_ELEMENT_TYPE;
}
function emptyTarget(val) {
  return Array.isArray(val) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
  return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
}
function defaultArrayMerge(target, source, options) {
  return target.concat(source).map(function(element) {
    return cloneUnlessOtherwiseSpecified(element, options);
  });
}
function mergeObject(target, source, options) {
  var destination = {};
  if (options.isMergeableObject(target)) {
    Object.keys(target).forEach(function(key2) {
      destination[key2] = cloneUnlessOtherwiseSpecified(target[key2], options);
    });
  }
  Object.keys(source).forEach(function(key2) {
    if (!options.isMergeableObject(source[key2]) || !target[key2]) {
      destination[key2] = cloneUnlessOtherwiseSpecified(source[key2], options);
    } else {
      destination[key2] = deepmerge(target[key2], source[key2], options);
    }
  });
  return destination;
}
function deepmerge(target, source, options) {
  options = options || {};
  options.arrayMerge = options.arrayMerge || defaultArrayMerge;
  options.isMergeableObject = options.isMergeableObject || isMergeableObject;
  var sourceIsArray = Array.isArray(source);
  var targetIsArray = Array.isArray(target);
  var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
  if (!sourceAndTargetTypesMatch) {
    return cloneUnlessOtherwiseSpecified(source, options);
  } else if (sourceIsArray) {
    return options.arrayMerge(target, source, options);
  } else {
    return mergeObject(target, source, options);
  }
}
deepmerge.all = function deepmergeAll(array, options) {
  if (!Array.isArray(array)) {
    throw new Error("first argument should be an array");
  }
  return array.reduce(function(prev, next) {
    return deepmerge(prev, next, options);
  }, {});
};
var deepmerge_1 = deepmerge;
var _a;
var FormikProvider = (_a = createContext({}), _a.Provider), FormikConsumer = _a.Consumer;
function connect(Comp) {
  var C2 = function(props) {
    return createElement(FormikConsumer, null, function(formik) {
      return createElement(Comp, __assign({}, props, { formik }));
    });
  };
  C2.WrappedComponent = Comp;
  return hoistNonReactStatics_cjs(C2, Comp);
}
function getIn(obj, key2, def, p2) {
  if (p2 === void 0) {
    p2 = 0;
  }
  var path = lodash_topath(key2);
  while (obj && p2 < path.length) {
    obj = obj[path[p2++]];
  }
  return obj === void 0 ? def : obj;
}
function setIn(obj, path, value) {
  var res = {};
  var resVal = res;
  var i = 0;
  var pathArray = lodash_topath(path);
  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));
    if (resVal[currentPath]) {
      resVal = resVal[currentPath];
    } else if (currentObj) {
      resVal = resVal[currentPath] = cloneDeep(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  }
  resVal[pathArray[i]] = value;
  return __assign({}, obj, res);
}
function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = /* @__PURE__ */ new WeakMap();
  }
  if (response === void 0) {
    response = {};
  }
  for (var _i = 0, _a2 = Object.keys(object); _i < _a2.length; _i++) {
    var k2 = _a2[_i];
    var val = object[k2];
    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true);
        response[k2] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k2]);
      }
    } else {
      response[k2] = value;
    }
  }
  return response;
}
var isFunction = function(obj) {
  return typeof obj === "function";
};
var isObject = function(obj) {
  return obj !== null && typeof obj === "object";
};
var isInteger = function(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
var isString = function(obj) {
  return Object.prototype.toString.call(obj) === "[object String]";
};
var isNaN$1 = function(obj) {
  return obj !== obj;
};
var isEmptyChildren = function(children) {
  return Children.count(children) === 0;
};
var isPromise = function(value) {
  return isObject(value) && isFunction(value.then);
};
var Formik = function(_super) {
  __extends(Formik2, _super);
  function Formik2(props) {
    var _this = _super.call(this, props) || this;
    _this.hcCache = {};
    _this.hbCache = {};
    _this.registerField = function(name, fns) {
      _this.fields[name] = fns;
    };
    _this.unregisterField = function(name) {
      delete _this.fields[name];
    };
    _this.setErrors = function(errors) {
      _this.setState({ errors });
    };
    _this.setTouched = function(touched) {
      _this.setState({ touched }, function() {
        if (_this.props.validateOnBlur) {
          _this.runValidations(_this.state.values);
        }
      });
    };
    _this.setValues = function(values) {
      _this.setState({ values }, function() {
        if (_this.props.validateOnChange) {
          _this.runValidations(values);
        }
      });
    };
    _this.setStatus = function(status) {
      _this.setState({ status });
    };
    _this.setError = function(error) {
      _this.setState({ error });
    };
    _this.setSubmitting = function(isSubmitting) {
      _this.setState({ isSubmitting });
    };
    _this.validateField = function(field) {
      _this.setState({ isValidating: true });
      _this.runSingleFieldLevelValidation(field, getIn(_this.state.values, field)).then(function(error) {
        if (!!error && _this.didMount) {
          _this.setState({
            errors: setIn(_this.state.errors, field, error),
            isValidating: false
          });
        }
      });
    };
    _this.runSingleFieldLevelValidation = function(field, value) {
      return new Promise(function(resolve) {
        return resolve(_this.fields[field].validate(value));
      });
    };
    _this.runValidationSchema = function(values) {
      return new Promise(function(resolve) {
        var validationSchema = _this.props.validationSchema;
        var schema = isFunction(validationSchema) ? validationSchema() : validationSchema;
        validateYupSchema(values, schema).then(function() {
          resolve({});
        }, function(err) {
          resolve(yupToFormErrors(err));
        });
      });
    };
    _this.runValidations = function(values) {
      if (values === void 0) {
        values = _this.state.values;
      }
      _this.setState({ isValidating: true });
      return Promise.all([
        _this.runFieldLevelValidations(values),
        _this.props.validationSchema ? _this.runValidationSchema(values) : {},
        _this.props.validate ? _this.runValidateHandler(values) : {}
      ]).then(function(_a2) {
        var fieldErrors = _a2[0], schemaErrors = _a2[1], handlerErrors = _a2[2];
        var combinedErrors = deepmerge_1.all([
          fieldErrors,
          schemaErrors,
          handlerErrors
        ]);
        if (_this.didMount) {
          _this.setState({ isValidating: false, errors: combinedErrors });
        }
        return combinedErrors;
      });
    };
    _this.handleChange = function(eventOrPath) {
      var executeChange = function(eventOrTextValue, maybePath) {
        var field = maybePath;
        var val = eventOrTextValue;
        var parsed;
        if (!isString(eventOrTextValue)) {
          if (eventOrTextValue.persist) {
            eventOrTextValue.persist();
          }
          var _a2 = eventOrTextValue.target, type = _a2.type, name_1 = _a2.name, id = _a2.id, value = _a2.value, checked = _a2.checked, outerHTML = _a2.outerHTML;
          field = maybePath ? maybePath : name_1 ? name_1 : id;
          if (!field && false) {
            warnAboutMissingIdentifier({
              htmlContent: outerHTML,
              documentationAnchorLink: "handlechange-e-reactchangeeventany--void",
              handlerName: "handleChange"
            });
          }
          val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN$1(parsed) ? "" : parsed) : /checkbox/.test(type) ? checked : value;
        }
        if (field) {
          _this.setState(function(prevState) {
            return __assign({}, prevState, { values: setIn(prevState.values, field, val) });
          });
          if (_this.props.validateOnChange) {
            _this.runValidations(setIn(_this.state.values, field, val));
          }
        }
      };
      if (isString(eventOrPath)) {
        return isFunction(_this.hcCache[eventOrPath]) ? _this.hcCache[eventOrPath] : _this.hcCache[eventOrPath] = function(event) {
          return executeChange(event, eventOrPath);
        };
      } else {
        executeChange(eventOrPath);
      }
    };
    _this.setFieldValue = function(field, value, shouldValidate) {
      if (shouldValidate === void 0) {
        shouldValidate = true;
      }
      _this.setState(function(prevState) {
        return __assign({}, prevState, { values: setIn(prevState.values, field, value) });
      }, function() {
        if (_this.props.validateOnChange && shouldValidate) {
          _this.runValidations(_this.state.values);
        }
      });
    };
    _this.handleSubmit = function(e2) {
      if (e2 && e2.preventDefault) {
        e2.preventDefault();
      }
      _this.submitForm();
    };
    _this.submitForm = function() {
      _this.setState(function(prevState) {
        return {
          touched: setNestedObjectValues(prevState.values, true),
          isSubmitting: true,
          submitCount: prevState.submitCount + 1
        };
      });
      return _this.runValidations().then(function(combinedErrors) {
        var isValid = Object.keys(combinedErrors).length === 0;
        if (isValid) {
          _this.executeSubmit();
        } else {
          _this.setState({ isSubmitting: false });
        }
      });
    };
    _this.executeSubmit = function() {
      _this.props.onSubmit(_this.state.values, _this.getFormikActions());
    };
    _this.handleBlur = function(eventOrString) {
      var executeBlur = function(e2, path) {
        if (e2.persist) {
          e2.persist();
        }
        var _a2 = e2.target, name = _a2.name, id = _a2.id, outerHTML = _a2.outerHTML;
        var field = path ? path : name ? name : id;
        if (!field && false) {
          warnAboutMissingIdentifier({
            htmlContent: outerHTML,
            documentationAnchorLink: "handleblur-e-any--void",
            handlerName: "handleBlur"
          });
        }
        _this.setState(function(prevState) {
          return {
            touched: setIn(prevState.touched, field, true)
          };
        });
        if (_this.props.validateOnBlur) {
          _this.runValidations(_this.state.values);
        }
      };
      if (isString(eventOrString)) {
        return isFunction(_this.hbCache[eventOrString]) ? _this.hbCache[eventOrString] : _this.hbCache[eventOrString] = function(event) {
          return executeBlur(event, eventOrString);
        };
      } else {
        executeBlur(eventOrString);
      }
    };
    _this.setFieldTouched = function(field, touched, shouldValidate) {
      if (touched === void 0) {
        touched = true;
      }
      if (shouldValidate === void 0) {
        shouldValidate = true;
      }
      _this.setState(function(prevState) {
        return __assign({}, prevState, { touched: setIn(prevState.touched, field, touched) });
      }, function() {
        if (_this.props.validateOnBlur && shouldValidate) {
          _this.runValidations(_this.state.values);
        }
      });
    };
    _this.setFieldError = function(field, message) {
      _this.setState(function(prevState) {
        return __assign({}, prevState, { errors: setIn(prevState.errors, field, message) });
      });
    };
    _this.resetForm = function(nextValues) {
      var values = nextValues ? nextValues : _this.props.initialValues;
      _this.initialValues = values;
      _this.setState({
        isSubmitting: false,
        isValidating: false,
        errors: {},
        touched: {},
        error: void 0,
        status: void 0,
        values,
        submitCount: 0
      });
    };
    _this.handleReset = function() {
      if (_this.props.onReset) {
        var maybePromisedOnReset = _this.props.onReset(_this.state.values, _this.getFormikActions());
        if (isPromise(maybePromisedOnReset)) {
          maybePromisedOnReset.then(_this.resetForm);
        } else {
          _this.resetForm();
        }
      } else {
        _this.resetForm();
      }
    };
    _this.setFormikState = function(s, callback) {
      return _this.setState(s, callback);
    };
    _this.getFormikActions = function() {
      return {
        resetForm: _this.resetForm,
        submitForm: _this.submitForm,
        validateForm: _this.runValidations,
        validateField: _this.validateField,
        setError: _this.setError,
        setErrors: _this.setErrors,
        setFieldError: _this.setFieldError,
        setFieldTouched: _this.setFieldTouched,
        setFieldValue: _this.setFieldValue,
        setStatus: _this.setStatus,
        setSubmitting: _this.setSubmitting,
        setTouched: _this.setTouched,
        setValues: _this.setValues,
        setFormikState: _this.setFormikState
      };
    };
    _this.getFormikComputedProps = function() {
      var isInitialValid = _this.props.isInitialValid;
      var dirty = !reactFastCompare(_this.initialValues, _this.state.values);
      return {
        dirty,
        isValid: dirty ? _this.state.errors && Object.keys(_this.state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(_this.props) : isInitialValid,
        initialValues: _this.initialValues
      };
    };
    _this.getFormikBag = function() {
      return __assign({}, _this.state, _this.getFormikActions(), _this.getFormikComputedProps(), { registerField: _this.registerField, unregisterField: _this.unregisterField, handleBlur: _this.handleBlur, handleChange: _this.handleChange, handleReset: _this.handleReset, handleSubmit: _this.handleSubmit, validateOnChange: _this.props.validateOnChange, validateOnBlur: _this.props.validateOnBlur });
    };
    _this.getFormikContext = function() {
      return __assign({}, _this.getFormikBag(), { validationSchema: _this.props.validationSchema, validate: _this.props.validate });
    };
    _this.state = {
      values: props.initialValues || {},
      errors: {},
      touched: {},
      isSubmitting: false,
      isValidating: false,
      submitCount: 0
    };
    _this.didMount = false;
    _this.fields = {};
    _this.initialValues = props.initialValues || {};
    browser(!(props.component && props.render));
    browser(!(props.component && props.children && !isEmptyChildren(props.children)));
    browser(!(props.render && props.children && !isEmptyChildren(props.children)));
    return _this;
  }
  Formik2.prototype.componentDidMount = function() {
    this.didMount = true;
  };
  Formik2.prototype.componentWillUnmount = function() {
    this.didMount = false;
  };
  Formik2.prototype.componentDidUpdate = function(prevProps) {
    if (this.props.enableReinitialize && !reactFastCompare(prevProps.initialValues, this.props.initialValues)) {
      this.initialValues = this.props.initialValues;
      this.resetForm(this.props.initialValues);
    }
  };
  Formik2.prototype.runFieldLevelValidations = function(values) {
    var _this = this;
    var fieldKeysWithValidation = Object.keys(this.fields).filter(function(f2) {
      return _this.fields && _this.fields[f2] && _this.fields[f2].validate && isFunction(_this.fields[f2].validate);
    });
    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function(f2) {
      return _this.runSingleFieldLevelValidation(f2, getIn(values, f2)).then(function(x) {
        return x;
      }, function(e2) {
        return e2;
      });
    }) : [Promise.resolve("DO_NOT_DELETE_YOU_WILL_BE_FIRED")];
    return Promise.all(fieldValidations).then(function(fieldErrorsList) {
      return fieldErrorsList.reduce(function(prev, curr, index2) {
        if (curr === "DO_NOT_DELETE_YOU_WILL_BE_FIRED") {
          return prev;
        }
        if (!!curr) {
          prev = setIn(prev, fieldKeysWithValidation[index2], curr);
        }
        return prev;
      }, {});
    });
  };
  Formik2.prototype.runValidateHandler = function(values) {
    var _this = this;
    return new Promise(function(resolve) {
      var maybePromisedErrors = _this.props.validate(values);
      if (maybePromisedErrors === void 0) {
        resolve({});
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function() {
          resolve({});
        }, function(errors) {
          resolve(errors);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  };
  Formik2.prototype.render = function() {
    var _a2 = this.props, component = _a2.component, render3 = _a2.render, children = _a2.children;
    var props = this.getFormikBag();
    var ctx = this.getFormikContext();
    return createElement(FormikProvider, { value: ctx }, component ? createElement(component, props) : render3 ? render3(props) : children ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? Children.only(children) : null : null);
  };
  Formik2.defaultProps = {
    validateOnChange: true,
    validateOnBlur: true,
    isInitialValid: false,
    enableReinitialize: false
  };
  return Formik2;
}(Component);
function warnAboutMissingIdentifier(_a2) {
  var htmlContent = _a2.htmlContent, documentationAnchorLink = _a2.documentationAnchorLink, handlerName = _a2.handlerName;
  console.error("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n\n    " + htmlContent + "\n\n    Formik cannot determine which value to update. For more info see https://github.com/jaredpalmer/formik#" + documentationAnchorLink + "\n  ");
}
function yupToFormErrors(yupError) {
  var errors = {};
  for (var _i = 0, _a2 = yupError.inner; _i < _a2.length; _i++) {
    var err = _a2[_i];
    if (!errors[err.path]) {
      errors = setIn(errors, err.path, err.message);
    }
  }
  return errors;
}
function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }
  if (context === void 0) {
    context = {};
  }
  var validateData = {};
  for (var k2 in values) {
    if (values.hasOwnProperty(k2)) {
      var key2 = String(k2);
      validateData[key2] = values[key2] !== "" ? values[key2] : void 0;
    }
  }
  return schema[sync ? "validateSync" : "validate"](validateData, {
    abortEarly: false,
    context
  });
}
var FieldInner = function(_super) {
  __extends(FieldInner2, _super);
  function FieldInner2(props) {
    var _this = _super.call(this, props) || this;
    _this.handleChange = function(e2) {
      var _a2 = _this.props.formik, handleChange = _a2.handleChange, validateOnChange = _a2.validateOnChange;
      handleChange(e2);
      if (!!validateOnChange && !!_this.props.validate) {
        _this.runFieldValidations(e2.target.value);
      }
    };
    _this.handleBlur = function(e2) {
      var _a2 = _this.props.formik, handleBlur = _a2.handleBlur, validateOnBlur = _a2.validateOnBlur;
      handleBlur(e2);
      if (!!validateOnBlur && !!_this.props.validate) {
        _this.runFieldValidations(e2.target.value);
      }
    };
    _this.runFieldValidations = function(value) {
      var setFieldError = _this.props.formik.setFieldError;
      var _a2 = _this.props, name = _a2.name, validate = _a2.validate;
      var maybePromise = validate(value);
      if (isPromise(maybePromise)) {
        maybePromise.then(function() {
          return setFieldError(name, void 0);
        }, function(error) {
          return setFieldError(name, error);
        });
      } else {
        setFieldError(name, maybePromise);
      }
    };
    var render3 = props.render, children = props.children;
    props.component;
    var formik = props.formik;
    browser(!(render3 && children && !isEmptyChildren(children)));
    formik.registerField(props.name, {
      validate: props.validate
    });
    return _this;
  }
  FieldInner2.prototype.componentDidUpdate = function(prevProps) {
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
  };
  FieldInner2.prototype.componentWillUnmount = function() {
    this.props.formik.unregisterField(this.props.name);
  };
  FieldInner2.prototype.render = function() {
    var _a2 = this.props, validate = _a2.validate, name = _a2.name, render3 = _a2.render, children = _a2.children, _b = _a2.component, component = _b === void 0 ? "input" : _b, formik = _a2.formik, props = __rest(_a2, ["validate", "name", "render", "children", "component", "formik"]);
    formik.validate;
    formik.validationSchema;
    var restOfFormik = __rest(formik, ["validate", "validationSchema"]);
    var field = {
      value: props.type === "radio" || props.type === "checkbox" ? props.value : getIn(formik.values, name),
      name,
      onChange: validate ? this.handleChange : formik.handleChange,
      onBlur: validate ? this.handleBlur : formik.handleBlur
    };
    var bag = { field, form: restOfFormik };
    if (render3) {
      return render3(bag);
    }
    if (isFunction(children)) {
      return children(bag);
    }
    if (typeof component === "string") {
      var innerRef = props.innerRef, rest = __rest(props, ["innerRef"]);
      return createElement(component, __assign({ ref: innerRef }, field, rest, { children }));
    }
    return createElement(component, __assign({}, bag, props, { children }));
  };
  return FieldInner2;
}(Component);
var Field$1 = connect(FieldInner);
var Form$1 = connect(function(_a2) {
  var handleSubmit = _a2.formik.handleSubmit, props = __rest(_a2, ["formik"]);
  return createElement("form", __assign({ onSubmit: handleSubmit }, props));
});
Form$1.displayName = "Form";
var move = function(array, from, to) {
  var copy = (array || []).slice();
  var value = copy[from];
  copy.splice(from, 1);
  copy.splice(to, 0, value);
  return copy;
};
var swap = function(array, indexA, indexB) {
  var copy = (array || []).slice();
  var a = copy[indexA];
  copy[indexA] = copy[indexB];
  copy[indexB] = a;
  return copy;
};
var insert = function(array, index2, value) {
  var copy = (array || []).slice();
  copy.splice(index2, 0, value);
  return copy;
};
var replace = function(array, index2, value) {
  var copy = (array || []).slice();
  copy[index2] = value;
  return copy;
};
var FieldArrayInner = function(_super) {
  __extends(FieldArrayInner2, _super);
  function FieldArrayInner2(props) {
    var _this = _super.call(this, props) || this;
    _this.updateArrayField = function(fn2, alterTouched, alterErrors) {
      var _a2 = _this.props, name = _a2.name, validateOnChange = _a2.validateOnChange, _b = _a2.formik, setFormikState = _b.setFormikState, validateForm = _b.validateForm, values = _b.values, touched = _b.touched, errors = _b.errors;
      setFormikState(function(prevState) {
        return __assign({}, prevState, { values: setIn(prevState.values, name, fn2(getIn(values, name))), errors: alterErrors ? setIn(prevState.errors, name, fn2(getIn(errors, name))) : prevState.errors, touched: alterTouched ? setIn(prevState.touched, name, fn2(getIn(touched, name))) : prevState.touched });
      }, function() {
        if (validateOnChange) {
          validateForm();
        }
      });
    };
    _this.push = function(value) {
      return _this.updateArrayField(function(array) {
        return (array || []).concat([value]);
      }, false, false);
    };
    _this.handlePush = function(value) {
      return function() {
        return _this.push(value);
      };
    };
    _this.swap = function(indexA, indexB) {
      return _this.updateArrayField(function(array) {
        return swap(array, indexA, indexB);
      }, false, false);
    };
    _this.handleSwap = function(indexA, indexB) {
      return function() {
        return _this.swap(indexA, indexB);
      };
    };
    _this.move = function(from, to) {
      return _this.updateArrayField(function(array) {
        return move(array, from, to);
      }, false, false);
    };
    _this.handleMove = function(from, to) {
      return function() {
        return _this.move(from, to);
      };
    };
    _this.insert = function(index2, value) {
      return _this.updateArrayField(function(array) {
        return insert(array, index2, value);
      }, false, false);
    };
    _this.handleInsert = function(index2, value) {
      return function() {
        return _this.insert(index2, value);
      };
    };
    _this.replace = function(index2, value) {
      return _this.updateArrayField(function(array) {
        return replace(array, index2, value);
      }, false, false);
    };
    _this.handleReplace = function(index2, value) {
      return function() {
        return _this.replace(index2, value);
      };
    };
    _this.unshift = function(value) {
      var arr = [];
      _this.updateArrayField(function(array) {
        arr = array ? [value].concat(array) : [value];
        return arr;
      }, false, false);
      return arr.length;
    };
    _this.handleUnshift = function(value) {
      return function() {
        return _this.unshift(value);
      };
    };
    _this.handleRemove = function(index2) {
      return function() {
        return _this.remove(index2);
      };
    };
    _this.handlePop = function() {
      return function() {
        return _this.pop();
      };
    };
    _this.remove = _this.remove.bind(_this);
    _this.pop = _this.pop.bind(_this);
    return _this;
  }
  FieldArrayInner2.prototype.remove = function(index2) {
    var result;
    this.updateArrayField(function(array) {
      var copy = array ? array.slice() : [];
      if (!result) {
        result = copy[index2];
      }
      if (isFunction(copy.splice)) {
        copy.splice(index2, 1);
      }
      return copy;
    }, true, true);
    return result;
  };
  FieldArrayInner2.prototype.pop = function() {
    var result;
    this.updateArrayField(function(array) {
      var tmp = array;
      if (!result) {
        result = tmp && tmp.pop && tmp.pop();
      }
      return tmp;
    }, true, true);
    return result;
  };
  FieldArrayInner2.prototype.render = function() {
    var arrayHelpers = {
      push: this.push,
      pop: this.pop,
      swap: this.swap,
      move: this.move,
      insert: this.insert,
      replace: this.replace,
      unshift: this.unshift,
      remove: this.remove,
      handlePush: this.handlePush,
      handlePop: this.handlePop,
      handleSwap: this.handleSwap,
      handleMove: this.handleMove,
      handleInsert: this.handleInsert,
      handleReplace: this.handleReplace,
      handleUnshift: this.handleUnshift,
      handleRemove: this.handleRemove
    };
    var _a2 = this.props, component = _a2.component, render3 = _a2.render, children = _a2.children, name = _a2.name, _b = _a2.formik;
    _b.validate;
    _b.validationSchema;
    var restOfFormik = __rest(_b, ["validate", "validationSchema"]);
    var props = __assign({}, arrayHelpers, { form: restOfFormik, name });
    return component ? createElement(component, props) : render3 ? render3(props) : children ? typeof children === "function" ? children(props) : !isEmptyChildren(children) ? Children.only(children) : null : null;
  };
  FieldArrayInner2.defaultProps = {
    validateOnChange: true
  };
  return FieldArrayInner2;
}(Component);
connect(FieldArrayInner);
function isEqualExceptForKey(a, b2, path) {
  return reactFastCompare(setIn(a, path, void 0), setIn(b2, path, void 0));
}
var FastFieldInner = function(_super) {
  __extends(FastFieldInner2, _super);
  function FastFieldInner2(props) {
    var _this = _super.call(this, props) || this;
    _this.handleChange = function(e2) {
      e2.persist();
      var _a2 = _this.props.formik, validateOnChange = _a2.validateOnChange, validate = _a2.validate, values = _a2.values, validationSchema = _a2.validationSchema, errors = _a2.errors, setFormikState = _a2.setFormikState;
      var _b = e2.target, type = _b.type, value = _b.value, checked = _b.checked;
      var val = /number|range/.test(type) ? parseFloat(value) : /checkbox/.test(type) ? checked : value;
      if (validateOnChange) {
        if (_this.props.validate) {
          var maybePromise = _this.props.validate(value);
          if (isPromise(maybePromise)) {
            _this.setState({ value: val });
            maybePromise.then(function() {
              return _this.setState({ error: void 0 });
            }, function(error) {
              return _this.setState({ error });
            });
          } else {
            _this.setState({ value: val, error: maybePromise });
          }
        } else if (validate) {
          var maybePromise_1 = validate(setIn(values, _this.props.name, val));
          if (isPromise(maybePromise_1)) {
            _this.setState({ value: val });
            maybePromise_1.then(function() {
              return _this.setState({ error: void 0 });
            }, function(error) {
              if (isEqualExceptForKey(maybePromise_1, errors, _this.props.name)) {
                _this.setState({ error: getIn(error, _this.props.name) });
              } else {
                setFormikState(function(prevState) {
                  return __assign({}, prevState, { errors: error });
                });
              }
            });
          } else {
            if (isEqualExceptForKey(maybePromise_1, errors, _this.props.name)) {
              _this.setState({
                value: val,
                error: getIn(maybePromise_1, _this.props.name)
              });
            } else {
              _this.setState({
                value: val
              });
              setFormikState(function(prevState) {
                return __assign({}, prevState, { errors: maybePromise_1 });
              });
            }
          }
        } else if (validationSchema) {
          var schema = isFunction(validationSchema) ? validationSchema() : validationSchema;
          var mergedValues = setIn(values, _this.props.name, val);
          try {
            validateYupSchema(mergedValues, schema, true);
            _this.setState({
              value: val,
              error: void 0
            });
          } catch (e3) {
            if (e3.name === "ValidationError") {
              _this.setState({
                value: val,
                error: getIn(yupToFormErrors(e3), _this.props.name)
              });
            } else {
              _this.setState({
                value: val
              });
              validateYupSchema(mergedValues, schema).then(function() {
                return _this.setState({ error: void 0 });
              }, function(err) {
                return _this.setState(function(s) {
                  return __assign({}, s, { error: getIn(yupToFormErrors(err), _this.props.name) });
                });
              });
            }
          }
        } else {
          _this.setState({ value: val });
        }
      } else {
        _this.setState({ value: val });
      }
    };
    _this.handleBlur = function() {
      var _a2 = _this.props.formik, validateOnBlur = _a2.validateOnBlur, setFormikState = _a2.setFormikState;
      var _b = _this.props, name = _b.name, validate = _b.validate;
      if (validateOnBlur && validate) {
        var maybePromise_2 = validate(_this.state.value);
        if (isPromise(maybePromise_2)) {
          maybePromise_2.then(function() {
            return setFormikState(function(prevState) {
              return __assign({}, prevState, { values: setIn(prevState.values, name, _this.state.value), errors: setIn(prevState.errors, name, void 0), touched: setIn(prevState.touched, name, true) });
            });
          }, function(error) {
            return setFormikState(function(prevState) {
              return __assign({}, prevState, { values: setIn(prevState.values, name, _this.state.value), errors: setIn(prevState.errors, name, error), touched: setIn(prevState.touched, name, true) });
            });
          });
        } else {
          setFormikState(function(prevState) {
            return __assign({}, prevState, { values: setIn(prevState.values, name, _this.state.value), errors: setIn(prevState.errors, name, maybePromise_2), touched: setIn(prevState.touched, name, true) });
          });
        }
      } else {
        setFormikState(function(prevState) {
          return __assign({}, prevState, { errors: setIn(prevState.errors, name, _this.state.error), values: setIn(prevState.values, name, _this.state.value), touched: setIn(prevState.touched, name, true) });
        });
      }
    };
    _this.state = {
      value: getIn(props.formik.values, props.name),
      error: getIn(props.formik.errors, props.name)
    };
    var render3 = props.render, children = props.children;
    props.component;
    var formik = props.formik;
    browser(!(props.component && children && isFunction(children)));
    browser(!(render3 && children && !isEmptyChildren(children)));
    formik.registerField(props.name, {
      validate: props.validate
    });
    return _this;
  }
  FastFieldInner2.prototype.componentDidUpdate = function(prevProps, _state) {
    var nextFieldValue = getIn(this.props.formik.values, this.props.name);
    var nextFieldError = getIn(this.props.formik.errors, this.props.name);
    var prevFieldValue = getIn(prevProps.formik.values, prevProps.name);
    var prevFieldError = getIn(prevProps.formik.errors, prevProps.name);
    if (!reactFastCompare(nextFieldValue, prevFieldValue)) {
      this.setState({ value: nextFieldValue });
    }
    if (!reactFastCompare(nextFieldError, prevFieldError)) {
      this.setState({ error: nextFieldError });
    }
    if (this.props.name !== prevProps.name) {
      this.props.formik.unregisterField(prevProps.name);
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
    if (this.props.validate !== prevProps.validate) {
      this.props.formik.registerField(this.props.name, {
        validate: this.props.validate
      });
    }
  };
  FastFieldInner2.prototype.componentWillUnmount = function() {
    this.props.formik.unregisterField(this.props.name);
  };
  FastFieldInner2.prototype.render = function() {
    var _a2 = this.props;
    _a2.validate;
    var name = _a2.name, render3 = _a2.render, children = _a2.children, _b = _a2.component, component = _b === void 0 ? "input" : _b, formik = _a2.formik, props = __rest(_a2, ["validate", "name", "render", "children", "component", "formik"]);
    formik.validate;
    formik.validationSchema;
    var restOfFormik = __rest(formik, ["validate", "validationSchema"]);
    var field = {
      value: props.type === "radio" || props.type === "checkbox" ? props.value : this.state.value,
      name,
      onChange: this.handleChange,
      onBlur: this.handleBlur
    };
    var bag = {
      field,
      form: restOfFormik,
      meta: { touched: getIn(formik.touched, name), error: this.state.error }
    };
    if (render3) {
      return render3(bag);
    }
    if (isFunction(children)) {
      return children(bag);
    }
    if (typeof component === "string") {
      var innerRef = props.innerRef, rest = __rest(props, ["innerRef"]);
      return createElement(component, __assign({ ref: innerRef }, field, rest, { children }));
    }
    return createElement(component, __assign({}, bag, props, { children }));
  };
  return FastFieldInner2;
}(Component);
connect(FastFieldInner);
const Actions = ({
  children,
  formik: {
    handleReset,
    submitForm
  }
}) => children({
  reset: handleReset,
  submit: submitForm
});
var Actions$1 = connect(Actions);
const FormAlert = /* @__PURE__ */ createStyled(Alert, {
  target: "e1e8qmhh0"
})("margin-top:", spacer(4), ";margin-bottom:", spacer(4), ";& + &{margin-top:0;}");
FormAlert.displayName = "Form.FormAlert";
const Errors = ({
  formik: {
    errors
  },
  name
}) => {
  if (name) {
    return errors[name] ? /* @__PURE__ */ jsx(FormAlert, {
      kind: "error",
      message: errors[name]
    }) : null;
  }
  return Array.isArray(errors.form) ? errors.form.map((message, idx) => /* @__PURE__ */ jsx(FormAlert, {
    kind: "error",
    message
  }, idx)) : errors.form ? /* @__PURE__ */ jsx(FormAlert, {
    kind: "error",
    message: errors.form
  }) : null;
};
var Errors$1 = connect(Errors);
const FieldAlert = /* @__PURE__ */ createStyled(Alert, {
  target: "e1997vs50"
})("margin-top:", spacer(2), ";");
FieldAlert.displayName = "Form.FieldAlert";
const Field = ({
  name,
  render: render3
}) => /* @__PURE__ */ jsx(Field$1, {
  name,
  render: ({
    field,
    form: {
      errors,
      setFieldError,
      setFieldValue,
      values
    }
  }) => render3(__spreadProps(__spreadValues({}, field), {
    form: {
      values
    },
    setFieldError,
    setValue: (value) => setFieldValue(name, value),
    error: errors[field.name],
    valid: !errors[field.name],
    renderError: () => errors[field.name] ? /* @__PURE__ */ jsx(FieldAlert, {
      kind: "error",
      message: errors[field.name]
    }) : null
  }))
});
const hover = (theme) => `
  && {
    border-color: ${style("uploader.hoverBorder", {
  theme
})};
    background-color: ${style("uploader.hoverBackground", {
  theme
})};
  }
`;
const disabledStyle = (theme) => `
  && {
    border-color: ${color("paleGrey", {
  theme
})};
    background-color: ${color("offWhite", {
  theme
})};
    color: ${color("silver", {
  theme
})};
    cursor: not-allowed;
  }
`;
const valid = ({
  valid: valid2,
  theme
}) => valid2 || `
    && {
      border-color: ${color("red", {
  theme
})};
      background-color: ${transparentize("lightRed", 0.5, {
  theme
})};
    }
  `;
const Dropzone = /* @__PURE__ */ createStyled(ReactDropzone, {
  shouldForwardProp: (prop2) => ["valid", "height"].indexOf(prop2) === -1,
  target: "e194vlav0"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;color:", color("pewter"), ";border:2px dashed ", color("silver"), ";cursor:pointer;height:", prop("height"), ";width:100%;overflow:hidden;padding:", spacer(4), " 0;text-align:center;transition:all 0.3s cubic-bezier(0.25,0.8,0.25,1);", borderRadius$1("default"), ";", valid, ";&:hover{", ({
  disabled,
  theme
}) => disabled || hover(theme), ";}");
const DropLabel = createStyled("div", {
  target: "e194vlav1"
})(typography$1("body2Medium"), ";margin-top:", spacer(2), ";margin-bottom:", spacer(2), ";");
const SubLabel = createStyled("div", {
  target: "e194vlav2"
})(typography$1("body1Medium"), ";", SecondaryLink, "{", typography$1("body1Medium"), ";}");
const Uploader = ({
  accept,
  disabled,
  height,
  multiple,
  name,
  onChange,
  theme,
  valid: valid2,
  value,
  label,
  subLabel
}) => {
  const files = Array.isArray(value) ? value : [value].filter(Boolean);
  return /* @__PURE__ */ jsx(ClassNames, {
    children: ({
      css: css2
    }) => /* @__PURE__ */ jsx(Dropzone, {
      accept,
      activeClassName: css2(hover(theme)),
      disabledClassName: css2(disabledStyle(theme)),
      height,
      multiple,
      name,
      disabled,
      onDrop: (files2) => multiple ? onChange(files2) : onChange(files2[0]),
      valid: valid2,
      children: files.length > 0 ? /* @__PURE__ */ jsx(DropLabel, {
        children: files.map(prop("name")).join(", ")
      }) : /* @__PURE__ */ jsxs(Fragment$2, {
        children: [/* @__PURE__ */ jsx(Upload, {
          size: "1.5rem",
          color: disabled ? "silver" : "pewter"
        }), /* @__PURE__ */ jsx(DropLabel, {
          children: label || `Drag and Drop ${multiple ? "files" : "a file"} here`
        }), /* @__PURE__ */ jsx(SubLabel, {
          children: subLabel || /* @__PURE__ */ jsxs(Fragment$2, {
            children: ["or ", /* @__PURE__ */ jsx(SecondaryLink, {
              external: true,
              disabled,
              children: "Browse"
            })]
          })
        })]
      })
    })
  });
};
Uploader.defaultProps = {
  multiple: false,
  onChange: () => {
  },
  valid: true
};
var Uploader$1 = withTheme(Uploader);
var composeHandlers = (...fns) => (...args) => fns.filter(Boolean).forEach((fn2) => fn2(...args));
const FileUpload = (_ga) => {
  var _ha = _ga, {
    name,
    onChange,
    multiple
  } = _ha, props = __objRest(_ha, [
    "name",
    "onChange",
    "multiple"
  ]);
  return /* @__PURE__ */ jsx(Field, {
    name,
    render: ({
      renderError,
      setValue,
      form,
      valid: valid2,
      value
    }) => /* @__PURE__ */ jsxs(Fragment$2, {
      children: [/* @__PURE__ */ jsx(Uploader$1, __spreadProps(__spreadValues({}, props), {
        name,
        onChange: composeHandlers(setValue, onChange),
        valid: valid2,
        value,
        multiple
      })), renderError()]
    })
  });
};
const buttons = ({
  buttons: buttons2,
  theme
}) => buttons2 && /* @__PURE__ */ css("flex-direction:row;justify-content:flex-end;", Button$1, " + ", Button$1, ",", ButtonLink, " + ", ButtonLink, ",", Button$1, " + ", ButtonLink, ",", ButtonLink, " + ", Button$1, "{margin-left:", spacer(2, {
  theme
}), ";}");
const Group = createStyled("div", {
  target: "e118sbgk0"
})("display:flex;width:100%;margin-bottom:", spacer(6), ";flex-direction:column;", buttons, ";&:last-of-type{margin-bottom:0;}");
Group.displayName = "Form.Group";
const size$4 = ({
  size: size2,
  theme
}) => {
  switch (size2) {
    case "lg":
      return /* @__PURE__ */ css(padding("xs", {
        theme
      }), ";", fontSize("s", {
        theme
      }), ";");
    default:
      return /* @__PURE__ */ css(padding("xxs", {
        theme
      }), ";", fontSize("xs", {
        theme
      }), ";");
  }
};
const Input$1 = createStyled("input", {
  target: "ed7u22d0"
})("display:", ({
  inline
}) => inline ? "inline-block" : "block", ";width:auto;background-clip:padding-box;transition:border-color 0.15s ease-in-out,box-shadow 0.15s ease-in-out;color:", color("black"), ";background-color:", color("white"), ";", borderRadius$1("default"), ";", size$4, ";&:disabled{border-color:", color("paleGrey"), ";background-color:", color("offWhite"), ";cursor:not-allowed;}", ({
  valid: valid2,
  theme
}) => /* @__PURE__ */ css("border:1px solid ", style(`input.${valid2 ? "valid" : "invalid"}.border`, {
  theme
}), ";&:focus{outline:0;border-color:", style(`input.${valid2 ? "valid" : "invalid"}.focusBorder`, {
  theme
}), ";}"), ";");
Input$1.defaultProps = {
  valid: true,
  inline: false
};
const FormInput = (_ia) => {
  var _ja = _ia, {
    type,
    label,
    name,
    onChange,
    onBlur,
    formatValue
  } = _ja, props = __objRest(_ja, [
    "type",
    "label",
    "name",
    "onChange",
    "onBlur",
    "formatValue"
  ]);
  return /* @__PURE__ */ jsx(Field, {
    name,
    render: (_a2) => {
      var _b = _a2, {
        onBlur: fieldOnBlur,
        onChange: fieldOnChange,
        renderError,
        setValue,
        valid: valid2,
        form
      } = _b, field = __objRest(_b, [
        "onBlur",
        "onChange",
        "renderError",
        "setValue",
        "valid",
        "form"
      ]);
      return /* @__PURE__ */ jsxs(Fragment$2, {
        children: [type === "checkbox" ? /* @__PURE__ */ jsx(Checkbox$1, __spreadProps(__spreadValues(__spreadValues({}, props), field), {
          onBlur: composeHandlers(fieldOnBlur, onBlur),
          onChange: composeHandlers(fieldOnChange, onChange),
          id: field.name,
          label,
          checked: field.value,
          valid: valid2
        })) : /* @__PURE__ */ jsx(Input$1, __spreadProps(__spreadValues(__spreadValues({}, props), field), {
          onBlur: composeHandlers(fieldOnBlur, onBlur),
          onChange: (e2) => {
            onChange && onChange(e2);
            formatValue ? setValue(formatValue(e2.target.value)) : fieldOnChange(e2);
          },
          type,
          valid: valid2
        })), renderError()]
      });
    }
  });
};
FormInput.displayName = "Form.Input";
const Select = (_ka) => {
  var _la = _ka, {
    name,
    onChange
  } = _la, props = __objRest(_la, [
    "name",
    "onChange"
  ]);
  return /* @__PURE__ */ jsx(Field, {
    name,
    render: ({
      renderError,
      setValue,
      valid: valid2,
      value
    }) => /* @__PURE__ */ jsxs(Fragment$2, {
      children: [/* @__PURE__ */ jsx(Dropdown, __spreadProps(__spreadValues({}, props), {
        name,
        onChange: composeHandlers(setValue, onChange),
        valid: valid2,
        value
      })), renderError()]
    })
  });
};
Select.Option = Dropdown.Option;
const SubmitButton = (_ma) => {
  var _na = _ma, {
    formik: {
      isSubmitting
    }
  } = _na, props = __objRest(_na, [
    "formik"
  ]);
  return /* @__PURE__ */ jsx(Button$1, __spreadProps(__spreadValues({}, props), {
    disabled: isSubmitting,
    type: "submit"
  }));
};
SubmitButton.defaultProps = {
  kind: "primary"
};
var SubmitButton$1 = connect(SubmitButton);
const Icon$1 = createStyled("svg", {
  target: "es72eiu0"
})("position:absolute;width:1.25rem;z-index:1;left:", ({
  left: left2
}) => left2, ";");
Icon$1.displayName = "SwitchInput.Icon";
const Cancel = ({
  disabled,
  theme
}) => /* @__PURE__ */ jsx(Icon$1, {
  left: "1.25rem",
  viewBox: "0 -3 27 27",
  children: /* @__PURE__ */ jsx("path", {
    fill: color(disabled ? "white" : "slate", {
      theme
    }),
    d: "M8.6,10l-3.3,3.3l1.4,1.4l3.3-3.3l3.3,3.3l1.4-1.4L11.4,10l3.3-3.3l-1.4-1.4L10,8.6L6.7,5.3L5.3,6.7L8.6,10z"
  })
});
Cancel.displayName = "SwitchInput.Cancel";
var Cancel$1 = withTheme(Cancel);
const Container$f = createStyled("div", {
  target: "e1ao7a0g0"
})({
  name: "1umqlch",
  styles: "position:relative;padding-left:3.375rem;height:20px;"
});
Container$f.displayName = "SwitchInput.Container";
const Checkmark = ({
  disabled,
  theme
}) => /* @__PURE__ */ jsx(Icon$1, {
  left: 0,
  viewBox: "-7 -7.5 23 23",
  children: /* @__PURE__ */ jsx("g", {
    fill: "none",
    children: /* @__PURE__ */ jsx("path", {
      stroke: color(disabled ? "white" : "silver", {
        theme
      }),
      strokeWidth: "1.5",
      d: "M1.5 3.75l3 3 6-6"
    })
  })
});
Checkmark.displayName = "SwitchInput.Checkmark";
var Checkmark$1 = withTheme(Checkmark);
const Input = createStyled("input", {
  target: "e5fyh4g0"
})({
  name: "w9pj7n",
  styles: "z-index:-1;opacity:0;position:absolute;"
});
Input.displayName = "SwitchInput.Input";
const Label$2 = createStyled("label", {
  target: "e124w0bc0"
})("margin-bottom:0;", typography$1("body2"), ";", ({
  disabled,
  theme
}) => /* @__PURE__ */ css("color:", color(disabled ? "pewter" : "slate", {
  theme
}), ";cursor:", disabled ? "default" : "pointer", ";"), ";&::before{content:'';width:1.25rem;height:1.25rem;border-radius:50%;user-select:none;pointer-events:none;position:absolute;left:0;z-index:2;transition:0.4s;", ({
  checked,
  disabled,
  theme
}) => /* @__PURE__ */ css("background-color:", color(disabled ? "offWhite" : "white", {
  theme
}), ";border:1px solid ", color(disabled || !checked ? "silver" : "slate", {
  theme
}), ";transform:translateX(", checked ? "1.25rem" : 0, ");"), ";}");
Label$2.displayName = "SwitchInput.Label";
const Slider = createStyled("span", {
  target: "eltasv70"
})("width:2.5rem;height:1.25rem;position:absolute;left:0;border-radius:0.825rem;transition:0.4s;", ({
  checked,
  disabled,
  theme
}) => /* @__PURE__ */ css("background-color:", color(disabled ? "silver" : checked ? "slate" : "paleGrey", {
  theme
}), ";border:1px solid ", color(disabled || !checked ? "silver" : "slate", {
  theme
}), ";"), ";");
Slider.displayName = "SwitchInput.Slider";
const SwitchInput = (_oa) => {
  var _pa = _oa, {
    checked,
    disabled,
    id,
    label,
    type
  } = _pa, rest = __objRest(_pa, [
    "checked",
    "disabled",
    "id",
    "label",
    "type"
  ]);
  return /* @__PURE__ */ jsxs(Container$f, {
    children: [/* @__PURE__ */ jsx(Input, __spreadValues({
      type: "checkbox",
      checked,
      disabled,
      id
    }, rest)), /* @__PURE__ */ jsxs(Label$2, {
      checked,
      disabled,
      htmlFor: id,
      children: [/* @__PURE__ */ jsx(Slider, {
        checked,
        disabled
      }), /* @__PURE__ */ jsx(Checkmark$1, {
        disabled
      }), /* @__PURE__ */ jsx(Cancel$1, {
        disabled
      }), /* @__PURE__ */ jsx("span", {
        children: label
      })]
    })]
  });
};
const Switch = (_qa) => {
  var _ra = _qa, {
    label,
    name,
    onChange,
    onBlur
  } = _ra, props = __objRest(_ra, [
    "label",
    "name",
    "onChange",
    "onBlur"
  ]);
  return /* @__PURE__ */ jsx(Field, {
    name,
    render: (_a2) => {
      var _b = _a2, {
        onBlur: fieldOnBlur,
        onChange: fieldOnChange,
        renderError,
        valid: valid2,
        value
      } = _b, field = __objRest(_b, [
        "onBlur",
        "onChange",
        "renderError",
        "valid",
        "value"
      ]);
      return /* @__PURE__ */ jsxs(Fragment$2, {
        children: [/* @__PURE__ */ jsx(SwitchInput, __spreadProps(__spreadValues(__spreadValues({}, props), field), {
          id: field.name,
          label,
          checked: value,
          valid: valid2,
          onChange: composeHandlers(fieldOnChange, onChange)
        })), renderError()]
      });
    }
  });
};
const Textarea = Input$1.withComponent("textarea", {
  target: "e1li8p1g0"
});
Textarea.defaultProps = {
  valid: true
};
const FormTextarea = (_sa) => {
  var _ta = _sa, {
    name,
    onBlur,
    onChange
  } = _ta, props = __objRest(_ta, [
    "name",
    "onBlur",
    "onChange"
  ]);
  return /* @__PURE__ */ jsx(Field, {
    name,
    render: (_a2) => {
      var _b = _a2, {
        onBlur: fieldOnBlur,
        onChange: fieldOnChange,
        renderError,
        valid: valid2
      } = _b, field = __objRest(_b, [
        "onBlur",
        "onChange",
        "renderError",
        "valid"
      ]);
      return /* @__PURE__ */ jsxs(Fragment$2, {
        children: [/* @__PURE__ */ jsx(Textarea, __spreadProps(__spreadValues(__spreadValues({}, props), field), {
          onBlur: composeHandlers(fieldOnBlur, onBlur),
          onChange: composeHandlers(fieldOnChange, onChange),
          valid: valid2
        })), renderError()]
      });
    }
  });
};
const Label$1 = createStyled("label", {
  target: "ejlcscx0"
})("display:inline-block;margin-bottom:", spacer(2), ";");
Label$1.displayName = "Form.Label";
const Title$2 = createStyled("h5", {
  target: "e1u3ng400"
})("margin-bottom:", spacer(5), ";");
const Value = ({
  children,
  name,
  formik: {
    setFieldValue,
    values
  }
}) => children({
  value: values[name],
  setValue: (value) => setFieldValue(name, value)
});
var Value$1 = connect(Value);
const Form = (_ua) => {
  var _va = _ua, {
    children,
    className,
    onSubmit,
    redirect,
    history,
    serializeErrors
  } = _va, props = __objRest(_va, [
    "children",
    "className",
    "onSubmit",
    "redirect",
    "history",
    "serializeErrors"
  ]);
  return /* @__PURE__ */ jsx(Formik, __spreadProps(__spreadValues({}, props), {
    onSubmit: (values, {
      setSubmitting,
      setErrors
    }) => {
      Promise.resolve(onSubmit(values)).then(() => {
        redirect ? history.replace(redirect) : setSubmitting(false);
      }).catch((error) => {
        setSubmitting(false);
        setErrors({
          form: serializeErrors ? serializeErrors(error) : error
        });
      });
    },
    render: (_a2) => {
      var _b = _a2, {
        handleSubmit
      } = _b, otherFormikRenderProps = __objRest(_b, [
        "handleSubmit"
      ]);
      return /* @__PURE__ */ jsx("form", {
        onSubmit: handleSubmit,
        className,
        children: typeof children === "function" ? children(__spreadValues({
          handleSubmit
        }, otherFormikRenderProps)) : children
      });
    }
  }));
};
Form.displayName = "Form";
Form.defaultProps = {
  validateOnBlur: false,
  validateOnChange: false
};
Form.Actions = Actions$1;
Form.Errors = Errors$1;
Form.Field = Field;
Form.FileUpload = FileUpload;
Form.Group = Group;
Form.Input = FormInput;
Form.Select = Select;
Form.SubmitButton = SubmitButton$1;
Form.Textarea = FormTextarea;
Form.Title = Title$2;
Form.SwitchInput = Switch;
Form.Label = Label$1;
Form.Value = Value$1;
var index$1 = withRouter(Form);
const LogoPath = createStyled("path", {
  target: "eh1gl2q0"
})("fill:", style("logoPath.fill"), ";");
const TextPath = createStyled("path", {
  target: "ez6h3mx0"
})("fill:", ({
  theme,
  dark: dark2
}) => color(dark2 ? "white" : "ink", {
  theme
}), ";");
var wrapDisplayName$1 = {};
var getDisplayName$1 = {};
getDisplayName$1.__esModule = true;
var getDisplayName = function getDisplayName2(Component2) {
  if (typeof Component2 === "string") {
    return Component2;
  }
  if (!Component2) {
    return void 0;
  }
  return Component2.displayName || Component2.name || "Component";
};
getDisplayName$1.default = getDisplayName;
wrapDisplayName$1.__esModule = true;
var _getDisplayName = getDisplayName$1;
var _getDisplayName2 = _interopRequireDefault$7(_getDisplayName);
function _interopRequireDefault$7(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var wrapDisplayName = function wrapDisplayName2(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName2.default)(BaseComponent) + ")";
};
wrapDisplayName$1.default = wrapDisplayName;
var setDisplayName$1 = {};
var setStatic$1 = {};
setStatic$1.__esModule = true;
var setStatic = function setStatic2(key2, value) {
  return function(BaseComponent) {
    BaseComponent[key2] = value;
    return BaseComponent;
  };
};
setStatic$1.default = setStatic;
setDisplayName$1.__esModule = true;
var _setStatic = setStatic$1;
var _setStatic2 = _interopRequireDefault$6(_setStatic);
function _interopRequireDefault$6(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var setDisplayName = function setDisplayName2(displayName) {
  return (0, _setStatic2.default)("displayName", displayName);
};
setDisplayName$1.default = setDisplayName;
var mapProps$1 = {};
mapProps$1.__esModule = true;
var _react$3 = React__default;
var _setDisplayName$1 = setDisplayName$1;
_interopRequireDefault$5(_setDisplayName$1);
var _wrapDisplayName$1 = wrapDisplayName$1;
_interopRequireDefault$5(_wrapDisplayName$1);
function _interopRequireDefault$5(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var mapProps2 = function mapProps3(propsMapper) {
  return function(BaseComponent) {
    var factory = (0, _react$3.createFactory)(BaseComponent);
    var MapProps = function MapProps2(props) {
      return factory(propsMapper(props));
    };
    return MapProps;
  };
};
mapProps$1.default = mapProps2;
var _extends$1 = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key2 in source) {
      if (Object.prototype.hasOwnProperty.call(source, key2)) {
        target[key2] = source[key2];
      }
    }
  }
  return target;
};
var _wrapDisplayName = wrapDisplayName$1;
_interopRequireDefault$4(_wrapDisplayName);
var _setDisplayName = setDisplayName$1;
_interopRequireDefault$4(_setDisplayName);
var _mapProps = mapProps$1;
var _mapProps2 = _interopRequireDefault$4(_mapProps);
function _interopRequireDefault$4(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var withProps2 = function withProps3(input) {
  var hoc = (0, _mapProps2.default)(function(props) {
    return _extends$1({}, props, typeof input === "function" ? input(props) : input);
  });
  return hoc;
};
var _default$2 = withProps2;
const size$3 = ({
  ieWidths,
  size: size2,
  oneLineHeight
}) => {
  let height;
  switch (size2) {
    case "sm":
      height = "60px";
      break;
    case "lg":
      height = "80px";
      break;
    default:
      height = "72px";
  }
  if (oneLineHeight)
    height = `${oneLineHeight[size2 || "default"]}px`;
  return /* @__PURE__ */ css("height:", height, ";width:auto;@media screen and (-ms-high-contrast:active),(-ms-high-contrast:none){width:", ieWidths[size2 || "default"], "px;}");
};
const Svg$2 = _default$2({
  xmlns: "http://www.w3.org/2000/svg"
})(createStyled("svg", {
  target: "e11xr0gk0"
})(size$3, ""));
const DigitalDiariesLogo = (_wa) => {
  var _xa = _wa, {
    dark: dark2
  } = _xa, rest = __objRest(_xa, [
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(Svg$2, __spreadProps(__spreadValues({
    viewBox: "0 0 1585.58 204.98",
    ieWidths: {
      sm: 531,
      lg: 707,
      default: 637
    }
  }, rest), {
    children: [/* @__PURE__ */ jsx(LogoPath, {
      d: "M17.34,16.83V41h68.78V16.83H17.34z M17.34,86.38h45.53v36.47h23.24v-60.4H17.34V86.38z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M260.65,55.6c-3.88-3.46-8.41-6.12-13.31-7.85c-10.44-3.63-21.79-3.63-32.23,0 c-4.91,1.71-9.42,4.38-13.28,7.85c-3.84,3.5-6.91,7.77-9,12.53c-2.27,5.23-3.41,10.89-3.32,16.6c-0.06,5.73,1.09,11.4,3.37,16.65 c2.09,4.8,5.16,9.12,9,12.68c3.86,3.53,8.37,6.28,13.28,8.08c10.4,3.83,21.83,3.83,32.23,0c4.89-1.84,9.4-4.58,13.28-8.08 c3.87-3.54,6.95-7.86,9.04-12.68c2.27-5.26,3.4-10.95,3.32-16.68c0.09-5.71-1.04-11.37-3.32-16.6 C267.6,63.35,264.51,59.09,260.65,55.6z M248.04,91.82c-0.74,2.28-1.89,4.4-3.4,6.26c-1.52,1.87-3.42,3.39-5.58,4.45 c-4.89,2.21-10.51,2.21-15.4,0c-2.16-1.06-4.06-2.58-5.58-4.45c-1.51-1.86-2.67-3.98-3.4-6.26c-1.51-4.61-1.51-9.57,0-14.18 c0.71-2.23,1.83-4.3,3.32-6.11c5.28-5.86,13.75-7.6,20.91-4.3c2.13,1.04,4.03,2.51,5.59,4.3c1.53,1.8,2.71,3.87,3.47,6.11 c0.8,2.28,1.21,4.68,1.21,7.09C249.18,87.14,248.79,89.54,248.04,91.82z M108.67,122.97H135l0.09-36.57h45.38V62.46h-45.38V40.99 h52.79V16.83h-79.21V122.97z M551.34,45.96v5.08c-5.22-3.4-11.23-5.39-17.45-5.77c-11.84-0.83-21.94,3-30.06,11.61 c-11.77,12.46-14.3,31.75-6.28,47.35c10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77L551.34,45.96z M525.54,100.38 c-5.7-4-7.91-9.7-7.69-16.42c0.31-9.26,6.59-16.24,15.78-17.34c6.59-0.73,13.15,1.67,17.71,6.49c0,7.31,0,17.53,0,23.92 C545.34,103.96,533.1,105.67,525.54,100.38z M471.68,101.79c-7.26-0.12-11.18-3.82-11.34-11c-0.15-7.07-0.06-20.66-0.06-20.66 h25.68v-24h-25.71V21.52h-25.28v24.54h-14.75v24.07h14.77c0,0,0,13.82,0,21.11c0.02,2.83,0.3,5.65,0.81,8.43 c2.26,12.93,10.93,22,23.78,24.57c9.3,1.9,20,0.3,28.92-2.8c-0.17-1.27-2.75-20.18-3.06-22.62c-4.34,1.93-9.02,2.95-13.76,3.01 L471.68,101.79z M307.41,45.99h-25.43v77h25.43v-43.4c5.93-5.78,13.73-9,26.06-9.52v-24c-11.24,0-19.35,3.59-26.06,9.36V45.99z M388.64,76.73l-14-2.35c-6.08-1.1-8-3.44-8-6.1c0-2.82,3-5.16,9.52-5.16c6.4,0,11.5,2.32,12.7,7h22.45 c-1.77-18.9-17.64-25-35.15-25c-20.13,0-33.7,9.39-33.7,25.34c0,13.3,9.21,20.65,22.16,22.84l15.29,2.66c5,0.78,8,2.66,8,5.32 c0,3.28-4.21,5.16-10.92,5.16s-12-2.25-14.11-6.83h-23c3,18,18.39,25.45,36.91,25.45c19.82,0,35.42-7.82,35.42-25.34 C412.2,86.27,402.68,79.38,388.64,76.73z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M665.87,16.77h-40.93v106.12h40.93c29.26,0,50-23.8,50-53.06S695.13,16.77,665.87,16.77z M665.87,112.89 h-30.32V26.78h30.32c23.65,0,39.72,19.25,39.72,43.05S689.52,112.89,665.87,112.89L665.87,112.89z M737.58,16.47 c-4.02,0-7.28,3.26-7.28,7.28s3.26,7.28,7.28,7.28c4.02,0,7.28-3.26,7.28-7.28C744.85,19.74,741.59,16.48,737.58,16.47 L737.58,16.47z M732.58,122.89h10v-75.8h-10V122.89z M828.99,61.95c-6.37-10.16-17.13-16.68-30.65-16.68 c-21.94,0-39.72,17.78-39.72,39.72s17.78,39.72,39.72,39.72c13.49,0,24.25-6.52,30.62-16.68v11.83c0,15.46-10.46,25.47-28,25.47 c-16.38,0-23.35-6.07-27.14-13.8l-8.79,5c5.91,11.83,18.49,18.5,35.93,18.5c19.55,0,38-12.13,38-35.17V47.09h-10L828.99,61.95z M799.13,115.01c-16.57,0.08-30.06-13.29-30.14-29.86s13.29-30.06,29.86-30.14c16.57-0.08,30.06,13.29,30.14,29.86 c0,0.05,0,0.09,0,0.14c0.23,16.33-12.82,29.77-29.16,30C799.6,115.02,799.36,115.02,799.13,115.01L799.13,115.01z M865.22,16.47 c-4.02,0-7.28,3.26-7.28,7.28s3.26,7.28,7.28,7.28c4.02,0,7.28-3.26,7.28-7.28C872.5,19.73,869.24,16.47,865.22,16.47 C865.22,16.47,865.22,16.47,865.22,16.47z M860.22,122.89h10v-75.8h-10V122.89z M909.79,25.89l-10,3v18.2h-15.92v9.71h15.92v45.93 c0,18.19,11.37,23.19,31.83,20.16v-8.79c-14.7,0.6-21.83,1.67-21.83-11.37V56.8h21.83v-9.71h-21.83V25.89z M1008.94,61.95 c-6.37-10.16-17.13-16.68-30.6-16.68c-21.94,0-39.72,17.78-39.72,39.72s17.78,39.72,39.72,39.72c13.5,0,24.26-6.52,30.63-16.68 v14.86h10v-75.8h-10L1008.94,61.95z M979.07,115.01c-16.57,0.07-30.06-13.3-30.13-29.87c-0.07-16.57,13.3-30.06,29.87-30.13 s30.06,13.3,30.13,29.87c0,0.04,0,0.09,0,0.13c0.23,16.33-12.82,29.77-29.16,30C979.54,115.02,979.3,115.02,979.07,115.01z M1040.17,122.89h10V12.23h-10V122.89z M1151.74,16.77h-40.93v106.12h40.93c29.26,0,50-23.8,50-53.06S1181,16.77,1151.74,16.77z M1151.74,112.89h-30.32V26.78h30.32c23.65,0,39.72,19.25,39.72,43.05S1175.39,112.89,1151.74,112.89L1151.74,112.89z M1218.44,122.89h10v-75.8h-10V122.89z M1223.44,16.47c-4.02-0.01-7.28,3.25-7.29,7.27c-0.01,4.02,3.25,7.28,7.27,7.29 s7.28-3.25,7.29-7.27c0,0,0-0.01,0-0.01c0-4.01-3.25-7.27-7.26-7.28L1223.44,16.47z M1314.85,61.95 c-6.37-10.16-17.13-16.68-30.62-16.68c-21.94,0-39.72,17.78-39.72,39.72s17.78,39.72,39.72,39.72c13.49,0,24.25-6.52,30.62-16.68 v14.86h10v-75.8h-10V61.95z M1284.98,115.01c-16.57,0.07-30.06-13.3-30.13-29.87s13.3-30.06,29.87-30.13s30.06,13.3,30.13,29.87 c0,0.04,0,0.09,0,0.13c0.23,16.33-12.82,29.77-29.16,30c-0.23,0-0.47,0-0.7,0H1284.98z M1356.08,59.68V47.09h-10v75.8h10V80.75 c0-18.8,11.83-25.17,24-25.17v-9.7c-9.74,0-18.68,3.18-23.99,13.8H1356.08z M1393.68,122.89h10v-75.8h-10V122.89z M1398.68,16.47 c-4.02,0-7.28,3.26-7.28,7.28c0,4.02,3.26,7.28,7.28,7.28c4.02,0,7.28-3.26,7.28-7.28c0-4.02-3.25-7.27-7.27-7.28L1398.68,16.47z M1459.93,45.27c-23.5,0-39.57,17.44-39.57,39.72c0,22.89,16.37,39.72,40.32,39.72c15.32,0,27-7.12,33.36-17.43l-8.8-5.16 c-4.09,7.28-12.43,12.89-24.4,12.89c-16.07,0-28-9.55-30.17-25h66.55c0.15-1.51,0.3-3.18,0.3-4.69 c0.01-20.79-14.39-40.05-37.58-40.05L1459.93,45.27z M1430.67,80.27c2-14.85,13.34-25.31,29.26-25.31c13,0,25.16,8.64,27.28,25.31 H1430.67z M1518.34,66.95c0-8.18,8-12,15.92-12c7.28,0,15,2.88,18.19,10.61l8.34-4.85c-4.4-9.4-14.1-15.47-26.53-15.47 c-15.16,0-25.92,9.56-25.92,21.68c0,27.9,44.27,17.13,44.27,35.93c0,8.95-8.49,12.13-17.44,12.13c-10.16,0-18-5-20.77-12.74 l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43c16.22,0,27.44-8.94,27.44-21.83C1562.57,74.99,1518.34,85.75,1518.34,66.95z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M86.33,172.9H70.31l-3.83,8.67H62.6l14-31.02h3.42l14,31.02h-3.88L86.33,172.9z M84.87,169.66l-6.57-14.87 l-6.57,14.87H84.87z M132.49,153.88h-11.45v27.69h-3.6v-27.69h-11.41v-3.33h26.46V153.88z M151.47,172.04h-17.7c0.41,3.92,3.1,6.98,7.53,6.98c2.69,0,4.74-0.96,5.66-2.74h3.88 c-1.32,3.65-4.97,5.84-9.53,5.84c-6.52,0-11.04-4.88-11.04-11.13c0-6.25,4.47-11.13,10.86-11.13 C147.91,159.86,152.15,165.1,151.47,172.04z M133.81,169.57H148c-0.18-4.2-2.87-6.71-6.89-6.71 C136.91,162.87,134.31,165.83,133.81,169.57z M174.32,174.36h3.6c-0.82,4.61-4.88,7.76-9.99,7.76c-6.43,0-11.09-4.88-11.09-11.13 c0-6.25,4.65-11.13,11.09-11.13c5.11,0,9.17,3.15,9.99,7.8h-3.6c-0.64-2.78-3.1-4.61-6.39-4.61c-4.61,0-7.62,3.56-7.62,7.94 c0,4.43,3.01,7.94,7.62,7.94C171.22,178.92,173.68,177.14,174.32,174.36z M204.15,169.44v12.13h-3.47v-11.95c0-4.29-2.51-6.57-6.25-6.57c-2.51,0-5.11,1.28-6.93,3.65v14.87h-3.47 v-32.39h3.47v13.59c1.96-1.87,4.56-2.92,7.57-2.92C200.46,159.86,204.15,163.46,204.15,169.44z M230.89,169.44v12.13h-3.47v-11.95c0-4.29-2.51-6.57-6.25-6.57c-2.51,0-5.11,1.28-6.93,3.65v14.87h-3.47 V160.4h3.47v2.37c1.96-1.87,4.56-2.92,7.57-2.92C227.19,159.86,230.89,163.46,230.89,169.44z M258.89,170.99c0,6.39-4.79,11.13-11.22,11.13c-6.48,0-11.27-4.74-11.27-11.13s4.79-11.13,11.27-11.13 C254.11,159.86,258.89,164.6,258.89,170.99z M255.38,170.99c0-4.56-3.28-7.94-7.71-7.94c-4.47,0-7.8,3.38-7.8,7.94 c0,4.56,3.33,7.94,7.8,7.94C252.1,178.92,255.38,175.55,255.38,170.99z M268.47,149.18v32.39h-3.47v-32.39H268.47z M297.17,170.99c0,6.39-4.79,11.13-11.22,11.13c-6.48,0-11.27-4.74-11.27-11.13s4.79-11.13,11.27-11.13 C292.38,159.86,297.17,164.6,297.17,170.99z M293.65,170.99c0-4.56-3.28-7.94-7.71-7.94c-4.47,0-7.8,3.38-7.8,7.94 c0,4.56,3.33,7.94,7.8,7.94C290.37,178.92,293.65,175.55,293.65,170.99z M323.85,160.4v22.22c0,6.2-4.24,9.99-10.54,9.99c-5.84,0-10.04-3.28-10.77-7.98h3.56 c0.59,2.87,3.24,4.84,7.21,4.84c4.24,0,7.07-2.56,7.07-6.84v-3.97c-1.96,1.73-4.61,2.74-7.66,2.74c-6.07,0-10.67-4.84-10.67-10.67 c0-6.25,4.61-10.86,10.67-10.86c3.06,0,5.7,1,7.66,2.74v-2.19H323.85z M320.39,174.59v-7.94c-1.78-2.6-4.42-3.74-7.21-3.74 c-4.47,0-7.66,3.33-7.66,7.8c0,4.06,3.19,7.62,7.66,7.62C315.96,178.33,318.61,177.19,320.39,174.59z M353.6,160.4l-14.32,31.7h-3.7l4.43-9.81l-10.9-21.9h3.74l8.85,18.2l8.21-18.2H353.6z M394.97,170.48h3.74c-1.46,6.98-7.16,11.68-14.78,11.68c-8.94,0-16.15-6.93-16.15-16.1 c0-9.17,7.21-16.06,16.15-16.06c7.62,0,13.32,4.65,14.78,11.63h-3.74c-1.28-5.06-5.38-8.26-11.04-8.26 c-7.02,0-12.5,5.43-12.5,12.68c0,7.25,5.47,12.73,12.5,12.73C389.59,178.79,393.69,175.5,394.97,170.48z M425.94,170.99c0,6.39-4.79,11.13-11.22,11.13c-6.48,0-11.27-4.74-11.27-11.13s4.79-11.13,11.27-11.13 C421.15,159.86,425.94,164.6,425.94,170.99z M422.43,170.99c0-4.56-3.28-7.94-7.71-7.94c-4.47,0-7.8,3.38-7.8,7.94 c0,4.56,3.33,7.94,7.8,7.94C419.15,178.92,422.43,175.55,422.43,170.99z M466.41,169.07v12.5h-3.47v-12.5c0-4.2-2.19-6.02-5.66-6.02c-2.56,0-4.93,1.05-6.61,3.6 c0.14,0.68,0.18,1.41,0.18,2.24v12.68h-3.47v-12.68c0-4.15-2.24-5.84-5.47-5.84c-2.65,0-4.97,1.09-6.61,3.56v14.96h-3.47V160.4 h3.47v2.28c1.73-1.78,3.92-2.83,6.98-2.83c3.24,0,5.75,1.19,7.21,3.51c2.05-2.24,4.65-3.51,8.03-3.51 C462.89,159.86,466.41,163,466.41,169.07z M494.82,170.99c0,6.2-4.84,11.09-10.9,11.09c-3.01,0-5.57-1-7.44-2.74v12.82h-3.47V160.4h3.47v2.24 c1.87-1.73,4.43-2.74,7.44-2.74C489.99,159.9,494.82,164.83,494.82,170.99z M491.36,170.99c0-4.38-3.42-8.03-7.89-8.03 c-2.78,0-5.25,1.14-6.98,3.7v8.67c1.73,2.55,4.2,3.7,6.98,3.7C487.94,179.02,491.36,175.37,491.36,170.99z M521.92,160.4v21.17h-3.47v-2.19c-1.87,1.73-4.42,2.74-7.44,2.74c-6.07,0-10.9-4.93-10.9-11.13 c0-6.16,4.84-11.13,10.9-11.13c3.01,0,5.57,1,7.44,2.74v-2.19H521.92z M518.45,175.32v-8.67c-1.73-2.55-4.2-3.6-6.98-3.6 c-4.47,0-7.89,3.56-7.89,7.94s3.42,7.94,7.89,7.94C514.26,178.92,516.72,177.87,518.45,175.32z M549.52,169.44v12.13h-3.47v-11.95c0-4.29-2.51-6.57-6.25-6.57c-2.51,0-5.11,1.28-6.93,3.65v14.87h-3.47 V160.4h3.47v2.37c1.96-1.87,4.56-2.92,7.57-2.92C545.82,159.86,549.52,163.46,549.52,169.44z M577.48,160.4l-14.32,31.7h-3.7l4.43-9.81l-10.9-21.9h3.74l8.85,18.2l8.21-18.2H577.48z"
    })]
  }));
};
const DigitalInterviewsLogo = (_ya) => {
  var _za = _ya, {
    dark: dark2
  } = _za, rest = __objRest(_za, [
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(Svg$2, __spreadProps(__spreadValues({
    viewBox: "0 0 1244 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      default: 637
    }
  }, rest), {
    children: [/* @__PURE__ */ jsx(LogoPath, {
      d: "M69.78,34V58.18H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M244.31,72.77A39.81,39.81,0,0,0,231,64.93a48.93,48.93,0,0,0-32.23,0,38.84,38.84,0,0,0-13.28,7.84,37.28,37.28,0,0,0-9,12.53,40.14,40.14,0,0,0-3.32,16.6,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.53,41.53,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40.11,40.11,0,0,0-3.32-16.6A36.94,36.94,0,0,0,244.31,72.77ZM231.7,109a19.52,19.52,0,0,1-3.4,6.26,16.57,16.57,0,0,1-5.58,4.45,18.59,18.59,0,0,1-15.4,0,16.54,16.54,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.34,18.34,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.66,17.66,0,0,1,5.59,4.3,18.86,18.86,0,0,1,3.47,6.11,21.26,21.26,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.48h45.38v23.93H118.75l-.09,36.57H92.33ZM535,63.14v5.07a36.08,36.08,0,0,0-17.45-5.77c-11.84-.82-21.94,3-30.06,11.61-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.45c-5.7-4-7.91-9.7-7.69-16.41.31-9.27,6.59-16.25,15.78-17.35A21.17,21.17,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.14,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.45,2.89,21.35,3.06,22.62-8.92,3.1-19.62,4.7-28.92,2.81-12.85-2.63-21.52-11.65-23.78-24.58a48.61,48.61,0,0,1-.81-8.42c0-7.3,0-21.12,0-21.12l-14.77,0V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68.05s-.09,13.6.06,20.66c.16,7.23,4.08,10.94,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.36c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.71,297,91,291.07,96.76v43.38H265.64v-77h25.43Zm104.8,44.32c0,17.53-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.66-3-4.53-8-5.32l-15.29-2.66c-12.95-2.19-22.16-9.54-22.16-22.84,0-16,13.57-25.34,33.7-25.34,17.51,0,33.38,6.07,35.15,25l-22.45,0c-1.2-4.63-6.3-7-12.7-7-6.56,0-9.52,2.35-9.52,5.16s1.88,5,8,6.1l14,2.35C386.34,96.55,395.86,103.44,395.87,116.9Z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M212.23,195.39a7.28,7.28,0,1,1-7.28-7.28A7.28,7.28,0,0,1,212.23,195.39Zm120.37-7.28a7.28,7.28,0,1,0,7.27,7.28A7.28,7.28,0,0,0,332.6,188.11Zm634.28,0a7.28,7.28,0,1,0,7.28,7.28A7.28,7.28,0,0,0,966.88,188.11ZM183.27,241.47c0,29.26-20.77,53.06-50,53.06H92.32V188.41h40.93C162.5,188.41,183.27,212.22,183.27,241.47Zm-10.31,0c0-23.8-16.07-43.05-39.71-43.05H102.93v86.11h30.32C156.89,284.53,173,265.27,173,241.47Zm27,53.06h10v-75.8H200Zm96.41-75.8h10V291.5c0,23-18.5,35.17-38.05,35.17-17.44,0-30-6.67-35.93-18.49l8.79-5C245,310.9,252,317,268.32,317c17.58,0,28-10,28-25.47V279.68c-6.36,10.15-17.13,16.67-30.62,16.67a39.72,39.72,0,0,1,0-79.44c13.49,0,24.26,6.52,30.62,16.68Zm0,37.9a29.87,29.87,0,1,0-29.86,30A29.56,29.56,0,0,0,296.36,256.63Zm31.23,37.9h10v-75.8h-10Zm49.57-97-10,3v18.19H351.24v9.71h15.92v45.93c0,18.19,11.37,23.19,31.84,20.16v-8.79c-14.71.61-21.84,1.67-21.84-11.37V228.44H399v-9.71H377.16Zm99.15,21.22h10v75.8h-10V279.68c-6.37,10.15-17.13,16.67-30.62,16.67a39.72,39.72,0,0,1,0-79.44c13.49,0,24.25,6.52,30.62,16.68Zm0,37.9a29.87,29.87,0,1,0-29.86,30A29.57,29.57,0,0,0,476.31,256.63Zm31.23,37.9h10V183.87h-10Zm70.64,0h10.61V188.41H578.18ZM647,216.91c-10.76,0-19.56,4.1-25.47,13.65V218.73h-10v75.8h10V254.81c0-20.31,11.22-28.19,24.56-28.19,13.19,0,20.62,7.88,20.62,21.37v46.54h10V248C676.72,229,665.5,216.91,647,216.91Zm67.46-19.4-10,3v18.19H688.55v9.71h15.91v45.93c0,18.19,11.37,23.19,31.84,20.16v-8.79c-14.7.61-21.83,1.67-21.83-11.37V228.44H736.3v-9.71H714.47ZM821,256.94c0,1.51-.15,3.18-.3,4.7H754.19c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.4-12.89l8.8,5.16c-6.37,10.31-18,17.43-33.35,17.43-24,0-40.33-16.83-40.33-39.72,0-22.28,16.07-39.72,39.57-39.72C806.64,216.91,821,236.17,821,256.94Zm-10.3-5c-2.13-16.67-14.25-25.31-27.29-25.31-15.92,0-27.29,10.46-29.26,25.31ZM847,231.32V218.73H837v75.8h10V252.39c0-18.8,11.82-25.17,23.95-25.17v-9.7C861.22,217.52,852.27,220.71,847,231.32Zm65.64,52.75-26.53-65.34H875.47l31.08,75.8h12.12l31.08-75.8H939.14Zm49.27,10.46h10v-75.8h-10Zm103.84-37.59c0,1.51-.15,3.18-.3,4.7H998.87c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.4-12.89l8.8,5.16c-6.37,10.31-18,17.43-33.35,17.43-24,0-40.33-16.83-40.33-39.72,0-22.28,16.07-39.72,39.57-39.72C1051.32,216.91,1065.72,236.17,1065.72,256.94Zm-10.31-5c-2.12-16.67-14.25-25.31-27.28-25.31-15.92,0-27.29,10.46-29.26,25.31Zm95.82,29.72-19.86-62.92h-10l-19.86,62.92-18.64-62.92h-10.31l23.34,75.8h10.92l19.56-61.09,19.55,61.09h10.92l23.34-75.8h-10.31Zm47.45-43.06c0-8.18,8-12,15.92-12,7.27,0,15,2.88,18.19,10.61l8.33-4.85c-4.39-9.4-14.09-15.47-26.52-15.47-15.16,0-25.93,9.56-25.93,21.68,0,27.9,44.27,17.13,44.27,35.93,0,9-8.49,12.13-17.43,12.13-10.16,0-18-5-20.77-12.74l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43,16.22,0,27.43-8.94,27.43-21.83C1242.94,246.63,1198.68,257.39,1198.68,238.59Z"
    })]
  }));
};
const ForstaLogo = (_Aa) => {
  var _Ba = _Aa, {
    dark: dark2
  } = _Ba, rest = __objRest(_Ba, [
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(Svg$2, __spreadProps(__spreadValues({
    viewBox: "0 0 420 420",
    ieWidths: {
      sm: 65,
      lg: 80,
      default: 72
    },
    oneLineHeight: {
      sm: 65,
      lg: 80,
      default: 72
    }
  }, rest), {
    children: [/* @__PURE__ */ jsx(LogoPath, {
      d: "M30.5,27.1L175.4,27.1 175.4,78.1 30.5,78.1z"
    }), /* @__PURE__ */ jsx(LogoPath, {
      d: "M175.4,123.4L30.5 123.4 30.5 173.7 126.3 173.7 126.3 250.6 175.4 250.6z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M222.7,250.8L278.3 250.8 278.3 173.7 373.9 173.7 373.9 123.4 278.3 123.4 278.3 78.1 389.5 78.1 389.5 27.1 222.7 27.1z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M66,306.5H47l-4.5,10.3h-4.6L54.5,280h4l16.6,36.7h-4.6L66,306.5z M64.3,302.6L56.5,285l-7.8,17.6H64.3z M120.6,284H107v32.7h-4.3V284H89.3V280h31.3V284z M143,305.4h-20.9c0.5,4.6,3.7,8.3,8.9,8.3c3.2,0,5.6-1.1,6.7-3.2h4.6c-1.6,4.3-5.9,6.9-11.3,6.9 c-7.7,0-13.1-5.8-13.1-13.2c0-7.4,5.3-13.2,12.8-13.2C138.8,291,143.8,297.2,143,305.4z M122.1,302.5h16.8c-0.2-5-3.4-7.9-8.1-7.9 C125.8,294.6,122.7,298.1,122.1,302.5z M170.1,308.2h4.3c-1,5.4-5.8,9.2-11.8,9.2c-7.6,0-13.1-5.8-13.1-13.2c0-7.4,5.5-13.2,13.1-13.2 c6,0,10.8,3.7,11.8,9.2h-4.3c-0.8-3.3-3.7-5.4-7.6-5.4c-5.4,0-9,4.2-9,9.4c0,5.2,3.6,9.4,9,9.4 C166.4,313.6,169.3,311.5,170.1,308.2z M205.3,302.4v14.4h-4.1v-14.1c0-5.1-3-7.8-7.4-7.8c-3,0-6,1.5-8.2,4.3v17.6h-4.1v-38.3h4.1v16.1 c2.3-2.2,5.4-3.5,9-3.5C201,291,205.3,295.3,205.3,302.4z M236.9,302.4v14.4h-4.1v-14.1c0-5.1-3-7.8-7.4-7.8c-3,0-6,1.5-8.2,4.3v17.6h-4.1v-25h4.1v2.8 c2.3-2.2,5.4-3.5,9-3.5C232.6,291,236.9,295.3,236.9,302.4z M270.1,304.2c0,7.6-5.7,13.2-13.3,13.2c-7.7,0-13.3-5.6-13.3-13.2c0-7.6,5.7-13.2,13.3-13.2 C264.4,291,270.1,296.6,270.1,304.2z M265.9,304.2c0-5.4-3.9-9.4-9.1-9.4c-5.3,0-9.2,4-9.2,9.4c0,5.4,3.9,9.4,9.2,9.4 C262,313.6,265.9,309.6,265.9,304.2z M281.4,278.4v38.3h-4.1v-38.3H281.4z M315.3,304.2c0,7.6-5.7,13.2-13.3,13.2c-7.7,0-13.3-5.6-13.3-13.2c0-7.6,5.7-13.2,13.3-13.2 C309.7,291,315.3,296.6,315.3,304.2z M311.2,304.2c0-5.4-3.9-9.4-9.1-9.4c-5.3,0-9.2,4-9.2,9.4c0,5.4,3.9,9.4,9.2,9.4 C307.3,313.6,311.2,309.6,311.2,304.2z M346.9,291.7V318c0,7.3-5,11.8-12.5,11.8c-6.9,0-11.9-3.9-12.7-9.4h4.2c0.7,3.4,3.8,5.7,8.5,5.7 c5,0,8.4-3,8.4-8.1v-4.7c-2.3,2.1-5.4,3.2-9.1,3.2c-7.2,0-12.6-5.7-12.6-12.6c0-7.4,5.4-12.8,12.6-12.8c3.6,0,6.7,1.2,9.1,3.2v-2.6 H346.9z M342.8,308.5v-9.4c-2.1-3.1-5.2-4.4-8.5-4.4c-5.3,0-9.1,3.9-9.1,9.2c0,4.8,3.8,9,9.1,9 C337.6,312.9,340.7,311.5,342.8,308.5z M382.1,291.7l-16.9,37.5h-4.4l5.2-11.6l-12.9-25.9h4.4l10.5,21.5l9.7-21.5H382.1z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M118.2,365.4h4.4c-1.7,8.3-8.5,13.8-17.5,13.8c-10.6,0-19.1-8.2-19.1-19s8.5-19,19.1-19 c9,0,15.8,5.5,17.5,13.8h-4.4c-1.5-6-6.4-9.8-13.1-9.8c-8.3,0-14.8,6.4-14.8,15c0,8.6,6.5,15.1,14.8,15.1 C111.8,375.2,116.6,371.4,118.2,365.4z M154.8,366c0,7.6-5.7,13.2-13.3,13.2c-7.7,0-13.3-5.6-13.3-13.2s5.7-13.2,13.3-13.2 C149.1,352.8,154.8,358.5,154.8,366z M150.6,366c0-5.4-3.9-9.4-9.1-9.4c-5.3,0-9.2,4-9.2,9.4c0,5.4,3.9,9.4,9.2,9.4 C146.7,375.4,150.6,371.4,150.6,366z M202.6,363.7v14.8h-4.1v-14.8c0-5-2.6-7.1-6.7-7.1c-3,0-5.8,1.2-7.8,4.3c0.2,0.8,0.2,1.7,0.2,2.6v15h-4.1v-15 c0-4.9-2.6-6.9-6.5-6.9c-3.1,0-5.9,1.3-7.8,4.2v17.7h-4.1v-25h4.1v2.7c2-2.1,4.6-3.3,8.3-3.3c3.8,0,6.8,1.4,8.5,4.2 c2.4-2.6,5.5-4.2,9.5-4.2C198.5,352.8,202.6,356.6,202.6,363.7z M236.2,366c0,7.3-5.7,13.1-12.9,13.1c-3.6,0-6.6-1.2-8.8-3.2V391h-4.1v-37.6h4.1v2.6c2.2-2.1,5.2-3.2,8.8-3.2 C230.5,352.9,236.2,358.7,236.2,366z M232.1,366c0-5.2-4-9.5-9.3-9.5c-3.3,0-6.2,1.3-8.3,4.4v10.3c2.1,3,5,4.4,8.3,4.4 C228.1,375.5,232.1,371.2,232.1,366z M268.3,353.5v25h-4.1v-2.6c-2.2,2.1-5.2,3.2-8.8,3.2c-7.2,0-12.9-5.8-12.9-13.2c0-7.3,5.7-13.2,12.9-13.2 c3.6,0,6.6,1.2,8.8,3.2v-2.6H268.3z M264.2,371.1v-10.3c-2-3-5-4.3-8.3-4.3c-5.3,0-9.3,4.2-9.3,9.4c0,5.2,4,9.4,9.3,9.4 C259.2,375.4,262.1,374.2,264.2,371.1z M300.9,364.2v14.4h-4.1v-14.1c0-5.1-3-7.8-7.4-7.8c-3,0-6,1.5-8.2,4.3v17.6h-4.1v-25h4.1v2.8 c2.3-2.2,5.4-3.5,9-3.5C296.6,352.8,300.9,357.1,300.9,364.2z M334,353.5L317.1,391h-4.4l5.2-11.6L305,353.5h4.4l10.5,21.5l9.7-21.5H334z"
    })]
  }));
};
const InterVuLogo = (_Ca) => {
  var _Da = _Ca, {
    dark: dark2
  } = _Da, rest = __objRest(_Da, [
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(Svg$2, __spreadProps(__spreadValues({
    viewBox: "0 0 561 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      default: 637
    }
  }, rest), {
    children: [/* @__PURE__ */ jsx(LogoPath, {
      d: "M69.78,34V58.17H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M244.31,72.77A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.85,37.22,37.22,0,0,0-9,12.54,40.06,40.06,0,0,0-3.32,16.59,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.71,41.71,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40,40,0,0,0-3.32-16.59A36.88,36.88,0,0,0,244.31,72.77ZM231.7,109a19.42,19.42,0,0,1-3.4,6.26,16.57,16.57,0,0,1-5.58,4.45,18.59,18.59,0,0,1-15.4,0,16.54,16.54,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.34,18.34,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.66,17.66,0,0,1,5.59,4.3,18.86,18.86,0,0,1,3.47,6.11,21.26,21.26,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v24H118.75l-.09,36.56H92.33ZM535,63.13v5.08a36,36,0,0,0-17.45-5.77c-11.84-.82-21.94,3-30.06,11.62-11.77,12.45-14.3,31.75-6.28,47.34,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.2,21.2,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.13,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.44,2.89,21.35,3.06,22.62-8.92,3.1-19.62,4.7-28.92,2.81-12.85-2.63-21.52-11.65-23.78-24.58a48.71,48.71,0,0,1-.81-8.42c0-7.29,0-21.12,0-21.12l-14.77.06V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68.05s-.09,13.59.06,20.66c.16,7.23,4.08,10.93,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.36c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.71,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.32c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.65-3-4.54-8-5.32l-15.29-2.66c-12.95-2.19-22.16-9.54-22.16-22.84,0-16,13.57-25.33,33.7-25.33,17.51,0,33.38,6.06,35.15,25l-22.45,0c-1.2-4.63-6.3-7-12.7-7-6.56,0-9.52,2.34-9.52,5.16,0,2.67,1.88,5,8,6.11l14,2.34C386.34,96.56,395.86,103.44,395.87,116.9Z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M92.31,188.41h10.62V294.53H92.31Zm68.83,28.5c-10.76,0-19.56,4.1-25.47,13.65V218.73h-10v75.8h10V254.81c0-20.31,11.22-28.19,24.56-28.19,13.19,0,20.62,7.88,20.62,21.37v46.54h10V248C190.85,229,179.63,216.91,161.14,216.91Zm67.46-19.4-10,3v18.19H202.68v9.71H218.6v45.93c0,18.19,11.37,23.19,31.83,20.16v-8.79c-14.7.61-21.83,1.67-21.83-11.37V228.44h21.83v-9.71H228.6Zm106.58,59.43c0,1.51-.16,3.18-.31,4.7H268.32c2.12,15.46,14.1,25,30.17,25,12,0,20.31-5.61,24.41-12.89l8.79,5.16c-6.37,10.31-18,17.43-33.35,17.43-23.95,0-40.33-16.83-40.33-39.72,0-22.28,16.07-39.72,39.57-39.72C320.77,216.91,335.18,236.17,335.18,256.94Zm-10.31-5c-2.13-16.67-14.25-25.31-27.29-25.31-15.92,0-27.29,10.46-29.26,25.31Zm36.23-20.61V218.73h-10v75.8h10V252.39c0-18.8,11.83-25.17,23.95-25.17v-9.7C375.35,217.52,366.41,220.7,361.1,231.32Zm73.07,49.11-33.05-92H389.6l39.11,106.12h10.92l39.11-106.12H467.22Zm105.51-61.7v39.72c0,20.32-11.22,28.2-24.56,28.2-13.18,0-20.61-7.88-20.61-21.38V218.73h-10v46.54c0,19,11.22,31.08,29.71,31.08,10.77,0,19.56-4.09,25.47-13.64v11.82h10v-75.8Z"
    })]
  }));
};
const LiveVideoLogo = (_Ea) => {
  var _Fa = _Ea, {
    dark: dark2
  } = _Fa, rest = __objRest(_Fa, [
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(Svg$2, __spreadProps(__spreadValues({
    viewBox: "0 0 741 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      default: 637
    }
  }, rest), {
    children: [/* @__PURE__ */ jsx(LogoPath, {
      d: "M69.78,34V58.17H1V34ZM1,103.59H46.53v36.48H69.77V79.63H1Z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M244.31,72.77A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.85,37.38,37.38,0,0,0-9,12.53,40.14,40.14,0,0,0-3.32,16.6,40.73,40.73,0,0,0,3.32,16.69,37.76,37.76,0,0,0,9,12.67,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.71,41.71,0,0,0,13.28-8.08,37.13,37.13,0,0,0,9.06-12.67,40.73,40.73,0,0,0,3.32-16.69,40.11,40.11,0,0,0-3.32-16.6A37,37,0,0,0,244.31,72.77ZM231.7,109a19.52,19.52,0,0,1-3.4,6.26,17.2,17.2,0,0,1-26.56,0,19.13,19.13,0,0,1-3.4-6.26,22.78,22.78,0,0,1,0-14.17,18.3,18.3,0,0,1,3.32-6.12,16.9,16.9,0,0,1,5.51-4.3,18.69,18.69,0,0,1,15.4,0,17.66,17.66,0,0,1,5.59,4.3,18.8,18.8,0,0,1,3.47,6.12,21.2,21.2,0,0,1,1.21,7.08A22.53,22.53,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v23.94H118.75l-.09,36.57H92.33ZM535,63.13v5.08a36,36,0,0,0-17.45-5.77c-11.84-.83-21.94,3-30.06,11.61-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.33A21.13,21.13,0,0,1,535,90.28c0,7.31,0,17.54,0,23.92C529,121.13,516.76,122.84,509.2,117.59Zm-40.11-1.65c.31,2.44,2.89,21.36,3.06,22.63-8.92,3.09-19.62,4.69-28.92,2.79-12.85-2.62-21.52-11.64-23.78-24.56a48.93,48.93,0,0,1-.81-8.44c0-7.29,0-21.11,0-21.11l-14.77,0V63.23h14.75V38.69h25.28V63.23h25.71v24l-25.68.06s-.09,13.58.06,20.65c.16,7.23,4.08,10.93,11.34,11A35,35,0,0,0,469.09,115.94Zm-178-43.35c6.71-5.77,14.82-9.37,26.06-9.37v24C304.8,87.71,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.31c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.44h23c2.13,4.57,7.39,6.82,14.11,6.82s10.92-1.88,10.92-5.16c0-2.66-3-4.54-8-5.32l-15.29-2.66c-12.95-2.18-22.16-9.54-22.16-22.84,0-16,13.57-25.34,33.7-25.34,17.51,0,33.38,6.08,35.15,25l-22.45,0c-1.2-4.64-6.3-7-12.7-7-6.56,0-9.52,2.33-9.52,5.15,0,2.66,1.88,5,8,6.1l14,2.35C386.34,96.55,395.86,103.44,395.87,116.9Z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M177.36,195.39a7.28,7.28,0,1,1-7.28-7.28A7.28,7.28,0,0,1,177.36,195.39Zm275.91-7.28a7.28,7.28,0,1,0,7.28,7.28A7.28,7.28,0,0,0,453.27,188.11Zm-350.34.31H92.31V294.53h59.13v-10H102.93Zm62.15,30.31h10v75.8h-10Zm85.8,0H261.5l-31.08,75.8H218.29l-31.08-75.8h10.62l26.53,65.34Zm54.73-1.81c-23.49,0-39.56,17.43-39.56,39.71,0,22.89,16.37,39.72,40.32,39.72,15.31,0,27-7.12,33.35-17.43l-8.79-5.16c-4.09,7.28-12.43,12.89-24.41,12.89-16.07,0-28-9.55-30.16-25h66.55c.15-1.52.3-3.19.3-4.7C343.21,236.17,328.81,216.92,305.61,216.92Zm-29.25,35c2-14.85,13.34-25.31,29.25-25.31,13,0,25.17,8.64,27.29,25.31Zm151.29-63.51h11.52L400.06,294.53H389.14L350,188.42h11.52l33.05,92Zm20.62,30.31h10v75.8h-10Zm96.41,14.86c-6.36-10.16-17.13-16.67-30.62-16.67a39.72,39.72,0,0,0,0,79.43c13.49,0,24.26-6.52,30.62-16.67v14.85h10V188.42h-10Zm-29.86,53.06a30,30,0,1,1,29.86-30A29.57,29.57,0,0,1,514.82,286.65Zm96.11-69.73c-23.5,0-39.56,17.43-39.56,39.71,0,22.89,16.37,39.72,40.32,39.72,15.31,0,27-7.12,33.35-17.43l-8.79-5.16c-4.09,7.28-12.43,12.89-24.41,12.89-16.07,0-28-9.55-30.17-25h66.55a46.54,46.54,0,0,0,.31-4.7C648.53,236.17,634.13,216.92,610.93,216.92Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.17,8.64,27.29,25.31Zm118.1-35a39.72,39.72,0,1,0,39.87,39.71A39.41,39.41,0,0,0,699.77,216.92Zm0,69.73a30,30,0,1,1,29.86-30A29.57,29.57,0,0,1,699.77,286.65Z"
    })]
  }));
};
const PanelManagementLogo = (_Ga) => {
  var _Ha = _Ga, {
    dark: dark2
  } = _Ha, rest = __objRest(_Ha, [
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(Svg$2, __spreadProps(__spreadValues({
    viewBox: "0 0 1441 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      default: 637
    }
  }, rest), {
    children: [/* @__PURE__ */ jsx(LogoPath, {
      d: "M69.78,34V58.17H1V34ZM1,103.59H46.53v36.47H69.77V79.62H1Z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M244.31,72.78A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.86,37.24,37.24,0,0,0-9,12.52,40.17,40.17,0,0,0-3.32,16.6,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.53,46.53,0,0,0,32.23,0,41.53,41.53,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40.11,40.11,0,0,0-3.32-16.6A36.9,36.9,0,0,0,244.31,72.78ZM231.7,109a19.52,19.52,0,0,1-3.4,6.26,16.69,16.69,0,0,1-5.58,4.45,18.69,18.69,0,0,1-15.4,0,16.67,16.67,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.44,18.44,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.8,17.8,0,0,1,5.59,4.3,19,19,0,0,1,3.47,6.11,21.3,21.3,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,34h79.18V58.16H118.72l0,21.47h45.38v23.94H118.75l-.09,36.57H92.33ZM535,63.13v5.09a35.77,35.77,0,0,0-17.45-5.77c-11.84-.84-21.94,3-30.06,11.6-11.77,12.46-14.3,31.75-6.28,47.35,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.2,21.2,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.13,516.76,122.84,509.2,117.59ZM469.09,116c.31,2.43,2.89,21.34,3.06,22.61-8.92,3.1-19.62,4.7-28.92,2.8-12.85-2.62-21.52-11.64-23.78-24.57a48.63,48.63,0,0,1-.81-8.43c0-7.29,0-21.11,0-21.11l-14.77,0V63.24h14.75V38.7h25.28V63.24h25.71v24l-25.68.05s-.09,13.59.06,20.66c.16,7.23,4.08,10.93,11.34,11A35.27,35.27,0,0,0,469.09,116Zm-178-43.37c6.71-5.77,14.82-9.36,26.06-9.36v24C304.8,87.72,297,91,291.07,96.76v43.37H265.64v-77h25.43Zm104.8,44.32c0,17.52-15.6,25.34-35.42,25.34-18.52,0-33.94-7.44-36.91-25.45h23c2.13,4.58,7.39,6.83,14.11,6.83s10.92-1.88,10.92-5.16c0-2.66-3-4.54-8-5.32l-15.29-2.65c-12.95-2.2-22.16-9.54-22.16-22.85,0-15.94,13.57-25.34,33.7-25.34,17.51,0,33.38,6.07,35.15,25l-22.45,0c-1.2-4.64-6.3-7-12.7-7-6.56,0-9.52,2.34-9.52,5.16,0,2.66,1.88,5,8,6.1l14,2.35C386.34,96.55,395.86,103.45,395.87,116.9Z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M130.21,188.41H92.32V294.53h10.61V255.12h27.28c19.11,0,33.36-14.4,33.36-33.35C163.57,202.66,149.32,188.41,130.21,188.41Zm0,56.7H102.93V198.42h27.28c13.19,0,22.74,9.7,22.74,23.35C153,235.26,143.4,245.11,130.21,245.11Zm109.16-11.52c-6.37-10.16-17.14-16.68-30.63-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.26-6.52,30.63-16.67v14.85h10v-75.8h-10ZM209.5,286.65a30,30,0,1,1,29.87-30A29.57,29.57,0,0,1,209.5,286.65ZM335.78,248v46.54h-10V248c0-13.49-7.43-21.37-20.62-21.37-13.34,0-24.56,7.88-24.56,28.19v39.72h-10v-75.8h10v11.83c5.91-9.55,14.7-13.65,25.47-13.65C324.56,216.91,335.78,229,335.78,248Zm54.43-31.08c-23.5,0-39.57,17.44-39.57,39.72,0,22.89,16.37,39.72,40.32,39.72,15.32,0,27-7.12,33.36-17.43l-8.8-5.16c-4.09,7.28-12.43,12.89-24.4,12.89-16.07,0-28.05-9.55-30.17-25H427.5c.15-1.52.3-3.19.3-4.7C427.8,236.17,413.4,216.91,390.21,216.91Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.16,8.64,27.28,25.31Zm82.77-68.06h10V294.53h-10Zm154.48,4.54h13.19V294.53H600.78v-90l-37.14,62.16h-1.52L525,204.48v90H514.37V188.41h13.19l35.32,59.13Zm101.12,45.18c-6.37-10.16-17.13-16.68-30.63-16.68a39.72,39.72,0,0,0,0,79.44c13.5,0,24.26-6.52,30.63-16.67v14.85h10v-75.8h-10Zm-29.87,53.06a30,30,0,1,1,29.87-30A29.57,29.57,0,0,1,669.45,286.65ZM795.73,248v46.54h-10V248c0-13.49-7.43-21.37-20.62-21.37-13.34,0-24.56,7.88-24.56,28.19v39.72h-10v-75.8h10v11.83c5.91-9.55,14.71-13.65,25.47-13.65C784.51,216.91,795.73,229,795.73,248Zm84.59-14.4c-6.36-10.16-17.13-16.68-30.62-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.26-6.52,30.62-16.67v14.85h10v-75.8h-10Zm-29.86,53.06a30,30,0,1,1,29.86-30A29.57,29.57,0,0,1,850.46,286.65Zm126.28-53.06c-6.37-10.16-17.13-16.68-30.62-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.25-6.52,30.62-16.67V291.5c0,15.46-10.46,25.47-28,25.47-16.37,0-23.34-6.07-27.13-13.8l-8.79,5c5.91,11.82,18.49,18.49,35.92,18.49,19.56,0,38-12.13,38-35.17V218.73h-10Zm-29.87,53.06a30,30,0,1,1,29.87-30A29.58,29.58,0,0,1,946.87,286.65ZM1043,216.91c-23.5,0-39.57,17.44-39.57,39.72,0,22.89,16.37,39.72,40.33,39.72,15.31,0,27-7.12,33.35-17.43l-8.8-5.16c-4.09,7.28-12.43,12.89-24.4,12.89-16.07,0-28.05-9.55-30.17-25h66.55c.15-1.52.3-3.19.3-4.7C1080.58,236.17,1066.18,216.91,1043,216.91Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.16,8.64,27.29,25.31Zm191.92-4.7v47.3h-10v-47.3c0-13.49-7.73-20.61-18.5-20.61-11.67,0-21.07,7.12-21.07,25.92v42h-10v-47.3c0-13.49-7-20.61-17.73-20.61-10.92,0-21.83,7.12-21.83,25.92v42h-10v-75.8h10V229.8c5.91-9.25,14.1-12.89,23.19-12.89,10.61,0,18.8,5,23,13.8a27.83,27.83,0,0,1,24.56-13.8C1194,216.91,1205.65,228.28,1205.65,247.23Zm54.43-30.32c-23.5,0-39.57,17.44-39.57,39.72,0,22.89,16.37,39.72,40.33,39.72,15.31,0,27-7.12,33.35-17.43l-8.8-5.16c-4.09,7.28-12.43,12.89-24.4,12.89-16.07,0-28-9.55-30.17-25h66.55c.15-1.52.3-3.19.3-4.7C1297.67,236.17,1283.27,216.91,1260.08,216.91Zm-29.26,35c2-14.85,13.34-25.31,29.26-25.31,13,0,25.16,8.64,27.28,25.31Zm148-3.94v46.54h-10V248c0-13.49-7.42-21.37-20.61-21.37-13.34,0-24.56,7.88-24.56,28.19v39.72h-10v-75.8h10v11.83c5.91-9.55,14.7-13.65,25.47-13.65C1367.56,216.91,1378.78,229,1378.78,248Zm37.75-19.55v45.93c0,13,7.12,12,21.83,11.37v8.79c-20.47,3-31.84-2-31.84-20.16V228.44h-15.91v-9.71h15.91V200.54l10-3v21.22h21.83v9.71Z"
    })]
  }));
};
const SurveysLogo = (_Ia) => {
  var _Ja = _Ia, {
    dark: dark2
  } = _Ja, rest = __objRest(_Ja, [
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(Svg$2, __spreadProps(__spreadValues({
    viewBox: "0 0 1140.96 204.98",
    ieWidths: {
      sm: 531,
      lg: 707,
      default: 637
    }
  }, rest), {
    children: [/* @__PURE__ */ jsx(LogoPath, {
      d: "M13.55 15.39h68.78v24.17H13.55Z M 82.32,61.01 13.55,61.01 13.55,84.98 59.08,84.98 59.08,121.45 82.32,121.45 z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M 104.88,121.53 131.21,121.53 131.3,84.96 176.68,84.96 176.68,61.02 131.3,61.02 131.27,39.55 184.06,39.55 184.06,15.39 104.88,15.39 z  M269.24,83.29c0,6.14-1.11,11.7-3.32,16.68c-2.21,4.98-5.23,9.21-9.06,12.68s-8.25,6.16-13.28,8.08 c-5.03,1.91-10.41,2.87-16.15,2.87c-5.64,0-11-0.96-16.08-2.87c-5.08-1.91-9.51-4.6-13.28-8.08c-3.77-3.47-6.77-7.7-8.98-12.68  c-2.21-4.98-3.32-10.54-3.32-16.68s1.11-11.67,3.32-16.6s5.21-9.11,8.98-12.53c3.77-3.42,8.2-6.04,13.28-7.85 c5.08-1.81,10.44-2.72,16.08-2.72c5.74,0,11.12,0.91,16.15,2.72s9.46,4.43,13.28,7.85s6.84,7.6,9.06,12.53  C268.13,71.61,269.24,77.15,269.24,83.29z M245.39,83.29c0-2.42-0.4-4.78-1.21-7.09s-1.96-4.35-3.47-6.11s-3.37-3.19-5.59-4.3 c-2.21-1.11-4.78-1.66-7.7-1.66s-5.49,0.55-7.7,1.66c-2.21,1.11-4.05,2.54-5.51,4.3c-1.46,1.76-2.57,3.8-3.32,6.11  c-0.75,2.32-1.13,4.68-1.13,7.09c0,2.41,0.38,4.78,1.13,7.09c0.75,2.32,1.89,4.4,3.4,6.26s3.37,3.35,5.58,4.45 c2.21,1.11,4.78,1.66,7.7,1.66s5.48-0.55,7.7-1.66c2.21-1.11,4.08-2.59,5.58-4.45c1.51-1.86,2.64-3.95,3.4-6.26  C245.01,88.07,245.39,85.7,245.39,83.29z M329.68,68.63c-12.33,0.47-20.13,3.74-26.06,9.52v43.37h-25.43V44.55h25.43v9.42 c6.71-5.77,14.82-9.36,26.06-9.36V68.63z M384.85,75.29l-14.04-2.35c-6.08-1.1-7.96-3.44-7.96-6.1c0-2.82,2.96-5.16,9.52-5.16  c6.4,0,11.5,2.32,12.7,6.96l22.45,0.02c-1.77-18.9-17.64-24.97-35.15-24.97c-20.13,0-33.7,9.39-33.7,25.34 c0,13.3,9.21,20.65,22.16,22.84l15.29,2.66c4.99,0.78,7.96,2.66,7.96,5.32c0,3.28-4.21,5.16-10.92,5.16  c-6.72,0-11.98-2.25-14.11-6.83h-22.96c2.97,18.01,18.39,25.45,36.91,25.45c19.82,0,35.42-7.82,35.42-25.34 C408.41,84.83,398.89,77.94,384.85,75.29z M467.89,100.39c-7.26-0.12-11.18-3.82-11.34-11.05c-0.15-7.07-0.06-20.66-0.06-20.66l25.68-0.05V44.62  h-25.71V20.08h-25.28v24.54h-14.75v24.07l14.77-0.05c0,0-0.01,13.82-0.01,21.11c0,2.81,0.32,5.66,0.81,8.43 c2.26,12.93,10.93,21.95,23.78,24.57c9.3,1.9,20,0.3,28.92-2.8c-0.17-1.27-2.75-20.18-3.06-22.62  C479.38,98.15,475.11,100.3,467.89,100.39z M547.55,44.52c0,0,0,3.64,0,5.08c-5.48-3.55-11.24-5.33-17.45-5.77c-11.84-0.83-21.94,3.01-30.06,11.61 c-11.77,12.46-14.3,31.75-6.28,47.35c10.91,21.24,36.28,25.7,53.76,14.8c0,0.91,0,3.94,0,3.94h25.25V44.52H547.55z  M547.55,95.59c-6.04,6.93-18.24,8.64-25.8,3.39c-5.7-3.97-7.91-9.7-7.69-16.42c0.31-9.26,6.59-16.24,15.78-17.34 c6.51-0.78,13.04,1.63,17.7,6.45C547.55,78.98,547.55,89.2,547.55,95.59z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M620.77,97.19l9.06-5.28c3.77,12.68,13.74,20.83,30.35,20.83c16,0,24.91-7.7,24.91-19.02 c0-12.23-10.42-16.15-25.97-21.29c-17.21-5.74-33.82-10.27-33.82-29.74c0-18.57,14.95-28.99,32.46-28.99 c17.36,0,29.44,10.27,34.87,22.8l-8.91,4.98c-3.92-9.51-12.08-17.51-25.97-17.51c-12.68,0-21.89,6.64-21.89,18.27 c0,11.47,9.06,15.1,23.4,19.78c19.17,6.34,36.38,11.78,36.38,31.4c0,18.12-14.49,29.59-35.63,29.59 C640.55,123.01,626.2,113.19,620.77,97.19z M775.36,45.71v75.49h-9.96v-11.78c-5.89,9.51-14.64,13.59-25.36,13.59c-18.42,0-29.59-12.08-29.59-30.95 V45.71h9.96v46.35c0,13.44,7.4,21.29,20.53,21.29c13.29,0,24.46-7.85,24.46-28.08V45.71H775.36z M830.31,44.5v9.66c-12.08,0-23.85,6.34-23.85,25.06v41.97h-9.96V45.71h9.96v12.53 C811.74,47.67,820.65,44.5,830.31,44.5z M908.81,45.71l-30.95,75.49h-12.08l-30.95-75.49h10.57l26.42,65.07l26.42-65.07H908.81z M990.18,83.75c0,1.51-0.15,3.17-0.3,4.68H923.6c2.11,15.4,14.04,24.91,30.04,24.91 c11.93,0,20.23-5.59,24.31-12.83l8.76,5.13c-6.34,10.27-17.96,17.36-33.21,17.36c-23.85,0-40.16-16.76-40.16-39.55 c0-22.19,16-39.55,39.4-39.55C975.84,43.9,990.18,63.07,990.18,83.75z M923.6,78.77h56.31c-2.11-16.61-14.19-25.21-27.17-25.21 C936.89,53.56,925.57,63.98,923.6,78.77z M1067.93,45.71l-32.31,82.43c-5.74,14.49-16.91,24.31-30.5,23.25v-9.36c9.81,1.06,16.61-5.89,20.68-15.7 l1.96-4.68l-33.82-75.94h10.57l28.38,63.26l24.46-63.26H1067.93z M1127.41,101.27c0,12.83-11.17,21.74-27.33,21.74c-15.1,0-25.36-7.7-29.14-17.36l8.45-4.98 c2.72,7.7,10.57,12.68,20.68,12.68c8.91,0,17.36-3.17,17.36-12.08c0-18.72-44.08-8-44.08-35.78c0-12.08,10.72-21.59,25.82-21.59 c12.38,0,22.04,6.04,26.42,15.4l-8.3,4.83c-3.17-7.7-10.87-10.57-18.12-10.57c-7.85,0-15.85,3.77-15.85,11.93 C1083.33,84.21,1127.41,73.49,1127.41,101.27z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M82.76,171.57H66.75l-3.83,8.67h-3.88l14-31.02h3.42l14,31.02h-3.88L82.76,171.57z M81.3,168.33l-6.57-14.87 l-6.57,14.87H81.3z M128.92,152.54h-11.45v27.69h-3.6v-27.69h-11.41v-3.33h26.46V152.54z M147.9,170.7h-17.7c0.41,3.92,3.1,6.98,7.53,6.98c2.69,0,4.74-0.96,5.66-2.74h3.88 c-1.32,3.65-4.97,5.84-9.53,5.84c-6.52,0-11.04-4.88-11.04-11.13c0-6.25,4.47-11.13,10.86-11.13 C144.34,158.52,148.58,163.77,147.9,170.7z M130.24,168.24h14.19c-0.18-4.2-2.87-6.71-6.89-6.71 C133.35,161.53,130.75,164.5,130.24,168.24z M170.75,173.03h3.6c-0.82,4.61-4.88,7.76-9.99,7.76c-6.43,0-11.09-4.88-11.09-11.13 c0-6.25,4.65-11.13,11.09-11.13c5.11,0,9.17,3.15,9.99,7.8h-3.6c-0.64-2.78-3.1-4.61-6.39-4.61c-4.61,0-7.62,3.56-7.62,7.94 c0,4.43,3.01,7.94,7.62,7.94C167.65,177.59,170.11,175.81,170.75,173.03z M200.59,168.1v12.13h-3.47v-11.95c0-4.29-2.51-6.57-6.25-6.57c-2.51,0-5.11,1.28-6.93,3.65v14.87h-3.47 v-32.39h3.47v13.59c1.96-1.87,4.56-2.92,7.57-2.92C196.89,158.52,200.59,162.13,200.59,168.1z M227.32,168.1v12.13h-3.47v-11.95c0-4.29-2.51-6.57-6.25-6.57c-2.51,0-5.11,1.28-6.93,3.65v14.87h-3.47 v-21.17h3.47v2.37c1.96-1.87,4.56-2.92,7.57-2.92C223.62,158.52,227.32,162.13,227.32,168.1z M255.33,169.65c0,6.39-4.79,11.13-11.22,11.13c-6.48,0-11.27-4.74-11.27-11.13s4.79-11.13,11.27-11.13 C250.54,158.52,255.33,163.26,255.33,169.65z M251.81,169.65c0-4.56-3.28-7.94-7.71-7.94c-4.47,0-7.8,3.38-7.8,7.94 c0,4.56,3.33,7.94,7.8,7.94C248.53,177.59,251.81,174.21,251.81,169.65z M264.91,147.85v32.39h-3.47v-32.39H264.91z M293.6,169.65c0,6.39-4.79,11.13-11.22,11.13c-6.48,0-11.27-4.74-11.27-11.13s4.79-11.13,11.27-11.13 C288.81,158.52,293.6,163.26,293.6,169.65z M290.09,169.65c0-4.56-3.28-7.94-7.71-7.94c-4.47,0-7.8,3.38-7.8,7.94 c0,4.56,3.33,7.94,7.8,7.94C286.8,177.59,290.09,174.21,290.09,169.65z M320.28,159.07v22.22c0,6.2-4.24,9.99-10.54,9.99c-5.84,0-10.04-3.28-10.77-7.98h3.56 c0.59,2.87,3.24,4.84,7.21,4.84c4.24,0,7.07-2.56,7.07-6.84v-3.97c-1.96,1.73-4.61,2.74-7.66,2.74c-6.07,0-10.67-4.84-10.67-10.67 c0-6.25,4.61-10.86,10.67-10.86c3.06,0,5.7,1,7.66,2.74v-2.19H320.28z M316.82,173.26v-7.94c-1.78-2.6-4.42-3.74-7.21-3.74 c-4.47,0-7.66,3.33-7.66,7.8c0,4.06,3.19,7.62,7.66,7.62C312.39,177,315.04,175.86,316.82,173.26z M350.03,159.07l-14.32,31.7h-3.7l4.43-9.81l-10.9-21.9h3.74l8.85,18.2l8.21-18.2H350.03z M391.4,169.15h3.74c-1.46,6.98-7.16,11.68-14.78,11.68c-8.94,0-16.15-6.93-16.15-16.1 c0-9.17,7.21-16.06,16.15-16.06c7.62,0,13.32,4.65,14.78,11.63h-3.74c-1.28-5.06-5.38-8.26-11.04-8.26 c-7.02,0-12.5,5.43-12.5,12.68c0,7.25,5.47,12.73,12.5,12.73C386.02,177.45,390.12,174.17,391.4,169.15z M422.38,169.65c0,6.39-4.79,11.13-11.22,11.13c-6.48,0-11.27-4.74-11.27-11.13s4.79-11.13,11.27-11.13 C417.59,158.52,422.38,163.26,422.38,169.65z M418.86,169.65c0-4.56-3.28-7.94-7.71-7.94c-4.47,0-7.8,3.38-7.8,7.94 c0,4.56,3.33,7.94,7.8,7.94C415.58,177.59,418.86,174.21,418.86,169.65z M462.84,167.74v12.5h-3.47v-12.5c0-4.2-2.19-6.02-5.66-6.02c-2.56,0-4.93,1.05-6.61,3.6 c0.14,0.68,0.18,1.41,0.18,2.24v12.68h-3.47v-12.68c0-4.15-2.24-5.84-5.47-5.84c-2.65,0-4.97,1.09-6.61,3.56v14.96h-3.47v-21.17 h3.47v2.28c1.73-1.78,3.92-2.83,6.98-2.83c3.24,0,5.75,1.19,7.21,3.51c2.05-2.24,4.65-3.51,8.03-3.51 C459.33,158.52,462.84,161.67,462.84,167.74z M491.26,169.65c0,6.2-4.84,11.09-10.9,11.09c-3.01,0-5.57-1-7.44-2.74v12.82h-3.47v-31.75h3.47v2.24 c1.87-1.73,4.43-2.74,7.44-2.74C486.42,158.57,491.26,163.49,491.26,169.65z M487.79,169.65c0-4.38-3.42-8.03-7.89-8.03 c-2.78,0-5.25,1.14-6.98,3.7v8.67c1.73,2.55,4.2,3.7,6.98,3.7C484.37,177.68,487.79,174.03,487.79,169.65z M518.35,159.07v21.17h-3.47v-2.19c-1.87,1.73-4.42,2.74-7.44,2.74c-6.07,0-10.9-4.93-10.9-11.13 c0-6.16,4.84-11.13,10.9-11.13c3.01,0,5.57,1,7.44,2.74v-2.19H518.35z M514.89,173.99v-8.67c-1.73-2.55-4.2-3.6-6.98-3.6 c-4.47,0-7.89,3.56-7.89,7.94c0,4.38,3.42,7.94,7.89,7.94C510.69,177.59,513.15,176.54,514.89,173.99z M545.95,168.1v12.13h-3.47v-11.95c0-4.29-2.51-6.57-6.25-6.57c-2.51,0-5.11,1.28-6.93,3.65v14.87h-3.47 v-21.17h3.47v2.37c1.96-1.87,4.56-2.92,7.57-2.92C542.26,158.52,545.95,162.13,545.95,168.1z M573.91,159.07l-14.32,31.7h-3.7l4.43-9.81l-10.9-21.9h3.74l8.85,18.2l8.21-18.2H573.91z"
    })]
  }));
};
const VideoInsightsLogo = (_Ka) => {
  var _La = _Ka, {
    dark: dark2
  } = _La, rest = __objRest(_La, [
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(Svg$2, __spreadProps(__spreadValues({
    viewBox: "0 0 1032 328",
    ieWidths: {
      sm: 531,
      lg: 707,
      default: 637
    }
  }, rest), {
    children: [/* @__PURE__ */ jsx(LogoPath, {
      d: "M1,34V58.17H69.78V34Zm0,69.59H46.53v36.47H69.77V79.62H1Z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M244.31,72.77A40,40,0,0,0,231,64.92a49.1,49.1,0,0,0-32.23,0,39,39,0,0,0-13.28,7.85,37.22,37.22,0,0,0-9,12.54,40.06,40.06,0,0,0-3.32,16.59,40.69,40.69,0,0,0,3.32,16.68,37.9,37.9,0,0,0,9,12.68,40.2,40.2,0,0,0,13.28,8.08,46.68,46.68,0,0,0,32.23,0,41.71,41.71,0,0,0,13.28-8.08,37.27,37.27,0,0,0,9.06-12.68,40.69,40.69,0,0,0,3.32-16.68,40,40,0,0,0-3.32-16.59A36.88,36.88,0,0,0,244.31,72.77ZM231.7,109a19.42,19.42,0,0,1-3.4,6.26,16.57,16.57,0,0,1-5.58,4.45,18.59,18.59,0,0,1-15.4,0,16.54,16.54,0,0,1-5.58-4.45,19.23,19.23,0,0,1-3.4-6.26,22.81,22.81,0,0,1,0-14.18,18.34,18.34,0,0,1,3.32-6.11,18,18,0,0,1,20.91-4.3,17.66,17.66,0,0,1,5.59,4.3,18.86,18.86,0,0,1,3.47,6.11,21.26,21.26,0,0,1,1.21,7.09A22.58,22.58,0,0,1,231.7,109ZM92.33,140.14h26.33l.09-36.56h45.38v-24H118.75l0-21.47h52.79V34H92.33ZM535,63.13v5.08a36,36,0,0,0-17.45-5.77c-11.84-.82-21.94,3-30.06,11.62-11.77,12.45-14.3,31.75-6.28,47.34,10.91,21.24,36.28,25.7,53.76,14.8v3.94h25.25v-77Zm-25.8,54.46c-5.7-4-7.91-9.7-7.69-16.42.31-9.26,6.59-16.24,15.78-17.34A21.2,21.2,0,0,1,535,90.28c0,7.31,0,17.53,0,23.92C529,121.13,516.76,122.84,509.2,117.59ZM455.34,119c-7.26-.12-11.18-3.82-11.34-11-.15-7.07-.06-20.66-.06-20.66l25.68-.05v-24H443.91V38.69H418.63V63.23H403.88V87.31l14.77-.06s0,13.83,0,21.12a48.71,48.71,0,0,0,.81,8.42c2.26,12.93,10.93,22,23.78,24.58,9.3,1.89,20,.29,28.92-2.81-.17-1.27-2.75-20.18-3.06-22.62A35,35,0,0,1,455.34,119ZM291.07,63.16H265.64v77h25.43V96.76C297,91,304.8,87.71,317.13,87.24v-24c-11.24,0-19.35,3.59-26.06,9.36ZM372.3,93.9l-14-2.34c-6.08-1.11-8-3.44-8-6.11,0-2.82,3-5.16,9.52-5.16,6.4,0,11.5,2.33,12.7,7l22.45,0c-1.77-18.9-17.64-25-35.15-25-20.13,0-33.7,9.38-33.7,25.33,0,13.3,9.21,20.65,22.16,22.84l15.29,2.66c5,.78,8,2.67,8,5.32,0,3.28-4.21,5.16-10.92,5.16s-12-2.25-14.11-6.83h-23c3,18,18.39,25.45,36.91,25.45,19.82,0,35.42-7.82,35.42-25.34C395.86,103.44,386.34,96.56,372.3,93.9Z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M126.27,280.43l-33-92H81.71l39.11,106.12h10.91l39.11-106.12H159.32Zm53.67,14.1h10v-75.8h-10Zm5-106.42a7.28,7.28,0,1,0,7.28,7.28A7.28,7.28,0,0,0,184.94,188.11Zm91.42,45.48c-6.37-10.16-17.13-16.68-30.63-16.68a39.72,39.72,0,0,0,0,79.44c13.5,0,24.26-6.52,30.63-16.68v14.86h10V188.41h-10Zm-29.87,53.06a30,30,0,1,1,29.87-30A29.58,29.58,0,0,1,246.49,286.65Zm96.11-69.74c-23.49,0-39.56,17.44-39.56,39.72,0,22.89,16.37,39.72,40.32,39.72,15.31,0,27-7.12,33.35-17.43l-8.79-5.16c-4.09,7.28-12.43,12.89-24.41,12.89-16.06,0-28-9.55-30.16-25H379.9c.15-1.52.3-3.19.3-4.7C380.2,236.17,365.8,216.91,342.6,216.91Zm-29.25,35c2-14.85,13.34-25.31,29.25-25.31,13,0,25.17,8.64,27.29,25.31Zm118.09-35a39.72,39.72,0,1,0,39.87,39.72A39.41,39.41,0,0,0,431.44,216.91Zm0,69.74a30,30,0,1,1,29.87-30A29.58,29.58,0,0,1,431.44,286.65Zm96,7.88H538V188.41H527.4Zm68.83-77.62c-10.76,0-19.56,4.1-25.47,13.65V218.73h-10v75.8h10V254.81c0-20.31,11.22-28.19,24.56-28.19,13.19,0,20.62,7.88,20.62,21.37v46.54h10V248C625.94,229,614.72,216.91,596.23,216.91Zm57,21.68c0-8.18,8-12,15.92-12,7.28,0,15,2.88,18.19,10.61l8.34-4.85c-4.4-9.4-14.1-15.47-26.53-15.47-15.16,0-25.92,9.56-25.92,21.68,0,27.9,44.26,17.13,44.26,35.93,0,9-8.49,12.13-17.43,12.13-10.16,0-18-5-20.77-12.74l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43,16.22,0,27.44-8.94,27.44-21.83C697.5,246.63,653.23,257.39,653.23,238.59Zm60.19,55.94h10v-75.8h-10Zm5-106.42a7.28,7.28,0,1,0,7.28,7.28A7.29,7.29,0,0,0,718.42,188.11Zm91.41,45.48c-6.36-10.16-17.13-16.68-30.62-16.68a39.72,39.72,0,0,0,0,79.44c13.49,0,24.26-6.52,30.62-16.68V291.5c0,15.46-10.46,25.47-28,25.47-16.37,0-23.35-6.07-27.14-13.8l-8.79,5c5.91,11.83,18.49,18.5,35.93,18.5,19.55,0,38.05-12.13,38.05-35.17V218.73h-10ZM780,286.65a30,30,0,1,1,29.86-30A29.58,29.58,0,0,1,780,286.65Zm96.56-69.74c-10.76,0-19.55,4.1-25.46,13.65V188.41h-10V294.53h10V254.81c0-20.31,11.21-28.19,24.56-28.19,13.18,0,20.61,7.88,20.61,21.37v46.54h10V248C906.25,229,895,216.91,876.53,216.91ZM944,197.51l-10,3v18.19H918.07v9.71H934v45.93c0,18.19,11.37,23.19,31.84,20.16v-8.79c-14.71.6-21.83,1.67-21.83-11.37V228.44h21.83v-9.71H944Zm41.84,41.08c0-8.18,8-12,15.92-12,7.27,0,15,2.88,18.19,10.61l8.34-4.85c-4.4-9.4-14.1-15.47-26.53-15.47-15.16,0-25.93,9.56-25.93,21.68,0,27.9,44.27,17.13,44.27,35.93,0,9-8.49,12.13-17.43,12.13-10.16,0-18-5-20.77-12.74l-8.49,5c3.79,9.7,14.1,17.43,29.26,17.43,16.22,0,27.43-8.94,27.43-21.83C1030.1,246.63,985.84,257.39,985.84,238.59Z"
    })]
  }));
};
const VIStreamlineLogo = (_Ma) => {
  var _Na = _Ma, {
    dark: dark2
  } = _Na, rest = __objRest(_Na, [
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(Svg$2, __spreadProps(__spreadValues({
    ieWidths: {
      sm: 531,
      lg: 707,
      default: 637
    },
    viewBox: "0 0 1552.53 173"
  }, rest), {
    children: [/* @__PURE__ */ jsx(LogoPath, {
      d: "M1 33.45v24.17h68.78V33.45zM1 103h45.53v36.47h23.24v-60.4H1z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M244.31 72.22A40 40 0 00231 64.37a49.1 49.1 0 00-32.23 0 39 39 0 00-13.28 7.85 37.28 37.28 0 00-9 12.53 40.14 40.14 0 00-3.32 16.6 40.69 40.69 0 003.37 16.65 37.9 37.9 0 009 12.68 40.2 40.2 0 0013.28 8.08 46.68 46.68 0 0032.23 0 41.71 41.71 0 0013.28-8.08 37.27 37.27 0 009.04-12.68 40.69 40.69 0 003.32-16.68 40.11 40.11 0 00-3.32-16.6 36.94 36.94 0 00-9.06-12.5zm-12.61 36.22a19.52 19.52 0 01-3.4 6.26 16.69 16.69 0 01-5.58 4.45 18.69 18.69 0 01-15.4 0 16.67 16.67 0 01-5.58-4.45 19.23 19.23 0 01-3.4-6.26 22.81 22.81 0 010-14.18 18.34 18.34 0 013.32-6.11 18 18 0 0120.91-4.3 17.66 17.66 0 015.59 4.3 18.86 18.86 0 013.47 6.11 21.26 21.26 0 011.21 7.09 22.58 22.58 0 01-1.14 7.09zM92.33 139.59h26.33l.09-36.57h45.38V79.08h-45.38V57.61h52.79V33.45H92.33zM535 62.58v5.08a36 36 0 00-17.45-5.77c-11.84-.83-21.94 3-30.06 11.61-11.77 12.46-14.3 31.75-6.28 47.35 10.91 21.24 36.28 25.7 53.76 14.8v3.94h25.25v-77zM509.2 117c-5.7-4-7.91-9.7-7.69-16.42.31-9.26 6.59-16.24 15.78-17.34A21.17 21.17 0 01535 89.73v23.92c-6 6.93-18.24 8.64-25.8 3.35zm-53.86 1.41c-7.26-.12-11.18-3.82-11.34-11-.15-7.07-.06-20.66-.06-20.66h25.68v-24h-25.71V38.14h-25.28v24.54h-14.75v24.07h14.77v21.11a48.73 48.73 0 00.81 8.43c2.26 12.93 10.93 22 23.78 24.57 9.3 1.9 20 .3 28.92-2.8-.17-1.27-2.75-20.18-3.06-22.62a35 35 0 01-13.76 3.01zm-164.27-55.8h-25.43v77h25.43v-43.4c5.93-5.78 13.73-9 26.06-9.52v-24c-11.24 0-19.35 3.59-26.06 9.36zm81.23 30.74l-14-2.35c-6.08-1.1-8-3.44-8-6.1 0-2.82 3-5.16 9.52-5.16 6.4 0 11.5 2.32 12.7 7h22.45c-1.77-18.9-17.64-25-35.15-25-20.13 0-33.7 9.39-33.7 25.34 0 13.3 9.21 20.65 22.16 22.84l15.29 2.66c5 .78 8 2.66 8 5.32 0 3.28-4.21 5.16-10.92 5.16s-12-2.25-14.11-6.83h-23c3 18 18.39 25.45 36.91 25.45 19.82 0 35.42-7.82 35.42-25.34-.01-13.45-9.53-20.34-23.57-22.99zM642.56 125.41l-33-92H598l39.1 106.1H648l39.13-106.12h-11.52zm58.67-92.32a7.28 7.28 0 107.28 7.28 7.29 7.29 0 00-7.28-7.28zm-5 106.42h10v-75.8h-10zm96.41-60.94c-6.37-10.16-17.13-16.68-30.64-16.68a39.72 39.72 0 000 79.44c13.49 0 24.25-6.52 30.62-16.68v14.86h10V33.39h-10zm-29.86 53.06a30 30 0 1129.86-30 29.58 29.58 0 01-29.86 30zm96.11-69.74c-23.5 0-39.57 17.44-39.57 39.72 0 22.89 16.38 39.72 40.33 39.72 15.31 0 27-7.13 33.35-17.43l-8.79-5.16c-4.1 7.28-12.43 12.89-24.41 12.89-16.07 0-28-9.55-30.17-25h66.55c.15-1.51.31-3.18.31-4.7 0-20.78-14.41-40.04-37.6-40.04zm-29.26 35c2-14.85 13.34-25.31 29.26-25.31 13 0 25.16 8.64 27.29 25.31zm118.1-35a39.72 39.72 0 1039.87 39.72 39.41 39.41 0 00-39.87-39.72zm0 69.74a30 30 0 1129.86-30 29.58 29.58 0 01-29.86 30zm96 7.88h10.61V33.39h-10.61zm68.82-77.62c-10.76 0-19.55 4.1-25.46 13.65V63.71h-10v75.8h10V99.79c0-20.31 11.21-28.19 24.55-28.19s20.62 7.88 20.62 21.37v46.54h10V93c-.03-19-11.26-31.11-29.75-31.11zm57 21.68c0-8.18 8-12 15.91-12 7.28 0 15 2.88 18.2 10.61l8.33-4.85c-4.39-9.4-14.1-15.47-26.53-15.47-15.16 0-25.92 9.55-25.92 21.68 0 27.9 44.27 17.13 44.27 35.93 0 8.94-8.49 12.13-17.44 12.13-10.15 0-18-5-20.77-12.74l-8.48 5c3.79 9.7 14.09 17.43 29.25 17.43 16.22 0 27.44-8.94 27.44-21.83-.03-27.85-44.29-17.09-44.29-35.89zm65.19-50.48a7.28 7.28 0 107.27 7.28 7.28 7.28 0 00-7.3-7.28zm-5 106.42h10v-75.8h-10zm96.42-60.94c-6.37-10.16-17.13-16.68-30.62-16.68a39.72 39.72 0 000 79.44c13.49 0 24.25-6.52 30.62-16.68v11.83c0 15.46-10.46 25.47-28 25.47-16.37 0-23.34-6.07-27.13-13.8l-8.8 5c5.92 11.83 18.5 18.5 35.93 18.5 19.56 0 38-12.13 38-35.17V63.71h-10zm-29.87 53.06a30 30 0 1129.87-30 29.58 29.58 0 01-29.91 30zm96.57-69.74c-10.76 0-19.56 4.1-25.47 13.65V33.39h-10v106.12h10V99.79c0-20.31 11.22-28.19 24.56-28.19 13.19 0 20.62 7.88 20.62 21.37v46.54h10V93c-.04-19-11.26-31.11-29.75-31.11zm67.46-19.4l-10 3v18.22h-15.92v9.7h15.92v45.94c0 18.19 11.37 23.19 31.83 20.16v-8.79c-14.7.6-21.83 1.67-21.83-11.37V73.41h21.83v-9.7h-21.83zm41.84 41.08c0-8.18 8-12 15.92-12 7.28 0 15 2.88 18.19 10.61l8.34-4.85c-4.4-9.4-14.1-15.47-26.53-15.47-15.16 0-25.92 9.55-25.92 21.68 0 27.9 44.26 17.13 44.26 35.93 0 8.94-8.49 12.13-17.43 12.13-10.16 0-18-5-20.77-12.74l-8.49 5c3.79 9.7 14.1 17.43 29.26 17.43 16.22 0 27.44-8.94 27.44-21.83-.04-27.85-44.31-17.09-44.31-35.89z"
    })]
  }));
};
const VideoInsightsLegacyLogo = (_Oa) => {
  var _Pa = _Oa, {
    dark: dark2
  } = _Pa, rest = __objRest(_Pa, [
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(Svg$2, __spreadProps(__spreadValues({
    ieWidths: {
      sm: 531,
      lg: 707,
      default: 637
    },
    viewBox: "0 0 1162 173"
  }, rest), {
    children: [/* @__PURE__ */ jsx(LogoPath, {
      d: "M1 33.45v24.17h68.78V33.45zM1 103h45.53v36.47h23.24v-60.4H1z"
    }), /* @__PURE__ */ jsx(TextPath, {
      dark: dark2,
      d: "M92.33 139.59h26.33l.09-36.57h45.38V79.08h-45.38l-.03-21.47h52.79V33.45H92.33v106.14zM253.85 125.41l-33-92h-11.57l39.11 106.12h10.92l39.11-106.14H286.9zm58.67-92.32a7.28 7.28 0 107.28 7.28 7.28 7.28 0 00-7.28-7.28zm-5 106.42h10v-75.8h-10zm96.41-60.94c-6.36-10.16-17.13-16.68-30.62-16.68a39.72 39.72 0 000 79.44c13.49 0 24.26-6.52 30.62-16.68v14.86h10V33.39h-10zm-29.86 53.06a30 30 0 1129.86-30 29.58 29.58 0 01-29.86 30zm96.11-69.74c-23.5 0-39.57 17.44-39.57 39.72 0 22.89 16.38 39.72 40.33 39.72 15.31 0 27-7.13 33.35-17.44l-8.79-5.15c-4.1 7.28-12.43 12.89-24.41 12.89-16.07 0-28-9.55-30.17-25h66.55c.15-1.51.31-3.18.31-4.7 0-20.79-14.41-40.04-37.6-40.04zm-29.26 35c2-14.86 13.34-25.32 29.26-25.32 13 0 25.16 8.64 27.29 25.32zm118.1-35a39.72 39.72 0 1039.87 39.72A39.41 39.41 0 00559 61.89zm0 69.74a30 30 0 1129.86-30 29.58 29.58 0 01-29.88 30zm96 7.88h10.61V33.39H655zm68.78-77.62c-10.76 0-19.55 4.09-25.46 13.65V63.71h-10v75.8h10V99.79c0-20.31 11.21-28.2 24.55-28.2s20.62 7.89 20.62 21.41v46.54h10V93c.01-19-11.21-31.11-29.71-31.11zm57 21.68c0-8.19 8-12 15.91-12 7.28 0 15 2.88 18.2 10.62l8.33-4.86c-4.39-9.39-14.1-15.46-26.53-15.46-15.16 0-25.92 9.55-25.92 21.68 0 27.89 44.27 17.13 44.27 35.93 0 8.94-8.49 12.13-17.44 12.13-10.15 0-18-5-20.77-12.74l-8.48 5c3.79 9.71 14.09 17.44 29.25 17.44 16.22 0 27.44-9 27.44-21.83.01-27.88-44.25-17.11-44.25-35.91zM846 33.09a7.28 7.28 0 107.27 7.28 7.27 7.27 0 00-7.27-7.28zm-5 106.42h10v-75.8h-10zm96.42-60.94c-6.42-10.16-17.14-16.68-30.63-16.68a39.72 39.72 0 000 79.44c13.49 0 24.25-6.52 30.62-16.68v11.83c0 15.46-10.46 25.47-28 25.47-16.37 0-23.34-6.07-27.13-13.8l-8.8 5c5.92 11.83 18.5 18.5 35.93 18.5 19.56 0 38-12.13 38-35.17V63.71h-10zm-29.87 53.06a30 30 0 1129.87-30 29.58 29.58 0 01-29.88 30zm96.57-69.74c-10.76 0-19.56 4.09-25.47 13.65V33.39h-10v106.12h10V99.79c0-20.31 11.22-28.2 24.56-28.2 13.19 0 20.62 7.89 20.62 21.38v46.54h10V93c-.01-19-11.23-31.11-29.72-31.11zm67.46-19.4l-10 3v18.22h-15.92v9.7h15.92v45.94c0 18.19 11.37 23.19 31.83 20.16v-8.79c-14.7.6-21.83 1.66-21.83-11.37V73.41h21.83v-9.7h-21.83zm41.84 41.08c0-8.19 8-12 15.92-12 7.28 0 15 2.88 18.19 10.62l8.34-4.86c-4.4-9.39-14.1-15.46-26.53-15.46-15.16 0-25.92 9.55-25.92 21.68 0 27.89 44.27 17.13 44.27 35.93 0 8.94-8.5 12.13-17.44 12.13-10.16 0-18-5-20.77-12.74l-8.49 5c3.79 9.71 14.1 17.44 29.26 17.44 16.22 0 27.44-9 27.44-21.83-.01-27.88-44.28-17.11-44.28-35.91z"
    })]
  }));
};
const SmallSvg = /* @__PURE__ */ createStyled(Svg$2, {
  target: "eaqmayw0"
})({
  name: "fs1x93",
  styles: "width:24px;height:20px;"
});
const FVLogoSmall = (_Qa) => {
  var rest = __objRest(_Qa, []);
  return /* @__PURE__ */ jsx(SmallSvg, __spreadProps(__spreadValues({
    viewBox: "0 0 24 20",
    ieWidths: {
      sm: 24,
      lg: 24,
      default: 24
    }
  }, rest), {
    children: /* @__PURE__ */ jsx(LogoPath, {
      d: "M13.9929 13.3636L18.7473 0H23.3524L16.2955 19.831L13.9929 13.3636ZM3.79494 10.6749H13.0336L11.598 6.64182H2.3594L3.79494 10.6749ZM10.6742 4.03305L9.23862 0.00726679H0L1.43554 4.03305H10.6742Z",
      fill: "#00CC52"
    })
  }));
};
const Container$e = createStyled("div", {
  target: "eca8x2g0"
})({
  name: "79vkaf",
  styles: "display:flex;align-items:center;flex:1;min-width:0;"
});
const AppName = createStyled("div", {
  target: "eca8x2g1"
})("flex:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-left:0.25em;font-size:0.875em;line-height:1.25;", fontWeight("bold"), ";");
const Logo = (_Ra) => {
  var _Sa = _Ra, {
    appName,
    renderLogo = () => /* @__PURE__ */ jsx(FVLogoSmall, {})
  } = _Sa, rest = __objRest(_Sa, [
    "appName",
    "renderLogo"
  ]);
  return /* @__PURE__ */ jsxs(Container$e, __spreadProps(__spreadValues({}, rest), {
    children: [renderLogo(), appName && /* @__PURE__ */ jsx(AppName, {
      children: appName
    })]
  }));
};
var _ref$9 = {
  name: "x8h6hl",
  styles: "margin-left:0.5em;"
};
const extraMarginLeftCss = ({
  extraMarginLeft
}) => extraMarginLeft ? _ref$9 : "";
const NavItem$1 = createStyled("div", {
  target: "edpciu70"
})("display:flex;align-items:center;justify-content:center;margin-left:0.25em;", extraMarginLeftCss, ";");
const lightBlue = "#d4e7fa";
const activeCss$1 = ({
  active
}) => active ? /* @__PURE__ */ css("background-color:", lightBlue, ";svg{fill:", color("ink"), ";}") : "";
const NavItemButton = createStyled("button", {
  target: "e9zwo4s0"
})("display:flex;align-items:center;justify-content:center;user-select:none;color:currentColor;font-family:inherit;border:1px solid transparent;transition:color 0.1s ease-in-out,background-color 0.1s ease-in-out,border-color 0.1s ease-in-out,box-shadow 0.1s ease-in-out 0s;border-radius:50%;font-size:1em;width:2.5em;height:2.5em;box-sizing:border-box;background:none;padding:0;&:enabled{cursor:pointer;}&:hover,&:focus{text-decoration:none;outline:0;}&:hover,&:focus{cursor:pointer;}&:disabled{cursor:not-allowed;}&:hover{background-color:", transparentize("slate", 0.08), ";}&:active{background-color:", lightBlue, ";svg{fill:", color("ink"), ";}}", activeCss$1, ";svg{fill:", color("pewter"), ";}");
const Container$d = createStyled("div", {
  target: "esg9m1l0"
})({
  name: "b3pn3b",
  styles: "display:inline-block;position:relative;"
});
Container$d.displayName = "DropdownMenu.Container";
const ItemLink = /* @__PURE__ */ createStyled((_Ta) => {
  var _Ua = _Ta, {
    external,
    to
  } = _Ua, props = __objRest(_Ua, [
    "external",
    "to"
  ]);
  return external ? /* @__PURE__ */ jsx("a", __spreadValues({
    href: to
  }, props)) : /* @__PURE__ */ jsx(Link$1, __spreadValues({
    to
  }, props));
}, {
  target: "e1bf6n140"
})("display:block;cursor:pointer;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;", padding("xxs"), ";", typography$1("body2"), ";&:hover{background-color:", transparentize("green", 0.15), ";}");
ItemLink.displayName = "DropdownMenu.ItemLink";
const ItemAction = ItemLink.withComponent("a", {
  target: "e1ycn4dc0"
});
ItemAction.displayName = "DropdownMenu.ItemAction";
const Item$2 = (props) => /* @__PURE__ */ jsx("li", {
  children: props.to ? /* @__PURE__ */ jsx(ItemLink, __spreadValues({}, props)) : /* @__PURE__ */ jsx(ItemAction, __spreadValues({}, props))
});
Item$2.displayName = "DropdownMenu.Item";
var _ref$8 = {
  name: "19zs6va",
  styles: "right:0;"
};
var _ref2$6 = {
  name: "260zpl",
  styles: "left:0;"
};
const Menu = createStyled("ul", {
  target: "en3gjji0"
})("display:", ({
  open
}) => open ? "block" : "none", ";position:absolute;top:100%;z-index:1000;min-width:10rem;list-style:none;margin:", spacer(1), " 0;padding:", spacer(1), " 0;color:", color("black"), ";background-color:", color("white"), ";max-height:", compose(defaultTo("275px"), prop("maxHeight")), ";overflow-y:auto;line-height:", compose(defaultTo("24px"), prop("lineHeight")), ";", borderRadius$1("default"), ";", shadow$1("distant"), ";", ({
  align
}) => align === "right" ? _ref$8 : _ref2$6, ";", ({
  width
}) => width && /* @__PURE__ */ css("width:", width, ";"), ";&[data-popper-reference-hidden='true']{opacity:0;pointer-events:none;}");
Menu.displayName = "DropdownMenu.Menu";
const Section = createStyled("div", {
  target: "e17rzm3e0"
})("&:not(:last-of-type){margin-bottom:", spacer(1), ";padding-bottom:", spacer(1), ";border-bottom:1px solid ", color("paleGrey"), ";}");
Section.displayName = "DropdownMenu.Section";
function DropdownMenu({
  align,
  children,
  lineHeight: lineHeight2,
  maxHeight,
  trigger,
  width,
  popperOptions,
  open: controlledOpen,
  onToggle
}) {
  const isControlled = controlledOpen !== void 0;
  const [open, setOpen] = useState(false);
  const toggle = useCallback(() => {
    if (isControlled) {
      if (onToggle) {
        onToggle(!controlledOpen);
      }
    } else {
      setOpen(!open);
    }
  }, [isControlled, onToggle, controlledOpen, open]);
  const menuRoot = useMemo(popperOptions ? () => getRoot$1("menu") : () => {
  }, []);
  const [menuRef, setMenuRef] = useState(null);
  const [triggerRef, setTriggerRef] = useState(null);
  const {
    styles: styles2,
    attributes,
    update
  } = usePopper$1(triggerRef, menuRef, popperOptions ? popperOptions : {});
  const trueOpen = isControlled ? controlledOpen : open;
  useLayoutEffect(() => {
    update && update();
    const maybeClose = (evt) => {
      if (trueOpen && !menuRef.contains(evt.target)) {
        toggle();
      }
    };
    document.addEventListener("click", maybeClose);
    return () => document.removeEventListener("click", maybeClose);
  }, [trueOpen, menuRef]);
  const triggerEl = popperOptions ? trigger(toggle, setTriggerRef, trueOpen) : trigger(toggle, trueOpen);
  const popperProps = popperOptions ? __spreadValues({
    style: styles2.popper
  }, attributes.popper) : {};
  const menu = /* @__PURE__ */ jsx(Menu, __spreadProps(__spreadValues({
    align,
    width,
    open: trueOpen,
    maxHeight,
    lineHeight: lineHeight2,
    ref: setMenuRef
  }, popperProps), {
    children
  }));
  return /* @__PURE__ */ jsxs(Container$d, {
    children: [triggerEl, popperOptions ? createPortal(menu, menuRoot) : menu]
  });
}
DropdownMenu.Item = Item$2;
DropdownMenu.Section = Section;
DropdownMenu.propTypes = {
  align: PropTypes$2.string,
  children: PropTypes$2.node,
  maxHeight: PropTypes$2.oneOf([PropTypes$2.string, PropTypes$2.number]),
  trigger: PropTypes$2.func,
  width: PropTypes$2.oneOf([PropTypes$2.string, PropTypes$2.number]),
  popperOptions: PropTypes$2.shape({
    placement: PropTypes$2.string,
    modifiers: PropTypes$2.arrayOf(PropTypes$2.object),
    strategy: PropTypes$2.string,
    onFirstUpdate: PropTypes$2.func
  }),
  open: PropTypes$2.bool,
  onToggle: PropTypes$2.func
};
const Carets = (_Va) => {
  var _Wa = _Va, {
    title = "carets",
    viewBox: viewBox2 = "0 0 16 24",
    size: size2 = "1.5rem"
  } = _Wa, props = __objRest(_Wa, [
    "title",
    "viewBox",
    "size"
  ]);
  return /* @__PURE__ */ jsxs(SVGIconV2, __spreadProps(__spreadValues({
    viewBox: viewBox2,
    size: size2
  }, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: title
    }), /* @__PURE__ */ jsx("path", {
      d: "M7.72833 6.99652L10.315 9.58318C10.575 9.84318 11.0017 9.83652 11.2617 9.58318C11.5217 9.32318 11.5217 8.90318 11.2617 8.64318L8.20167 5.58318C7.94167 5.32318 7.52167 5.32318 7.26167 5.58318L4.20167 8.64318C3.94167 8.90318 3.94167 9.32318 4.20167 9.58318C4.46167 9.84318 4.88167 9.84318 5.14167 9.58318L7.72833 6.99652ZM7.72833 16.5565L5.14167 13.9698C4.88167 13.7098 4.455 13.7165 4.195 13.9698C3.935 14.2298 3.935 14.6498 4.195 14.9098L7.255 17.9698C7.515 18.2298 7.935 18.2298 8.195 17.9698L11.255 14.9098C11.515 14.6498 11.515 14.2298 11.255 13.9698C10.995 13.7098 10.575 13.7098 10.315 13.9698L7.72833 16.5565Z"
    })]
  }));
};
const Divider = createStyled("div", {
  target: "e1k2pysd0"
})("margin:0.25em 0;border-bottom:1px solid ", color("paleGrey"), ";");
Divider.displayName = "GlobalHeader.DropdownMenu.Divider";
const baseCss = {
  name: "3mmjyd",
  styles: "display:flex;align-items:center;justify-content:space-between;padding:0.75em 1em;font-size:0.875em;"
};
const Link = createStyled("a", {
  target: "ek6blv00"
})(baseCss, ";cursor:pointer;&:hover{background-color:", transparentize("silver", 0.3), ";text-decoration:none;}");
const StyledItem = createStyled("li", {
  target: "ek6blv01"
})(baseCss, ";");
const Item$1 = (props) => props.to ? /* @__PURE__ */ jsx("li", {
  children: /* @__PURE__ */ jsx(Link, __spreadValues({
    href: props.to
  }, props))
}) : /* @__PURE__ */ jsx(StyledItem, __spreadValues({}, props));
Item$1.displayName = "GlobalHeader.DropdownMenu.Item";
var _ref$7 = {
  name: "b6deu8",
  styles: "background:rgba(0,0,0,0.04);border:1px solid #e4e8eb;border-radius:4px;"
};
const PlaceholderButton = createStyled("button", {
  target: "e12sv0q00"
})("font-size:1em;display:flex;align-items:center;height:3.25em;padding:0.5em;border:0;box-sizing:border-box;background:", color("white"), ";min-width:8.25em;max-width:16.25em;border:1px solid transparent;cursor:pointer;outline:0;", ({
  open
}) => open ? _ref$7 : "", "");
const ChevronsContainer = createStyled("div", {
  target: "e12sv0q01"
})({
  name: "mhgpyg",
  styles: "display:flex;flex-direction:column;margin-left:0.5em;"
});
const Chevrons = () => /* @__PURE__ */ jsx(ChevronsContainer, {
  children: /* @__PURE__ */ jsx(Carets, {})
});
const ButtonLabel = createStyled("span", {
  target: "e12sv0q02"
})({
  name: "mtbf91",
  styles: "font-size:0.875em;font-weight:500;flex:1;text-align:left;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;"
});
const Image = createStyled("img", {
  target: "e12sv0q03"
})({
  name: "1l4k18e",
  styles: "width:2em;max-height:2em;margin-right:0.5em;"
});
const GlobalHeaderDropdownMenu = ({
  children,
  placeholder,
  width,
  align,
  imageSrc,
  renderTrigger,
  maxHeight,
  lineHeight: lineHeight2
}) => /* @__PURE__ */ jsx(DropdownMenu, {
  align,
  width,
  maxHeight,
  lineHeight: lineHeight2,
  trigger: (toggle, open) => renderTrigger ? renderTrigger({
    toggle,
    open
  }) : /* @__PURE__ */ jsxs(PlaceholderButton, {
    open,
    onClick: toggle,
    children: [/* @__PURE__ */ jsx(Image, {
      src: imageSrc
    }), /* @__PURE__ */ jsx(ButtonLabel, {
      children: placeholder
    }), /* @__PURE__ */ jsx(Chevrons, {})]
  }),
  children
});
GlobalHeaderDropdownMenu.Divider = Divider;
GlobalHeaderDropdownMenu.Item = Item$1;
GlobalHeaderDropdownMenu.Image = Image;
GlobalHeaderDropdownMenu.PlaceholderButton = PlaceholderButton;
GlobalHeaderDropdownMenu.ButtonLabel = ButtonLabel;
GlobalHeaderDropdownMenu.Chevrons = Chevrons;
const Avatar = createStyled("div", {
  target: "elwuy6j0"
})("display:flex;justify-content:center;align-items:center;border-radius:50%;width:2em;height:2em;background-color:", color("slate"), ";color:", color("cadet"), ";img{width:100%;pointer-events:none;}");
Avatar.displayName = "GlobalHeader.Avatar";
const GlobalHeader = createStyled("nav", {
  target: "e19u03go0"
})("display:flex;justify-content:center;align-items:center;width:100%;padding:0.375em;box-sizing:border-box;height:4.375em;color:", color("ink"), ";background-color:", color("white"), ";border-top:2px solid ", style("globalHeader.topBorderColor"), ";border-bottom:1px solid ", color("silver"), ";", ({
  baseFontSize = "16px"
}) => /* @__PURE__ */ css("font-size:", baseFontSize, ";"), ";", ({
  borderTopColor
}) => borderTopColor ? /* @__PURE__ */ css("border-top-color:", borderTopColor, ";") : "", ";", ({
  borderBottomColor
}) => borderBottomColor ? /* @__PURE__ */ css("border-bottom-color:", borderBottomColor, ";") : "", ";");
const Main$1 = createStyled("div", {
  target: "e19u03go1"
})({
  name: "1n3p764",
  styles: "flex:1;min-width:0;display:flex;align-items:center;height:2.5em;"
});
const Side = createStyled("div", {
  target: "e19u03go2"
})({
  name: "j212vf",
  styles: "display:flex;flex-direction:row;align-items:center;justify-content:center;height:2.5em;"
});
GlobalHeader.Logo = Logo;
GlobalHeader.Main = Main$1;
GlobalHeader.Side = Side;
GlobalHeader.NavItem = NavItem$1;
GlobalHeader.NavItemButton = NavItemButton;
GlobalHeader.DropdownMenu = GlobalHeaderDropdownMenu;
GlobalHeader.Avatar = Avatar;
const userNameColor = ({
  fontColor
}) => /* @__PURE__ */ css("color:", transparentize(fontColor, 0.5), ";");
const UserName = createStyled("span", {
  target: "e17wgi270"
})("margin-left:", spacer(2), ";", typography$1("body1"), ";", userNameColor, ";");
UserName.displayName = "HeaderAvatar.UserName";
const AvatarButton = /* @__PURE__ */ createStyled(Button$1, {
  target: "e1q84wsz0"
})("display:flex;justify-content:center;align-items:center;background:none;padding:0;border:none;&::after{content:'';color:", color("cadet"), ";margin-left:0.625rem;width:0;height:0;vertical-align:0.255em;border-top:0.3em solid;border-right:0.3em solid transparent;border-bottom:0;border-left:0.3em solid transparent;}&:hover{", UserName, "{color:", color("offWhite"), ";}}");
AvatarButton.displayName = "HeaderAvatar.Button";
const HeaderAvatar = ({
  align,
  children,
  firstName,
  lastName,
  email,
  hideUserName,
  avatarUrl,
  fontColor
}) => /* @__PURE__ */ jsx(DropdownMenu, {
  align,
  trigger: (toggle) => /* @__PURE__ */ jsxs(AvatarButton, {
    onClick: toggle,
    children: [/* @__PURE__ */ jsx(Avatar$1, {
      firstName,
      lastName,
      email,
      avatarUrl
    }), !hideUserName && /* @__PURE__ */ jsx(UserName, {
      fontColor,
      children: `${firstName} ${lastName}`.trim()
    })]
  }),
  children
});
HeaderAvatar.MenuItem = DropdownMenu.Item;
HeaderAvatar.MenuSection = DropdownMenu.Section;
HeaderAvatar.propTypes = {
  align: PropTypes$2.string,
  children: PropTypes$2.node,
  firstName: PropTypes$2.string,
  lastName: PropTypes$2.string,
  hideUserName: PropTypes$2.bool,
  avatarUrl: PropTypes$2.string,
  fontColor: PropTypes$2.string
};
HeaderAvatar.defaultProps = {
  align: "left",
  firstName: "",
  lastName: "",
  hideUserName: false,
  avatarUrl: "",
  fontColor: "offWhite"
};
function createCommonjsModule(fn2, module2) {
  return module2 = { exports: {} }, fn2(module2, module2.exports), module2.exports;
}
function makeEmptyFunction(arg) {
  return function() {
    return arg;
  };
}
var emptyFunction2 = function emptyFunction3() {
};
emptyFunction2.thatReturns = makeEmptyFunction;
emptyFunction2.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction2.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction2.thatReturnsNull = makeEmptyFunction(null);
emptyFunction2.thatReturnsThis = function() {
  return this;
};
emptyFunction2.thatReturnsArgument = function(arg) {
  return arg;
};
var emptyFunction_1 = emptyFunction2;
function invariant(condition, format, a, b2, c2, d2, e2, f2) {
  if (!condition) {
    var error;
    if (format === void 0) {
      error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    } else {
      var args = [a, b2, c2, d2, e2, f2];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function() {
        return args[argIndex++];
      }));
      error.name = "Invariant Violation";
    }
    error.framesToPop = 1;
    throw error;
  }
}
var invariant_1 = invariant;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key2 in from) {
      if (hasOwnProperty.call(from, key2)) {
        to[key2] = from[key2];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
var ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
var ReactPropTypesSecret_1 = ReactPropTypesSecret;
var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      return;
    }
    invariant_1(false, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };
  ReactPropTypes.checkPropTypes = emptyFunction_1;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};
var propTypes = createCommonjsModule(function(module2) {
  {
    module2.exports = factoryWithThrowingShims();
  }
});
var invariant$3 = function(condition, format, a, b2, c2, d2, e2, f2) {
  if (!condition) {
    var error;
    if (format === void 0) {
      error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    } else {
      var args = [a, b2, c2, d2, e2, f2];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function() {
        return args[argIndex++];
      }));
      error.name = "Invariant Violation";
    }
    error.framesToPop = 1;
    throw error;
  }
};
var invariant_1$2 = invariant$3;
var camel2hyphen = function(str) {
  return str.replace(/[A-Z]/g, function(match) {
    return "-" + match.toLowerCase();
  }).toLowerCase();
};
var camel2hyphen_1 = camel2hyphen;
var isDimension = function(feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};
var obj2mq = function(obj) {
  var mq = "";
  var features = Object.keys(obj);
  features.forEach(function(feature, index2) {
    var value = obj[feature];
    feature = camel2hyphen_1(feature);
    if (isDimension(feature) && typeof value === "number") {
      value = value + "px";
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += "not " + feature;
    } else {
      mq += "(" + feature + ": " + value + ")";
    }
    if (index2 < features.length - 1) {
      mq += " and ";
    }
  });
  return mq;
};
var json2mq = function(query) {
  var mq = "";
  if (typeof query === "string") {
    return query;
  }
  if (query instanceof Array) {
    query.forEach(function(q2, index2) {
      mq += obj2mq(q2);
      if (index2 < query.length - 1) {
        mq += ", ";
      }
    });
    return mq;
  }
  return obj2mq(query);
};
var json2mq_1 = json2mq;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
  return typeof obj;
} : function(obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var classCallCheck = function(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var inherits = function(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
};
var Media = function(_React$Component) {
  inherits(Media2, _React$Component);
  function Media2() {
    var _temp, _this, _ret;
    classCallCheck(this, Media2);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      matches: _this.props.defaultMatches
    }, _this.updateMatches = function() {
      return _this.setState({ matches: _this.mediaQueryList.matches });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }
  Media2.prototype.componentWillMount = function componentWillMount() {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== "object")
      return;
    var targetWindow = this.props.targetWindow || window;
    invariant_1$2(typeof targetWindow.matchMedia === "function", "<Media targetWindow> does not support `matchMedia`.");
    var query = this.props.query;
    if (typeof query !== "string")
      query = json2mq_1(query);
    this.mediaQueryList = targetWindow.matchMedia(query);
    this.mediaQueryList.addListener(this.updateMatches);
    this.updateMatches();
  };
  Media2.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mediaQueryList.removeListener(this.updateMatches);
  };
  Media2.prototype.render = function render3() {
    var _props = this.props, children = _props.children, render4 = _props.render;
    var matches = this.state.matches;
    return render4 ? matches ? render4() : null : children ? typeof children === "function" ? children(matches) : !Array.isArray(children) || children.length ? matches ? React__default.Children.only(children) : null : null : null;
  };
  return Media2;
}(React__default.Component);
Media.propTypes = {
  defaultMatches: propTypes.bool,
  query: propTypes.oneOfType([propTypes.string, propTypes.object, propTypes.arrayOf(propTypes.object.isRequired)]).isRequired,
  render: propTypes.func,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  targetWindow: propTypes.object
};
Media.defaultProps = {
  defaultMatches: true
};
const breakpointAt = (size2) => {
  browser$1(size2, `No breakpoint exists for '${size2}'`);
  return BREAKPOINTS[size2];
};
const MediaQuery = ({
  above,
  below,
  children,
  render: render3
}) => {
  const query = {};
  if (above) {
    query.minWidth = breakpointAt(above);
  }
  if (below) {
    query.maxWidth = breakpointAt(below);
  }
  return /* @__PURE__ */ jsx(Media, {
    query,
    children,
    render: render3
  });
};
MediaQuery.propTypes = {
  above: PropTypes$2.oneOf(Object.keys(BREAKPOINTS)),
  below: PropTypes$2.oneOf(Object.keys(BREAKPOINTS)),
  children: PropTypes$2.func,
  render: PropTypes$2.func
};
var _ref$6 = {
  name: "r2ff5g",
  styles: "visibility:visible;opacity:1;"
};
var _ref2$5 = {
  name: "ge94et",
  styles: "visibility:hidden;opacity:0;"
};
const animationState$3 = ({
  animationState: animationState2
}) => {
  switch (animationState2) {
    case "entering":
    case "entered":
      return _ref$6;
    case "exiting":
    case "exited":
      return _ref2$5;
  }
};
const Backdrop$1 = createStyled("div", {
  target: "e1uy2bqx0"
})("position:fixed;top:0;left:0;right:0;bottom:0;background:", transparentize("pewter", 0.6), ";transition:all 0.3s;z-index:1049;", animationState$3, ";");
Backdrop$1.displayName = "Modal.Backdrop";
const Body$1 = createStyled("div", {
  target: "e2k4l6j0"
})("padding-left:", spacer(6), ";padding-right:", spacer(6), ";flex:1;");
Body$1.displayName = "Modal.Body";
const {
  Provider,
  Consumer
} = createContext$1();
const CancelButton = ({
  children
}) => /* @__PURE__ */ jsx(Consumer, {
  children: ({
    onClose
  }) => /* @__PURE__ */ jsx(Button$1, {
    kind: "ghost",
    type: "button",
    onClick: onClose,
    children
  })
});
CancelButton.defaultProps = {
  children: "Cancel"
};
var _ref$5 = {
  name: "8l3sia",
  styles: "visiblity:visible;opacity:1;transform:scale(1);"
};
var _ref2$4 = {
  name: "19mr2x1",
  styles: "visibility:hidden;opacity:0;transform:scale(1.15);"
};
const animationState$2 = ({
  animationState: animationState2
}) => {
  switch (animationState2) {
    case "entering":
    case "entered":
      return _ref$5;
    case "exiting":
    case "exited":
      return _ref2$4;
  }
};
const Container$c = createStyled("div", {
  target: "eeb19m80"
})("position:fixed;top:0;left:0;right:0;bottom:0;z-index:1050;overflow-x:hidden;overflow-y:auto;display:flex;justify-content:center;align-items:center;transition:all 0.3s;", animationState$2, ";");
Container$c.displayName = "Modal.Container";
var _ref$4 = {
  name: "v2kfba",
  styles: "height:100%;width:100%;"
};
const size$2 = ({
  size: size2,
  theme
}) => {
  switch (size2) {
    case "fullscreen":
      return _ref$4;
    case "lg":
      return /* @__PURE__ */ css("margin-top:", spacer(5, {
        theme
      }), ";margin-bottom:", spacer(5, {
        theme
      }), ";width:720px;", borderRadius$1("default", {
        theme
      }), ";");
    default:
      return /* @__PURE__ */ css("margin-top:", spacer(5, {
        theme
      }), ";margin-bottom:", spacer(5, {
        theme
      }), ";width:480px;", borderRadius$1("default", {
        theme
      }), ";");
  }
};
var _ref2$3 = {
  name: "1uwx7m9",
  styles: "background:none;border-color:transparent;box-shadow:unset;"
};
const kind = ({
  kind: kind2
}) => kind2 === "ghost" && _ref2$3;
const Content$1 = createStyled("div", {
  target: "e1kmc53z0"
})("background:", color("white"), ";display:flex;flex-direction:column;max-width:100%;", shadow$1("raised"), ";", size$2, ";", kind, ";");
Content$1.displayName = "Modal.Content";
const Footer$2 = createStyled("footer", {
  target: "e1vcz2id0"
})("display:flex;justify-content:flex-end;", padding("md"), ";", Button$1, " + ", Button$1, "{margin-left:", spacer(2), ";}");
Footer$2.displayName = "Modal.Footer";
const Container$b = createStyled("header", {
  target: "ecx2ctm0"
})("display:flex;justify-content:space-between;align-items:center;> h3:first-of-type{flex:1;margin-bottom:0;}", padding("md"), ";");
Container$b.displayName = "Modal.Header.Container";
const Header$2 = ({
  children
}) => /* @__PURE__ */ jsx(Consumer, {
  children: ({
    dismissable,
    onClose
  }) => /* @__PURE__ */ jsxs(Container$b, {
    children: [children, dismissable && /* @__PURE__ */ jsx(CloseButton, {
      onClick: onClose
    })]
  })
});
Header$2.displayName = "Modal.Header";
const Title$1 = (props) => /* @__PURE__ */ jsx("h3", __spreadValues({}, props));
Title$1.displayName = "Modal.Title";
var Transition$1 = {};
var PropTypes$1 = {};
PropTypes$1.__esModule = true;
PropTypes$1.classNamesShape = PropTypes$1.timeoutsShape = void 0;
PropTypes$1.transitionTimeout = transitionTimeout;
var _propTypes$2 = propTypes$2.exports;
var _propTypes2$1 = _interopRequireDefault$3(_propTypes$2);
function _interopRequireDefault$3(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function transitionTimeout(transitionType) {
  var timeoutPropName = "transition" + transitionType + "Timeout";
  var enabledPropName = "transition" + transitionType;
  return function(props) {
    if (props[enabledPropName]) {
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + " wasn't supplied to CSSTransitionGroup: this can cause unreliable animations and won't be supported in a future version of React. See https://fb.me/react-animation-transition-group-timeout for more information.");
      } else if (typeof props[timeoutPropName] !== "number") {
        return new Error(timeoutPropName + " must be a number (in milliseconds)");
      }
    }
    return null;
  };
}
PropTypes$1.timeoutsShape = _propTypes2$1.default.oneOfType([_propTypes2$1.default.number, _propTypes2$1.default.shape({
  enter: _propTypes2$1.default.number,
  exit: _propTypes2$1.default.number
}).isRequired]);
PropTypes$1.classNamesShape = _propTypes2$1.default.oneOfType([_propTypes2$1.default.string, _propTypes2$1.default.shape({
  enter: _propTypes2$1.default.string,
  exit: _propTypes2$1.default.string,
  active: _propTypes2$1.default.string
}), _propTypes2$1.default.shape({
  enter: _propTypes2$1.default.string,
  enterDone: _propTypes2$1.default.string,
  enterActive: _propTypes2$1.default.string,
  exit: _propTypes2$1.default.string,
  exitDone: _propTypes2$1.default.string,
  exitActive: _propTypes2$1.default.string
})]);
Transition$1.__esModule = true;
Transition$1.EXITING = Transition$1.ENTERED = Transition$1.ENTERING = Transition$1.EXITED = Transition$1.UNMOUNTED = void 0;
var _propTypes$1 = propTypes$2.exports;
var PropTypes = _interopRequireWildcard(_propTypes$1);
var _react$2 = React__default;
var _react2$1 = _interopRequireDefault$2(_react$2);
var _reactDom = require$$2;
var _reactDom2 = _interopRequireDefault$2(_reactDom);
function _interopRequireDefault$2(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key2 in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key2))
          newObj[key2] = obj[key2];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _objectWithoutProperties$1(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn$1(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var UNMOUNTED = Transition$1.UNMOUNTED = "unmounted";
var EXITED = Transition$1.EXITED = "exited";
var ENTERING = Transition$1.ENTERING = "entering";
var ENTERED = Transition$1.ENTERED = "entered";
var EXITING = Transition$1.EXITING = "exiting";
var Transition = function(_React$Component) {
  _inherits$1(Transition2, _React$Component);
  function Transition2(props, context) {
    _classCallCheck$1(this, Transition2);
    var _this = _possibleConstructorReturn$1(this, _React$Component.call(this, props, context));
    var parentGroup = context.transitionGroup;
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus = void 0;
    _this.nextStatus = null;
    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }
    _this.state = { status: initialStatus };
    _this.nextCallback = null;
    return _this;
  }
  Transition2.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null };
  };
  Transition2.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };
  Transition2.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _ref6 = this.pendingState || this.state, status = _ref6.status;
    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };
  Transition2.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };
  Transition2.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };
  Transition2.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit = void 0, enter = void 0, appear = void 0;
    exit = enter = appear = timeout;
    if (timeout != null && typeof timeout !== "number") {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit, enter, appear };
  };
  Transition2.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var nextStatus = this.nextStatus;
    if (nextStatus !== null) {
      this.nextStatus = null;
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);
      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };
  Transition2.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;
    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function() {
        _this2.props.onEntered(node);
      });
      return;
    }
    this.props.onEnter(node, appearing);
    this.safeSetState({ status: ENTERING }, function() {
      _this2.props.onEntering(node, appearing);
      _this2.onTransitionEnd(node, timeouts.enter, function() {
        _this2.safeSetState({ status: ENTERED }, function() {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };
  Transition2.prototype.performExit = function performExit(node) {
    var _this3 = this;
    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    if (!exit) {
      this.safeSetState({ status: EXITED }, function() {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);
    this.safeSetState({ status: EXITING }, function() {
      _this3.props.onExiting(node);
      _this3.onTransitionEnd(node, timeouts.exit, function() {
        _this3.safeSetState({ status: EXITED }, function() {
          _this3.props.onExited(node);
        });
      });
    });
  };
  Transition2.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };
  Transition2.prototype.safeSetState = function safeSetState(nextState, callback) {
    var _this4 = this;
    this.pendingState = nextState;
    callback = this.setNextCallback(callback);
    this.setState(nextState, function() {
      _this4.pendingState = null;
      callback();
    });
  };
  Transition2.prototype.setNextCallback = function setNextCallback(callback) {
    var _this5 = this;
    var active = true;
    this.nextCallback = function(event) {
      if (active) {
        active = false;
        _this5.nextCallback = null;
        callback(event);
      }
    };
    this.nextCallback.cancel = function() {
      active = false;
    };
    return this.nextCallback;
  };
  Transition2.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };
  Transition2.prototype.render = function render3() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }
    var _props = this.props, children = _props.children, childProps = _objectWithoutProperties$1(_props, ["children"]);
    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;
    if (typeof children === "function") {
      return children(status, childProps);
    }
    var child = _react2$1.default.Children.only(children);
    return _react2$1.default.cloneElement(child, childProps);
  };
  return Transition2;
}(_react2$1.default.Component);
Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {
  }
};
Transition.propTypes = {};
function noop() {
}
Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;
var _default$1 = Transition$1.default = Transition;
const ESC = 27;
const blurBodyStyle$1 = {
  name: "1y5smrt",
  styles: "body > *:not(#modal-root){filter:blur(3px);}"
};
class Modal$1 extends Component {
  constructor() {
    super();
    __publicField(this, "container", document.createElement("div"));
    __publicField(this, "modalRoot", document.getElementById("modal-root"));
    __publicField(this, "freezeScrolling", () => {
      this.initialBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    });
    __publicField(this, "resetScrolling", () => {
      document.body.style.overflow = this.initialBodyOverflow;
    });
    __publicField(this, "listenForKeydown", () => {
      this.props;
    });
    __publicField(this, "handleKeydown", (e2) => {
      const {
        dismissable,
        open,
        onClose
      } = this.props;
      if (!dismissable || !open) {
        return;
      }
      switch (e2.keyCode) {
        case ESC:
          onClose();
      }
    });
  }
  componentDidMount() {
    this.modalRoot.appendChild(this.container);
    document.addEventListener("keydown", this.handleKeydown);
    if (this.props.open) {
      this.freezeScrolling();
    }
  }
  componentDidUpdate({
    open: prevOpen
  }) {
    const {
      open
    } = this.props;
    if (!prevOpen && open) {
      this.freezeScrolling();
    }
    if (prevOpen && !open) {
      this.resetScrolling();
    }
  }
  componentWillUnmount() {
    this.modalRoot.removeChild(this.container);
    this.resetScrolling();
    document.removeEventListener("keydown", this.handleKeydown);
  }
  render() {
    const {
      dismissable,
      children,
      onClose,
      open,
      size: size2,
      kind: kind2,
      blurBackground
    } = this.props;
    return createPortal(/* @__PURE__ */ jsx(Provider, {
      value: {
        dismissable,
        onClose
      },
      children: /* @__PURE__ */ jsx(_default$1, {
        in: open,
        timeout: 300,
        children: (state) => /* @__PURE__ */ jsxs(Fragment$2, {
          children: [open && blurBackground && /* @__PURE__ */ jsx(Global, {
            styles: blurBodyStyle$1
          }), /* @__PURE__ */ jsx(Backdrop$1, {
            animationState: state
          }), /* @__PURE__ */ jsx(Container$c, {
            animationState: state,
            onClick: dismissable ? onClose : null,
            children: /* @__PURE__ */ jsx(Content$1, {
              onClick: (e2) => e2.stopPropagation(),
              size: size2,
              kind: kind2,
              children
            })
          })]
        })
      })
    }), this.container);
  }
}
__publicField(Modal$1, "Body", Body$1);
__publicField(Modal$1, "CancelButton", CancelButton);
__publicField(Modal$1, "Footer", Footer$2);
__publicField(Modal$1, "Header", Header$2);
__publicField(Modal$1, "Title", Title$1);
__publicField(Modal$1, "propTypes", {
  dismissable: PropTypes$2.bool.isRequired,
  onClose: PropTypes$2.func.isRequired,
  open: PropTypes$2.bool.isRequired,
  size: PropTypes$2.oneOf(["lg", "fullscreen"])
});
__publicField(Modal$1, "defaultProps", {
  dismissable: true
});
var _ref$3 = {
  name: "r2ff5g",
  styles: "visibility:visible;opacity:1;"
};
var _ref2$2 = {
  name: "ge94et",
  styles: "visibility:hidden;opacity:0;"
};
const animationState$1 = ({
  animationState: animationState2
}) => {
  switch (animationState2) {
    case "entering":
    case "entered":
      return _ref$3;
    case "exiting":
    case "exited":
      return _ref2$2;
  }
};
const Backdrop = createStyled("div", {
  target: "e1l9lze30"
})("position:fixed;top:0;left:0;right:0;bottom:0;background:", transparentize("pewter", 0.6), ";transition:all 0.3s;z-index:1049;", animationState$1, ";");
Backdrop.displayName = "Modal.Backdrop";
var _ref$2 = {
  name: "8l3sia",
  styles: "visiblity:visible;opacity:1;transform:scale(1);"
};
var _ref2$1 = {
  name: "19mr2x1",
  styles: "visibility:hidden;opacity:0;transform:scale(1.15);"
};
const animationState = ({
  animationState: animationState2
}) => {
  switch (animationState2) {
    case "entering":
    case "entered":
      return _ref$2;
    case "exiting":
    case "exited":
      return _ref2$1;
  }
};
const Container$a = createStyled("div", {
  target: "enuadwn0"
})("position:fixed;top:0;left:0;right:0;bottom:0;z-index:1050;overflow-x:hidden;overflow-y:auto;display:flex;justify-content:center;align-items:center;transition:all 0.3s;", animationState, ";");
Container$a.displayName = "Modal.Container";
const blurBodyStyle = {
  name: "1y5smrt",
  styles: "body > *:not(#modal-root){filter:blur(3px);}"
};
class Modal extends Component {
  constructor() {
    super();
    __publicField(this, "state", {
      open: false,
      transitioning: false
    });
    __publicField(this, "show", () => this.setState({
      open: true
    }));
    __publicField(this, "hide", () => this.setState({
      open: false
    }));
    __publicField(this, "setTransitioning", (transitioning) => this.setState({
      transitioning
    }));
    __publicField(this, "container", document.createElement("div"));
    __publicField(this, "modalRoot", document.getElementById("modal-root"));
    __publicField(this, "freezeScrolling", () => {
      this.initialBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    });
    __publicField(this, "resetScrolling", () => {
      document.body.style.overflow = this.initialBodyOverflow;
    });
    __publicField(this, "handleKeydown", (e2) => {
      const {
        dismissable
      } = this.props;
      const {
        open
      } = this.state;
      if (!dismissable || !open) {
        return;
      }
      switch (e2.keyCode) {
        case ESC:
          this.hide();
          this.props.onDismiss && this.props.onDismiss();
      }
    });
  }
  componentDidMount() {
    this.modalRoot.appendChild(this.container);
    document.addEventListener("keydown", this.handleKeydown);
    if (this.props.open) {
      this.freezeScrolling();
    }
  }
  componentDidUpdate(_prevProps, {
    open: prevOpen
  }) {
    const {
      open
    } = this.state;
    if (!prevOpen && open) {
      this.freezeScrolling();
    }
    if (prevOpen && !open) {
      this.resetScrolling();
    }
  }
  componentWillUnmount() {
    this.modalRoot.removeChild(this.container);
    this.resetScrolling();
    document.removeEventListener("keydown", this.handleKeydown);
  }
  renderPortal() {
    const {
      dismissable,
      render: render3,
      lazyRender,
      blurBackground
    } = this.props;
    const {
      open,
      transitioning
    } = this.state;
    const shouldRender = !lazyRender || open || transitioning;
    return createPortal(/* @__PURE__ */ jsx(_default$1, {
      in: open,
      timeout: 300,
      onEnter: () => this.setTransitioning(true),
      onExited: () => this.setTransitioning(false),
      children: (state) => /* @__PURE__ */ jsxs(Fragment$2, {
        children: [open && blurBackground && /* @__PURE__ */ jsx(Global, {
          styles: blurBodyStyle
        }), /* @__PURE__ */ jsx(Backdrop, {
          animationState: state
        }), /* @__PURE__ */ jsx(Container$a, {
          animationState: state,
          onClick: dismissable ? () => {
            this.hide();
            this.props.onDismiss && this.props.onDismiss();
          } : null,
          children: shouldRender && render3({
            hide: this.hide
          })
        })]
      })
    }), this.container);
  }
  render() {
    const {
      children
    } = this.props;
    const {
      open
    } = this.state;
    return /* @__PURE__ */ jsxs(Fragment$2, {
      children: [this.renderPortal(), children({
        show: this.show,
        open
      })]
    });
  }
}
__publicField(Modal, "propTypes", {
  dismissable: PropTypes$2.bool.isRequired,
  onDismiss: PropTypes$2.func
});
__publicField(Modal, "defaultProps", {
  dismissable: true,
  onDismiss: noop$1
});
const Container$9 = createStyled("div", {
  target: "eamnbua0"
})("position:fixed;z-index:1200;display:flex;flex-direction:column-reverse;flex-flow:column-reverse;top:", spacer(4), ";right:", spacer(5), ";");
Container$9.displayName = "Notifications.Container";
const Close = /* @__PURE__ */ createStyled(CloseButton, {
  target: "e1hnkbds0"
})("margin-left:", spacer(2), ";margin-right:", spacer(2), ";");
Close.displayName = "Notification.CloseButton";
const Container$8 = createStyled("div", {
  target: "e464qrf0"
})("color:", color("black"), ";background:", color("white"), ";width:375px;display:flex;align-items:center;overflow:hidden;", borderRadius$1("default"), ";", shadow$1("raised"), ";", typography$1("body2"), ";");
Container$8.displayName = "Notification.Container";
const ICON_SIZE = "1.75rem";
const PADDING_SIZE = "xs";
const IconContainer = createStyled("div", {
  target: "eice3zl0"
})(padding(PADDING_SIZE), ";padding-right:0;svg{vertical-align:middle;}");
IconContainer.displayName = "Notification.IconContainer";
const Icon = ({
  kind: kind2,
  renderIcon
}) => {
  const props = {
    width: ICON_SIZE,
    height: ICON_SIZE
  };
  const theme = useTheme();
  const iconColor = style(`notifications.${kind2}IconColor`, {
    theme
  });
  if (typeof renderIcon === "function") {
    return /* @__PURE__ */ jsx(IconContainer, {
      children: renderIcon(props)
    });
  }
  switch (kind2) {
    case "success":
      return /* @__PURE__ */ jsx(IconContainer, {
        children: /* @__PURE__ */ jsx(CheckCircle, __spreadProps(__spreadValues({}, props), {
          color: iconColor
        }))
      });
    case "warning":
      return /* @__PURE__ */ jsx(IconContainer, {
        children: /* @__PURE__ */ jsx(AlertTriangle, __spreadProps(__spreadValues({}, props), {
          color: iconColor
        }))
      });
    case "info":
      return /* @__PURE__ */ jsx(IconContainer, {
        children: /* @__PURE__ */ jsx(Info, __spreadProps(__spreadValues({}, props), {
          color: iconColor
        }))
      });
    case "danger":
      return /* @__PURE__ */ jsx(IconContainer, {
        children: /* @__PURE__ */ jsx(AlertCircle, __spreadProps(__spreadValues({}, props), {
          color: iconColor
        }))
      });
    default:
      return null;
  }
};
Icon.displayName = "Notification.Icon";
const Message = createStyled("div", {
  target: "e16vh4rn0"
})("flex:1;", padding("xs"), ";");
Message.displayName = "Notification.Message";
const NOTIFY = "NOTIFY";
const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
let id$1 = 1;
const generateId$1 = () => String(id$1++);
const notify = (type, message, options = {}) => ({
  type: NOTIFY,
  payload: __spreadValues({
    type,
    message,
    sticky: false,
    timeout: 3e3,
    dismissable: true,
    id: generateId$1(),
    onClick: () => {
    },
    onClose: () => {
    }
  }, options)
});
const removeNotification = (id) => ({
  type: REMOVE_NOTIFICATION,
  payload: {
    id
  }
});
const reducer$1 = (state = [], action) => {
  switch (action.type) {
    case NOTIFY:
      return [...state, action.payload];
    case REMOVE_NOTIFICATION:
      return state.filter((notification) => notification.id !== action.payload.id);
    default:
      return state;
  }
};
const NotificationsContext = createContext$1({
  notifications: [],
  dispatch: () => {
  },
  notify: noop$1,
  removeNotification: noop$1
});
const NotificationsProvider = ({
  children
}) => {
  const [notifications, dispatch2] = useReducer(reducer$1, []);
  const notifyCallback = useCallback((...args) => {
    const action = notify(...args);
    dispatch2(action);
    return action.payload.id;
  }, []);
  const removeNotificationCallback = useCallback((id) => dispatch2(removeNotification(id)), []);
  return /* @__PURE__ */ jsx(NotificationsContext.Provider, {
    value: {
      notify: notifyCallback,
      removeNotification: removeNotificationCallback,
      notifications
    },
    children
  });
};
const withNotifier = (Component2) => (props) => {
  const value = useContext(NotificationsContext);
  return /* @__PURE__ */ jsx(Component2, __spreadValues(__spreadValues({}, props), value));
};
const Notification = ({
  notification,
  removeNotification: removeNotification2,
  style: style2
}) => {
  const [timer, setTimer] = useState(null);
  useEffect(() => {
    if (!notification.sticky) {
      scheduleHide();
    }
    return () => {
      cancelHide();
      notification.onClose(notification);
    };
  }, []);
  const scheduleHide = () => {
    setTimer(setTimeout(remove, notification.timeout));
  };
  const cancelHide = () => {
    clearTimeout(timer);
  };
  const handleOnClick = () => {
    notification.onClick(notification);
  };
  const handleDismiss = (e2) => {
    e2.stopPropagation();
    remove();
  };
  const remove = () => {
    removeNotification2(notification.id);
  };
  return /* @__PURE__ */ jsxs(Container$8, {
    onMouseOver: cancelHide,
    onMouseOut: notification.sticky ? null : scheduleHide,
    onClick: handleOnClick,
    style: {
      minHeight: style2.minHeight,
      marginBottom: `${style2.spacing}rem`,
      opacity: style2.opacity,
      transform: `translate3d(${style2.translate}%, 0, 0) scaleY(${style2.scaleY})`
    },
    children: [/* @__PURE__ */ jsx(Icon, {
      kind: notification.type,
      renderIcon: notification.renderIcon
    }), /* @__PURE__ */ jsx(Message, {
      children: notification.message
    }), notification.dismissable && /* @__PURE__ */ jsx(Close, {
      onClick: handleDismiss
    })]
  });
};
var Notification$1 = withNotifier(Notification);
var Motion = { exports: {} };
var mapToZero = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = mapToZero2;
  function mapToZero2(obj) {
    var ret = {};
    for (var key2 in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key2)) {
        ret[key2] = 0;
      }
    }
    return ret;
  }
  module2.exports = exports["default"];
})(mapToZero, mapToZero.exports);
var stripStyle = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = stripStyle2;
  function stripStyle2(style2) {
    var ret = {};
    for (var key2 in style2) {
      if (!Object.prototype.hasOwnProperty.call(style2, key2)) {
        continue;
      }
      ret[key2] = typeof style2[key2] === "number" ? style2[key2] : style2[key2].val;
    }
    return ret;
  }
  module2.exports = exports["default"];
})(stripStyle, stripStyle.exports);
var stepper = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = stepper2;
  var reusedTuple = [0, 0];
  function stepper2(secondPerFrame, x, v2, destX, k2, b2, precision) {
    var Fspring = -k2 * (x - destX);
    var Fdamper = -b2 * v2;
    var a = Fspring + Fdamper;
    var newV = v2 + a * secondPerFrame;
    var newX = x + newV * secondPerFrame;
    if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
      reusedTuple[0] = destX;
      reusedTuple[1] = 0;
      return reusedTuple;
    }
    reusedTuple[0] = newX;
    reusedTuple[1] = newV;
    return reusedTuple;
  }
  module2.exports = exports["default"];
})(stepper, stepper.exports);
var performanceNow$1 = { exports: {} };
(function() {
  var getNanoSeconds, hrtime, loadTime;
  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    performanceNow$1.exports = function() {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    performanceNow$1.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    performanceNow$1.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    performanceNow$1.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(commonjsGlobal);
var raf$1 = { exports: {} };
var performanceNow = { exports: {} };
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    performanceNow.exports = function() {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    performanceNow.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    performanceNow.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    performanceNow.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(commonjsGlobal);
var now = performanceNow.exports, root = typeof window === "undefined" ? commonjsGlobal : window, vendors = ["moz", "webkit"], suffix = "AnimationFrame", raf = root["request" + suffix], caf = root["cancel" + suffix] || root["cancelRequest" + suffix];
for (var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + "Request" + suffix];
  caf = root[vendors[i] + "Cancel" + suffix] || root[vendors[i] + "CancelRequest" + suffix];
}
if (!raf || !caf) {
  var last = 0, id = 0, queue = [], frameDuration = 1e3 / 60;
  raf = function(callback) {
    if (queue.length === 0) {
      var _now = now(), next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function() {
        var cp = queue.slice(0);
        queue.length = 0;
        for (var i = 0; i < cp.length; i++) {
          if (!cp[i].cancelled) {
            try {
              cp[i].callback(last);
            } catch (e2) {
              setTimeout(function() {
                throw e2;
              }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback,
      cancelled: false
    });
    return id;
  };
  caf = function(handle) {
    for (var i = 0; i < queue.length; i++) {
      if (queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}
raf$1.exports = function(fn2) {
  return raf.call(root, fn2);
};
raf$1.exports.cancel = function() {
  caf.apply(root, arguments);
};
raf$1.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
var shouldStopAnimation = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = shouldStopAnimation2;
  function shouldStopAnimation2(currentStyle, style2, currentVelocity) {
    for (var key2 in style2) {
      if (!Object.prototype.hasOwnProperty.call(style2, key2)) {
        continue;
      }
      if (currentVelocity[key2] !== 0) {
        return false;
      }
      var styleValue = typeof style2[key2] === "number" ? style2[key2] : style2[key2].val;
      if (currentStyle[key2] !== styleValue) {
        return false;
      }
    }
    return true;
  }
  module2.exports = exports["default"];
})(shouldStopAnimation, shouldStopAnimation.exports);
(function(module2, exports) {
  exports.__esModule = true;
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _createClass2 = function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps)
        defineProperties(Constructor.prototype, protoProps);
      if (staticProps)
        defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var _mapToZero = mapToZero.exports;
  var _mapToZero2 = _interopRequireDefault2(_mapToZero);
  var _stripStyle2 = stripStyle.exports;
  var _stripStyle22 = _interopRequireDefault2(_stripStyle2);
  var _stepper3 = stepper.exports;
  var _stepper4 = _interopRequireDefault2(_stepper3);
  var _performanceNow = performanceNow$1.exports;
  var _performanceNow2 = _interopRequireDefault2(_performanceNow);
  var _raf = raf$1.exports;
  var _raf2 = _interopRequireDefault2(_raf);
  var _shouldStopAnimation = shouldStopAnimation.exports;
  var _shouldStopAnimation2 = _interopRequireDefault2(_shouldStopAnimation);
  var _react3 = React__default;
  var _react22 = _interopRequireDefault2(_react3);
  var _propTypes3 = propTypes$2.exports;
  var _propTypes22 = _interopRequireDefault2(_propTypes3);
  var msPerFrame = 1e3 / 60;
  var Motion2 = function(_React$Component) {
    _inherits2(Motion3, _React$Component);
    _createClass2(Motion3, null, [{
      key: "propTypes",
      value: {
        defaultStyle: _propTypes22["default"].objectOf(_propTypes22["default"].number),
        style: _propTypes22["default"].objectOf(_propTypes22["default"].oneOfType([_propTypes22["default"].number, _propTypes22["default"].object])).isRequired,
        children: _propTypes22["default"].func.isRequired,
        onRest: _propTypes22["default"].func
      },
      enumerable: true
    }]);
    function Motion3(props) {
      var _this = this;
      _classCallCheck2(this, Motion3);
      _React$Component.call(this, props);
      this.wasAnimating = false;
      this.animationID = null;
      this.prevTime = 0;
      this.accumulatedTime = 0;
      this.unreadPropStyle = null;
      this.clearUnreadPropStyle = function(destStyle) {
        var dirty = false;
        var _state = _this.state;
        var currentStyle = _state.currentStyle;
        var currentVelocity = _state.currentVelocity;
        var lastIdealStyle = _state.lastIdealStyle;
        var lastIdealVelocity = _state.lastIdealVelocity;
        for (var key2 in destStyle) {
          if (!Object.prototype.hasOwnProperty.call(destStyle, key2)) {
            continue;
          }
          var styleValue = destStyle[key2];
          if (typeof styleValue === "number") {
            if (!dirty) {
              dirty = true;
              currentStyle = _extends2({}, currentStyle);
              currentVelocity = _extends2({}, currentVelocity);
              lastIdealStyle = _extends2({}, lastIdealStyle);
              lastIdealVelocity = _extends2({}, lastIdealVelocity);
            }
            currentStyle[key2] = styleValue;
            currentVelocity[key2] = 0;
            lastIdealStyle[key2] = styleValue;
            lastIdealVelocity[key2] = 0;
          }
        }
        if (dirty) {
          _this.setState({ currentStyle, currentVelocity, lastIdealStyle, lastIdealVelocity });
        }
      };
      this.startAnimationIfNecessary = function() {
        _this.animationID = _raf2["default"](function(timestamp) {
          var propsStyle = _this.props.style;
          if (_shouldStopAnimation2["default"](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
            if (_this.wasAnimating && _this.props.onRest) {
              _this.props.onRest();
            }
            _this.animationID = null;
            _this.wasAnimating = false;
            _this.accumulatedTime = 0;
            return;
          }
          _this.wasAnimating = true;
          var currentTime = timestamp || _performanceNow2["default"]();
          var timeDelta = currentTime - _this.prevTime;
          _this.prevTime = currentTime;
          _this.accumulatedTime = _this.accumulatedTime + timeDelta;
          if (_this.accumulatedTime > msPerFrame * 10) {
            _this.accumulatedTime = 0;
          }
          if (_this.accumulatedTime === 0) {
            _this.animationID = null;
            _this.startAnimationIfNecessary();
            return;
          }
          var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
          var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          for (var key2 in propsStyle) {
            if (!Object.prototype.hasOwnProperty.call(propsStyle, key2)) {
              continue;
            }
            var styleValue = propsStyle[key2];
            if (typeof styleValue === "number") {
              newCurrentStyle[key2] = styleValue;
              newCurrentVelocity[key2] = 0;
              newLastIdealStyle[key2] = styleValue;
              newLastIdealVelocity[key2] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyle[key2];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key2];
              for (var i = 0; i < framesToCatchUp; i++) {
                var _stepper = _stepper4["default"](msPerFrame / 1e3, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }
              var _stepper2 = _stepper4["default"](msPerFrame / 1e3, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];
              newCurrentStyle[key2] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key2] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key2] = newLastIdealStyleValue;
              newLastIdealVelocity[key2] = newLastIdealVelocityValue;
            }
          }
          _this.animationID = null;
          _this.accumulatedTime -= framesToCatchUp * msPerFrame;
          _this.setState({
            currentStyle: newCurrentStyle,
            currentVelocity: newCurrentVelocity,
            lastIdealStyle: newLastIdealStyle,
            lastIdealVelocity: newLastIdealVelocity
          });
          _this.unreadPropStyle = null;
          _this.startAnimationIfNecessary();
        });
      };
      this.state = this.defaultState();
    }
    Motion3.prototype.defaultState = function defaultState() {
      var _props = this.props;
      var defaultStyle2 = _props.defaultStyle;
      var style2 = _props.style;
      var currentStyle = defaultStyle2 || _stripStyle22["default"](style2);
      var currentVelocity = _mapToZero2["default"](currentStyle);
      return {
        currentStyle,
        currentVelocity,
        lastIdealStyle: currentStyle,
        lastIdealVelocity: currentVelocity
      };
    };
    Motion3.prototype.componentDidMount = function componentDidMount() {
      this.prevTime = _performanceNow2["default"]();
      this.startAnimationIfNecessary();
    };
    Motion3.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
      if (this.unreadPropStyle != null) {
        this.clearUnreadPropStyle(this.unreadPropStyle);
      }
      this.unreadPropStyle = props.style;
      if (this.animationID == null) {
        this.prevTime = _performanceNow2["default"]();
        this.startAnimationIfNecessary();
      }
    };
    Motion3.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.animationID != null) {
        _raf2["default"].cancel(this.animationID);
        this.animationID = null;
      }
    };
    Motion3.prototype.render = function render3() {
      var renderedChildren = this.props.children(this.state.currentStyle);
      return renderedChildren && _react22["default"].Children.only(renderedChildren);
    };
    return Motion3;
  }(_react22["default"].Component);
  exports["default"] = Motion2;
  module2.exports = exports["default"];
})(Motion, Motion.exports);
var StaggeredMotion = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _createClass2 = function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps)
        defineProperties(Constructor.prototype, protoProps);
      if (staticProps)
        defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var _mapToZero = mapToZero.exports;
  var _mapToZero2 = _interopRequireDefault2(_mapToZero);
  var _stripStyle2 = stripStyle.exports;
  var _stripStyle22 = _interopRequireDefault2(_stripStyle2);
  var _stepper3 = stepper.exports;
  var _stepper4 = _interopRequireDefault2(_stepper3);
  var _performanceNow = performanceNow$1.exports;
  var _performanceNow2 = _interopRequireDefault2(_performanceNow);
  var _raf = raf$1.exports;
  var _raf2 = _interopRequireDefault2(_raf);
  var _shouldStopAnimation = shouldStopAnimation.exports;
  var _shouldStopAnimation2 = _interopRequireDefault2(_shouldStopAnimation);
  var _react3 = React__default;
  var _react22 = _interopRequireDefault2(_react3);
  var _propTypes3 = propTypes$2.exports;
  var _propTypes22 = _interopRequireDefault2(_propTypes3);
  var msPerFrame = 1e3 / 60;
  function shouldStopAnimationAll(currentStyles, styles2, currentVelocities) {
    for (var i = 0; i < currentStyles.length; i++) {
      if (!_shouldStopAnimation2["default"](currentStyles[i], styles2[i], currentVelocities[i])) {
        return false;
      }
    }
    return true;
  }
  var StaggeredMotion2 = function(_React$Component) {
    _inherits2(StaggeredMotion3, _React$Component);
    _createClass2(StaggeredMotion3, null, [{
      key: "propTypes",
      value: {
        defaultStyles: _propTypes22["default"].arrayOf(_propTypes22["default"].objectOf(_propTypes22["default"].number)),
        styles: _propTypes22["default"].func.isRequired,
        children: _propTypes22["default"].func.isRequired
      },
      enumerable: true
    }]);
    function StaggeredMotion3(props) {
      var _this = this;
      _classCallCheck2(this, StaggeredMotion3);
      _React$Component.call(this, props);
      this.animationID = null;
      this.prevTime = 0;
      this.accumulatedTime = 0;
      this.unreadPropStyles = null;
      this.clearUnreadPropStyle = function(unreadPropStyles) {
        var _state = _this.state;
        var currentStyles = _state.currentStyles;
        var currentVelocities = _state.currentVelocities;
        var lastIdealStyles = _state.lastIdealStyles;
        var lastIdealVelocities = _state.lastIdealVelocities;
        var someDirty = false;
        for (var i = 0; i < unreadPropStyles.length; i++) {
          var unreadPropStyle = unreadPropStyles[i];
          var dirty = false;
          for (var key2 in unreadPropStyle) {
            if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key2)) {
              continue;
            }
            var styleValue = unreadPropStyle[key2];
            if (typeof styleValue === "number") {
              if (!dirty) {
                dirty = true;
                someDirty = true;
                currentStyles[i] = _extends2({}, currentStyles[i]);
                currentVelocities[i] = _extends2({}, currentVelocities[i]);
                lastIdealStyles[i] = _extends2({}, lastIdealStyles[i]);
                lastIdealVelocities[i] = _extends2({}, lastIdealVelocities[i]);
              }
              currentStyles[i][key2] = styleValue;
              currentVelocities[i][key2] = 0;
              lastIdealStyles[i][key2] = styleValue;
              lastIdealVelocities[i][key2] = 0;
            }
          }
        }
        if (someDirty) {
          _this.setState({ currentStyles, currentVelocities, lastIdealStyles, lastIdealVelocities });
        }
      };
      this.startAnimationIfNecessary = function() {
        _this.animationID = _raf2["default"](function(timestamp) {
          var destStyles = _this.props.styles(_this.state.lastIdealStyles);
          if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
            _this.animationID = null;
            _this.accumulatedTime = 0;
            return;
          }
          var currentTime = timestamp || _performanceNow2["default"]();
          var timeDelta = currentTime - _this.prevTime;
          _this.prevTime = currentTime;
          _this.accumulatedTime = _this.accumulatedTime + timeDelta;
          if (_this.accumulatedTime > msPerFrame * 10) {
            _this.accumulatedTime = 0;
          }
          if (_this.accumulatedTime === 0) {
            _this.animationID = null;
            _this.startAnimationIfNecessary();
            return;
          }
          var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
          var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
          var newLastIdealStyles = [];
          var newLastIdealVelocities = [];
          var newCurrentStyles = [];
          var newCurrentVelocities = [];
          for (var i = 0; i < destStyles.length; i++) {
            var destStyle = destStyles[i];
            var newCurrentStyle = {};
            var newCurrentVelocity = {};
            var newLastIdealStyle = {};
            var newLastIdealVelocity = {};
            for (var key2 in destStyle) {
              if (!Object.prototype.hasOwnProperty.call(destStyle, key2)) {
                continue;
              }
              var styleValue = destStyle[key2];
              if (typeof styleValue === "number") {
                newCurrentStyle[key2] = styleValue;
                newCurrentVelocity[key2] = 0;
                newLastIdealStyle[key2] = styleValue;
                newLastIdealVelocity[key2] = 0;
              } else {
                var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key2];
                var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key2];
                for (var j = 0; j < framesToCatchUp; j++) {
                  var _stepper = _stepper4["default"](msPerFrame / 1e3, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                  newLastIdealStyleValue = _stepper[0];
                  newLastIdealVelocityValue = _stepper[1];
                }
                var _stepper2 = _stepper4["default"](msPerFrame / 1e3, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                var nextIdealX = _stepper2[0];
                var nextIdealV = _stepper2[1];
                newCurrentStyle[key2] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                newCurrentVelocity[key2] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                newLastIdealStyle[key2] = newLastIdealStyleValue;
                newLastIdealVelocity[key2] = newLastIdealVelocityValue;
              }
            }
            newCurrentStyles[i] = newCurrentStyle;
            newCurrentVelocities[i] = newCurrentVelocity;
            newLastIdealStyles[i] = newLastIdealStyle;
            newLastIdealVelocities[i] = newLastIdealVelocity;
          }
          _this.animationID = null;
          _this.accumulatedTime -= framesToCatchUp * msPerFrame;
          _this.setState({
            currentStyles: newCurrentStyles,
            currentVelocities: newCurrentVelocities,
            lastIdealStyles: newLastIdealStyles,
            lastIdealVelocities: newLastIdealVelocities
          });
          _this.unreadPropStyles = null;
          _this.startAnimationIfNecessary();
        });
      };
      this.state = this.defaultState();
    }
    StaggeredMotion3.prototype.defaultState = function defaultState() {
      var _props = this.props;
      var defaultStyles = _props.defaultStyles;
      var styles2 = _props.styles;
      var currentStyles = defaultStyles || styles2().map(_stripStyle22["default"]);
      var currentVelocities = currentStyles.map(function(currentStyle) {
        return _mapToZero2["default"](currentStyle);
      });
      return {
        currentStyles,
        currentVelocities,
        lastIdealStyles: currentStyles,
        lastIdealVelocities: currentVelocities
      };
    };
    StaggeredMotion3.prototype.componentDidMount = function componentDidMount() {
      this.prevTime = _performanceNow2["default"]();
      this.startAnimationIfNecessary();
    };
    StaggeredMotion3.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
      if (this.unreadPropStyles != null) {
        this.clearUnreadPropStyle(this.unreadPropStyles);
      }
      this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
      if (this.animationID == null) {
        this.prevTime = _performanceNow2["default"]();
        this.startAnimationIfNecessary();
      }
    };
    StaggeredMotion3.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.animationID != null) {
        _raf2["default"].cancel(this.animationID);
        this.animationID = null;
      }
    };
    StaggeredMotion3.prototype.render = function render3() {
      var renderedChildren = this.props.children(this.state.currentStyles);
      return renderedChildren && _react22["default"].Children.only(renderedChildren);
    };
    return StaggeredMotion3;
  }(_react22["default"].Component);
  exports["default"] = StaggeredMotion2;
  module2.exports = exports["default"];
})(StaggeredMotion, StaggeredMotion.exports);
var TransitionMotion$1 = { exports: {} };
var mergeDiff = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = mergeDiff2;
  function mergeDiff2(prev, next, onRemove) {
    var prevKeyIndex = {};
    for (var i = 0; i < prev.length; i++) {
      prevKeyIndex[prev[i].key] = i;
    }
    var nextKeyIndex = {};
    for (var i = 0; i < next.length; i++) {
      nextKeyIndex[next[i].key] = i;
    }
    var ret = [];
    for (var i = 0; i < next.length; i++) {
      ret[i] = next[i];
    }
    for (var i = 0; i < prev.length; i++) {
      if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
        var fill = onRemove(i, prev[i]);
        if (fill != null) {
          ret.push(fill);
        }
      }
    }
    return ret.sort(function(a, b2) {
      var nextOrderA = nextKeyIndex[a.key];
      var nextOrderB = nextKeyIndex[b2.key];
      var prevOrderA = prevKeyIndex[a.key];
      var prevOrderB = prevKeyIndex[b2.key];
      if (nextOrderA != null && nextOrderB != null) {
        return nextKeyIndex[a.key] - nextKeyIndex[b2.key];
      } else if (prevOrderA != null && prevOrderB != null) {
        return prevKeyIndex[a.key] - prevKeyIndex[b2.key];
      } else if (nextOrderA != null) {
        for (var i2 = 0; i2 < next.length; i2++) {
          var pivot = next[i2].key;
          if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
            continue;
          }
          if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
            return -1;
          } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
            return 1;
          }
        }
        return 1;
      }
      for (var i2 = 0; i2 < next.length; i2++) {
        var pivot = next[i2].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }
        if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
          return 1;
        } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
          return -1;
        }
      }
      return -1;
    });
  }
  module2.exports = exports["default"];
})(mergeDiff, mergeDiff.exports);
(function(module2, exports) {
  exports.__esModule = true;
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _createClass2 = function() {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor)
          descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }
    return function(Constructor, protoProps, staticProps) {
      if (protoProps)
        defineProperties(Constructor.prototype, protoProps);
      if (staticProps)
        defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var _mapToZero = mapToZero.exports;
  var _mapToZero2 = _interopRequireDefault2(_mapToZero);
  var _stripStyle2 = stripStyle.exports;
  var _stripStyle22 = _interopRequireDefault2(_stripStyle2);
  var _stepper3 = stepper.exports;
  var _stepper4 = _interopRequireDefault2(_stepper3);
  var _mergeDiff = mergeDiff.exports;
  var _mergeDiff2 = _interopRequireDefault2(_mergeDiff);
  var _performanceNow = performanceNow$1.exports;
  var _performanceNow2 = _interopRequireDefault2(_performanceNow);
  var _raf = raf$1.exports;
  var _raf2 = _interopRequireDefault2(_raf);
  var _shouldStopAnimation = shouldStopAnimation.exports;
  var _shouldStopAnimation2 = _interopRequireDefault2(_shouldStopAnimation);
  var _react3 = React__default;
  var _react22 = _interopRequireDefault2(_react3);
  var _propTypes3 = propTypes$2.exports;
  var _propTypes22 = _interopRequireDefault2(_propTypes3);
  var msPerFrame = 1e3 / 60;
  function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
    var cUnreadPropStyles = unreadPropStyles;
    if (cUnreadPropStyles == null) {
      return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        return {
          key: mergedPropsStyle.key,
          data: mergedPropsStyle.data,
          style: plainStyles[i]
        };
      });
    }
    return mergedPropsStyles.map(function(mergedPropsStyle, i) {
      for (var j = 0; j < cUnreadPropStyles.length; j++) {
        if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
          return {
            key: cUnreadPropStyles[j].key,
            data: cUnreadPropStyles[j].data,
            style: plainStyles[i]
          };
        }
      }
      return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
    });
  }
  function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
    if (mergedPropsStyles.length !== destStyles.length) {
      return false;
    }
    for (var i = 0; i < mergedPropsStyles.length; i++) {
      if (mergedPropsStyles[i].key !== destStyles[i].key) {
        return false;
      }
    }
    for (var i = 0; i < mergedPropsStyles.length; i++) {
      if (!_shouldStopAnimation2["default"](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
        return false;
      }
    }
    return true;
  }
  function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
    var newMergedPropsStyles = _mergeDiff2["default"](oldMergedPropsStyles, destStyles, function(oldIndex, oldMergedPropsStyle) {
      var leavingStyle = willLeave(oldMergedPropsStyle);
      if (leavingStyle == null) {
        didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
        return null;
      }
      if (_shouldStopAnimation2["default"](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
        didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
        return null;
      }
      return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
    });
    var newCurrentStyles = [];
    var newCurrentVelocities = [];
    var newLastIdealStyles = [];
    var newLastIdealVelocities = [];
    for (var i = 0; i < newMergedPropsStyles.length; i++) {
      var newMergedPropsStyleCell = newMergedPropsStyles[i];
      var foundOldIndex = null;
      for (var j = 0; j < oldMergedPropsStyles.length; j++) {
        if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
          foundOldIndex = j;
          break;
        }
      }
      if (foundOldIndex == null) {
        var plainStyle = willEnter(newMergedPropsStyleCell);
        newCurrentStyles[i] = plainStyle;
        newLastIdealStyles[i] = plainStyle;
        var velocity = _mapToZero2["default"](newMergedPropsStyleCell.style);
        newCurrentVelocities[i] = velocity;
        newLastIdealVelocities[i] = velocity;
      } else {
        newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
        newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
        newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
        newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
      }
    }
    return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
  }
  var TransitionMotion2 = function(_React$Component) {
    _inherits2(TransitionMotion3, _React$Component);
    _createClass2(TransitionMotion3, null, [{
      key: "propTypes",
      value: {
        defaultStyles: _propTypes22["default"].arrayOf(_propTypes22["default"].shape({
          key: _propTypes22["default"].string.isRequired,
          data: _propTypes22["default"].any,
          style: _propTypes22["default"].objectOf(_propTypes22["default"].number).isRequired
        })),
        styles: _propTypes22["default"].oneOfType([_propTypes22["default"].func, _propTypes22["default"].arrayOf(_propTypes22["default"].shape({
          key: _propTypes22["default"].string.isRequired,
          data: _propTypes22["default"].any,
          style: _propTypes22["default"].objectOf(_propTypes22["default"].oneOfType([_propTypes22["default"].number, _propTypes22["default"].object])).isRequired
        }))]).isRequired,
        children: _propTypes22["default"].func.isRequired,
        willEnter: _propTypes22["default"].func,
        willLeave: _propTypes22["default"].func,
        didLeave: _propTypes22["default"].func
      },
      enumerable: true
    }, {
      key: "defaultProps",
      value: {
        willEnter: function willEnter(styleThatEntered) {
          return _stripStyle22["default"](styleThatEntered.style);
        },
        willLeave: function willLeave() {
          return null;
        },
        didLeave: function didLeave() {
        }
      },
      enumerable: true
    }]);
    function TransitionMotion3(props) {
      var _this = this;
      _classCallCheck2(this, TransitionMotion3);
      _React$Component.call(this, props);
      this.unmounting = false;
      this.animationID = null;
      this.prevTime = 0;
      this.accumulatedTime = 0;
      this.unreadPropStyles = null;
      this.clearUnreadPropStyle = function(unreadPropStyles) {
        var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
        var mergedPropsStyles = _mergeAndSync[0];
        var currentStyles = _mergeAndSync[1];
        var currentVelocities = _mergeAndSync[2];
        var lastIdealStyles = _mergeAndSync[3];
        var lastIdealVelocities = _mergeAndSync[4];
        for (var i = 0; i < unreadPropStyles.length; i++) {
          var unreadPropStyle = unreadPropStyles[i].style;
          var dirty = false;
          for (var key2 in unreadPropStyle) {
            if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key2)) {
              continue;
            }
            var styleValue = unreadPropStyle[key2];
            if (typeof styleValue === "number") {
              if (!dirty) {
                dirty = true;
                currentStyles[i] = _extends2({}, currentStyles[i]);
                currentVelocities[i] = _extends2({}, currentVelocities[i]);
                lastIdealStyles[i] = _extends2({}, lastIdealStyles[i]);
                lastIdealVelocities[i] = _extends2({}, lastIdealVelocities[i]);
                mergedPropsStyles[i] = {
                  key: mergedPropsStyles[i].key,
                  data: mergedPropsStyles[i].data,
                  style: _extends2({}, mergedPropsStyles[i].style)
                };
              }
              currentStyles[i][key2] = styleValue;
              currentVelocities[i][key2] = 0;
              lastIdealStyles[i][key2] = styleValue;
              lastIdealVelocities[i][key2] = 0;
              mergedPropsStyles[i].style[key2] = styleValue;
            }
          }
        }
        _this.setState({
          currentStyles,
          currentVelocities,
          mergedPropsStyles,
          lastIdealStyles,
          lastIdealVelocities
        });
      };
      this.startAnimationIfNecessary = function() {
        if (_this.unmounting) {
          return;
        }
        _this.animationID = _raf2["default"](function(timestamp) {
          if (_this.unmounting) {
            return;
          }
          var propStyles = _this.props.styles;
          var destStyles = typeof propStyles === "function" ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
          if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
            _this.animationID = null;
            _this.accumulatedTime = 0;
            return;
          }
          var currentTime = timestamp || _performanceNow2["default"]();
          var timeDelta = currentTime - _this.prevTime;
          _this.prevTime = currentTime;
          _this.accumulatedTime = _this.accumulatedTime + timeDelta;
          if (_this.accumulatedTime > msPerFrame * 10) {
            _this.accumulatedTime = 0;
          }
          if (_this.accumulatedTime === 0) {
            _this.animationID = null;
            _this.startAnimationIfNecessary();
            return;
          }
          var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
          var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
          var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
          var newMergedPropsStyles = _mergeAndSync2[0];
          var newCurrentStyles = _mergeAndSync2[1];
          var newCurrentVelocities = _mergeAndSync2[2];
          var newLastIdealStyles = _mergeAndSync2[3];
          var newLastIdealVelocities = _mergeAndSync2[4];
          for (var i = 0; i < newMergedPropsStyles.length; i++) {
            var newMergedPropsStyle = newMergedPropsStyles[i].style;
            var newCurrentStyle = {};
            var newCurrentVelocity = {};
            var newLastIdealStyle = {};
            var newLastIdealVelocity = {};
            for (var key2 in newMergedPropsStyle) {
              if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key2)) {
                continue;
              }
              var styleValue = newMergedPropsStyle[key2];
              if (typeof styleValue === "number") {
                newCurrentStyle[key2] = styleValue;
                newCurrentVelocity[key2] = 0;
                newLastIdealStyle[key2] = styleValue;
                newLastIdealVelocity[key2] = 0;
              } else {
                var newLastIdealStyleValue = newLastIdealStyles[i][key2];
                var newLastIdealVelocityValue = newLastIdealVelocities[i][key2];
                for (var j = 0; j < framesToCatchUp; j++) {
                  var _stepper = _stepper4["default"](msPerFrame / 1e3, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                  newLastIdealStyleValue = _stepper[0];
                  newLastIdealVelocityValue = _stepper[1];
                }
                var _stepper2 = _stepper4["default"](msPerFrame / 1e3, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                var nextIdealX = _stepper2[0];
                var nextIdealV = _stepper2[1];
                newCurrentStyle[key2] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                newCurrentVelocity[key2] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                newLastIdealStyle[key2] = newLastIdealStyleValue;
                newLastIdealVelocity[key2] = newLastIdealVelocityValue;
              }
            }
            newLastIdealStyles[i] = newLastIdealStyle;
            newLastIdealVelocities[i] = newLastIdealVelocity;
            newCurrentStyles[i] = newCurrentStyle;
            newCurrentVelocities[i] = newCurrentVelocity;
          }
          _this.animationID = null;
          _this.accumulatedTime -= framesToCatchUp * msPerFrame;
          _this.setState({
            currentStyles: newCurrentStyles,
            currentVelocities: newCurrentVelocities,
            lastIdealStyles: newLastIdealStyles,
            lastIdealVelocities: newLastIdealVelocities,
            mergedPropsStyles: newMergedPropsStyles
          });
          _this.unreadPropStyles = null;
          _this.startAnimationIfNecessary();
        });
      };
      this.state = this.defaultState();
    }
    TransitionMotion3.prototype.defaultState = function defaultState() {
      var _props = this.props;
      var defaultStyles = _props.defaultStyles;
      var styles2 = _props.styles;
      var willEnter = _props.willEnter;
      var willLeave = _props.willLeave;
      var didLeave = _props.didLeave;
      var destStyles = typeof styles2 === "function" ? styles2(defaultStyles) : styles2;
      var oldMergedPropsStyles = void 0;
      if (defaultStyles == null) {
        oldMergedPropsStyles = destStyles;
      } else {
        oldMergedPropsStyles = defaultStyles.map(function(defaultStyleCell) {
          for (var i = 0; i < destStyles.length; i++) {
            if (destStyles[i].key === defaultStyleCell.key) {
              return destStyles[i];
            }
          }
          return defaultStyleCell;
        });
      }
      var oldCurrentStyles = defaultStyles == null ? destStyles.map(function(s) {
        return _stripStyle22["default"](s.style);
      }) : defaultStyles.map(function(s) {
        return _stripStyle22["default"](s.style);
      });
      var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function(s) {
        return _mapToZero2["default"](s.style);
      }) : defaultStyles.map(function(s) {
        return _mapToZero2["default"](s.style);
      });
      var _mergeAndSync3 = mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, oldCurrentVelocities);
      var mergedPropsStyles = _mergeAndSync3[0];
      var currentStyles = _mergeAndSync3[1];
      var currentVelocities = _mergeAndSync3[2];
      var lastIdealStyles = _mergeAndSync3[3];
      var lastIdealVelocities = _mergeAndSync3[4];
      return {
        currentStyles,
        currentVelocities,
        lastIdealStyles,
        lastIdealVelocities,
        mergedPropsStyles
      };
    };
    TransitionMotion3.prototype.componentDidMount = function componentDidMount() {
      this.prevTime = _performanceNow2["default"]();
      this.startAnimationIfNecessary();
    };
    TransitionMotion3.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
      if (this.unreadPropStyles) {
        this.clearUnreadPropStyle(this.unreadPropStyles);
      }
      var styles2 = props.styles;
      if (typeof styles2 === "function") {
        this.unreadPropStyles = styles2(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
      } else {
        this.unreadPropStyles = styles2;
      }
      if (this.animationID == null) {
        this.prevTime = _performanceNow2["default"]();
        this.startAnimationIfNecessary();
      }
    };
    TransitionMotion3.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unmounting = true;
      if (this.animationID != null) {
        _raf2["default"].cancel(this.animationID);
        this.animationID = null;
      }
    };
    TransitionMotion3.prototype.render = function render3() {
      var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
      var renderedChildren = this.props.children(hydratedStyles);
      return renderedChildren && _react22["default"].Children.only(renderedChildren);
    };
    return TransitionMotion3;
  }(_react22["default"].Component);
  exports["default"] = TransitionMotion2;
  module2.exports = exports["default"];
})(TransitionMotion$1, TransitionMotion$1.exports);
var spring$1 = { exports: {} };
var presets = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = {
    noWobble: { stiffness: 170, damping: 26 },
    gentle: { stiffness: 120, damping: 14 },
    wobbly: { stiffness: 180, damping: 12 },
    stiff: { stiffness: 210, damping: 20 }
  };
  module2.exports = exports["default"];
})(presets, presets.exports);
(function(module2, exports) {
  exports.__esModule = true;
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  exports["default"] = spring2;
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  var _presets2 = presets.exports;
  var _presets22 = _interopRequireDefault2(_presets2);
  var defaultConfig = _extends2({}, _presets22["default"].noWobble, {
    precision: 0.01
  });
  function spring2(val, config) {
    return _extends2({}, defaultConfig, config, { val });
  }
  module2.exports = exports["default"];
})(spring$1, spring$1.exports);
var reorderKeys = { exports: {} };
(function(module2, exports) {
  exports.__esModule = true;
  exports["default"] = reorderKeys2;
  function reorderKeys2() {
  }
  module2.exports = exports["default"];
})(reorderKeys, reorderKeys.exports);
function _interopRequire(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}
var _Motion = Motion.exports;
_interopRequire(_Motion);
var _StaggeredMotion = StaggeredMotion.exports;
_interopRequire(_StaggeredMotion);
var _TransitionMotion = TransitionMotion$1.exports;
var TransitionMotion = _interopRequire(_TransitionMotion);
var _spring = spring$1.exports;
var spring = _interopRequire(_spring);
var _presets = presets.exports;
_interopRequire(_presets);
var _stripStyle = stripStyle.exports;
_interopRequire(_stripStyle);
var _reorderKeys = reorderKeys.exports;
_interopRequire(_reorderKeys);
const springConfig = {
  stiffness: 120,
  damping: 15
};
const Notifications = () => {
  const {
    notifications
  } = useContext(NotificationsContext);
  return /* @__PURE__ */ jsx(TransitionMotion, {
    styles: notifications.map((notification) => ({
      key: notification.id,
      data: notification,
      style: {
        spacing: spring(1, springConfig),
        minHeight: spring(56, springConfig),
        scaleY: spring(1, springConfig),
        translate: spring(0, springConfig),
        opacity: spring(1)
      }
    })),
    willEnter: () => ({
      spacing: 0,
      minHeight: 0,
      scaleY: 0,
      opacity: 0,
      translate: 100
    }),
    willLeave: () => ({
      spacing: spring(0, springConfig),
      minHeight: spring(0),
      scaleY: spring(0),
      opacity: spring(0),
      translate: spring(100, springConfig)
    }),
    children: (styles2) => /* @__PURE__ */ jsx(Container$9, {
      children: styles2.map(({
        key: key2,
        data,
        style: style2
      }) => /* @__PURE__ */ jsx(Notification$1, {
        notification: data,
        style: style2
      }, key2))
    })
  });
};
const visibility = ({
  open
}) => /* @__PURE__ */ css("visibility:", open ? "visible" : "hidden", ";");
const Container$7 = createStyled("div", {
  target: "efmjqc70"
})("display:flex;justify-content:center;align-items:center;max-width:100%;z-index:1020;", visibility, ";");
Container$7.displayName = "Popover.Container";
const Wrapper$1 = createStyled("div", {
  target: "e1pyxqpy0"
})({
  name: "79elbk",
  styles: "position:relative;"
});
Wrapper$1.displayName = "Popover.Wrapper";
class Popover extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "state", {
      open: false
    });
    __publicField(this, "popoverRoot", document.getElementById("popover-root"));
    __publicField(this, "show", () => this.setState({
      open: true
    }));
    __publicField(this, "hide", () => this.setState({
      open: false
    }));
    __publicField(this, "toggle", () => this.setState({
      open: !this.state.open
    }));
  }
  render() {
    const {
      placement,
      wrapperClassName,
      children
    } = this.props;
    const {
      open
    } = this.state;
    const popover = /* @__PURE__ */ jsx(Popper, {
      placement,
      children: ({
        ref,
        placement: placement2,
        style: style2
      }) => /* @__PURE__ */ jsx(Container$7, {
        ref,
        style: style2,
        "data-placement": placement2,
        open,
        children: this.props.render({
          hide: this.hide
        })
      })
    });
    const reference2 = /* @__PURE__ */ jsx(Reference, {
      children: ({
        ref
      }) => children({
        ref,
        hide: this.hide,
        show: this.show,
        toggle: this.toggle
      })
    });
    return /* @__PURE__ */ jsx(Manager, {
      children: /* @__PURE__ */ jsxs(Fragment$2, {
        children: [reference2, createPortal(popover, this.popoverRoot)]
      })
    });
  }
}
__publicField(Popover, "defaultProps", {
  placement: "top",
  render: noop$1
});
const RadioButtonHidden = withProps$1({
  type: "radio"
})(createStyled("input", {
  target: "erw3h5h0"
})({
  name: "sxypit",
  styles: "position:absolute;opacity:0;z-index:-1;"
}));
const radioButtonBackgroundStyle = ({
  disabled,
  dark: dark2
}) => {
  if (disabled) {
    return dark2 ? "disabledDarkBackground" : "disabledBackground";
  }
  return dark2 ? "darkBackground" : "background";
};
const radioButtonBorderStyle = ({
  checked,
  disabled,
  valid: valid2,
  dark: dark2
}) => {
  if (disabled) {
    return dark2 ? "disabledDarkColor" : "disabledColor";
  } else if (!valid2) {
    return "invalidBorder";
  }
  return checked ? "checkedColor" : "border";
};
const hoverBorderStyle = ({
  disabled,
  valid: valid2,
  dark: dark2
}) => {
  if (disabled) {
    return dark2 ? "disabledDarkColor" : "disabledColor";
  } else if (!valid2) {
    return "invalidBorder";
  } else {
    return "hoverBorder";
  }
};
const findStyle = (props, fn2 = (key2) => key2) => {
  const styleKey = fn2(props);
  if (styleKey) {
    return style(`radio.${styleKey}`)({
      theme: props.theme
    });
  }
  return "transparent";
};
const RadioButtonDisplay = createStyled("div", {
  target: "ek0vkco0"
})("background-color:", (props) => findStyle(props, radioButtonBackgroundStyle), ";border:solid 0.0675rem ", (props) => findStyle(props, radioButtonBorderStyle), ";border-radius:50%;height:", spacer(4), ";width:", spacer(4), ";display:inline-block;margin-right:", spacer(3), ";margin-left:-1px;vertical-align:middle;&:hover{border-color:", (props) => findStyle(props, hoverBorderStyle), ";}");
const Label = createStyled("label", {
  target: "et7z2oq0"
})("display:grid;grid-auto-flow:column;grid-template-columns:auto 1fr;align-items:center;justify-items:start;cursor:", ({
  disabled
}) => disabled ? "not-allowed" : "pointer", ";");
const LabelText = createStyled("span", {
  target: "et7z2oq1"
})("margin-bottom:0;color:", ({
  disabled,
  dark: dark2
}) => disabled ? dark2 ? color("slate") : transparentize("slate", 0.5) : dark2 ? color("silver") : color("slate"), ";vertical-align:middle;");
const RadioButtonContainer = createStyled("div", {
  target: "et7z2oq2"
})({
  name: "79elbk",
  styles: "position:relative;"
});
const fillStyle = (disabled, dark2) => !disabled ? "checkedColor" : dark2 ? "disabledDarkColor" : "disabledColor";
const RadioButton = (_Xa) => {
  var _Ya = _Xa, {
    checked,
    label,
    disabled,
    valid: valid2,
    id,
    theme,
    dark: dark2
  } = _Ya, rest = __objRest(_Ya, [
    "checked",
    "label",
    "disabled",
    "valid",
    "id",
    "theme",
    "dark"
  ]);
  return /* @__PURE__ */ jsxs(RadioButtonContainer, {
    children: [/* @__PURE__ */ jsx(RadioButtonHidden, __spreadValues({
      checked,
      disabled,
      id
    }, rest)), /* @__PURE__ */ jsxs(Label, {
      disabled,
      htmlFor: id,
      children: [/* @__PURE__ */ jsx(RadioButtonDisplay, {
        checked,
        disabled,
        valid: valid2,
        dark: dark2,
        children: /* @__PURE__ */ jsx("svg", {
          viewBox: "-10 -10 20 20",
          children: /* @__PURE__ */ jsx("g", {
            fill: "none",
            children: checked && /* @__PURE__ */ jsx("circle", {
              r: "6",
              fill: style(`radio.${fillStyle(disabled, dark2)}`)({
                theme
              })
            })
          })
        })
      }), /* @__PURE__ */ jsx(LabelText, {
        dark: dark2,
        disabled,
        children: label
      })]
    })]
  });
};
RadioButton.propTypes = {
  checked: PropTypes$2.bool,
  disabled: PropTypes$2.bool,
  label: PropTypes$2.node,
  valid: PropTypes$2.bool,
  id: PropTypes$2.string.isRequired,
  onChange: PropTypes$2.func
};
RadioButton.defaultProps = {
  onChange: () => {
  },
  checked: false,
  disabled: false,
  valid: true
};
var index = withTheme(RadioButton);
const Row$2 = createStyled("section", {
  target: "e1vvijyc0"
})("width:100%;display:flex;flex-direction:column;align-items:center;@supports (display:grid){display:grid;justify-items:center;justify-content:unset;align-items:unset;grid-auto-flow:row;grid-gap:", spacer(4), ";}");
const deletable = ({
  deletable: deletable2,
  theme
}) => deletable2 && /* @__PURE__ */ css("padding-right:", spacer(2, {
  theme
}), ";");
const selectable = ({
  selectable: selectable2,
  selected,
  theme
}) => selectable2 ? /* @__PURE__ */ css("cursor:pointer;color:", color(selected ? "white" : "slate", {
  theme
}), ";background-color:", color(selected ? "slate" : "paleGrey", {
  theme
}), ";&:hover{background-color:", !selected && style("tag.selectable.hoverBackground", {
  theme
}), ";}") : /* @__PURE__ */ css("color:", color("slate", {
  theme
}), ";background-color:", color("paleGrey", {
  theme
}), ";");
const Container$6 = createStyled("span", {
  target: "etsmacj0"
})("display:inline-block;border-radius:2rem;padding:", spacer(1), " ", spacer(3), ";transition:margin-right 0.3s ease 0s;", typography$1("body1Medium"), ";", selectable, ";", deletable, ";&.stylist-tag:not(:last-of-type){margin-right:", spacer(2), ";}");
const InnerContainer = createStyled("div", {
  target: "etsmacj1"
})("display:flex;flex-direction:justify-content;align-items:center;button{margin-left:", spacer(1), ";}");
const Tag = ({
  children,
  deletable: deletable2,
  id,
  selectable: selectable2,
  selected,
  onDelete,
  onSelect
}) => /* @__PURE__ */ jsx(Container$6, {
  className: "stylist-tag",
  deletable: deletable2,
  selectable: selectable2,
  selected,
  onClick: selectable2 ? () => onSelect(id) : null,
  children: /* @__PURE__ */ jsxs(InnerContainer, {
    children: [children, deletable2 && /* @__PURE__ */ jsx(CloseButton, {
      size: "1rem",
      onClick: () => onDelete(id)
    })]
  })
});
var brand$1 = {
  brandGreen: "#00cc52",
  lightBrandGreen: "#5ae070",
  lighterBrandGreen: "#82eb7f",
  brandMain: "#FF00FF",
  ink: "#00253B",
  slate: "#3e5467",
  pewter: "#627585",
  cadet: "#8394a3",
  silver: "#cbd2d6",
  paleGrey: "#e4e8eb",
  offWhite: "#F7F9FA",
  white: "#fff",
  black: "#2e3033",
  green: "#39a84c",
  lightGreen: "#CEF5D4",
  red: "#f5496c",
  lightRed: "#FFDBE2",
  darkRed: "#F21945",
  orange: "#e07a04",
  lightOrange: "#FFEAD1",
  blue: "#428fdb",
  lightBlue: "#D4E7FA",
  royalBlue: "#62a1f3",
  darkPurple: "#5641cc",
  purple: "#725ee0",
  ocean: "#1B73B3",
  forest: "#1A825F",
  darkOcean: "#07558c",
  greenGradient: {
    start: "#00c753",
    end: "#00d4e8"
  },
  blueGradient: {
    start: "#00d4e8",
    end: "#786ce9"
  },
  purpleGradient: {
    start: "#a379ff",
    end: "#786ce9"
  },
  bluePinkGradient: {
    start: "#3023ae",
    end: "#c86dd7"
  }
};
var borderRadius = {
  sm: "2px",
  default: "4px",
  lg: "6px"
};
const base = "16px";
var font = {
  base,
  lineHeight: {
    xxxl: rem$1("64px", base),
    xxl: rem$1("48px", base),
    xl: rem$1("36px", base),
    l: rem$1("30px", base),
    m: rem$1("24px", base),
    s: rem$1("22px", base),
    xs: rem$1("20px", base),
    xxs: rem$1("17px", base),
    xxxs: rem$1("15px", base)
  },
  size: {
    xxxl: rem$1("48px", base),
    xxl: rem$1("36px", base),
    xl: rem$1("28px", base),
    l: rem$1("22px", base),
    m: rem$1("18px", base),
    s: rem$1("16px", base),
    xs: rem$1("14px", base),
    xxs: rem$1("12px", base),
    xxxs: rem$1("11px", base)
  },
  weight: {
    regular: 400,
    medium: 500,
    bold: 700,
    black: 900
  }
};
var shadow = {
  subtle: "0 1px 3px 0 rgba(22, 38, 59, 0.08)",
  close: "0 2px 6px 0 rgba(22, 38, 59, 0.14)",
  raised: "0 3px 8px 0 rgba(22, 38, 59, 0.2)",
  distant: "0 4px 12px 0 rgba(22, 38, 59, 0.28)"
};
const size$1 = {
  spacer1: rem$1("4px", font.base),
  spacer2: rem$1("8px", font.base),
  spacer3: rem$1("14px", font.base),
  spacer4: rem$1("20px", font.base),
  spacer5: rem$1("28px", font.base),
  spacer6: rem$1("36px", font.base),
  spacer7: rem$1("48px", font.base),
  spacer8: rem$1("60px", font.base)
};
var spacing = {
  size: size$1,
  xxxs: {
    x: size$1.spacer2,
    y: size$1.spacer1
  },
  xxs: {
    x: size$1.spacer3,
    y: size$1.spacer2
  },
  xs: {
    x: size$1.spacer4,
    y: size$1.spacer3
  },
  sm: {
    x: size$1.spacer5,
    y: size$1.spacer4
  },
  md: {
    x: size$1.spacer6,
    y: size$1.spacer5
  },
  lg: {
    x: size$1.spacer7,
    y: size$1.spacer6
  },
  xl: {
    x: size$1.spacer8,
    y: size$1.spacer7
  }
};
const {
  lineHeight,
  size,
  weight
} = font;
var typography = {
  headline3: {
    lineHeight: lineHeight.xxxl,
    fontSize: size.xxxl,
    fontWeight: weight.regular
  },
  headline2: {
    lineHeight: lineHeight.xxl,
    fontSize: size.xxl,
    fontWeight: weight.regular
  },
  headline1: {
    lineHeight: lineHeight.xl,
    fontSize: size.xl,
    fontWeight: weight.medium
  },
  title3: {
    lineHeight: lineHeight.l,
    fontSize: size.l,
    fontWeight: weight.medium
  },
  title2: {
    lineHeight: lineHeight.m,
    fontSize: size.m,
    fontWeight: weight.bold
  },
  title1: {
    lineHeight: lineHeight.s,
    fontSize: size.s,
    fontWeight: weight.bold
  },
  subheading3: {
    lineHeight: lineHeight.xs,
    fontSize: size.xs,
    fontWeight: weight.black,
    textTransform: "uppercase",
    letterSpacing: "0.8px"
  },
  subheading2: {
    lineHeight: lineHeight.xxs,
    fontSize: size.xxs,
    fontWeight: weight.black,
    textTransform: "uppercase",
    letterSpacing: "0.8px"
  },
  subheading1: {
    lineHeight: lineHeight.xxxs,
    fontSize: size.xxxs,
    fontWeight: weight.black,
    textTransform: "uppercase",
    letterSpacing: "0.8px"
  },
  body4: {
    lineHeight: lineHeight.m,
    fontSize: size.m,
    fontWeight: weight.regular
  },
  body4Medium: {
    lineHeight: lineHeight.m,
    fontSize: size.m,
    fontWeight: weight.medium
  },
  body3: {
    lineHeight: lineHeight.s,
    fontSize: size.s,
    fontWeight: weight.regular
  },
  body3Medium: {
    lineHeight: lineHeight.s,
    fontSize: size.s,
    fontWeight: weight.medium
  },
  body2: {
    lineHeight: lineHeight.xs,
    fontSize: size.xs,
    fontWeight: weight.regular
  },
  body2Medium: {
    lineHeight: lineHeight.xs,
    fontSize: size.xs,
    fontWeight: weight.medium
  },
  body1: {
    lineHeight: lineHeight.xxs,
    fontSize: size.xxs,
    fontWeight: weight.regular
  },
  body1Medium: {
    lineHeight: lineHeight.xxs,
    fontSize: size.xxs,
    fontWeight: weight.medium
  },
  numeral6: {
    lineHeight: lineHeight.xxxl,
    fontSize: size.xxxl,
    fontWeight: weight.regular
  },
  numeral5: {
    lineHeight: lineHeight.xxl,
    fontSize: size.xxl,
    fontWeight: weight.regular
  },
  numeral4: {
    lineHeight: lineHeight.xl,
    fontSize: size.xl,
    fontWeight: weight.regular
  },
  numeral3: {
    lineHeight: lineHeight.l,
    fontSize: size.l,
    fontWeight: weight.medium
  },
  numeral2: {
    lineHeight: lineHeight.m,
    fontSize: size.m,
    fontWeight: weight.medium
  },
  numeral1: {
    lineHeight: lineHeight.s,
    fontSize: size.s,
    fontWeight: weight.medium
  }
};
var fvStyles = {
  cookieBanner: {
    background: brand$1.slate
  },
  globalHeader: {
    topBorderColor: brand$1.brandGreen
  },
  logoPath: {
    fill: brand$1.brandMain
  },
  dropdown: {
    checkIconColor: brand$1.brandGreen
  },
  input: {
    valid: {
      border: brand$1.paleGrey,
      focusBorder: brand$1.brandGreen
    },
    invalid: {
      border: brand$1.red,
      focusBorder: brand$1.red
    }
  },
  tabs: {
    navLink: {
      underlineColor: brand$1.brandGreen,
      hoverUnderlineColor: "transparent"
    }
  },
  tag: {
    selectable: {
      hoverBackground: rgba(brand$1.brandGreen, 0.25)
    }
  },
  table: {
    row: {
      hoverBackground: rgba(brand$1.brandGreen, 0.15)
    }
  },
  uploader: {
    hoverBorder: brand$1.brandGreen,
    hoverBackground: rgba(brand$1.lightGreen, 0.5)
  },
  checkbox: {
    border: brand$1.cadet,
    invalidBorder: brand$1.red,
    disabledBorder: brand$1.silver,
    disabledBackground: brand$1.offWhite,
    checkedBackground: brand$1.brandGreen,
    checkedDisabledBackground: brand$1.silver
  },
  radio: {
    checkedColor: brand$1.brandGreen,
    disabledColor: brand$1.silver,
    disabledDarkColor: brand$1.pewter,
    border: brand$1.cadet,
    hoverBorder: brand$1.brandGreen,
    invalidBorder: brand$1.red,
    background: brand$1.white,
    darkBackground: "transparent",
    disabledBackground: brand$1.offWhite,
    disabledDarkBackground: "transparent"
  },
  listbox: {
    hoverBackground: rgba(brand$1.brandGreen, 0.15),
    focusedBackground: rgba(brand$1.brandGreen, 0.15),
    selectedBackground: rgba(brand$1.brandGreen, 0.15),
    disabledColor: rgba(brand$1.slate, 0.4)
  },
  notifications: {
    successIconColor: brand$1.brandGreen,
    warningIconColor: brand$1.orange,
    infoIconColor: brand$1.blue,
    dangerIconColor: brand$1.red
  },
  button: {
    primary: {
      color: brand$1.ink,
      background: brand$1.lightBrandGreen,
      border: brand$1.lightBrandGreen,
      hoverBackground: brand$1.lighterBrandGreen,
      hoverBorder: brand$1.lighterBrandGreen,
      disabledColor: brand$1.white,
      disabledBackground: brand$1.silver,
      disabledBorder: brand$1.silver
    },
    standardDark: {
      color: brand$1.white,
      background: brand$1.ink,
      border: rgba(brand$1.offWhite, 0.5),
      hoverColor: brand$1.ink,
      hoverBackground: brand$1.white,
      hoverBorder: brand$1.white,
      disabledColor: rgba(brand$1.offWhite, 0.3),
      disabledBackground: rgba(brand$1.offWhite, 0.2),
      disabledBorder: "transparent"
    },
    standard: {
      color: brand$1.slate,
      background: brand$1.white,
      border: rgba(brand$1.slate, 0.5),
      hoverColor: brand$1.white,
      hoverBackground: brand$1.slate,
      hoverBorder: brand$1.slate,
      disabledColor: rgba(brand$1.slate, 0.3),
      disabledBackground: rgba(brand$1.slate, 0.1),
      disabledBorder: "transparent"
    },
    utilityDark: {
      color: brand$1.offWhite,
      background: rgba(brand$1.offWhite, 0.2),
      border: "transparent",
      hoverBackground: rgba(brand$1.offWhite, 0.3),
      disabledColor: rgba(brand$1.offWhite, 0.3),
      disabledBackground: rgba(brand$1.offWhite, 0.2)
    },
    utility: {
      color: brand$1.slate,
      background: rgba(brand$1.slate, 0.08),
      border: "transparent",
      hoverBackground: rgba(brand$1.slate, 0.16),
      disabledColor: rgba(brand$1.slate, 0.3),
      disabledBackground: rgba(brand$1.slate, 0.1)
    },
    ghostDark: {
      color: brand$1.offWhite,
      background: "none",
      border: "transparent",
      hoverBackground: rgba(brand$1.offWhite, 0.16),
      disabledColor: rgba(brand$1.offWhite, 0.3),
      disabledBackground: "none"
    },
    ghost: {
      color: brand$1.slate,
      background: "none",
      border: "transparent",
      hoverBackground: rgba(brand$1.slate, 0.08),
      disabledColor: rgba(brand$1.slate, 0.3),
      disabledBackground: "inherit"
    },
    danger: {
      color: brand$1.offWhite,
      background: brand$1.red,
      border: brand$1.red,
      hoverBackground: brand$1.darkRed,
      hoverBorder: brand$1.darkRed,
      disabledColor: brand$1.white,
      disabledBackground: brand$1.silver,
      disabledBorder: brand$1.silver
    }
  }
};
var fvStyle = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  brand: brand$1,
  borderRadius,
  font,
  shadow,
  spacing,
  typography,
  styles: fvStyles
}, Symbol.toStringTag, { value: "Module" }));
var brand = {
  brandMagenta: "#FF00FF",
  brandBlue: "#007DB8",
  darkBrandBlue: "#006CA1",
  darkerBrandBlue: "#005B87",
  ink: "#00253B",
  slate: "#3e5467",
  pewter: "#627585",
  cadet: "#8394a3",
  darkGrey: "#b8babd",
  silver: "#cbd2d6",
  grey: "#e2e3e4",
  paleGrey: "#e4e8eb",
  offWhite: "#F7F9FA",
  white: "#fff",
  black: "#2e3033",
  green: "#39a84c",
  lightGreen: "#CEF5D4",
  red: "#f5496c",
  lightRed: "#FFDBE2",
  darkRed: "#F21945",
  orange: "#e07a04",
  lightOrange: "#FFEAD1",
  blue: "#428fdb",
  lightBlue: "#D4E7FA",
  royalBlue: "#62a1f3",
  darkPurple: "#5641cc",
  purple: "#725ee0",
  ocean: "#1B73B3",
  forest: "#1A825F",
  darkOcean: "#07558c",
  greenGradient: {
    start: "#00c753",
    end: "#00d4e8"
  },
  blueGradient: {
    start: "#00d4e8",
    end: "#786ce9"
  },
  purpleGradient: {
    start: "#a379ff",
    end: "#786ce9"
  },
  bluePinkGradient: {
    start: "#3023ae",
    end: "#c86dd7"
  }
};
var styles = {
  cookieBanner: {
    background: brand.ink
  },
  globalHeader: fvStyles.globalHeader,
  logoPath: {
    fill: brand.brandMagenta
  },
  dropdown: {
    checkIconColor: brand.brandBlue
  },
  input: {
    valid: {
      border: brand.paleGrey,
      focusBorder: brand.brandBlue
    },
    invalid: {
      border: brand.red,
      focusBorder: brand.red
    }
  },
  tabs: {
    navLink: {
      underlineColor: brand.brandBlue,
      hoverUnderlineColor: "transparent"
    }
  },
  tag: fvStyles.tag,
  table: fvStyles.table,
  uploader: {
    hoverBorder: brand.brandBlue,
    hoverBackground: rgba(brand.brandBlue, 0.08)
  },
  checkbox: {
    border: brand.cadet,
    invalidBorder: brand.red,
    disabledBorder: brand.silver,
    disabledBackground: brand.offWhite,
    checkedBackground: brand.brandBlue,
    checkedDisabledBackground: brand.silver
  },
  radio: {
    checkedColor: brand.brandBlue,
    disabledColor: brand.silver,
    disabledDarkColor: brand.pewter,
    border: brand.cadet,
    hoverBorder: brand.brandBlue,
    invalidBorder: brand.red,
    background: brand.white,
    darkBackground: "transparent",
    disabledBackground: brand.offWhite,
    disabledDarkBackground: "transparent"
  },
  listbox: {
    hoverBackground: rgba(brand.brandBlue, 0.16),
    focusedBackground: rgba(brand.brandBlue, 0.16),
    selectedBackground: rgba(brand.brandBlue, 0.16),
    disabledColor: rgba(brand.slate, 0.4)
  },
  notifications: {
    successIconColor: brand.green,
    warningIconColor: brand.orange,
    infoIconColor: brand.blue,
    dangerIconColor: brand.red
  },
  button: {
    primary: {
      color: brand.white,
      background: brand.brandBlue,
      border: brand.brandBlue,
      hoverBackground: brand.darkBrandBlue,
      hoverBorder: brand.darkBrandBlue,
      activeBackground: brand.darkerBrandBlue,
      activeBorder: brand.darkerBrandBlue,
      disabledColor: brand.darkGrey,
      disabledBackground: brand.grey,
      disabledBorder: brand.grey
    },
    primaryDark: {
      color: brand.ink,
      background: brand.silver,
      border: "transparent",
      hoverBackground: brand.white,
      activeBackground: brand.white,
      disabledColor: brand.darkGrey,
      disabledBackground: brand.grey,
      disabledBorder: brand.grey
    },
    standardDark: {
      color: brand.white,
      background: brand.ink,
      border: rgba(brand.offWhite, 0.5),
      hoverColor: brand.ink,
      hoverBackground: brand.white,
      hoverBorder: brand.white,
      disabledColor: rgba(brand.offWhite, 0.3),
      disabledBackground: rgba(brand.offWhite, 0.2),
      disabledBorder: "transparent"
    },
    standard: {
      color: brand.slate,
      background: brand.white,
      border: rgba(brand.slate, 0.5),
      hoverColor: brand.white,
      hoverBackground: brand.slate,
      hoverBorder: brand.slate,
      disabledColor: rgba(brand.slate, 0.3),
      disabledBackground: rgba(brand.slate, 0.1),
      disabledBorder: "transparent"
    },
    utilityDark: {
      color: brand.offWhite,
      background: rgba(brand.offWhite, 0.2),
      border: "transparent",
      hoverBackground: rgba(brand.offWhite, 0.3),
      disabledColor: rgba(brand.offWhite, 0.3),
      disabledBackground: rgba(brand.offWhite, 0.2)
    },
    utility: {
      color: brand.slate,
      background: rgba(brand.slate, 0.08),
      border: "transparent",
      hoverBackground: rgba(brand.slate, 0.16),
      disabledColor: rgba(brand.slate, 0.3),
      disabledBackground: rgba(brand.slate, 0.1)
    },
    ghostDark: {
      color: brand.offWhite,
      background: "none",
      border: "transparent",
      hoverBackground: rgba(brand.offWhite, 0.16),
      disabledColor: rgba(brand.offWhite, 0.3),
      disabledBackground: "none"
    },
    ghost: {
      color: brand.slate,
      background: "none",
      border: "transparent",
      hoverBackground: rgba(brand.slate, 0.08),
      disabledColor: rgba(brand.slate, 0.3),
      disabledBackground: "inherit"
    },
    danger: {
      color: brand.offWhite,
      background: brand.red,
      border: brand.red,
      hoverBackground: brand.darkRed,
      hoverBorder: brand.darkRed,
      disabledColor: brand.white,
      disabledBackground: brand.silver,
      disabledBorder: brand.silver
    }
  }
};
var forsta = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  borderRadius,
  font,
  shadow,
  spacing,
  typography,
  brand,
  styles
}, Symbol.toStringTag, { value: "Module" }));
var themes = {
  fvStyle,
  forsta
};
const Theme = ({
  children,
  include,
  theme = "fvStyle"
}) => /* @__PURE__ */ jsx(ThemeProvider, {
  theme: __spreadValues(__spreadValues({}, include), themes[theme]),
  children
});
const recolorButton = ({
  colorName,
  theme
}) => {
  const buttonColor = color(colorName, {
    theme
  });
  return /* @__PURE__ */ css("button{background-color:", buttonColor, ";}");
};
const backgroundColor = ({
  colorName,
  transparency,
  theme
}) => {
  return transparentize(colorName, transparency, {
    theme
  });
};
const position = ({
  position: position2,
  theme,
  colorName
}) => {
  const borderColor = transparentize(colorName, 0.85, {
    theme
  });
  const solidColor = color(colorName, {
    theme
  });
  switch (position2) {
    case "bottom":
      return /* @__PURE__ */ css("&::after{left:50%;bottom:100%;transform:translateX(-50%);border-bottom-color:", borderColor, ";}");
    case "top":
      return /* @__PURE__ */ css("&::after{left:50%;top:100%;transform:translateX(-50%);border-top-color:", borderColor, ";}");
    case "left":
      return /* @__PURE__ */ css("&::after{top:50%;left:100%;transform:translateY(-50%);border-left-color:", borderColor, ";}");
    case "right":
      return /* @__PURE__ */ css("&::after{top:50%;right:100%;transform:translateY(-50%);border-right-color:", borderColor, ";}");
    case "bottom-left":
      return /* @__PURE__ */ css("&::after{left:90%;bottom:100%;transform:translateX(-50%);border-bottom-color:", solidColor, ";}");
    case "bottom-right":
      return /* @__PURE__ */ css("&::after{left:10%;bottom:100%;transform:translateX(-50%);border-bottom-color:", solidColor, ";}");
  }
};
const Container$5 = createStyled("div", {
  target: "efhrsw50"
})("pointer-events:", ({
  open
}) => open ? "auto" : "none", ";transition:all 0.2s ease-out;max-width:", ({
  wide
}) => wide ? "325px" : "250px", ";text-align:left;opacity:", ({
  open
}) => open ? 0.8 : 0, ";color:", color("white"), ";background:", backgroundColor, ";z-index:1020;", ({
  portal
}) => !portal && "white-space: nowrap;", ";", borderRadius$1("default"), ";", padding("xxs"), ";", typography$1("body2"), ";&::after{content:'';position:absolute;border:5px solid transparent;}", recolorButton, ";", position, ";");
Container$5.displayName = "Tooltip.Container";
const Title = createStyled("div", {
  target: "e71juu70"
})("margin-bottom:", spacer(1), ";color:", color("white"), ";", typography$1("body2Medium"), ";");
Title.displayName = "Tooltip.Title";
const Wrapper = createStyled("div", {
  target: "e1ha8v9x0"
})({
  name: "79elbk",
  styles: "position:relative;"
});
Wrapper.displayName = "Tooltip.Wrapper";
const OFFSET = 12;
const placements = {
  "bottom-left": "bottom-end",
  "bottom-right": "bottom-start"
};
const getRoot = () => {
  const root2 = document.getElementById("tooltip-root");
  return root2;
};
const renderTooltip = () => {
  return null;
};
const Tooltip = ({
  delay = 0,
  position: position2 = "top",
  containerOpenOnHover = false,
  wide = false,
  color: color2 = "black",
  transparency = 0.85,
  render: render3,
  portal,
  label,
  title,
  wrapperClassName,
  className
}) => {
  const [open, setOpen] = useState(false);
  const [, forceUpdate] = useState(0);
  const timer = useRef(null);
  const containerHoverOver = useRef(null);
  const tooltipRoot = getRoot();
  const popperElement = useRef(null);
  const referenceElement = useRef(null);
  const modifiers = useMemo(() => [{
    name: "preventOverflow",
    enabled: false
  }, {
    name: "hide",
    enabled: false
  }, {
    name: "offset",
    options: {
      offset: () => [0, OFFSET]
    }
  }], []);
  const {
    styles: styles2,
    attributes
  } = usePopper$1(referenceElement.current, popperElement.current, {
    placement: placements[position2] || position2,
    modifiers
  });
  const show = () => {
    timer.current = setTimeout(() => {
      setOpen(true);
    }, delay);
  };
  const hide2 = () => {
    clearTimeout(timer.current);
    setTimeout(() => {
      containerOpenOnHover && containerHoverOver.current ? null : setOpen(false);
    }, containerOpenOnHover ? 200 : 0);
  };
  const containerEnter = () => {
    if (open && containerOpenOnHover) {
      containerHoverOver.current = true;
      setOpen(true);
    }
  };
  const containerOut = () => {
    if (containerOpenOnHover) {
      containerHoverOver.current = false;
      setOpen(false);
    }
  };
  useLayoutEffect(() => {
    forceUpdate(new Date().getTime());
    return () => clearTimeout(timer.current);
  }, []);
  const tooltip = /* @__PURE__ */ jsxs(Container$5, __spreadProps(__spreadValues({
    open,
    wide,
    ref: popperElement,
    portal,
    colorName: color2,
    transparency,
    position: position2,
    className,
    onMouseEnter: containerEnter,
    onMouseLeave: containerOut,
    style: styles2.popper
  }, attributes.popper), {
    children: [title && /* @__PURE__ */ jsx(Title, {
      children: title
    }), label]
  }));
  const reference2 = render3({
    hide: hide2,
    show,
    ref: referenceElement,
    renderTooltip
  });
  return /* @__PURE__ */ jsx(Fragment, {
    children: portal ? /* @__PURE__ */ jsxs(Fragment$2, {
      children: [reference2, createPortal(tooltip, tooltipRoot)]
    }) : /* @__PURE__ */ jsxs(Wrapper, {
      className: wrapperClassName,
      children: [reference2, tooltip]
    })
  });
};
Tooltip.propTypes = {
  position: PropTypes$2.string,
  delay: PropTypes$2.number,
  containerOpenOnHover: PropTypes$2.bool,
  wide: PropTypes$2.bool,
  color: PropTypes$2.string,
  transparency: PropTypes$2.number,
  render: PropTypes$2.func,
  portal: PropTypes$2.bool,
  label: PropTypes$2.oneOfType([PropTypes$2.string, PropTypes$2.element]),
  title: PropTypes$2.string,
  wrapperClassName: PropTypes$2.string,
  className: PropTypes$2.string
};
function ConsumeTheme({
  children
}) {
  const theme = useTheme();
  return children({
    theme
  });
}
var global$1 = (styles2) => {
  return /* @__PURE__ */ jsx(ConsumeTheme, {
    children: ({
      theme
    }) => /* @__PURE__ */ jsx(Global, {
      styles: /* @__PURE__ */ css("html{box-sizing:border-box;font-size:", theme.font.base, ";-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;}*,*:before,*:after{box-sizing:inherit;}body{font-family:'Roboto',sans-serif;color:", color("black", {
        theme
      }), ";", typography$1("body2", {
        theme
      }), ";}a{text-decoration:none;color:currentColor;transition:all 0.1s ease-in-out;touch-action:manipulation;}h1,h2,h3,h4,h5,h6{margin-top:0;margin-bottom:", spacer(2, {
        theme
      }), ";}h1{", typography$1("headline3", {
        theme
      }), ";}h2{", typography$1("headline2", {
        theme
      }), ";}h3{", typography$1("headline1", {
        theme
      }), ";}h4{", typography$1("title3", {
        theme
      }), ";}h5{", typography$1("title2", {
        theme
      }), ";}h6{", typography$1("title1", {
        theme
      }), ";}strong{", fontWeight("bold", {
        theme
      }), ";}p{margin-top:0;margin-bottom:", spacer(2, {
        theme
      }), ";}label{color:", color("pewter", {
        theme
      }), ";margin-bottom:", spacer(2, {
        theme
      }), ";touch-action:manipulation;", typography$1("body1Medium", {
        theme
      }), ";}", styles2 && styles2(theme), ";")
    })
  });
};
const grid = ({
  grid: grid2
}) => grid2 && /* @__PURE__ */ css("grid:", grid2, ";");
const gridArea = ({
  gridArea: gridArea2
}) => gridArea2 && /* @__PURE__ */ css("grid-area:", gridArea2, ";");
const gridGap = ({
  gridGap: gridGap2
}) => gridGap2 && /* @__PURE__ */ css("grid-gap:", gridGap2, ";");
const gridRow = ({
  gridRow: gridRow2
}) => gridRow2 && /* @__PURE__ */ css("grid-row:", gridRow2, ";");
const gridColumn = ({
  gridColumn: gridColumn2
}) => gridColumn2 && /* @__PURE__ */ css("grid-column:", gridColumn2, ";");
const gridTemplate = ({
  gridTemplate: gridTemplate2
}) => gridTemplate2 && /* @__PURE__ */ css("grid-template:", gridTemplate2, ";");
const gridTemplateColumns = ({
  gridTemplateColumns: gridTemplateColumns2
}) => gridTemplateColumns2 && /* @__PURE__ */ css("grid-template-columns:", gridTemplateColumns2, ";");
const gridTemplateRows = ({
  gridTemplateRows: gridTemplateRows2
}) => gridTemplateRows2 && /* @__PURE__ */ css("grid-template-rows:", gridTemplateRows2, ";");
const gridAutoFlow = ({
  gridAutoFlow: gridAutoFlow2
}) => gridAutoFlow2 && /* @__PURE__ */ css("grid-auto-flow:", gridAutoFlow2, ";");
const gridAutoRows = ({
  gridAutoRows: gridAutoRows2
}) => gridAutoRows2 && /* @__PURE__ */ css("grid-auto-rows:", gridAutoRows2, ";");
const gridAutoColumns = ({
  gridAutoColumns: gridAutoColumns2
}) => gridAutoColumns2 && /* @__PURE__ */ css("grid-auto-columns:", gridAutoColumns2, ";");
const justifyItems = ({
  justifyItems: justifyItems2
}) => justifyItems2 && /* @__PURE__ */ css("justify-items:", justifyItems2, ";");
const justifyContent = ({
  justifyContent: justifyContent2
}) => justifyContent2 && /* @__PURE__ */ css("justify-content:", justifyContent2, ";");
const alignItems = ({
  alignItems: alignItems2
}) => alignItems2 && /* @__PURE__ */ css("align-items:", alignItems2, ";");
const alignContent = ({
  alignContent: alignContent2
}) => alignContent2 && /* @__PURE__ */ css("align-content:", alignContent2, ";");
const Grid = createStyled("div", {
  target: "e1y8n9000"
})("display:grid;", grid, ";", gridArea, ";", gridGap, ";", gridTemplate, ";", gridTemplateColumns, ";", gridTemplateRows, ";", gridRow, ";", gridColumn, ";", gridAutoFlow, ";", gridAutoColumns, ";", gridAutoRows, ";", justifyItems, ";", justifyContent, ";", alignItems, ";", alignContent, ";");
const NavContainer = createStyled("div", {
  target: "ee1j8zj0"
})("display:flex;justify-content:center;width:100%;", ({
  theme,
  dark: dark2
}) => /* @__PURE__ */ css("background-color:", color(dark2 ? "ink" : "white", {
  theme
}), ";a:not(", ItemLink, "){&,&:hover{color:", color(dark2 ? "white" : "ink", {
  theme
}), ";}}"), ";");
const Nav = createStyled("nav", {
  target: "ee1j8zj1"
})("display:flex;align-items:center;padding-left:", spacer(4), ";padding-right:", spacer(4), ";height:70px;", responsiveContainer, ";@supports (display:grid){display:grid;grid-template-columns:auto 1fr;grid-template-rows:70px;height:auto;}");
const NavItem = createStyled("div", {
  target: "ee1j8zj2"
})({
  name: "4mjo1p",
  styles: "&:nth-of-type(2){display:flex;justify-content:flex-end;flex:1;}@supports (display:grid){&:nth-of-type(2){display:grid;justify-content:end;grid-auto-flow:column;}}"
});
const Navbar = ({
  children,
  dark: dark2,
  fluid,
  homeRoute
}) => /* @__PURE__ */ jsx(NavContainer, {
  dark: dark2,
  children: /* @__PURE__ */ jsxs(Nav, {
    fluid,
    children: [/* @__PURE__ */ jsx(NavItem, {
      children: /* @__PURE__ */ jsx(Link$1, {
        to: homeRoute,
        children: /* @__PURE__ */ jsx(ForstaLogo, {
          size: "sm",
          dark: dark2
        })
      })
    }), /* @__PURE__ */ jsx(NavItem, {
      children
    })]
  })
});
const Container$4 = createStyled("ul", {
  target: "ecsw2jx0"
})({
  name: "dlxhph",
  styles: "border-bottom:0;display:flex;flex-wrap:wrap;padding-left:0;margin-bottom:0;list-style:none;"
});
Container$4.displayName = "Tabs.Container";
const TabContainer = createStyled("li", {
  target: "ermi7160"
})("padding:0 ", spacer(4), ";&:first-of-type{padding-left:0;}&:last-of-type{padding-right:0;}");
const activeCss = ({
  dark: dark2,
  theme
}) => `
  && {
    color: ${color(dark2 ? "white" : "ink", {
  theme
})};
    border-bottom-color: ${style("tabs.navLink.underlineColor", {
  theme
})};
    &:hover {
      border-bottom-color: ${style("tabs.navLink.hoverUnderlineColor", {
  theme
})};
    }
  }
`;
const StyledNavLink = /* @__PURE__ */ createStyled(NavLink, {
  shouldForwardProp: (prop2) => prop2 !== "dark",
  target: "edu3jul0"
})("color:", ({
  dark: dark2
}) => dark2 ? transparentize("offWhite", 0.5) : color("pewter"), ";padding:", spacer(2), " 0;border-bottom:2px solid transparent;display:block;cursor:pointer;transition:all 0.1s ease-in-out;", typography$1("subheading2"), ";&:hover{color:", ({
  dark: dark2
}) => color(dark2 ? "white" : "ink"), ";}");
const TabsNavLink = (_Za) => {
  var __a = _Za, {
    dark: dark2,
    theme
  } = __a, rest = __objRest(__a, [
    "dark",
    "theme"
  ]);
  return /* @__PURE__ */ jsx(ClassNames, {
    children: ({
      css: css2
    }) => /* @__PURE__ */ jsx(StyledNavLink, __spreadValues({
      activeClassName: css2(activeCss({
        dark: dark2,
        theme
      })),
      dark: dark2
    }, rest))
  });
};
var TabNavLink = withTheme(TabsNavLink);
const Caret = /* @__PURE__ */ createStyled(Caret$2, {
  target: "e1os2y1p0"
})("margin-left:", spacer(1), ";");
const isActive = (children) => (match, location) => Children.toArray(children).filter(Boolean).some(({
  props
}) => props.to === location.pathname);
const DropdownItem = (_$a) => {
  var _ab = _$a, {
    children,
    dark: dark2,
    text
  } = _ab, props = __objRest(_ab, [
    "children",
    "dark",
    "text"
  ]);
  return /* @__PURE__ */ jsx(TabContainer, {
    children: /* @__PURE__ */ jsx(DropdownMenu, __spreadProps(__spreadValues({}, props), {
      trigger: (toggle) => /* @__PURE__ */ jsxs(TabNavLink, {
        to: "",
        dark: dark2,
        onClick: (e2) => {
          e2.preventDefault();
          toggle();
        },
        isActive: isActive(children),
        children: [text, /* @__PURE__ */ jsx(Caret, {
          size: "0.5rem"
        })]
      }),
      children
    }))
  });
};
const TabsItem = (_bb) => {
  var _cb = _bb, {
    children,
    dark: dark2
  } = _cb, props = __objRest(_cb, [
    "children",
    "dark"
  ]);
  return /* @__PURE__ */ jsx(TabContainer, {
    children: /* @__PURE__ */ jsx(TabNavLink, __spreadProps(__spreadValues({}, props), {
      dark: dark2,
      children
    }))
  });
};
const Tabs = (_db) => {
  var _eb = _db, {
    children,
    dark: dark2
  } = _eb, props = __objRest(_eb, [
    "children",
    "dark"
  ]);
  return /* @__PURE__ */ jsx(Container$4, __spreadProps(__spreadValues({}, props), {
    children: Children.map(children, (child) => isValidElement(child) ? cloneElement(child, {
      dark: dark2
    }) : child)
  }));
};
Tabs.Item = TabsItem;
Tabs.DropdownItem = DropdownItem;
const Col = defaultProps$4({
  gridAutoRows: "min-content",
  gridAutoFlow: "row"
})(Grid);
var withClass = (klassName) => _default$2(({
  className
}) => {
  return {
    className: `${className || ""} ${klassName}`
  };
});
const StyledRow = /* @__PURE__ */ createStyled(Row$2, {
  target: "eou32rh0"
})("background-color:", ({
  dark: dark2
}) => color(dark2 ? "ink" : "white"), ";");
const NavbarSecondary = (_fb) => {
  var _gb = _fb, {
    children,
    fluid,
    dark: dark2
  } = _gb, rest = __objRest(_gb, [
    "children",
    "fluid",
    "dark"
  ]);
  return /* @__PURE__ */ jsx(StyledRow, __spreadProps(__spreadValues({
    dark: dark2
  }, rest), {
    children: /* @__PURE__ */ jsx(Container$h, {
      fluid,
      children: /* @__PURE__ */ jsx(Col, {
        gridAutoFlow: "column",
        children: /* @__PURE__ */ jsx("nav", {
          children: /* @__PURE__ */ jsx(Tabs, {
            dark: dark2,
            children
          })
        })
      })
    })
  }));
};
NavbarSecondary.NavItem = Tabs.Item;
NavbarSecondary.DropdownItem = Tabs.DropdownItem;
const Header$1 = /* @__PURE__ */ createStyled("div", {
  target: "egsom8c0"
})(padding("xs"), ";h6{margin-bottom:0;}");
const withPadding = ({
  theme,
  pad
}) => pad && /* @__PURE__ */ css(padding("xs", {
  theme
}), ";");
const withPaddingY = ({
  theme,
  padY
}) => padY && /* @__PURE__ */ css("padding-top:", spacer(3, {
  theme
}), ";padding-bottom:", spacer(3, {
  theme
}), ";");
const Item = /* @__PURE__ */ createStyled("div", {
  target: "e7agfjs0"
})(withPadding, ";", withPaddingY, ";");
const Empty = /* @__PURE__ */ createStyled(Item, {
  target: "eiajbqa0"
})("text-align:center;color:", color("cadet"), ";");
const Footer$1 = /* @__PURE__ */ createStyled("div", {
  target: "ervq2v60"
})(padding("xs"), ";");
const dividers = ({
  dividers: dividers2,
  theme
}) => dividers2 && /* @__PURE__ */ css(".box-item + .box-item,.box-header + .box-item,.box-item + .box-footer{border-top:1px solid ", color("paleGrey", {
  theme
}), ";}");
const ghost = ({
  ghost: ghost2,
  theme
}) => !ghost2 && /* @__PURE__ */ css("background:", color("white", {
  theme
}), ";", shadow$1("subtle", {
  theme
}), ";", borderRadius$1("sm", {
  theme
}), ";");
const dark = ({
  dark: dark2,
  theme
}) => dark2 && /* @__PURE__ */ css("color:", color("white", {
  theme
}), ";.box-item + .box-item,.box-header + .box-item,.box-item + .box-footer{border-top-color:", color("pewter", {
  theme
}), ";}");
const Box = /* @__PURE__ */ createStyled("div", {
  target: "eevfmbf0"
})("& + &{margin-top:", spacer("sm"), ";}", ghost, ";", dividers, ";", dark, ";");
Box.Header = withClass("box-header")(Header$1);
Box.Item = withClass("box-item")(Item);
Box.Empty = withClass("box-item")(Empty);
Box.Footer = withClass("box-footer")(Footer$1);
const Column = (props) => {
  throw new Error("Column should never render. You may be using this outside of a <Table /> component.");
};
const Row$1 = (props) => {
  throw new Error("Row should never render. You may be using this outside of a <Table /> component.");
};
Row$1.defaultProps = {
  collapsible: false
};
const commonStyles = ({
  onClick,
  theme
}) => /* @__PURE__ */ css("border-collapse:collapse;width:100%;max-width:100%;thead{th{color:", color("slate", {
  theme
}), ";border:none;}}tbody{background-color:", color("white", {
  theme
}), ";tr{transition:all 0.3s ease 0s;", onClick ? "&:hover { cursor: pointer; }" : "", ";}}");
const simple = (_hb) => {
  var _ib = _hb, {
    theme
  } = _ib, rest = __objRest(_ib, [
    "theme"
  ]);
  return /* @__PURE__ */ css(commonStyles(__spreadValues({
    theme
  }, rest)), ";", shadow$1("subtle", {
    theme
  }), ";th{text-align:inherit;}thead{background-color:", color("paleGrey", {
    theme
  }), ";th{", typography$1("body2Medium", {
    theme
  }), ";", padding("xxs", {
    theme
  }), ";&:first-of-type{padding-left:", spacer(4, {
    theme
  }), ";}}}tbody{tr{&:hover{background-color:", style("table.row.hoverBackground", {
    theme
  }), ";}&:first-of-type td{padding-top:", spacer(3, {
    theme
  }), ";}&:last-of-type td{padding-bottom:", spacer(3, {
    theme
  }), ";}}td{color:", color("slate", {
    theme
  }), ";", typography$1("body2Medium", {
    theme
  }), ";", padding("xxs", {
    theme
  }), ";&:first-of-type{padding-left:", spacer(4, {
    theme
  }), ";}&:not(:last-of-type){border-right:1px solid ", color("paleGrey", {
    theme
  }), ";}}}");
};
const multiline = (_jb) => {
  var _kb = _jb, {
    theme
  } = _kb, rest = __objRest(_kb, [
    "theme"
  ]);
  return /* @__PURE__ */ css(commonStyles(__spreadValues({
    theme
  }, rest)), ";margin-bottom:", spacer(4, {
    theme
  }), ";background-color:transparent;thead{background-color:transparent;th{position:relative;padding:", spacer(3, {
    theme
  }), " ", spacer(5, {
    theme
  }), ";vertical-align:bottom;", fontSize("xxs", {
    theme
  }), ";", fontWeight("medium", {
    theme
  }), ";}}tbody{", shadow$1("subtle", {
    theme
  }), ";tr{&:not(:last-of-type){border-bottom:1px solid ", color("paleGrey", {
    theme
  }), ";}&:hover{", shadow$1("raised", {
    theme
  }), ";background-color:transparent;}}td{&:first-of-type{padding-left:", spacer(5, {
    theme
  }), ";display:flex;align-items:center;}position:relative;", fontSize("xs", {
    theme
  }), ";", fontWeight("regular", {
    theme
  }), ";height:79px;padding:0 ", spacer(3.5, {
    theme
  }), ";border:none;vertical-align:middle;}}");
};
const flatCellPadding = (theme) => /* @__PURE__ */ css("padding:", spacer(3, {
  theme
}), ";&:first-of-type{padding-left:", spacer(5, {
  theme
}), ";}&:last-of-type{padding-right:", spacer(5, {
  theme
}), ";}");
const flat = (_lb) => {
  var _mb = _lb, {
    theme
  } = _mb, rest = __objRest(_mb, [
    "theme"
  ]);
  return /* @__PURE__ */ css(commonStyles(__spreadValues({
    theme
  }, rest)), ";margin-bottom:", spacer(4, {
    theme
  }), ";background-color:transparent;thead{background-color:transparent;th{text-align:inherit;position:relative;", flatCellPadding(theme), ";vertical-align:bottom;", fontSize("s", {
    theme
  }), ";", fontWeight("body", {
    theme
  }), ";}}tbody{border:1px solid ", color("paleGrey", {
    theme
  }), ";tr{&:not(:last-of-type){border-bottom:1px solid ", color("paleGrey", {
    theme
  }), ";}&:hover{background-color:", color("offWhite", {
    theme
  }), ";}}td{", flatCellPadding(theme), ";position:relative;", fontSize("xs", {
    theme
  }), ";", fontWeight("regular", {
    theme
  }), ";height:60px;border:none;vertical-align:middle;}}");
};
const TR = createStyled("tr", {
  target: "e1qtvw8e0"
})(({
  collapsible,
  expanded,
  theme
}) => collapsible && /* @__PURE__ */ css(shadow$1("close", {
  theme
}), ";display:", expanded ? "table-row" : "none", ";"), ";");
const TD = createStyled("td", {
  target: "e1qtvw8e1"
})((props) => props.width && /* @__PURE__ */ css("width:", props.width, "px;"), ";");
const StyledTable = createStyled("table", {
  target: "e1qtvw8e2"
})((_nb) => {
  var _ob = _nb, {
    type
  } = _ob, rest = __objRest(_ob, [
    "type"
  ]);
  return (type === "multi" ? multiline : type === "flat" ? flat : simple)(rest);
}, ";");
const firstChild = (children) => Children.toArray(children)[0];
const nestedChildren = ({
  props
}) => props.children;
const isCollapsible = (children) => Children.toArray(children).some(({
  props
}) => props.collapsible);
const normalizedData = (data) => {
  return typeof data === "boolean" ? data.toString() : data;
};
class Table extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      expandedRows: []
    });
    __publicField(this, "toggle", (idx) => {
      this.setState(({
        expandedRows
      }) => ({
        expandedRows: expandedRows.includes(idx) ? expandedRows.filter((i) => i !== idx) : [...expandedRows, idx]
      }));
    });
    __publicField(this, "renderColumns", (columns, data) => {
      return Children.map(columns, (_a2) => {
        var {
          props: _b
        } = _a2, _c = _b, {
          render: render3,
          dataKey
        } = _c, rest = __objRest(_c, [
          "render",
          "dataKey"
        ]);
        return /* @__PURE__ */ jsx(TD, __spreadProps(__spreadValues({}, rest), {
          children: render3 ? render3(data) : normalizedData(data[dataKey])
        }), dataKey);
      });
    });
  }
  render() {
    const _a2 = this.props, {
      children,
      data,
      type
    } = _a2, rest = __objRest(_a2, [
      "children",
      "data",
      "type"
    ]);
    const {
      expandedRows
    } = this.state;
    const collapsible = isCollapsible(children);
    const rows = Children.toArray(children);
    const regularRows = rows.filter((child) => !child.props.collapsible);
    const collapsibleRows = rows.filter((child) => child.props.collapsible);
    return /* @__PURE__ */ jsxs(StyledTable, __spreadProps(__spreadValues({
      type
    }, rest), {
      children: [/* @__PURE__ */ jsx("thead", {
        children: /* @__PURE__ */ jsxs("tr", {
          children: [Children.map(nestedChildren(firstChild(children)), ({
            props
          }) => /* @__PURE__ */ jsx("th", {
            children: props.label
          }, props.dataKey)), collapsible && /* @__PURE__ */ jsx("th", {})]
        })
      }), /* @__PURE__ */ jsx("tbody", {
        children: data.map((row, idx) => /* @__PURE__ */ jsxs(Fragment$2, {
          children: [regularRows.map(({
            props
          }) => /* @__PURE__ */ jsxs(TR, __spreadProps(__spreadValues({}, props), {
            onClick: (e2) => props.onClick && props.onClick(e2, row),
            children: [this.renderColumns(props.children, row), collapsible && /* @__PURE__ */ jsx(TD, {
              width: 50,
              children: /* @__PURE__ */ jsx(Button$1, {
                kind: "utility",
                size: "sm",
                onClick: () => this.toggle(idx),
                children: /* @__PURE__ */ jsx(Chevron$1, {
                  size: "1.25rem",
                  direction: expandedRows.includes(idx) ? "up" : "down"
                })
              })
            })]
          }), `row:${idx}`)), collapsibleRows.map(({
            props
          }) => /* @__PURE__ */ jsx(TR, __spreadProps(__spreadValues({
            expanded: expandedRows.includes(idx)
          }, props), {
            children: this.renderColumns(props.children, row)
          }), `collapsible:${idx}`))]
        }, `fragment-row-${idx}`))
      })]
    }));
  }
}
__publicField(Table, "Column", Column);
__publicField(Table, "Row", Row$1);
__publicField(Table, "defaultProps", {
  onClick: null
});
const LayoutWithStandardHeader = withProps$1({
  gridTemplateRows: `auto 1fr auto`,
  gridAutoFlow: "row"
})(/* @__PURE__ */ createStyled(Grid, {
  target: "e1u5ql7t0"
})("min-height:100vh;background:", color("offWhite"), ";"));
const Footer = createStyled("footer", {
  target: "e1u5ql7t1"
})("background:", (_pb) => {
  var _qb = _pb, {
    theme
  } = _qb, props = __objRest(_qb, [
    "theme"
  ]);
  return color(props.dark ? "ink" : "offWhite")(__spreadValues({
    theme
  }, props));
}, ";");
Footer.propTypes = {
  dark: PropTypes$2.bool
};
LayoutWithStandardHeader.Header = Navbar;
LayoutWithStandardHeader.Main = (_rb) => {
  var _sb = _rb, {
    children
  } = _sb, props = __objRest(_sb, [
    "children"
  ]);
  return /* @__PURE__ */ jsx("main", __spreadProps(__spreadValues({}, props), {
    children
  }));
};
LayoutWithStandardHeader.Footer = (_tb) => {
  var _ub = _tb, {
    children
  } = _ub, props = __objRest(_ub, [
    "children"
  ]);
  return /* @__PURE__ */ jsx(Footer, __spreadProps(__spreadValues({}, props), {
    children
  }));
};
LayoutWithStandardHeader.SecondaryHeader = NavbarSecondary;
const LayoutSidebar = /* @__PURE__ */ createStyled(Grid, {
  target: "ehwsdlt0"
})("grid-template-columns:", ({
  sidebarWidth = "200px"
}) => sidebarWidth, " 1fr;grid-auto-flow:column;grid-column-gap:", spacer(4), ";padding:", spacer(4), ";background:", color("offWhite"), ";");
LayoutSidebar.Content = (_vb) => {
  var _wb = _vb, {
    children
  } = _wb, rest = __objRest(_wb, [
    "children"
  ]);
  return /* @__PURE__ */ jsx("div", __spreadProps(__spreadValues({}, rest), {
    children
  }));
};
LayoutSidebar.Sidebar = (_xb) => {
  var _yb = _xb, {
    children
  } = _yb, rest = __objRest(_yb, [
    "children"
  ]);
  return /* @__PURE__ */ jsx("div", __spreadProps(__spreadValues({}, rest), {
    children
  }));
};
const Svg = createStyled("svg", {
  target: "ehuab110"
})({
  name: "9y6172",
  styles: "user-select:none;"
});
var Svg$1 = withProps$1({
  xmlns: "http://www.w3.org/2000/svg"
})(Svg);
const DiagonalDividerVertical = (_zb) => {
  var _Ab = _zb, {
    theme
  } = _Ab, props = __objRest(_Ab, [
    "theme"
  ]);
  return /* @__PURE__ */ jsxs(Svg$1, __spreadProps(__spreadValues({
    viewBox: "0 0 115 801",
    preserveAspectRatio: "none"
  }, props), {
    children: [/* @__PURE__ */ jsx("title", {
      children: "brand diagonal"
    }), /* @__PURE__ */ jsx("rect", {
      fill: color("white", {
        theme
      }),
      width: "104.6",
      height: "801"
    }), /* @__PURE__ */ jsxs("linearGradient", {
      id: "greenGradient",
      gradientUnits: "userSpaceOnUse",
      x1: "25.8617",
      y1: "-249.8779",
      x2: "158.2286",
      y2: "432.3206",
      gradientTransform: "matrix(1 0 0 1 0 130)",
      children: [/* @__PURE__ */ jsx("stop", {
        offset: "0",
        stopColor: gradientStart("green", {
          theme
        })
      }), /* @__PURE__ */ jsx("stop", {
        offset: "1",
        stopColor: gradientEnd("green", {
          theme
        })
      })]
    }), /* @__PURE__ */ jsx("polygon", {
      fill: "url(#greenGradient)",
      points: "0,0 64.6,419.3 115,0 "
    }), /* @__PURE__ */ jsx("polygon", {
      fill: color("ink", {
        theme
      }),
      points: "115,0 64.6,419.3 18.7,801 115,801 "
    })]
  }));
};
var DiagonalDivider = withTheme(DiagonalDividerVertical);
const Header = createStyled("header", {
  target: "e1st5z9h0"
})("display:flex;align-items:center;padding-left:", spacer(4), ";padding-right:", spacer(4), ";");
const Main = createStyled("main", {
  target: "e1st5z9h1"
})("display:flex;justify-content:center;align-items:center;width:100%;padding-left:", spacer(4), ";padding-right:", spacer(4), ";>:first-of-type{width:400px;}@supports (display:grid){display:grid;justify-content:center;align-content:center;align-items:unset;grid-template-columns:400px;width:auto;>:first-of-type{width:auto;}", mediaDn("sm"), "{grid-template-columns:1fr;}}");
const StyledLayoutWithVertical = createStyled("div", {
  target: "e1st5z9h2"
})("display:flex;height:100vh;background:", color("white"), ";@supports (display:grid){display:grid;grid-template-columns:1fr;grid-auto-flow:column;", mediaUp("lg"), "{grid-template-columns:repeat(2,1fr);}}");
const Left = createStyled("div", {
  target: "e1st5z9h3"
})("display:flex;flex-direction:column;width:100%;header{height:70px;}main{flex:1;}", mediaUp("lg"), "{width:50%;}@supports (display:grid){display:grid;grid-template-rows:70px 1fr;header{height:auto;}main{align-self:center;}", mediaUp("lg"), "{width:100%;}}");
const Right = createStyled("div", {
  target: "e1st5z9h4"
})("width:50%;background:", color("ink"), ";position:relative;> svg{position:absolute;display:block;left:0;height:100%;width:80px;}@supports (display:grid){width:auto;}");
const LayoutWithVertical = (_Bb) => {
  var _Cb = _Bb, {
    children
  } = _Cb, props = __objRest(_Cb, [
    "children"
  ]);
  return /* @__PURE__ */ jsx(MediaQuery, {
    above: "lg",
    children: (matches) => /* @__PURE__ */ jsxs(StyledLayoutWithVertical, __spreadProps(__spreadValues({}, props), {
      children: [/* @__PURE__ */ jsx(Left, {
        children
      }), matches && /* @__PURE__ */ jsx(Right, {
        children: /* @__PURE__ */ jsx(DiagonalDivider, {})
      })]
    }))
  });
};
LayoutWithVertical.Header = Header;
LayoutWithVertical.Main = Main;
LayoutWithVertical.Footer = (props) => /* @__PURE__ */ jsx("footer", __spreadValues({}, props));
const DiagonalDividerHorizontal = ({
  theme
}) => /* @__PURE__ */ jsxs(Svg$1, {
  viewBox: "0 0 1280 156",
  preserveAspectRatio: "none",
  children: [/* @__PURE__ */ jsx("path", {
    fill: color("ink", {
      theme
    }),
    d: "M0 0v80h1280V0z"
  }), /* @__PURE__ */ jsxs("linearGradient", {
    id: "greenGradient",
    gradientUnits: "userSpaceOnUse",
    y1: "81",
    x2: "1280",
    y2: "81",
    gradientTransform: "matrix(1 0 0 -1 0 156)",
    children: [/* @__PURE__ */ jsx("stop", {
      offset: "0",
      stopColor: gradientEnd("green", {
        theme
      })
    }), /* @__PURE__ */ jsx("stop", {
      offset: "1",
      stopColor: gradientStart("green", {
        theme
      })
    })]
  }), /* @__PURE__ */ jsx("path", {
    fill: "url(#greenGradient)",
    d: "M1280 0L0 148v2h1280z"
  }), /* @__PURE__ */ jsx("path", {
    fill: color("white", {
      theme
    }),
    d: "M0 0l1280 148v8H0z"
  })]
});
var DiagonalDividerHorizontal$1 = withTheme(DiagonalDividerHorizontal);
var _ref$1 = {
  name: "hu0xcq",
  styles: "bottom:0;left:0;transform:translate(-50%,50%);"
};
var _ref2 = {
  name: "1p8meti",
  styles: "bottom:0;right:0;transform:translate(50%,50%);"
};
var _ref3 = {
  name: "1t40x28",
  styles: "top:0;left:0;transform:translate(-50%,-50%);"
};
var _ref4 = {
  name: "46kkzh",
  styles: "top:0;right:0;transform:translate(50%,-50%);"
};
const diagonalPositioning = ({
  position: position2 = "top-right"
}) => {
  switch (position2) {
    case "bottom-left":
      return _ref$1;
    case "bottom-right":
      return _ref2;
    case "top-left":
      return _ref3;
    case "top-right":
    default:
      return _ref4;
  }
};
const BadgeWrapper = createStyled("div", {
  target: "e8lwdzt0"
})("position:absolute;", diagonalPositioning, ";");
const badgeOptions = ({
  theme,
  fill = "red",
  background = "white",
  color: textColor = "white"
}) => /* @__PURE__ */ css("color:", color(textColor, {
  theme
}), ";background-color:", color(fill, {
  theme
}), ";border-color:", color(background, {
  theme
}), ";");
const Badge = createStyled("div", {
  target: "e8lwdzt1"
})("display:flex;align-items:ceneter;justify-content:center;border-width:2px;border-style:solid;border-radius:50%;box-sizing:content-box;width:0.4rem;height:0.4rem;", fontSize("xs"), ";", fontWeight("bold"), ";", badgeOptions, ";");
const Container$3 = createStyled("div", {
  target: "e8lwdzt2"
})({
  name: "1gomreu",
  styles: "position:relative;display:inline-block;"
});
const WithBadge = ({
  children,
  on = true,
  position: position2 = "top-right",
  badgeStyle
}) => /* @__PURE__ */ jsxs(Container$3, {
  children: [children, /* @__PURE__ */ jsx(BadgeWrapper, {
    position: position2,
    children: on && /* @__PURE__ */ jsx(Badge, {
      style: badgeStyle
    })
  })]
});
const Body = createStyled("tbody", {
  target: "euimo9d0"
})("&&{background-color:", color("white"), ";}");
const highlightedStyle = ({
  highlighted = false,
  theme
}) => highlighted && /* @__PURE__ */ css("background-color:", transparentize("black", 0.07, {
  theme
}), ";");
const highlightOnHoverStyle = ({
  highlightOnHover = false,
  theme
}) => highlightOnHover && /* @__PURE__ */ css("&:hover{", highlightedStyle({
  highlighted: true,
  theme
}), "}");
const vertPadding = {
  default: 2,
  compact: 1,
  comfortable: 3
};
const paddingStyle = ({
  spacing: spacing2 = "default",
  theme
}) => {
  const y2 = spacer(vertPadding[spacing2], {
    theme
  });
  const x = spacer(3, {
    theme
  });
  return /* @__PURE__ */ css("padding:", y2, " ", x, ";");
};
var _ref = {
  name: "y8yffq",
  styles: "hyphens:auto;"
};
const hyphensStyle = ({
  hyphens
}) => hyphens && _ref;
const Cell$1 = createStyled("td", {
  target: "e194s5c20"
})("&&{", fontWeight("regular"), " text-align:", ({
  textAlign = "left"
}) => textAlign, ";", highlightedStyle, " ", paddingStyle, " ", highlightOnHoverStyle, " ", hyphensStyle, "}");
Cell$1.propTypes = {
  highlightOnHover: PropTypes$2.bool,
  highlighted: PropTypes$2.bool,
  noBorder: PropTypes$2.bool,
  hyphens: PropTypes$2.bool,
  textAlign: PropTypes$2.oneOf(["left", "center", "right"]),
  spacing: PropTypes$2.oneOf(["default", "compact", "comfortable"]),
  children: PropTypes$2.node
};
const Container$2 = createStyled("div", {
  target: "e1wfxndb0"
})({
  name: "17xotax",
  styles: "&&{width:100%;overflow-x:auto;}"
});
const borderStyle = ({
  noBorder = false,
  theme
}) => /* @__PURE__ */ css("border-width:1px 1px 0 1px;border-style:solid;border-color:", noBorder ? "transparent" : color("silver", {
  theme
}), ";tbody > &:last-child{border-bottom-width:1px;}");
const selectableStyle = ({
  selectable: selectable2 = false,
  theme
}) => selectable2 && /* @__PURE__ */ css("cursor:pointer;&:hover{background-color:", transparentize("black", 0.07, {
  theme
}), ";}");
const selectedStyle = ({
  selected = false,
  theme
}) => selected && /* @__PURE__ */ css("background-color:", transparentize("blue", 0.2, {
  theme
}), ";&:hover{background-color:", transparentize("blue", 0.3, {
  theme
}), ";}");
const Row = createStyled("tr", {
  target: "egcnfba0"
})("&&{", selectableStyle, " ", selectedStyle, " ", borderStyle, "}");
const FlexedDiv = createStyled("div", {
  target: "e9l0v1x0"
})("&&{display:flex;& > div{display:flex;align-items:center;flex:1;& > * + *{margin-left:", spacer(2), ";}}}");
const FootCell = /* @__PURE__ */ createStyled(Cell$1, {
  target: "e9l0v1x1"
})("&&{padding:", spacer(2), " 0;}");
const defaultPaginatedRenderResultCounts$1 = ({
  pageStartRow,
  pageEndRow,
  totalNumRows
}) => `Showing ${pageStartRow}\u2013${pageEndRow} of ${totalNumRows}`;
const defaultRenderResultCounts$1 = ({
  totalNumRows
}) => `Showing ${totalNumRows} records`;
const defaultRenderPageNavigationText = ({
  currentPage,
  pageCount
}) => `
  ${currentPage} of ${pageCount}
`;
const defaultRenderPageJumpToText = () => "Go to page:";
const defaultRenderPageJumpToButtonText = () => "Go";
function Foot(props) {
  const [gotoPageValue, setGotoPageValue] = useState(void 0);
  const _a2 = props, {
    numCols,
    totalNumRows = 0,
    pageIndex = 0,
    pageSize = 0,
    pageCount = 0,
    gotoPage = () => {
    },
    canPreviousPage = false,
    previousPage = () => {
    },
    canNextPage = false,
    nextPage = () => {
    },
    renderResultCounts = pageCount > 0 ? defaultPaginatedRenderResultCounts$1 : defaultRenderResultCounts$1,
    renderPageNavigationText = defaultRenderPageNavigationText,
    renderPageJumpToText = defaultRenderPageJumpToText,
    renderPageJumpToButtonText = defaultRenderPageJumpToButtonText
  } = _a2, rest = __objRest(_a2, [
    "numCols",
    "totalNumRows",
    "pageIndex",
    "pageSize",
    "pageCount",
    "gotoPage",
    "canPreviousPage",
    "previousPage",
    "canNextPage",
    "nextPage",
    "renderResultCounts",
    "renderPageNavigationText",
    "renderPageJumpToText",
    "renderPageJumpToButtonText"
  ]);
  const pageStartRow = pageIndex * pageSize + 1;
  const pageEndRow = Math.min(pageStartRow + pageSize - 1, totalNumRows);
  const handleInputChange = (e2) => {
    setGotoPageValue(e2.target.value === "" ? void 0 : Math.floor(e2.target.value));
  };
  const callGotoPage = () => {
    const maxIndex = pageCount - 1;
    const newIndex = gotoPageValue - 1;
    const clampedIndex = Math.min(maxIndex, Math.max(0, newIndex));
    setGotoPageValue(clampedIndex + 1);
    gotoPage(clampedIndex);
  };
  const maybeRenderPagination = () => {
    if (pageCount <= 0)
      return null;
    return /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsxs("div", {
        style: {
          justifyContent: "center"
        },
        children: [/* @__PURE__ */ jsx(Button$1, {
          kind: "ghost",
          onClick: previousPage,
          disabled: !canPreviousPage,
          children: /* @__PURE__ */ jsx(Chevron$1, {
            size: "s",
            direction: "left"
          })
        }), /* @__PURE__ */ jsx("div", {
          children: renderPageNavigationText({
            currentPage: pageIndex + 1,
            pageCount
          })
        }), /* @__PURE__ */ jsx(Button$1, {
          kind: "ghost",
          onClick: nextPage,
          disabled: !canNextPage,
          children: /* @__PURE__ */ jsx(Chevron$1, {
            size: "s",
            direction: "right"
          })
        })]
      }), /* @__PURE__ */ jsxs("div", {
        style: {
          justifyContent: "flex-end"
        },
        children: [/* @__PURE__ */ jsx("div", {
          children: renderPageJumpToText()
        }), /* @__PURE__ */ jsx(Input$1, {
          min: "0",
          max: pageCount,
          type: "number",
          value: gotoPageValue,
          onChange: handleInputChange,
          onKeyPress: (e2) => e2.key === "Enter" && callGotoPage()
        }), /* @__PURE__ */ jsxs(Button$1, {
          kind: "utility",
          onClick: callGotoPage,
          children: [renderPageJumpToButtonText(), " ", /* @__PURE__ */ jsx(Chevron$1, {
            size: "s",
            direction: "right"
          })]
        })]
      })]
    });
  };
  return /* @__PURE__ */ jsx("tfoot", __spreadProps(__spreadValues({}, rest), {
    children: /* @__PURE__ */ jsx(Row, {
      noBorder: true,
      children: /* @__PURE__ */ jsx(FootCell, {
        colSpan: numCols,
        children: /* @__PURE__ */ jsxs(FlexedDiv, {
          children: [/* @__PURE__ */ jsx("div", {
            children: renderResultCounts({
              pageStartRow,
              pageEndRow,
              totalNumRows
            })
          }), maybeRenderPagination()]
        })
      })
    })
  }));
}
Foot.propTypes = {
  numCols: PropTypes$2.number,
  totalNumRows: PropTypes$2.number,
  pageCount: PropTypes$2.number,
  canPreviousPage: PropTypes$2.bool,
  canNextPage: PropTypes$2.bool,
  pageIndex: PropTypes$2.number,
  pageSize: PropTypes$2.number,
  gotoPage: PropTypes$2.func,
  previousPage: PropTypes$2.func,
  nextPage: PropTypes$2.func,
  renderResultCounts: PropTypes$2.func,
  renderPageNavigationText: PropTypes$2.func,
  renderPageJumpToText: PropTypes$2.func,
  renderPageJumpToButtonText: PropTypes$2.func
};
const Head = createStyled("thead", {
  target: "e1hmyn6e0"
})("background-color:", transparentize("black", 0.07), ";", fontSize("xxs"), "");
const AscendingSortPath = (props) => /* @__PURE__ */ jsx("path", __spreadProps(__spreadValues({}, props), {
  d: "M4,5H1.5C1.1,5,0.9,4.5,1.1,4.2l1.1-1.3l1.4-1.7C3.8,1,4.2,1,4.4,1.2l1.4,1.7l1.1,1.3C7.1,4.5,6.9,5,6.5,5H4z"
}));
const DescendingSortPath = (props) => /* @__PURE__ */ jsx("path", __spreadProps(__spreadValues({}, props), {
  d: "M4,7h2.5c0.4,0,0.7,0.5,0.4,0.8L5.8,9.1l-1.4,1.7c-0.2,0.2-0.6,0.2-0.8,0L2.2,9.1L1.1,7.8C0.9,7.5,1.1,7,1.5,7H4z"
}));
const UnsortedPath = (props) => /* @__PURE__ */ jsxs(Fragment, {
  children: [/* @__PURE__ */ jsx(DescendingSortPath, __spreadValues({}, props)), /* @__PURE__ */ jsx(AscendingSortPath, __spreadValues({}, props))]
});
const getViewBox = {
  asc: "0 0 8 8",
  desc: "0 4 8 12",
  unsorted: "0 0 8 12"
};
const SortIconV2 = (_Db) => {
  var _Eb = _Db, {
    sort,
    fill,
    size: size2 = "s"
  } = _Eb, props = __objRest(_Eb, [
    "sort",
    "fill",
    "size"
  ]);
  return /* @__PURE__ */ jsx(SVGIconV2, __spreadProps(__spreadValues({}, props), {
    size: size2,
    viewBox: getViewBox[sort] || getViewBox["unsorted"],
    children: sort === "asc" ? /* @__PURE__ */ jsx(AscendingSortPath, {
      fill: fill || "#626263"
    }) : sort === "desc" ? /* @__PURE__ */ jsx(DescendingSortPath, {
      fill: fill || "#626263"
    }) : /* @__PURE__ */ jsx(UnsortedPath, {
      fill: fill || "#c9cbcc"
    })
  }));
};
const SortLabel = /* @__PURE__ */ createStyled(SortIconV2, {
  target: "e1f90yas0"
})({
  name: "14bp983",
  styles: "&&{flex-shrink:0;}"
});
const sortLabelCss = ({
  textAlign,
  theme
}) => textAlign === "right" ? /* @__PURE__ */ css("padding-right:", spacer(2, {
  theme
}), ";") : /* @__PURE__ */ css("padding-left:", spacer(2, {
  theme
}), ";");
const Cell = /* @__PURE__ */ createStyled(Cell$1, {
  target: "e1kis920"
})("&&{", fontWeight("medium"), " color:#626262;", SortLabel, "{", sortLabelCss, "}}");
const CellContentFlexed = createStyled("div", {
  target: "e1kis921"
})("&&{display:flex;justify-content:", ({
  alignedRight
}) => alignedRight ? "flex-end" : "flex-start", ";}");
const CellTextWrapper = createStyled("div", {
  target: "e1kis922"
})({
  name: "9n0386",
  styles: "&&{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"
});
function HeadCell(props) {
  const _a2 = props, {
    isSorted = false,
    isSortedDesc = false,
    canSort = false,
    children = null
  } = _a2, rest = __objRest(_a2, [
    "isSorted",
    "isSortedDesc",
    "canSort",
    "children"
  ]);
  const maybeRenderSortLabel = () => {
    if (!canSort)
      return null;
    return /* @__PURE__ */ jsx(SortLabel, {
      sort: isSorted ? isSortedDesc ? "desc" : "asc" : false
    });
  };
  const alignedRight = rest.textAlign === "right";
  return /* @__PURE__ */ jsx(Cell, __spreadProps(__spreadValues({
    highlightOnHover: canSort,
    highlighted: isSorted
  }, rest), {
    as: "th",
    children: /* @__PURE__ */ jsxs(CellContentFlexed, {
      alignedRight,
      children: [alignedRight && maybeRenderSortLabel(), /* @__PURE__ */ jsx(CellTextWrapper, {
        children
      }), !alignedRight && maybeRenderSortLabel()]
    })
  }));
}
HeadCell.propTypes = __spreadProps(__spreadValues({}, Cell.propTypes), {
  isSorted: PropTypes$2.bool,
  isSortedDesc: PropTypes$2.bool,
  canSort: PropTypes$2.bool
});
function RowSpacer(_Fb) {
  var _Gb = _Fb, {
    numRows = 0,
    numCols = 0
  } = _Gb, rest = __objRest(_Gb, [
    "numRows",
    "numCols"
  ]);
  const blankRows = [];
  for (let i = 0; i < numRows; i++) {
    blankRows.push(/* @__PURE__ */ jsx(Row, {
      style: i !== numRows - 1 ? {
        borderBottomColor: "transparent"
      } : {},
      children: /* @__PURE__ */ jsx(Cell$1, __spreadProps(__spreadValues({}, rest), {
        colSpan: numCols,
        children: "\xA0"
      }))
    }, i));
  }
  return blankRows;
}
RowSpacer.propTypes = __spreadProps(__spreadValues({}, Cell$1.propTypes), {
  numRows: PropTypes$2.number,
  numCols: PropTypes$2.number
});
const ToolbarContainer = createStyled("div", {
  target: "e11zi3s90"
})({
  name: "1lekzkb",
  styles: "display:flex;align-items:center;justify-content:space-between;"
});
const ToolbarButtons = createStyled("div", {
  target: "e11zi3s91"
})("background-color:#2473db;button{background:0;border:0;padding:", spacer(2), " ", spacer(3), ";color:white;", fontSize("xs"), " &:hover{background-color:rgba(255,255,255,0.1);cursor:pointer;}&:focus,&:active{outline:0;}&.focus-visible{outline:1;}}");
const defaultPaginatedRenderResultCounts = ({
  pageStartRow,
  pageEndRow,
  totalNumRows
}) => `Showing ${pageStartRow}\u2013${pageEndRow} of ${totalNumRows}`;
const defaultRenderResultCounts = ({
  totalNumRows
}) => `Showing ${totalNumRows} records`;
function Toolbar({
  buttonContent = "DEFAULT",
  buttonOnClick = () => {
  },
  pageIndex = 0,
  pageSize = 0,
  pageCount = 0,
  totalNumRows = 0,
  renderResultCounts = pageCount > 0 ? defaultPaginatedRenderResultCounts : defaultRenderResultCounts
}) {
  const pageStartRow = pageIndex * pageSize + 1;
  const pageEndRow = Math.min(pageStartRow + pageSize - 1, totalNumRows);
  return /* @__PURE__ */ jsxs(ToolbarContainer, {
    children: [renderResultCounts({
      pageStartRow,
      pageEndRow,
      totalNumRows
    }), /* @__PURE__ */ jsx(ToolbarButtons, {
      children: /* @__PURE__ */ jsx("button", {
        onClick: buttonOnClick,
        children: buttonContent
      })
    })]
  });
}
Toolbar.propTypes = {
  buttonContent: PropTypes$2.string,
  buttonOnClick: PropTypes$2.func,
  pageIndex: PropTypes$2.number,
  pageSize: PropTypes$2.number,
  pageCount: PropTypes$2.number,
  totalNumRows: PropTypes$2.number,
  renderResultCounts: PropTypes$2.func
};
var reactTable = { exports: {} };
var reactTable_production_min = { exports: {} };
(function(module2, exports) {
  !function(e2, t2) {
    t2(exports, React__default);
  }(commonjsGlobal, function(e2, t2) {
    function n2(e3, t3, n3, o2, r3, i2, u3) {
      try {
        var l3 = e3[i2](u3), s2 = l3.value;
      } catch (e4) {
        return void n3(e4);
      }
      l3.done ? t3(s2) : Promise.resolve(s2).then(o2, r3);
    }
    function o(e3) {
      return function() {
        var t3 = this, o2 = arguments;
        return new Promise(function(r3, i2) {
          var u3 = e3.apply(t3, o2);
          function l3(e4) {
            n2(u3, r3, i2, l3, s2, "next", e4);
          }
          function s2(e4) {
            n2(u3, r3, i2, l3, s2, "throw", e4);
          }
          l3(void 0);
        });
      };
    }
    function r2() {
      return (r2 = Object.assign || function(e3) {
        for (var t3 = 1; t3 < arguments.length; t3++) {
          var n3 = arguments[t3];
          for (var o2 in n3)
            Object.prototype.hasOwnProperty.call(n3, o2) && (e3[o2] = n3[o2]);
        }
        return e3;
      }).apply(this, arguments);
    }
    function i(e3, t3) {
      if (e3 == null)
        return {};
      var n3, o2, r3 = {}, i2 = Object.keys(e3);
      for (o2 = 0; o2 < i2.length; o2++)
        n3 = i2[o2], t3.indexOf(n3) >= 0 || (r3[n3] = e3[n3]);
      return r3;
    }
    function u2(e3) {
      var t3 = function(e4, t4) {
        if (typeof e4 != "object" || e4 === null)
          return e4;
        var n3 = e4[Symbol.toPrimitive];
        if (n3 !== void 0) {
          var o2 = n3.call(e4, t4 || "default");
          if (typeof o2 != "object")
            return o2;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (t4 === "string" ? String : Number)(e4);
      }(e3, "string");
      return typeof t3 == "symbol" ? t3 : String(t3);
    }
    t2 = t2 && Object.prototype.hasOwnProperty.call(t2, "default") ? t2.default : t2;
    var l2 = { init: "init" }, s = function(e3) {
      var t3 = e3.value;
      return t3 === void 0 ? "" : t3;
    }, a = function() {
      return t2.createElement(t2.Fragment, null, "\xA0");
    }, c2 = { Cell: s, width: 150, minWidth: 0, maxWidth: Number.MAX_SAFE_INTEGER };
    function d2() {
      for (var e3 = arguments.length, t3 = new Array(e3), n3 = 0; n3 < e3; n3++)
        t3[n3] = arguments[n3];
      return t3.reduce(function(e4, t4) {
        var n4 = t4.style, o2 = t4.className;
        return e4 = r2({}, e4, {}, i(t4, ["style", "className"])), n4 && (e4.style = e4.style ? r2({}, e4.style || {}, {}, n4 || {}) : n4), o2 && (e4.className = e4.className ? e4.className + " " + o2 : o2), e4.className === "" && delete e4.className, e4;
      }, {});
    }
    var f2 = function(e3, t3) {
      return t3 === void 0 && (t3 = {}), function(n3) {
        return n3 === void 0 && (n3 = {}), [].concat(e3, [n3]).reduce(function(e4, o2) {
          return function e5(t4, n4, o3) {
            return typeof n4 == "function" ? e5({}, n4(t4, o3)) : Array.isArray(n4) ? d2.apply(void 0, [t4].concat(n4)) : d2(t4, n4);
          }(e4, o2, r2({}, t3, { userProps: n3 }));
        }, {});
      };
    }, p2 = function(e3, t3, n3, o2) {
      return n3 === void 0 && (n3 = {}), e3.reduce(function(e4, t4) {
        return t4(e4, n3);
      }, t3);
    }, g2 = function(e3, t3, n3) {
      return n3 === void 0 && (n3 = {}), e3.forEach(function(e4) {
        e4(t3, n3);
      });
    };
    function v2(e3, t3, n3, o2) {
      e3.findIndex(function(e4) {
        return e4.pluginName === n3;
      });
      t3.forEach(function(t4) {
        e3.findIndex(function(e4) {
          return e4.pluginName === t4;
        });
      });
    }
    function m2(e3, t3) {
      return typeof e3 == "function" ? e3(t3) : e3;
    }
    function h2(e3) {
      var n3 = t2.useRef();
      return n3.current = e3, t2.useCallback(function() {
        return n3.current;
      }, []);
    }
    var y2 = typeof document != "undefined" ? t2.useLayoutEffect : t2.useEffect;
    function w2(e3, n3) {
      var o2 = t2.useRef(false);
      y2(function() {
        o2.current && e3(), o2.current = true;
      }, n3);
    }
    function R(e3, t3, n3) {
      return n3 === void 0 && (n3 = {}), function(o2, i2) {
        i2 === void 0 && (i2 = {});
        var u3 = typeof o2 == "string" ? t3[o2] : o2;
        if (u3 === void 0)
          throw console.info(t3), new Error("Renderer Error \u261D\uFE0F");
        return b2(u3, r2({}, e3, { column: t3 }, n3, {}, i2));
      };
    }
    function b2(e3, n3) {
      return function(e4) {
        return typeof e4 == "function" && ((t3 = Object.getPrototypeOf(e4)).prototype && t3.prototype.isReactComponent);
        var t3;
      }(o2 = e3) || typeof o2 == "function" || function(e4) {
        return typeof e4 == "object" && typeof e4.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e4.$$typeof.description);
      }(o2) ? t2.createElement(e3, n3) : e3;
      var o2;
    }
    function S(e3, t3, n3) {
      return n3 === void 0 && (n3 = 0), e3.map(function(e4) {
        return P(e4 = r2({}, e4, { parent: t3, depth: n3 })), e4.columns && (e4.columns = S(e4.columns, e4, n3 + 1)), e4;
      });
    }
    function C2(e3) {
      return G2(e3, "columns");
    }
    function P(e3) {
      var t3 = e3.id, n3 = e3.accessor, o2 = e3.Header;
      if (typeof n3 == "string") {
        t3 = t3 || n3;
        var r3 = n3.split(".");
        n3 = function(e4) {
          return function(e5, t4, n4) {
            if (!t4)
              return e5;
            var o3, r4 = typeof t4 == "function" ? t4 : JSON.stringify(t4), i2 = E2.get(r4) || function() {
              var e6 = function(e7) {
                return function e8(t5, n5) {
                  n5 === void 0 && (n5 = []);
                  if (Array.isArray(t5))
                    for (var o4 = 0; o4 < t5.length; o4 += 1)
                      e8(t5[o4], n5);
                  else
                    n5.push(t5);
                  return n5;
                }(e7).map(function(e8) {
                  return String(e8).replace(".", "_");
                }).join(".").replace(z2, ".").replace(W, "").split(".");
              }(t4);
              return E2.set(r4, e6), e6;
            }();
            try {
              o3 = i2.reduce(function(e6, t5) {
                return e6[t5];
              }, e5);
            } catch (e6) {
            }
            return o3 !== void 0 ? o3 : n4;
          }(e4, r3);
        };
      }
      if (!t3 && typeof o2 == "string" && o2 && (t3 = o2), !t3 && e3.columns)
        throw console.error(e3), new Error('A column ID (or unique "Header" value) is required!');
      if (!t3)
        throw console.error(e3), new Error("A column ID (or string accessor) is required!");
      return Object.assign(e3, { id: t3, accessor: n3 }), e3;
    }
    function x(e3, t3) {
      if (!t3)
        throw new Error();
      return Object.assign(e3, r2({ Header: a, Footer: a }, c2, {}, t3, {}, e3)), Object.assign(e3, { originalWidth: e3.width }), e3;
    }
    function B2(e3, t3, n3) {
      n3 === void 0 && (n3 = function() {
        return {};
      });
      for (var o2 = [], i2 = e3, u3 = 0, l3 = function() {
        return u3++;
      }, s2 = function() {
        var e4 = { headers: [] }, u4 = [], s3 = i2.some(function(e5) {
          return e5.parent;
        });
        i2.forEach(function(o3) {
          var i3, a2 = [].concat(u4).reverse()[0];
          if (s3) {
            if (o3.parent)
              i3 = r2({}, o3.parent, { originalId: o3.parent.id, id: o3.parent.id + "_" + l3(), headers: [o3] }, n3(o3));
            else
              i3 = x(r2({ originalId: o3.id + "_placeholder", id: o3.id + "_placeholder_" + l3(), placeholderOf: o3, headers: [o3] }, n3(o3)), t3);
            a2 && a2.originalId === i3.originalId ? a2.headers.push(o3) : u4.push(i3);
          }
          e4.headers.push(o3);
        }), o2.push(e4), i2 = u4;
      }; i2.length; )
        s2();
      return o2.reverse();
    }
    var E2 = /* @__PURE__ */ new Map();
    function I2() {
      for (var e3 = arguments.length, t3 = new Array(e3), n3 = 0; n3 < e3; n3++)
        t3[n3] = arguments[n3];
      for (var o2 = 0; o2 < t3.length; o2 += 1)
        if (t3[o2] !== void 0)
          return t3[o2];
    }
    function F2(e3) {
      if (typeof e3 == "function")
        return e3;
    }
    function G2(e3, t3) {
      var n3 = [];
      return function e4(o2) {
        o2.forEach(function(o3) {
          o3[t3] ? e4(o3[t3]) : n3.push(o3);
        });
      }(e3), n3;
    }
    function A2(e3, t3) {
      var n3 = t3.manualExpandedKey, o2 = t3.expanded, r3 = t3.expandSubRows, i2 = r3 === void 0 || r3, u3 = [];
      return e3.forEach(function e4(t4) {
        t4.isExpanded = t4.original && t4.original[n3] || o2[t4.id], t4.canExpand = t4.subRows && !!t4.subRows.length, u3.push(t4), i2 && t4.subRows && t4.subRows.length && t4.isExpanded && t4.subRows.forEach(e4);
      }), u3;
    }
    function k2(e3, t3, n3) {
      return F2(e3) || t3[e3] || n3[e3] || n3.text;
    }
    function H2(e3, t3, n3) {
      return e3 ? e3(t3, n3) : t3 === void 0;
    }
    function T() {
      throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.");
    }
    var O = null;
    var z2 = /\[/g, W = /\]/g;
    var M = function(e3) {
      return r2({ role: "table" }, e3);
    }, j = function(e3) {
      return r2({ role: "rowgroup" }, e3);
    }, N = function(e3, t3) {
      var n3 = t3.column;
      return r2({ key: "header_" + n3.id, colSpan: n3.totalVisibleHeaderCount, role: "columnheader" }, e3);
    }, D2 = function(e3, t3) {
      var n3 = t3.column;
      return r2({ key: "footer_" + n3.id, colSpan: n3.totalVisibleHeaderCount }, e3);
    }, V = function(e3, t3) {
      return r2({ key: "headerGroup_" + t3.index, role: "row" }, e3);
    }, _ = function(e3, t3) {
      return r2({ key: "footerGroup_" + t3.index }, e3);
    }, L = function(e3, t3) {
      return r2({ key: "row_" + t3.row.id, role: "row" }, e3);
    }, X = function(e3, t3) {
      var n3 = t3.cell;
      return r2({ key: "cell_" + n3.row.id + "_" + n3.column.id, role: "cell" }, e3);
    };
    function q2() {
      return { useOptions: [], stateReducers: [], useControlledState: [], columns: [], columnsDeps: [], allColumns: [], allColumnsDeps: [], accessValue: [], materializedColumns: [], materializedColumnsDeps: [], useInstanceAfterData: [], visibleColumns: [], visibleColumnsDeps: [], headerGroups: [], headerGroupsDeps: [], useInstanceBeforeDimensions: [], useInstance: [], prepareRow: [], getTableProps: [M], getTableBodyProps: [j], getHeaderGroupProps: [V], getFooterGroupProps: [_], getHeaderProps: [N], getFooterProps: [D2], getRowProps: [L], getCellProps: [X], useFinalInstance: [] };
    }
    l2.resetHiddenColumns = "resetHiddenColumns", l2.toggleHideColumn = "toggleHideColumn", l2.setHiddenColumns = "setHiddenColumns", l2.toggleHideAllColumns = "toggleHideAllColumns";
    var K = function(e3) {
      e3.getToggleHiddenProps = [U], e3.getToggleHideAllColumnsProps = [$], e3.stateReducers.push(J), e3.useInstanceBeforeDimensions.push(Y), e3.headerGroupsDeps.push(function(e4, t3) {
        var n3 = t3.instance;
        return [].concat(e4, [n3.state.hiddenColumns]);
      }), e3.useInstance.push(Q);
    };
    K.pluginName = "useColumnVisibility";
    var U = function(e3, t3) {
      var n3 = t3.column;
      return [e3, { onChange: function(e4) {
        n3.toggleHidden(!e4.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isVisible, title: "Toggle Column Visible" }];
    }, $ = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onChange: function(e4) {
        n3.toggleHideAllColumns(!e4.target.checked);
      }, style: { cursor: "pointer" }, checked: !n3.allColumnsHidden && !n3.state.hiddenColumns.length, title: "Toggle All Columns Hidden", indeterminate: !n3.allColumnsHidden && n3.state.hiddenColumns.length }];
    };
    function J(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ hiddenColumns: [] }, e3);
      if (t3.type === l2.resetHiddenColumns)
        return r2({}, e3, { hiddenColumns: o2.initialState.hiddenColumns || [] });
      if (t3.type === l2.toggleHideColumn) {
        var i2 = (t3.value !== void 0 ? t3.value : !e3.hiddenColumns.includes(t3.columnId)) ? [].concat(e3.hiddenColumns, [t3.columnId]) : e3.hiddenColumns.filter(function(e4) {
          return e4 !== t3.columnId;
        });
        return r2({}, e3, { hiddenColumns: i2 });
      }
      return t3.type === l2.setHiddenColumns ? r2({}, e3, { hiddenColumns: m2(t3.value, e3.hiddenColumns) }) : t3.type === l2.toggleHideAllColumns ? r2({}, e3, { hiddenColumns: (t3.value !== void 0 ? t3.value : !e3.hiddenColumns.length) ? o2.allColumns.map(function(e4) {
        return e4.id;
      }) : [] }) : void 0;
    }
    function Y(e3) {
      var n3 = e3.headers, o2 = e3.state.hiddenColumns;
      t2.useRef(false).current;
      var r3 = 0;
      n3.forEach(function(e4) {
        return r3 += function e5(t3, n4) {
          t3.isVisible = n4 && !o2.includes(t3.id);
          var r4 = 0;
          return t3.headers && t3.headers.length ? t3.headers.forEach(function(n5) {
            return r4 += e5(n5, t3.isVisible);
          }) : r4 = t3.isVisible ? 1 : 0, t3.totalVisibleHeaderCount = r4, r4;
        }(e4, true);
      });
    }
    function Q(e3) {
      var n3 = e3.columns, o2 = e3.flatHeaders, r3 = e3.dispatch, i2 = e3.allColumns, u3 = e3.getHooks, s2 = e3.state.hiddenColumns, a2 = e3.autoResetHiddenColumns, c3 = a2 === void 0 || a2, d3 = h2(e3), p3 = i2.length === s2.length, g3 = t2.useCallback(function(e4, t3) {
        return r3({ type: l2.toggleHideColumn, columnId: e4, value: t3 });
      }, [r3]), v3 = t2.useCallback(function(e4) {
        return r3({ type: l2.setHiddenColumns, value: e4 });
      }, [r3]), m3 = t2.useCallback(function(e4) {
        return r3({ type: l2.toggleHideAllColumns, value: e4 });
      }, [r3]), y3 = f2(u3().getToggleHideAllColumnsProps, { instance: d3() });
      o2.forEach(function(e4) {
        e4.toggleHidden = function(t3) {
          r3({ type: l2.toggleHideColumn, columnId: e4.id, value: t3 });
        }, e4.getToggleHiddenProps = f2(u3().getToggleHiddenProps, { instance: d3(), column: e4 });
      });
      var R2 = h2(c3);
      w2(function() {
        R2() && r3({ type: l2.resetHiddenColumns });
      }, [r3, n3]), Object.assign(e3, { allColumnsHidden: p3, toggleHideColumn: g3, setHiddenColumns: v3, toggleHideAllColumns: m3, getToggleHideAllColumnsProps: y3 });
    }
    var Z = {}, ee = {}, te = function(e3, t3, n3) {
      return e3;
    }, ne = function(e3, t3) {
      return e3.subRows || [];
    }, oe = function(e3, t3, n3) {
      return "" + (n3 ? [n3.id, t3].join(".") : t3);
    }, re = function(e3) {
      return e3;
    };
    function ie(e3) {
      var t3 = e3.initialState, n3 = t3 === void 0 ? Z : t3, o2 = e3.defaultColumn, u3 = o2 === void 0 ? ee : o2, l3 = e3.getSubRows, s2 = l3 === void 0 ? ne : l3, a2 = e3.getRowId, c3 = a2 === void 0 ? oe : a2, d3 = e3.stateReducer, f3 = d3 === void 0 ? te : d3, p3 = e3.useControlledState, g3 = p3 === void 0 ? re : p3;
      return r2({}, i(e3, ["initialState", "defaultColumn", "getSubRows", "getRowId", "stateReducer", "useControlledState"]), { initialState: n3, defaultColumn: u3, getSubRows: s2, getRowId: c3, stateReducer: f3, useControlledState: g3 });
    }
    function ue(e3, t3) {
      t3 === void 0 && (t3 = 0);
      var n3 = 0, o2 = 0, r3 = 0, i2 = 0;
      return e3.forEach(function(e4) {
        var u3 = e4.headers;
        if (e4.totalLeft = t3, u3 && u3.length) {
          var l3 = ue(u3, t3), s2 = l3[0], a2 = l3[1], c3 = l3[2], d3 = l3[3];
          e4.totalMinWidth = s2, e4.totalWidth = a2, e4.totalMaxWidth = c3, e4.totalFlexWidth = d3;
        } else
          e4.totalMinWidth = e4.minWidth, e4.totalWidth = Math.min(Math.max(e4.minWidth, e4.width), e4.maxWidth), e4.totalMaxWidth = e4.maxWidth, e4.totalFlexWidth = e4.canResize ? e4.totalWidth : 0;
        e4.isVisible && (t3 += e4.totalWidth, n3 += e4.totalMinWidth, o2 += e4.totalWidth, r3 += e4.totalMaxWidth, i2 += e4.totalFlexWidth);
      }), [n3, o2, r3, i2];
    }
    function le(e3) {
      var t3 = e3.data, n3 = e3.rows, o2 = e3.flatRows, r3 = e3.rowsById, i2 = e3.column, u3 = e3.getRowId, l3 = e3.getSubRows, s2 = e3.accessValueHooks, a2 = e3.getInstance;
      t3.forEach(function(e4, t4) {
        return function e5(t5, n4, c3, d3, f3) {
          c3 === void 0 && (c3 = 0);
          var g3 = t5, v3 = u3(t5, n4, d3), m3 = r3[v3];
          if (m3)
            m3.subRows && m3.originalSubRows.forEach(function(t6, n5) {
              return e5(t6, n5, c3 + 1, m3);
            });
          else if ((m3 = { id: v3, original: g3, index: n4, depth: c3, cells: [{}] }).cells.map = T, m3.cells.filter = T, m3.cells.forEach = T, m3.cells[0].getCellProps = T, m3.values = {}, f3.push(m3), o2.push(m3), r3[v3] = m3, m3.originalSubRows = l3(t5, n4), m3.originalSubRows) {
            var h3 = [];
            m3.originalSubRows.forEach(function(t6, n5) {
              return e5(t6, n5, c3 + 1, m3, h3);
            }), m3.subRows = h3;
          }
          i2.accessor && (m3.values[i2.id] = i2.accessor(t5, n4, m3)), m3.values[i2.id] = p2(s2, m3.values[i2.id], { row: m3, column: i2, instance: a2() });
        }(e4, t4, 0, void 0, n3);
      });
    }
    l2.resetExpanded = "resetExpanded", l2.toggleRowExpanded = "toggleRowExpanded", l2.toggleAllRowsExpanded = "toggleAllRowsExpanded";
    var se = function(e3) {
      e3.getToggleAllRowsExpandedProps = [ae], e3.getToggleRowExpandedProps = [ce], e3.stateReducers.push(de), e3.useInstance.push(fe), e3.prepareRow.push(pe);
    };
    se.pluginName = "useExpanded";
    var ae = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onClick: function(e4) {
        n3.toggleAllRowsExpanded();
      }, style: { cursor: "pointer" }, title: "Toggle All Rows Expanded" }];
    }, ce = function(e3, t3) {
      var n3 = t3.row;
      return [e3, { onClick: function() {
        n3.toggleRowExpanded();
      }, style: { cursor: "pointer" }, title: "Toggle Row Expanded" }];
    };
    function de(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ expanded: {} }, e3);
      if (t3.type === l2.resetExpanded)
        return r2({}, e3, { expanded: o2.initialState.expanded || {} });
      if (t3.type === l2.toggleAllRowsExpanded) {
        var s2 = t3.value, a2 = o2.isAllRowsExpanded, c3 = o2.rowsById;
        if (s2 !== void 0 ? s2 : !a2) {
          var d3 = {};
          return Object.keys(c3).forEach(function(e4) {
            d3[e4] = true;
          }), r2({}, e3, { expanded: d3 });
        }
        return r2({}, e3, { expanded: {} });
      }
      if (t3.type === l2.toggleRowExpanded) {
        var f3, p3 = t3.id, g3 = t3.value, v3 = e3.expanded[p3], m3 = g3 !== void 0 ? g3 : !v3;
        if (!v3 && m3)
          return r2({}, e3, { expanded: r2({}, e3.expanded, (f3 = {}, f3[p3] = true, f3)) });
        if (v3 && !m3) {
          var h3 = e3.expanded;
          h3[p3];
          return r2({}, e3, { expanded: i(h3, [p3].map(u2)) });
        }
        return e3;
      }
    }
    function fe(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.rowsById, i2 = e3.manualExpandedKey, u3 = i2 === void 0 ? "expanded" : i2, s2 = e3.paginateExpandedRows, a2 = s2 === void 0 || s2, c3 = e3.expandSubRows, d3 = c3 === void 0 || c3, p3 = e3.autoResetExpanded, g3 = p3 === void 0 || p3, m3 = e3.getHooks, y3 = e3.plugins, R2 = e3.state.expanded, b3 = e3.dispatch;
      v2(y3, ["useSortBy", "useGroupBy", "usePivotColumns", "useGlobalFilter"], "useExpanded");
      var S2 = h2(g3), C3 = Boolean(Object.keys(r3).length && Object.keys(R2).length);
      C3 && Object.keys(r3).some(function(e4) {
        return !R2[e4];
      }) && (C3 = false), w2(function() {
        S2() && b3({ type: l2.resetExpanded });
      }, [b3, n3]);
      var P2 = t2.useCallback(function(e4, t3) {
        b3({ type: l2.toggleRowExpanded, id: e4, value: t3 });
      }, [b3]), x2 = t2.useCallback(function(e4) {
        return b3({ type: l2.toggleAllRowsExpanded, value: e4 });
      }, [b3]), B3 = t2.useMemo(function() {
        return a2 ? A2(o2, { manualExpandedKey: u3, expanded: R2, expandSubRows: d3 }) : o2;
      }, [a2, o2, u3, R2, d3]), E3 = t2.useMemo(function() {
        return function(e4) {
          var t3 = 0;
          return Object.keys(e4).forEach(function(e5) {
            var n4 = e5.split(".");
            t3 = Math.max(t3, n4.length);
          }), t3;
        }(R2);
      }, [R2]), I3 = h2(e3), F3 = f2(m3().getToggleAllRowsExpandedProps, { instance: I3() });
      Object.assign(e3, { preExpandedRows: o2, expandedRows: B3, rows: B3, expandedDepth: E3, isAllRowsExpanded: C3, toggleRowExpanded: P2, toggleAllRowsExpanded: x2, getToggleAllRowsExpandedProps: F3 });
    }
    function pe(e3, t3) {
      var n3 = t3.instance.getHooks, o2 = t3.instance;
      e3.toggleRowExpanded = function(t4) {
        return o2.toggleRowExpanded(e3.id, t4);
      }, e3.getToggleRowExpandedProps = f2(n3().getToggleRowExpandedProps, { instance: o2, row: e3 });
    }
    var ge = function(e3, t3, n3) {
      return e3 = e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return String(o2).toLowerCase().includes(String(n3).toLowerCase());
        });
      });
    };
    ge.autoRemove = function(e3) {
      return !e3;
    };
    var ve = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return o2 === void 0 || String(o2).toLowerCase() === String(n3).toLowerCase();
        });
      });
    };
    ve.autoRemove = function(e3) {
      return !e3;
    };
    var me = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return o2 === void 0 || String(o2) === String(n3);
        });
      });
    };
    me.autoRemove = function(e3) {
      return !e3;
    };
    var he = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          return e4.values[t4].includes(n3);
        });
      });
    };
    he.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var ye = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return o2 && o2.length && n3.every(function(e5) {
            return o2.includes(e5);
          });
        });
      });
    };
    ye.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var we = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return o2 && o2.length && n3.some(function(e5) {
            return o2.includes(e5);
          });
        });
      });
    };
    we.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var Re = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var o2 = e4.values[t4];
          return n3.includes(o2);
        });
      });
    };
    Re.autoRemove = function(e3) {
      return !e3 || !e3.length;
    };
    var be = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          return e4.values[t4] === n3;
        });
      });
    };
    be.autoRemove = function(e3) {
      return e3 === void 0;
    };
    var Se = function(e3, t3, n3) {
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          return e4.values[t4] == n3;
        });
      });
    };
    Se.autoRemove = function(e3) {
      return e3 == null;
    };
    var Ce = function(e3, t3, n3) {
      var o2 = n3 || [], r3 = o2[0], i2 = o2[1];
      if ((r3 = typeof r3 == "number" ? r3 : -1 / 0) > (i2 = typeof i2 == "number" ? i2 : 1 / 0)) {
        var u3 = r3;
        r3 = i2, i2 = u3;
      }
      return e3.filter(function(e4) {
        return t3.some(function(t4) {
          var n4 = e4.values[t4];
          return n4 >= r3 && n4 <= i2;
        });
      });
    };
    Ce.autoRemove = function(e3) {
      return !e3 || typeof e3[0] != "number" && typeof e3[1] != "number";
    };
    var Pe = Object.freeze({ __proto__: null, text: ge, exactText: ve, exactTextCase: me, includes: he, includesAll: ye, includesSome: we, includesValue: Re, exact: be, equals: Se, between: Ce });
    l2.resetFilters = "resetFilters", l2.setFilter = "setFilter", l2.setAllFilters = "setAllFilters";
    var xe = function(e3) {
      e3.stateReducers.push(Be), e3.useInstance.push(Ee);
    };
    function Be(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ filters: [] }, e3);
      if (t3.type === l2.resetFilters)
        return r2({}, e3, { filters: o2.initialState.filters || [] });
      if (t3.type === l2.setFilter) {
        var i2 = t3.columnId, u3 = t3.filterValue, s2 = o2.allColumns, a2 = o2.filterTypes, c3 = s2.find(function(e4) {
          return e4.id === i2;
        });
        if (!c3)
          throw new Error("React-Table: Could not find a column with id: " + i2);
        var d3 = k2(c3.filter, a2 || {}, Pe), f3 = e3.filters.find(function(e4) {
          return e4.id === i2;
        }), p3 = m2(u3, f3 && f3.value);
        return H2(d3.autoRemove, p3, c3) ? r2({}, e3, { filters: e3.filters.filter(function(e4) {
          return e4.id !== i2;
        }) }) : r2({}, e3, f3 ? { filters: e3.filters.map(function(e4) {
          return e4.id === i2 ? { id: i2, value: p3 } : e4;
        }) } : { filters: [].concat(e3.filters, [{ id: i2, value: p3 }]) });
      }
      if (t3.type === l2.setAllFilters) {
        var g3 = t3.filters, v3 = o2.allColumns, h3 = o2.filterTypes;
        return r2({}, e3, { filters: m2(g3, e3.filters).filter(function(e4) {
          var t4 = v3.find(function(t5) {
            return t5.id === e4.id;
          });
          return !H2(k2(t4.filter, h3 || {}, Pe).autoRemove, e4.value, t4);
        }) });
      }
    }
    function Ee(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.flatRows, i2 = e3.rowsById, u3 = e3.allColumns, s2 = e3.filterTypes, a2 = e3.manualFilters, c3 = e3.defaultCanFilter, d3 = c3 !== void 0 && c3, f3 = e3.disableFilters, p3 = e3.state.filters, g3 = e3.dispatch, v3 = e3.autoResetFilters, m3 = v3 === void 0 || v3, y3 = t2.useCallback(function(e4, t3) {
        g3({ type: l2.setFilter, columnId: e4, filterValue: t3 });
      }, [g3]), R2 = t2.useCallback(function(e4) {
        g3({ type: l2.setAllFilters, filters: e4 });
      }, [g3]);
      u3.forEach(function(e4) {
        var t3 = e4.id, n4 = e4.accessor, o3 = e4.defaultCanFilter, r4 = e4.disableFilters;
        e4.canFilter = n4 ? I2(r4 !== true && void 0, f3 !== true && void 0, true) : I2(o3, d3, false), e4.setFilter = function(t4) {
          return y3(e4.id, t4);
        };
        var i3 = p3.find(function(e5) {
          return e5.id === t3;
        });
        e4.filterValue = i3 && i3.value;
      });
      var b3 = t2.useMemo(function() {
        if (a2 || !p3.length)
          return [o2, r3, i2];
        var e4 = [], t3 = {};
        return [function n4(o3, r4) {
          r4 === void 0 && (r4 = 0);
          var i3 = o3;
          return (i3 = p3.reduce(function(e5, t4) {
            var n5 = t4.id, o4 = t4.value, i4 = u3.find(function(e6) {
              return e6.id === n5;
            });
            if (!i4)
              return e5;
            r4 === 0 && (i4.preFilteredRows = e5);
            var l3 = k2(i4.filter, s2 || {}, Pe);
            return l3 ? (i4.filteredRows = l3(e5, [n5], o4), i4.filteredRows) : (console.warn("Could not find a valid 'column.filter' for column with the ID: " + i4.id + "."), e5);
          }, o3)).forEach(function(o4) {
            e4.push(o4), t3[o4.id] = o4, o4.subRows && (o4.subRows = o4.subRows && o4.subRows.length > 0 ? n4(o4.subRows, r4 + 1) : o4.subRows);
          }), i3;
        }(o2), e4, t3];
      }, [a2, p3, o2, r3, i2, u3, s2]), S2 = b3[0], C3 = b3[1], P2 = b3[2];
      t2.useMemo(function() {
        u3.filter(function(e4) {
          return !p3.find(function(t3) {
            return t3.id === e4.id;
          });
        }).forEach(function(e4) {
          e4.preFilteredRows = S2, e4.filteredRows = S2;
        });
      }, [S2, p3, u3]);
      var x2 = h2(m3);
      w2(function() {
        x2() && g3({ type: l2.resetFilters });
      }, [g3, a2 ? null : n3]), Object.assign(e3, { preFilteredRows: o2, preFilteredFlatRows: r3, preFilteredRowsById: i2, filteredRows: S2, filteredFlatRows: C3, filteredRowsById: P2, rows: S2, flatRows: C3, rowsById: P2, setFilter: y3, setAllFilters: R2 });
    }
    xe.pluginName = "useFilters", l2.resetGlobalFilter = "resetGlobalFilter", l2.setGlobalFilter = "setGlobalFilter";
    var Ie = function(e3) {
      e3.stateReducers.push(Fe), e3.useInstance.push(Ge);
    };
    function Fe(e3, t3, n3, o2) {
      if (t3.type === l2.resetGlobalFilter)
        return r2({}, e3, { globalFilter: o2.initialState.globalFilter || void 0 });
      if (t3.type === l2.setGlobalFilter) {
        var u3 = t3.filterValue, s2 = o2.userFilterTypes, a2 = k2(o2.globalFilter, s2 || {}, Pe), c3 = m2(u3, e3.globalFilter);
        if (H2(a2.autoRemove, c3)) {
          e3.globalFilter;
          return i(e3, ["globalFilter"]);
        }
        return r2({}, e3, { globalFilter: c3 });
      }
    }
    function Ge(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.flatRows, i2 = e3.rowsById, u3 = e3.allColumns, s2 = e3.filterTypes, a2 = e3.globalFilter, c3 = e3.manualGlobalFilter, d3 = e3.state.globalFilter, f3 = e3.dispatch, p3 = e3.autoResetGlobalFilter, g3 = p3 === void 0 || p3, v3 = e3.disableGlobalFilter, m3 = t2.useCallback(function(e4) {
        f3({ type: l2.setGlobalFilter, filterValue: e4 });
      }, [f3]), y3 = t2.useMemo(function() {
        if (c3 || d3 === void 0)
          return [o2, r3, i2];
        var e4 = [], t3 = {}, n4 = k2(a2, s2 || {}, Pe);
        if (!n4)
          return console.warn("Could not find a valid 'globalFilter' option."), o2;
        u3.forEach(function(e5) {
          var t4 = e5.disableGlobalFilter;
          e5.canFilter = I2(t4 !== true && void 0, v3 !== true && void 0, true);
        });
        var l3 = u3.filter(function(e5) {
          return e5.canFilter === true;
        });
        return [function o3(r4) {
          return (r4 = n4(r4, l3.map(function(e5) {
            return e5.id;
          }), d3)).forEach(function(n5) {
            e4.push(n5), t3[n5.id] = n5, n5.subRows = n5.subRows && n5.subRows.length ? o3(n5.subRows) : n5.subRows;
          }), r4;
        }(o2), e4, t3];
      }, [c3, d3, a2, s2, u3, o2, r3, i2, v3]), R2 = y3[0], b3 = y3[1], S2 = y3[2], C3 = h2(g3);
      w2(function() {
        C3() && f3({ type: l2.resetGlobalFilter });
      }, [f3, c3 ? null : n3]), Object.assign(e3, { preGlobalFilteredRows: o2, preGlobalFilteredFlatRows: r3, preGlobalFilteredRowsById: i2, globalFilteredRows: R2, globalFilteredFlatRows: b3, globalFilteredRowsById: S2, rows: R2, flatRows: b3, rowsById: S2, setGlobalFilter: m3, disableGlobalFilter: v3 });
    }
    function Ae(e3, t3) {
      return t3.reduce(function(e4, t4) {
        return e4 + (typeof t4 == "number" ? t4 : 0);
      }, 0);
    }
    Ie.pluginName = "useGlobalFilter";
    var ke = Object.freeze({ __proto__: null, sum: Ae, min: function(e3) {
      var t3 = 0;
      return e3.forEach(function(e4) {
        typeof e4 == "number" && (t3 = Math.min(t3, e4));
      }), t3;
    }, max: function(e3) {
      var t3 = 0;
      return e3.forEach(function(e4) {
        typeof e4 == "number" && (t3 = Math.max(t3, e4));
      }), t3;
    }, minMax: function(e3) {
      var t3 = 0, n3 = 0;
      return e3.forEach(function(e4) {
        typeof e4 == "number" && (t3 = Math.min(t3, e4), n3 = Math.max(n3, e4));
      }), t3 + ".." + n3;
    }, average: function(e3) {
      return Ae(0, e3) / e3.length;
    }, median: function(e3) {
      if (!e3.length)
        return null;
      var t3 = Math.floor(e3.length / 2), n3 = [].concat(e3).sort(function(e4, t4) {
        return e4 - t4;
      });
      return e3.length % 2 != 0 ? n3[t3] : (n3[t3 - 1] + n3[t3]) / 2;
    }, unique: function(e3) {
      return Array.from(new Set(e3).values());
    }, uniqueCount: function(e3) {
      return new Set(e3).size;
    }, count: function(e3) {
      return e3.length;
    } }), He = [], Te = {};
    l2.resetGroupBy = "resetGroupBy", l2.setGroupBy = "setGroupBy", l2.toggleGroupBy = "toggleGroupBy";
    var Oe = function(e3) {
      e3.getGroupByToggleProps = [ze], e3.stateReducers.push(We), e3.visibleColumnsDeps.push(function(e4, t3) {
        var n3 = t3.instance;
        return [].concat(e4, [n3.state.groupBy]);
      }), e3.visibleColumns.push(Me), e3.useInstance.push(Ne), e3.prepareRow.push(De);
    };
    Oe.pluginName = "useGroupBy";
    var ze = function(e3, t3) {
      var n3 = t3.header;
      return [e3, { onClick: n3.canGroupBy ? function(e4) {
        e4.persist(), n3.toggleGroupBy();
      } : void 0, style: { cursor: n3.canGroupBy ? "pointer" : void 0 }, title: "Toggle GroupBy" }];
    };
    function We(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ groupBy: [] }, e3);
      if (t3.type === l2.resetGroupBy)
        return r2({}, e3, { groupBy: o2.initialState.groupBy || [] });
      if (t3.type === l2.setGroupBy)
        return r2({}, e3, { groupBy: t3.value });
      if (t3.type === l2.toggleGroupBy) {
        var i2 = t3.columnId, u3 = t3.value, s2 = u3 !== void 0 ? u3 : !e3.groupBy.includes(i2);
        return r2({}, e3, s2 ? { groupBy: [].concat(e3.groupBy, [i2]) } : { groupBy: e3.groupBy.filter(function(e4) {
          return e4 !== i2;
        }) });
      }
    }
    function Me(e3, t3) {
      var n3 = t3.instance.state.groupBy, o2 = n3.map(function(t4) {
        return e3.find(function(e4) {
          return e4.id === t4;
        });
      }).filter(Boolean), r3 = e3.filter(function(e4) {
        return !n3.includes(e4.id);
      });
      return (e3 = [].concat(o2, r3)).forEach(function(e4) {
        e4.isGrouped = n3.includes(e4.id), e4.groupedIndex = n3.indexOf(e4.id);
      }), e3;
    }
    var je = {};
    function Ne(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.flatRows, i2 = e3.rowsById, u3 = e3.allColumns, s2 = e3.flatHeaders, a2 = e3.groupByFn, c3 = a2 === void 0 ? Ve : a2, d3 = e3.manualGroupBy, p3 = e3.aggregations, g3 = p3 === void 0 ? je : p3, m3 = e3.plugins, y3 = e3.state.groupBy, R2 = e3.dispatch, b3 = e3.autoResetGroupBy, S2 = b3 === void 0 || b3, C3 = e3.disableGroupBy, P2 = e3.defaultCanGroupBy, x2 = e3.getHooks;
      v2(m3, ["useColumnOrder", "useFilters"], "useGroupBy");
      var B3 = h2(e3);
      u3.forEach(function(t3) {
        var n4 = t3.accessor, o3 = t3.defaultGroupBy, r4 = t3.disableGroupBy;
        t3.canGroupBy = n4 ? I2(t3.canGroupBy, r4 !== true && void 0, C3 !== true && void 0, true) : I2(t3.canGroupBy, o3, P2, false), t3.canGroupBy && (t3.toggleGroupBy = function() {
          return e3.toggleGroupBy(t3.id);
        }), t3.Aggregated = t3.Aggregated || t3.Cell;
      });
      var E3 = t2.useCallback(function(e4, t3) {
        R2({ type: l2.toggleGroupBy, columnId: e4, value: t3 });
      }, [R2]), F3 = t2.useCallback(function(e4) {
        R2({ type: l2.setGroupBy, value: e4 });
      }, [R2]);
      s2.forEach(function(e4) {
        e4.getGroupByToggleProps = f2(x2().getGroupByToggleProps, { instance: B3(), header: e4 });
      });
      var A3 = t2.useMemo(function() {
        if (d3 || !y3.length)
          return [o2, r3, i2, He, Te, r3, i2];
        var e4 = y3.filter(function(e5) {
          return u3.find(function(t4) {
            return t4.id === e5;
          });
        }), t3 = [], n4 = {}, l3 = [], s3 = {}, a3 = [], f3 = {}, p4 = function o3(r4, i3, d4) {
          if (i3 === void 0 && (i3 = 0), i3 === e4.length)
            return r4;
          var p5 = e4[i3], v3 = c3(r4, p5);
          return Object.entries(v3).map(function(r5, c4) {
            var v4 = r5[0], m4 = r5[1], h3 = p5 + ":" + v4, y4 = o3(m4, i3 + 1, h3 = d4 ? d4 + ">" + h3 : h3), w3 = i3 ? G2(m4, "leafRows") : m4, R3 = function(t4, n5, o4) {
              var r6 = {};
              return u3.forEach(function(i4) {
                if (e4.includes(i4.id))
                  r6[i4.id] = n5[0] ? n5[0].values[i4.id] : null;
                else {
                  var u4 = n5.map(function(e5) {
                    return e5.values[i4.id];
                  }), l4 = t4.map(function(e5) {
                    var t5 = e5.values[i4.id];
                    if (!o4 && i4.aggregateValue) {
                      var n6 = typeof i4.aggregateValue == "function" ? i4.aggregateValue : g3[i4.aggregateValue] || ke[i4.aggregateValue];
                      if (!n6)
                        throw console.info({ column: i4 }), new Error("React Table: Invalid column.aggregateValue option for column listed above");
                      t5 = n6(t5, e5, i4);
                    }
                    return t5;
                  }), s4 = typeof i4.aggregate == "function" ? i4.aggregate : g3[i4.aggregate] || ke[i4.aggregate];
                  if (s4)
                    r6[i4.id] = s4(l4, u4);
                  else {
                    if (i4.aggregate)
                      throw console.info({ column: i4 }), new Error("React Table: Invalid column.aggregate option for column listed above");
                    r6[i4.id] = null;
                  }
                }
              }), r6;
            }(w3, m4, i3), b4 = { id: h3, isGrouped: true, groupByID: p5, groupByVal: v4, values: R3, subRows: y4, leafRows: w3, depth: i3, index: c4 };
            return y4.forEach(function(e5) {
              t3.push(e5), n4[e5.id] = e5, e5.isGrouped ? (l3.push(e5), s3[e5.id] = e5) : (a3.push(e5), f3[e5.id] = e5);
            }), b4;
          });
        }(o2);
        return p4.forEach(function(e5) {
          t3.push(e5), n4[e5.id] = e5, e5.isGrouped ? (l3.push(e5), s3[e5.id] = e5) : (a3.push(e5), f3[e5.id] = e5);
        }), [p4, t3, n4, l3, s3, a3, f3];
      }, [d3, y3, o2, r3, i2, u3, g3, c3]), k3 = A3[0], H3 = A3[1], T2 = A3[2], O2 = A3[3], z3 = A3[4], W2 = A3[5], M2 = A3[6], j2 = h2(S2);
      w2(function() {
        j2() && R2({ type: l2.resetGroupBy });
      }, [R2, d3 ? null : n3]), Object.assign(e3, { preGroupedRows: o2, preGroupedFlatRow: r3, preGroupedRowsById: i2, groupedRows: k3, groupedFlatRows: H3, groupedRowsById: T2, onlyGroupedFlatRows: O2, onlyGroupedRowsById: z3, nonGroupedFlatRows: W2, nonGroupedRowsById: M2, rows: k3, flatRows: H3, rowsById: T2, toggleGroupBy: E3, setGroupBy: F3 });
    }
    function De(e3) {
      e3.allCells.forEach(function(t3) {
        var n3;
        t3.isGrouped = t3.column.isGrouped && t3.column.id === e3.groupByID, t3.isPlaceholder = !t3.isGrouped && t3.column.isGrouped, t3.isAggregated = !t3.isGrouped && !t3.isPlaceholder && ((n3 = e3.subRows) == null ? void 0 : n3.length);
      });
    }
    function Ve(e3, t3) {
      return e3.reduce(function(e4, n3, o2) {
        var r3 = "" + n3.values[t3];
        return e4[r3] = Array.isArray(e4[r3]) ? e4[r3] : [], e4[r3].push(n3), e4;
      }, {});
    }
    var _e = /([0-9]+)/gm;
    function Le(e3, t3) {
      return e3 === t3 ? 0 : e3 > t3 ? 1 : -1;
    }
    function Xe(e3, t3) {
      return e3.values[t3];
    }
    function qe(e3) {
      return typeof e3 == "number" ? isNaN(e3) || e3 === 1 / 0 || e3 === -1 / 0 ? "" : String(e3) : typeof e3 == "string" ? e3 : "";
    }
    var Ke = Object.freeze({ __proto__: null, alphanumeric: function(e3, t3, n3) {
      var o2 = Xe(e3, n3), r3 = Xe(t3, n3);
      for (o2 = qe(o2), r3 = qe(r3), o2 = o2.split(_e).filter(Boolean), r3 = r3.split(_e).filter(Boolean); o2.length && r3.length; ) {
        var i2 = o2.shift(), u3 = r3.shift(), l3 = parseInt(i2, 10), s2 = parseInt(u3, 10), a2 = [l3, s2].sort();
        if (isNaN(a2[0])) {
          if (i2 > u3)
            return 1;
          if (u3 > i2)
            return -1;
        } else {
          if (isNaN(a2[1]))
            return isNaN(l3) ? -1 : 1;
          if (l3 > s2)
            return 1;
          if (s2 > l3)
            return -1;
        }
      }
      return o2.length - r3.length;
    }, datetime: function(e3, t3, n3) {
      var o2 = Xe(e3, n3), r3 = Xe(t3, n3);
      return Le(o2 = o2.getTime(), r3 = r3.getTime());
    }, basic: function(e3, t3, n3) {
      return Le(Xe(e3, n3), Xe(t3, n3));
    } });
    l2.resetSortBy = "resetSortBy", l2.setSortBy = "setSortBy", l2.toggleSortBy = "toggleSortBy", l2.clearSortBy = "clearSortBy", c2.sortType = "alphanumeric", c2.sortDescFirst = false;
    var Ue = function(e3) {
      e3.getSortByToggleProps = [$e], e3.stateReducers.push(Je), e3.useInstance.push(Ye);
    };
    Ue.pluginName = "useSortBy";
    var $e = function(e3, t3) {
      var n3 = t3.instance, o2 = t3.column, r3 = n3.isMultiSortEvent, i2 = r3 === void 0 ? function(e4) {
        return e4.shiftKey;
      } : r3;
      return [e3, { onClick: o2.canSort ? function(e4) {
        e4.persist(), o2.toggleSortBy(void 0, !n3.disableMultiSort && i2(e4));
      } : void 0, style: { cursor: o2.canSort ? "pointer" : void 0 }, title: o2.canSort ? "Toggle SortBy" : void 0 }];
    };
    function Je(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ sortBy: [] }, e3);
      if (t3.type === l2.resetSortBy)
        return r2({}, e3, { sortBy: o2.initialState.sortBy || [] });
      if (t3.type === l2.clearSortBy)
        return r2({}, e3, { sortBy: e3.sortBy.filter(function(e4) {
          return e4.id !== t3.columnId;
        }) });
      if (t3.type === l2.setSortBy)
        return r2({}, e3, { sortBy: t3.sortBy });
      if (t3.type === l2.toggleSortBy) {
        var i2, u3 = t3.columnId, s2 = t3.desc, a2 = t3.multi, c3 = o2.allColumns, d3 = o2.disableMultiSort, f3 = o2.disableSortRemove, p3 = o2.disableMultiRemove, g3 = o2.maxMultiSortColCount, v3 = g3 === void 0 ? Number.MAX_SAFE_INTEGER : g3, m3 = e3.sortBy, h3 = c3.find(function(e4) {
          return e4.id === u3;
        }).sortDescFirst, y3 = m3.find(function(e4) {
          return e4.id === u3;
        }), w3 = m3.findIndex(function(e4) {
          return e4.id === u3;
        }), R2 = s2 != null, b3 = [];
        return (i2 = !d3 && a2 ? y3 ? "toggle" : "add" : w3 !== m3.length - 1 || m3.length !== 1 ? "replace" : y3 ? "toggle" : "replace") !== "toggle" || f3 || R2 || a2 && p3 || !(y3 && y3.desc && !h3 || !y3.desc && h3) || (i2 = "remove"), i2 === "replace" ? b3 = [{ id: u3, desc: R2 ? s2 : h3 }] : i2 === "add" ? (b3 = [].concat(m3, [{ id: u3, desc: R2 ? s2 : h3 }])).splice(0, b3.length - v3) : i2 === "toggle" ? b3 = m3.map(function(e4) {
          return e4.id === u3 ? r2({}, e4, { desc: R2 ? s2 : !y3.desc }) : e4;
        }) : i2 === "remove" && (b3 = m3.filter(function(e4) {
          return e4.id !== u3;
        })), r2({}, e3, { sortBy: b3 });
      }
    }
    function Ye(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.flatRows, i2 = e3.allColumns, u3 = e3.orderByFn, s2 = u3 === void 0 ? Qe : u3, a2 = e3.sortTypes, c3 = e3.manualSortBy, d3 = e3.defaultCanSort, p3 = e3.disableSortBy, g3 = e3.flatHeaders, m3 = e3.state.sortBy, y3 = e3.dispatch, R2 = e3.plugins, b3 = e3.getHooks, S2 = e3.autoResetSortBy, C3 = S2 === void 0 || S2;
      v2(R2, ["useFilters", "useGlobalFilter", "useGroupBy", "usePivotColumns"], "useSortBy");
      var P2 = t2.useCallback(function(e4) {
        y3({ type: l2.setSortBy, sortBy: e4 });
      }, [y3]), x2 = t2.useCallback(function(e4, t3, n4) {
        y3({ type: l2.toggleSortBy, columnId: e4, desc: t3, multi: n4 });
      }, [y3]), B3 = h2(e3);
      g3.forEach(function(e4) {
        var t3 = e4.accessor, n4 = e4.canSort, o3 = e4.disableSortBy, r4 = e4.id, i3 = t3 ? I2(o3 !== true && void 0, p3 !== true && void 0, true) : I2(d3, n4, false);
        e4.canSort = i3, e4.canSort && (e4.toggleSortBy = function(t4, n5) {
          return x2(e4.id, t4, n5);
        }, e4.clearSortBy = function() {
          y3({ type: l2.clearSortBy, columnId: e4.id });
        }), e4.getSortByToggleProps = f2(b3().getSortByToggleProps, { instance: B3(), column: e4 });
        var u4 = m3.find(function(e5) {
          return e5.id === r4;
        });
        e4.isSorted = !!u4, e4.sortedIndex = m3.findIndex(function(e5) {
          return e5.id === r4;
        }), e4.isSortedDesc = e4.isSorted ? u4.desc : void 0;
      });
      var E3 = t2.useMemo(function() {
        if (c3 || !m3.length)
          return [o2, r3];
        var e4 = [], t3 = m3.filter(function(e5) {
          return i2.find(function(t4) {
            return t4.id === e5.id;
          });
        });
        return [function n4(o3) {
          var r4 = s2(o3, t3.map(function(e5) {
            var t4 = i2.find(function(t5) {
              return t5.id === e5.id;
            });
            if (!t4)
              throw new Error("React-Table: Could not find a column with id: " + e5.id + " while sorting");
            var n5 = t4.sortType, o4 = F2(n5) || (a2 || {})[n5] || Ke[n5];
            if (!o4)
              throw new Error("React-Table: Could not find a valid sortType of '" + n5 + "' for column '" + e5.id + "'.");
            return function(t5, n6) {
              return o4(t5, n6, e5.id, e5.desc);
            };
          }), t3.map(function(e5) {
            var t4 = i2.find(function(t5) {
              return t5.id === e5.id;
            });
            return t4 && t4.sortInverted ? e5.desc : !e5.desc;
          }));
          return r4.forEach(function(t4) {
            e4.push(t4), t4.subRows && (t4.subRows.length !== 1 ? t4.subRows = n4(t4.subRows) : e4.push(t4.subRows[0]));
          }), r4;
        }(o2), e4];
      }, [c3, m3, o2, r3, i2, s2, a2]), G3 = E3[0], A3 = E3[1], k3 = h2(C3);
      w2(function() {
        k3() && y3({ type: l2.resetSortBy });
      }, [c3 ? null : n3]), Object.assign(e3, { preSortedRows: o2, preSortedFlatRows: r3, sortedRows: G3, sortedFlatRows: A3, rows: G3, flatRows: A3, setSortBy: P2, toggleSortBy: x2 });
    }
    function Qe(e3, t3, n3) {
      return [].concat(e3).sort(function(e4, o2) {
        for (var r3 = 0; r3 < t3.length; r3 += 1) {
          var i2 = t3[r3], u3 = n3[r3] === false || n3[r3] === "desc", l3 = i2(e4, o2);
          if (l3 !== 0)
            return u3 ? -l3 : l3;
        }
        return n3[0] ? e4.index - o2.index : o2.index - e4.index;
      });
    }
    l2.resetPage = "resetPage", l2.gotoPage = "gotoPage", l2.setPageSize = "setPageSize";
    var Ze = function(e3) {
      e3.stateReducers.push(et), e3.useInstance.push(tt);
    };
    function et(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ pageSize: 10, pageIndex: 0 }, e3);
      if (t3.type === l2.resetPage)
        return r2({}, e3, { pageIndex: o2.initialState.pageIndex || 0 });
      if (t3.type === l2.gotoPage) {
        var i2 = o2.pageCount, u3 = o2.page, s2 = m2(t3.pageIndex, e3.pageIndex), a2 = false;
        return s2 > e3.pageIndex ? a2 = i2 === -1 ? u3.length >= e3.pageSize : s2 <= i2 : s2 < e3.pageIndex && (a2 = s2 > -1), a2 ? r2({}, e3, { pageIndex: s2 }) : e3;
      }
      if (t3.type === l2.setPageSize) {
        var c3 = t3.pageSize, d3 = e3.pageSize * e3.pageIndex;
        return r2({}, e3, { pageIndex: Math.floor(d3 / c3), pageSize: c3 });
      }
    }
    function tt(e3) {
      var n3 = e3.rows, o2 = e3.autoResetPage, r3 = o2 === void 0 || o2, i2 = e3.manualExpandedKey, u3 = i2 === void 0 ? "expanded" : i2, s2 = e3.plugins, a2 = e3.pageCount, c3 = e3.paginateExpandedRows, d3 = c3 === void 0 || c3, f3 = e3.expandSubRows, p3 = f3 === void 0 || f3, g3 = e3.state, m3 = g3.pageSize, y3 = g3.pageIndex, R2 = g3.expanded, b3 = g3.globalFilter, S2 = g3.filters, C3 = g3.groupBy, P2 = g3.sortBy, x2 = e3.dispatch, B3 = e3.data, E3 = e3.manualPagination;
      v2(s2, ["useGlobalFilter", "useFilters", "useGroupBy", "useSortBy", "useExpanded"], "usePagination");
      var I3 = h2(r3);
      w2(function() {
        I3() && x2({ type: l2.resetPage });
      }, [x2, E3 ? null : B3, b3, S2, C3, P2]);
      var F3 = E3 ? a2 : Math.ceil(n3.length / m3), G3 = t2.useMemo(function() {
        return F3 > 0 ? [].concat(new Array(F3)).fill(null).map(function(e4, t3) {
          return t3;
        }) : [];
      }, [F3]), k3 = t2.useMemo(function() {
        var e4;
        if (E3)
          e4 = n3;
        else {
          var t3 = m3 * y3, o3 = t3 + m3;
          e4 = n3.slice(t3, o3);
        }
        return d3 ? e4 : A2(e4, { manualExpandedKey: u3, expanded: R2, expandSubRows: p3 });
      }, [p3, R2, u3, E3, y3, m3, d3, n3]), H3 = y3 > 0, T2 = F3 === -1 ? k3.length >= m3 : y3 < F3 - 1, O2 = t2.useCallback(function(e4) {
        x2({ type: l2.gotoPage, pageIndex: e4 });
      }, [x2]), z3 = t2.useCallback(function() {
        return O2(function(e4) {
          return e4 - 1;
        });
      }, [O2]), W2 = t2.useCallback(function() {
        return O2(function(e4) {
          return e4 + 1;
        });
      }, [O2]), M2 = t2.useCallback(function(e4) {
        x2({ type: l2.setPageSize, pageSize: e4 });
      }, [x2]);
      Object.assign(e3, { pageOptions: G3, pageCount: F3, page: k3, canPreviousPage: H3, canNextPage: T2, gotoPage: O2, previousPage: z3, nextPage: W2, setPageSize: M2 });
    }
    Ze.pluginName = "usePagination", l2.resetPivot = "resetPivot", l2.togglePivot = "togglePivot";
    var nt = function(e3) {
      e3.getPivotToggleProps = [rt], e3.stateReducers.push(it), e3.useInstanceAfterData.push(ut), e3.allColumns.push(lt), e3.accessValue.push(st), e3.materializedColumns.push(at), e3.materializedColumnsDeps.push(ct), e3.visibleColumns.push(dt), e3.visibleColumnsDeps.push(ft), e3.useInstance.push(pt), e3.prepareRow.push(gt);
    };
    nt.pluginName = "usePivotColumns";
    var ot = [], rt = function(e3, t3) {
      var n3 = t3.header;
      return [e3, { onClick: n3.canPivot ? function(e4) {
        e4.persist(), n3.togglePivot();
      } : void 0, style: { cursor: n3.canPivot ? "pointer" : void 0 }, title: "Toggle Pivot" }];
    };
    function it(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ pivotColumns: ot }, e3);
      if (t3.type === l2.resetPivot)
        return r2({}, e3, { pivotColumns: o2.initialState.pivotColumns || ot });
      if (t3.type === l2.togglePivot) {
        var i2 = t3.columnId, u3 = t3.value, s2 = u3 !== void 0 ? u3 : !e3.pivotColumns.includes(i2);
        return r2({}, e3, s2 ? { pivotColumns: [].concat(e3.pivotColumns, [i2]) } : { pivotColumns: e3.pivotColumns.filter(function(e4) {
          return e4 !== i2;
        }) });
      }
    }
    function ut(e3) {
      e3.allColumns.forEach(function(t3) {
        t3.isPivotSource = e3.state.pivotColumns.includes(t3.id);
      });
    }
    function lt(e3, t3) {
      var n3 = t3.instance;
      return e3.forEach(function(e4) {
        e4.isPivotSource = n3.state.pivotColumns.includes(e4.id), e4.uniqueValues = /* @__PURE__ */ new Set();
      }), e3;
    }
    function st(e3, t3) {
      var n3 = t3.column;
      return n3.uniqueValues && e3 !== void 0 && n3.uniqueValues.add(e3), e3;
    }
    function at(e3, t3) {
      var n3 = t3.instance, o2 = n3.allColumns, i2 = n3.state;
      if (!i2.pivotColumns.length || !i2.groupBy || !i2.groupBy.length)
        return e3;
      var u3 = i2.pivotColumns.map(function(e4) {
        return o2.find(function(t4) {
          return t4.id === e4;
        });
      }).filter(Boolean), l3 = o2.filter(function(e4) {
        return !e4.isPivotSource && !i2.groupBy.includes(e4.id) && !i2.pivotColumns.includes(e4.id);
      }), s2 = C2(function e4(t4, n4, o3) {
        t4 === void 0 && (t4 = 0), o3 === void 0 && (o3 = []);
        var i3 = u3[t4];
        return i3 ? Array.from(i3.uniqueValues).sort().map(function(u4) {
          var l4 = r2({}, i3, { Header: i3.PivotHeader || typeof i3.header == "string" ? i3.Header + ": " + u4 : u4, isPivotGroup: true, parent: n4, depth: t4, id: n4 ? n4.id + "." + i3.id + "." + u4 : i3.id + "." + u4, pivotValue: u4 });
          return l4.columns = e4(t4 + 1, l4, [].concat(o3, [function(e5) {
            return e5.values[i3.id] === u4;
          }])), l4;
        }) : l3.map(function(e5) {
          return r2({}, e5, { canPivot: false, isPivoted: true, parent: n4, depth: t4, id: "" + (n4 ? n4.id + "." + e5.id : e5.id), accessor: function(t5, n5, r3) {
            if (o3.every(function(e6) {
              return e6(r3);
            }))
              return r3.values[e5.id];
          } });
        });
      }());
      return [].concat(e3, s2);
    }
    function ct(e3, t3) {
      var n3 = t3.instance.state, o2 = n3.pivotColumns, r3 = n3.groupBy;
      return [].concat(e3, [o2, r3]);
    }
    function dt(e3, t3) {
      var n3 = t3.instance.state;
      return e3 = e3.filter(function(e4) {
        return !e4.isPivotSource;
      }), n3.pivotColumns.length && n3.groupBy && n3.groupBy.length && (e3 = e3.filter(function(e4) {
        return e4.isGrouped || e4.isPivoted;
      })), e3;
    }
    function ft(e3, t3) {
      var n3 = t3.instance;
      return [].concat(e3, [n3.state.pivotColumns, n3.state.groupBy]);
    }
    function pt(e3) {
      var t3 = e3.columns, n3 = e3.allColumns, o2 = e3.flatHeaders, r3 = e3.getHooks, i2 = e3.plugins, u3 = e3.dispatch, s2 = e3.autoResetPivot, a2 = s2 === void 0 || s2, c3 = e3.manaulPivot, d3 = e3.disablePivot, p3 = e3.defaultCanPivot;
      v2(i2, ["useGroupBy"], "usePivotColumns");
      var g3 = h2(e3);
      n3.forEach(function(t4) {
        var n4 = t4.accessor, o3 = t4.defaultPivot, r4 = t4.disablePivot;
        t4.canPivot = n4 ? I2(t4.canPivot, r4 !== true && void 0, d3 !== true && void 0, true) : I2(t4.canPivot, o3, p3, false), t4.canPivot && (t4.togglePivot = function() {
          return e3.togglePivot(t4.id);
        }), t4.Aggregated = t4.Aggregated || t4.Cell;
      });
      o2.forEach(function(e4) {
        e4.getPivotToggleProps = f2(r3().getPivotToggleProps, { instance: g3(), header: e4 });
      });
      var m3 = h2(a2);
      w2(function() {
        m3() && u3({ type: l2.resetPivot });
      }, [u3, c3 ? null : t3]), Object.assign(e3, { togglePivot: function(e4, t4) {
        u3({ type: l2.togglePivot, columnId: e4, value: t4 });
      } });
    }
    function gt(e3) {
      e3.allCells.forEach(function(e4) {
        e4.isPivoted = e4.column.isPivoted;
      });
    }
    l2.resetSelectedRows = "resetSelectedRows", l2.toggleAllRowsSelected = "toggleAllRowsSelected", l2.toggleRowSelected = "toggleRowSelected", l2.toggleAllPageRowsSelected = "toggleAllPageRowsSelected";
    var vt = function(e3) {
      e3.getToggleRowSelectedProps = [mt], e3.getToggleAllRowsSelectedProps = [ht], e3.getToggleAllPageRowsSelectedProps = [yt], e3.stateReducers.push(wt), e3.useInstance.push(Rt), e3.prepareRow.push(bt);
    };
    vt.pluginName = "useRowSelect";
    var mt = function(e3, t3) {
      var n3 = t3.instance, o2 = t3.row, r3 = n3.manualRowSelectedKey, i2 = r3 === void 0 ? "isSelected" : r3;
      return [e3, { onChange: function(e4) {
        o2.toggleRowSelected(e4.target.checked);
      }, style: { cursor: "pointer" }, checked: !(!o2.original || !o2.original[i2]) || o2.isSelected, title: "Toggle Row Selected", indeterminate: o2.isSomeSelected }];
    }, ht = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onChange: function(e4) {
        n3.toggleAllRowsSelected(e4.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isAllRowsSelected, title: "Toggle All Rows Selected", indeterminate: Boolean(!n3.isAllRowsSelected && Object.keys(n3.state.selectedRowIds).length) }];
    }, yt = function(e3, t3) {
      var n3 = t3.instance;
      return [e3, { onChange: function(e4) {
        n3.toggleAllPageRowsSelected(e4.target.checked);
      }, style: { cursor: "pointer" }, checked: n3.isAllPageRowsSelected, title: "Toggle All Current Page Rows Selected", indeterminate: Boolean(!n3.isAllPageRowsSelected && n3.page.some(function(e4) {
        var t4 = e4.id;
        return n3.state.selectedRowIds[t4];
      })) }];
    };
    function wt(e3, t3, n3, o2) {
      if (t3.type === l2.init)
        return r2({ selectedRowIds: {} }, e3);
      if (t3.type === l2.resetSelectedRows)
        return r2({}, e3, { selectedRowIds: o2.initialState.selectedRowIds || {} });
      if (t3.type === l2.toggleAllRowsSelected) {
        var i2 = t3.value, u3 = o2.isAllRowsSelected, s2 = o2.rowsById, a2 = o2.nonGroupedRowsById, c3 = a2 === void 0 ? s2 : a2, d3 = i2 !== void 0 ? i2 : !u3, f3 = Object.assign({}, e3.selectedRowIds);
        return d3 ? Object.keys(c3).forEach(function(e4) {
          f3[e4] = true;
        }) : Object.keys(c3).forEach(function(e4) {
          delete f3[e4];
        }), r2({}, e3, { selectedRowIds: f3 });
      }
      if (t3.type === l2.toggleRowSelected) {
        var p3 = t3.id, g3 = t3.value, v3 = o2.rowsById, m3 = o2.selectSubRows, h3 = m3 === void 0 || m3, y3 = o2.getSubRows, w3 = v3[p3].isSelected, R2 = g3 !== void 0 ? g3 : !w3;
        if (w3 === R2)
          return e3;
        var b3 = r2({}, e3.selectedRowIds);
        return function e4(t4) {
          var n4 = v3[t4];
          if (n4.isGrouped || (R2 ? b3[t4] = true : delete b3[t4]), h3 && y3(n4))
            return y3(n4).forEach(function(t5) {
              return e4(t5.id);
            });
        }(p3), r2({}, e3, { selectedRowIds: b3 });
      }
      if (t3.type === l2.toggleAllPageRowsSelected) {
        var S2 = t3.value, C3 = o2.page, P2 = o2.rowsById, x2 = o2.selectSubRows, B3 = x2 === void 0 || x2, E3 = o2.isAllPageRowsSelected, I3 = o2.getSubRows, F3 = S2 !== void 0 ? S2 : !E3, G3 = r2({}, e3.selectedRowIds);
        return C3.forEach(function(e4) {
          return function e5(t4) {
            var n4 = P2[t4];
            if (n4.isGrouped || (F3 ? G3[t4] = true : delete G3[t4]), B3 && I3(n4))
              return I3(n4).forEach(function(t5) {
                return e5(t5.id);
              });
          }(e4.id);
        }), r2({}, e3, { selectedRowIds: G3 });
      }
      return e3;
    }
    function Rt(e3) {
      var n3 = e3.data, o2 = e3.rows, r3 = e3.getHooks, i2 = e3.plugins, u3 = e3.rowsById, s2 = e3.nonGroupedRowsById, a2 = s2 === void 0 ? u3 : s2, c3 = e3.autoResetSelectedRows, d3 = c3 === void 0 || c3, p3 = e3.state.selectedRowIds, g3 = e3.selectSubRows, m3 = g3 === void 0 || g3, y3 = e3.dispatch, R2 = e3.page, b3 = e3.getSubRows;
      v2(i2, ["useFilters", "useGroupBy", "useSortBy", "useExpanded", "usePagination"], "useRowSelect");
      var S2 = t2.useMemo(function() {
        var e4 = [];
        return o2.forEach(function(t3) {
          var n4 = m3 ? function e5(t4, n5, o3) {
            if (n5[t4.id])
              return true;
            var r4 = o3(t4);
            if (r4 && r4.length) {
              var i3 = true, u4 = false;
              return r4.forEach(function(t5) {
                u4 && !i3 || (e5(t5, n5, o3) ? u4 = true : i3 = false);
              }), !!i3 || !!u4 && null;
            }
            return false;
          }(t3, p3, b3) : !!p3[t3.id];
          t3.isSelected = !!n4, t3.isSomeSelected = n4 === null, n4 && e4.push(t3);
        }), e4;
      }, [o2, m3, p3, b3]), C3 = Boolean(Object.keys(a2).length && Object.keys(p3).length), P2 = C3;
      C3 && Object.keys(a2).some(function(e4) {
        return !p3[e4];
      }) && (C3 = false), C3 || R2 && R2.length && R2.some(function(e4) {
        var t3 = e4.id;
        return !p3[t3];
      }) && (P2 = false);
      var x2 = h2(d3);
      w2(function() {
        x2() && y3({ type: l2.resetSelectedRows });
      }, [y3, n3]);
      var B3 = t2.useCallback(function(e4) {
        return y3({ type: l2.toggleAllRowsSelected, value: e4 });
      }, [y3]), E3 = t2.useCallback(function(e4) {
        return y3({ type: l2.toggleAllPageRowsSelected, value: e4 });
      }, [y3]), I3 = t2.useCallback(function(e4, t3) {
        return y3({ type: l2.toggleRowSelected, id: e4, value: t3 });
      }, [y3]), F3 = h2(e3), G3 = f2(r3().getToggleAllRowsSelectedProps, { instance: F3() }), A3 = f2(r3().getToggleAllPageRowsSelectedProps, { instance: F3() });
      Object.assign(e3, { selectedFlatRows: S2, isAllRowsSelected: C3, isAllPageRowsSelected: P2, toggleRowSelected: I3, toggleAllRowsSelected: B3, getToggleAllRowsSelectedProps: G3, getToggleAllPageRowsSelectedProps: A3, toggleAllPageRowsSelected: E3 });
    }
    function bt(e3, t3) {
      var n3 = t3.instance;
      e3.toggleRowSelected = function(t4) {
        return n3.toggleRowSelected(e3.id, t4);
      }, e3.getToggleRowSelectedProps = f2(n3.getHooks().getToggleRowSelectedProps, { instance: n3, row: e3 });
    }
    var St = function(e3) {
      return {};
    }, Ct = function(e3) {
      return {};
    };
    l2.setRowState = "setRowState", l2.setCellState = "setCellState", l2.resetRowState = "resetRowState";
    var Pt = function(e3) {
      e3.stateReducers.push(xt), e3.useInstance.push(Bt), e3.prepareRow.push(Et);
    };
    function xt(e3, t3, n3, o2) {
      var i2 = o2.initialRowStateAccessor, u3 = i2 === void 0 ? St : i2, s2 = o2.initialCellStateAccessor, a2 = s2 === void 0 ? Ct : s2, c3 = o2.rowsById;
      if (t3.type === l2.init)
        return r2({ rowState: {} }, e3);
      if (t3.type === l2.resetRowState)
        return r2({}, e3, { rowState: o2.initialState.rowState || {} });
      if (t3.type === l2.setRowState) {
        var d3, f3 = t3.rowId, p3 = t3.value, g3 = e3.rowState[f3] !== void 0 ? e3.rowState[f3] : u3(c3[f3].original);
        return r2({}, e3, { rowState: r2({}, e3.rowState, (d3 = {}, d3[f3] = m2(p3, g3), d3)) });
      }
      if (t3.type === l2.setCellState) {
        var v3, h3, y3, w3 = t3.rowId, R2 = t3.columnId, b3 = t3.value, S2 = e3.rowState[w3] !== void 0 ? e3.rowState[w3] : u3(c3[w3].original), C3 = (S2 == null ? void 0 : (v3 = S2.cellState) == null ? void 0 : v3[R2]) !== void 0 ? S2.cellState[R2] : a2(c3[w3].original);
        return r2({}, e3, { rowState: r2({}, e3.rowState, (y3 = {}, y3[w3] = r2({}, S2, { cellState: r2({}, S2.cellState || {}, (h3 = {}, h3[R2] = m2(b3, C3), h3)) }), y3)) });
      }
    }
    function Bt(e3) {
      var n3 = e3.autoResetRowState, o2 = n3 === void 0 || n3, r3 = e3.data, i2 = e3.dispatch, u3 = t2.useCallback(function(e4, t3) {
        return i2({ type: l2.setRowState, rowId: e4, value: t3 });
      }, [i2]), s2 = t2.useCallback(function(e4, t3, n4) {
        return i2({ type: l2.setCellState, rowId: e4, columnId: t3, value: n4 });
      }, [i2]), a2 = h2(o2);
      w2(function() {
        a2() && i2({ type: l2.resetRowState });
      }, [r3]), Object.assign(e3, { setRowState: u3, setCellState: s2 });
    }
    function Et(e3, t3) {
      var n3 = t3.instance, o2 = n3.initialRowStateAccessor, r3 = o2 === void 0 ? St : o2, i2 = n3.initialCellStateAccessor, u3 = i2 === void 0 ? Ct : i2, l3 = n3.state.rowState;
      e3.original && (e3.state = l3[e3.id] !== void 0 ? l3[e3.id] : r3(e3.original), e3.setState = function(t4) {
        return n3.setRowState(e3.id, t4);
      }, e3.cells.forEach(function(t4) {
        e3.state.cellState || (e3.state.cellState = {}), t4.state = e3.state.cellState[t4.column.id] !== void 0 ? e3.state.cellState[t4.column.id] : u3(e3.original), t4.setState = function(o3) {
          return n3.setCellState(e3.id, t4.column.id, o3);
        };
      }));
    }
    Pt.pluginName = "useRowState", l2.resetColumnOrder = "resetColumnOrder", l2.setColumnOrder = "setColumnOrder";
    var It = function(e3) {
      e3.stateReducers.push(Ft), e3.visibleColumnsDeps.push(function(e4, t3) {
        var n3 = t3.instance;
        return [].concat(e4, [n3.state.columnOrder]);
      }), e3.visibleColumns.push(Gt), e3.useInstance.push(At);
    };
    function Ft(e3, t3, n3, o2) {
      return t3.type === l2.init ? r2({ columnOrder: [] }, e3) : t3.type === l2.resetColumnOrder ? r2({}, e3, { columnOrder: o2.initialState.columnOrder || [] }) : t3.type === l2.setColumnOrder ? r2({}, e3, { columnOrder: m2(t3.columnOrder, e3.columnOrder) }) : void 0;
    }
    function Gt(e3, t3) {
      var n3 = t3.instance.state.columnOrder;
      if (!n3 || !n3.length)
        return e3;
      for (var o2 = [].concat(n3), r3 = [].concat(e3), i2 = [], u3 = function() {
        var e4 = o2.shift(), t4 = r3.findIndex(function(t5) {
          return t5.id === e4;
        });
        t4 > -1 && i2.push(r3.splice(t4, 1)[0]);
      }; r3.length && o2.length; )
        u3();
      return [].concat(i2, r3);
    }
    function At(e3) {
      var n3 = e3.dispatch;
      e3.setColumnOrder = t2.useCallback(function(e4) {
        return n3({ type: l2.setColumnOrder, columnOrder: e4 });
      }, [n3]);
    }
    It.pluginName = "useColumnOrder", c2.canResize = true, l2.columnStartResizing = "columnStartResizing", l2.columnResizing = "columnResizing", l2.columnDoneResizing = "columnDoneResizing", l2.resetResize = "resetResize";
    var kt = function(e3) {
      e3.getResizerProps = [Ht], e3.getHeaderProps.push({ style: { position: "relative" } }), e3.stateReducers.push(Tt), e3.useInstance.push(zt), e3.useInstanceBeforeDimensions.push(Ot);
    }, Ht = function(e3, t3) {
      var n3 = t3.instance, o2 = t3.header, r3 = n3.dispatch, i2 = function(e4, t4) {
        var n4 = false;
        if (e4.type === "touchstart") {
          if (e4.touches && e4.touches.length > 1)
            return;
          n4 = true;
        }
        var o3 = function(e5) {
          var t5 = [];
          return function e6(n5) {
            n5.columns && n5.columns.length && n5.columns.map(e6);
            t5.push(n5);
          }(e5), t5;
        }(t4).map(function(e5) {
          return [e5.id, e5.totalWidth];
        }), i3 = n4 ? Math.round(e4.touches[0].clientX) : e4.clientX, u3 = function(e5) {
          r3({ type: l2.columnResizing, clientX: e5 });
        }, s2 = function() {
          return r3({ type: l2.columnDoneResizing });
        }, a2 = { mouse: { moveEvent: "mousemove", moveHandler: function(e5) {
          return u3(e5.clientX);
        }, upEvent: "mouseup", upHandler: function(e5) {
          document.removeEventListener("mousemove", a2.mouse.moveHandler), document.removeEventListener("mouseup", a2.mouse.upHandler), s2();
        } }, touch: { moveEvent: "touchmove", moveHandler: function(e5) {
          return e5.cancelable && (e5.preventDefault(), e5.stopPropagation()), u3(e5.touches[0].clientX), false;
        }, upEvent: "touchend", upHandler: function(e5) {
          document.removeEventListener(a2.touch.moveEvent, a2.touch.moveHandler), document.removeEventListener(a2.touch.upEvent, a2.touch.moveHandler), s2();
        } } }, c3 = n4 ? a2.touch : a2.mouse, d3 = !!function() {
          if (typeof O == "boolean")
            return O;
          var e5 = false;
          try {
            var t5 = { get passive() {
              return e5 = true, false;
            } };
            window.addEventListener("test", null, t5), window.removeEventListener("test", null, t5);
          } catch (t6) {
            e5 = false;
          }
          return O = e5;
        }() && { passive: false };
        document.addEventListener(c3.moveEvent, c3.moveHandler, d3), document.addEventListener(c3.upEvent, c3.upHandler, d3), r3({ type: l2.columnStartResizing, columnId: t4.id, columnWidth: t4.totalWidth, headerIdWidths: o3, clientX: i3 });
      };
      return [e3, { onMouseDown: function(e4) {
        return e4.persist() || i2(e4, o2);
      }, onTouchStart: function(e4) {
        return e4.persist() || i2(e4, o2);
      }, style: { cursor: "ew-resize" }, draggable: false, role: "separator" }];
    };
    function Tt(e3, t3) {
      if (t3.type === l2.init)
        return r2({ columnResizing: { columnWidths: {} } }, e3);
      if (t3.type === l2.resetResize)
        return r2({}, e3, { columnResizing: { columnWidths: {} } });
      if (t3.type === l2.columnStartResizing) {
        var n3 = t3.clientX, o2 = t3.columnId, i2 = t3.columnWidth, u3 = t3.headerIdWidths;
        return r2({}, e3, { columnResizing: r2({}, e3.columnResizing, { startX: n3, headerIdWidths: u3, columnWidth: i2, isResizingColumn: o2 }) });
      }
      if (t3.type === l2.columnResizing) {
        var s2 = t3.clientX, a2 = e3.columnResizing, c3 = a2.startX, d3 = a2.columnWidth, f3 = a2.headerIdWidths, p3 = (s2 - c3) / d3, g3 = {};
        return f3.forEach(function(e4) {
          var t4 = e4[0], n4 = e4[1];
          g3[t4] = Math.max(n4 + n4 * p3, 0);
        }), r2({}, e3, { columnResizing: r2({}, e3.columnResizing, { columnWidths: r2({}, e3.columnResizing.columnWidths, {}, g3) }) });
      }
      return t3.type === l2.columnDoneResizing ? r2({}, e3, { columnResizing: r2({}, e3.columnResizing, { startX: null, isResizingColumn: null }) }) : void 0;
    }
    kt.pluginName = "useResizeColumns";
    var Ot = function(e3) {
      var t3 = e3.flatHeaders, n3 = e3.disableResizing, o2 = e3.getHooks, r3 = e3.state.columnResizing, i2 = h2(e3);
      t3.forEach(function(e4) {
        var t4 = I2(e4.disableResizing !== true && void 0, n3 !== true && void 0, true);
        e4.canResize = t4, e4.width = r3.columnWidths[e4.id] || e4.originalWidth || e4.width, e4.isResizing = r3.isResizingColumn === e4.id, t4 && (e4.getResizerProps = f2(o2().getResizerProps, { instance: i2(), header: e4 }));
      });
    };
    function zt(e3) {
      var n3 = e3.plugins, o2 = e3.dispatch, r3 = e3.autoResetResize, i2 = r3 === void 0 || r3, u3 = e3.columns;
      v2(n3, ["useAbsoluteLayout"], "useResizeColumns");
      var s2 = h2(i2);
      w2(function() {
        s2() && o2({ type: l2.resetResize });
      }, [u3]);
      var a2 = t2.useCallback(function() {
        return o2({ type: l2.resetResize });
      }, [o2]);
      Object.assign(e3, { resetResizing: a2 });
    }
    var Wt = { position: "absolute", top: 0 }, Mt = function(e3) {
      e3.getTableBodyProps.push(jt), e3.getRowProps.push(jt), e3.getHeaderGroupProps.push(jt), e3.getFooterGroupProps.push(jt), e3.getHeaderProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Wt, { left: n3.totalLeft + "px", width: n3.totalWidth + "px" }) }];
      }), e3.getCellProps.push(function(e4, t3) {
        var n3 = t3.cell;
        return [e4, { style: r2({}, Wt, { left: n3.column.totalLeft + "px", width: n3.column.totalWidth + "px" }) }];
      }), e3.getFooterProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Wt, { left: n3.totalLeft + "px", width: n3.totalWidth + "px" }) }];
      });
    };
    Mt.pluginName = "useAbsoluteLayout";
    var jt = function(e3, t3) {
      return [e3, { style: { position: "relative", width: t3.instance.totalColumnsWidth + "px" } }];
    }, Nt = { display: "inline-block", boxSizing: "border-box" }, Dt = function(e3, t3) {
      return [e3, { style: { display: "flex", width: t3.instance.totalColumnsWidth + "px" } }];
    }, Vt = function(e3) {
      e3.getRowProps.push(Dt), e3.getHeaderGroupProps.push(Dt), e3.getFooterGroupProps.push(Dt), e3.getHeaderProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Nt, { width: n3.totalWidth + "px" }) }];
      }), e3.getCellProps.push(function(e4, t3) {
        var n3 = t3.cell;
        return [e4, { style: r2({}, Nt, { width: n3.column.totalWidth + "px" }) }];
      }), e3.getFooterProps.push(function(e4, t3) {
        var n3 = t3.column;
        return [e4, { style: r2({}, Nt, { width: n3.totalWidth + "px" }) }];
      });
    };
    function _t(e3) {
      e3.getTableProps.push(Lt), e3.getRowProps.push(Xt), e3.getHeaderGroupProps.push(Xt), e3.getFooterGroupProps.push(Xt), e3.getHeaderProps.push(qt), e3.getCellProps.push(Kt), e3.getFooterProps.push(Ut);
    }
    Vt.pluginName = "useBlockLayout", _t.pluginName = "useFlexLayout";
    var Lt = function(e3, t3) {
      return [e3, { style: { minWidth: t3.instance.totalColumnsWidth + "px" } }];
    }, Xt = function(e3, t3) {
      return [e3, { style: { display: "flex", flex: "1 0 auto", minWidth: t3.instance.totalColumnsMinWidth + "px" } }];
    }, qt = function(e3, t3) {
      var n3 = t3.column;
      return [e3, { style: { boxSizing: "border-box", flex: n3.totalFlexWidth ? n3.totalFlexWidth + " 0 auto" : void 0, minWidth: n3.totalMinWidth + "px", width: n3.totalWidth + "px" } }];
    }, Kt = function(e3, t3) {
      var n3 = t3.cell;
      return [e3, { style: { boxSizing: "border-box", flex: n3.column.totalFlexWidth + " 0 auto", minWidth: n3.column.totalMinWidth + "px", width: n3.column.totalWidth + "px" } }];
    }, Ut = function(e3, t3) {
      var n3 = t3.column;
      return [e3, { style: { boxSizing: "border-box", flex: n3.totalFlexWidth ? n3.totalFlexWidth + " 0 auto" : void 0, minWidth: n3.totalMinWidth + "px", width: n3.totalWidth + "px" } }];
    };
    e2._UNSTABLE_usePivotColumns = nt, e2.actions = l2, e2.defaultColumn = c2, e2.defaultGroupByFn = Ve, e2.defaultOrderByFn = Qe, e2.defaultRenderer = s, e2.emptyRenderer = a, e2.ensurePluginOrder = v2, e2.flexRender = b2, e2.functionalUpdate = m2, e2.loopHooks = g2, e2.makePropGetter = f2, e2.makeRenderer = R, e2.reduceHooks = p2, e2.safeUseLayoutEffect = y2, e2.useAbsoluteLayout = Mt, e2.useAsyncDebounce = function(e3, n3) {
      n3 === void 0 && (n3 = 0);
      var r3 = t2.useRef({}), i2 = h2(e3), u3 = h2(n3);
      return t2.useCallback(function() {
        var e4 = o(regeneratorRuntime.mark(function e5() {
          var t3, n4, l3, s2 = arguments;
          return regeneratorRuntime.wrap(function(e6) {
            for (; ; )
              switch (e6.prev = e6.next) {
                case 0:
                  for (t3 = s2.length, n4 = new Array(t3), l3 = 0; l3 < t3; l3++)
                    n4[l3] = s2[l3];
                  return r3.current.promise || (r3.current.promise = new Promise(function(e7, t4) {
                    r3.current.resolve = e7, r3.current.reject = t4;
                  })), r3.current.timeout && clearTimeout(r3.current.timeout), r3.current.timeout = setTimeout(o(regeneratorRuntime.mark(function e7() {
                    return regeneratorRuntime.wrap(function(e8) {
                      for (; ; )
                        switch (e8.prev = e8.next) {
                          case 0:
                            return delete r3.current.timeout, e8.prev = 1, e8.t0 = r3.current, e8.next = 5, i2().apply(void 0, n4);
                          case 5:
                            e8.t1 = e8.sent, e8.t0.resolve.call(e8.t0, e8.t1), e8.next = 12;
                            break;
                          case 9:
                            e8.prev = 9, e8.t2 = e8.catch(1), r3.current.reject(e8.t2);
                          case 12:
                            return e8.prev = 12, delete r3.current.promise, e8.finish(12);
                          case 15:
                          case "end":
                            return e8.stop();
                        }
                    }, e7, null, [[1, 9, 12, 15]]);
                  })), u3()), e6.abrupt("return", r3.current.promise);
                case 5:
                case "end":
                  return e6.stop();
              }
          }, e5);
        }));
        return function() {
          return e4.apply(this, arguments);
        };
      }(), [i2, u3]);
    }, e2.useBlockLayout = Vt, e2.useColumnOrder = It, e2.useExpanded = se, e2.useFilters = xe, e2.useFlexLayout = _t, e2.useGetLatest = h2, e2.useGlobalFilter = Ie, e2.useGroupBy = Oe, e2.useMountedLayoutEffect = w2, e2.usePagination = Ze, e2.useResizeColumns = kt, e2.useRowSelect = vt, e2.useRowState = Pt, e2.useSortBy = Ue, e2.useTable = function(e3) {
      for (var n3 = arguments.length, o2 = new Array(n3 > 1 ? n3 - 1 : 0), i2 = 1; i2 < n3; i2++)
        o2[i2 - 1] = arguments[i2];
      e3 = ie(e3), o2 = [K].concat(o2);
      var u3 = t2.useRef({}), s2 = h2(u3.current);
      Object.assign(s2(), r2({}, e3, { plugins: o2, hooks: q2() })), o2.filter(Boolean).forEach(function(e4) {
        e4(s2().hooks);
      });
      var a2 = h2(s2().hooks);
      s2().getHooks = a2, delete s2().hooks, Object.assign(s2(), p2(a2().useOptions, ie(e3)));
      var c3 = s2(), d3 = c3.data, v3 = c3.columns, m3 = c3.initialState, y3 = c3.defaultColumn, w3 = c3.getSubRows, b3 = c3.getRowId, E3 = c3.stateReducer, I3 = c3.useControlledState, F3 = h2(E3), G3 = t2.useCallback(function(e4, t3) {
        if (!t3.type)
          throw console.info({ action: t3 }), new Error("Unknown Action \u{1F446}");
        return [].concat(a2().stateReducers, Array.isArray(F3()) ? F3() : [F3()]).reduce(function(n4, o3) {
          return o3(n4, t3, e4, s2()) || n4;
        }, e4);
      }, [a2, F3, s2]), A3 = t2.useReducer(G3, void 0, function() {
        return G3(m3, { type: l2.init });
      }), k3 = A3[0], H3 = A3[1], T2 = p2([].concat(a2().useControlledState, [I3]), k3, { instance: s2() });
      Object.assign(s2(), { state: T2, dispatch: H3 });
      var O2 = t2.useMemo(function() {
        return S(p2(a2().columns, v3, { instance: s2() }));
      }, [a2, s2, v3].concat(p2(a2().columnsDeps, [], { instance: s2() })));
      s2().columns = O2;
      var z3 = t2.useMemo(function() {
        return p2(a2().allColumns, C2(O2), { instance: s2() }).map(P);
      }, [O2, a2, s2].concat(p2(a2().allColumnsDeps, [], { instance: s2() })));
      s2().allColumns = z3;
      var W2 = t2.useMemo(function() {
        for (var e4 = [], t3 = [], n4 = {}, o3 = [].concat(z3); o3.length; ) {
          var r3 = o3.shift();
          le({ data: d3, rows: e4, flatRows: t3, rowsById: n4, column: r3, getRowId: b3, getSubRows: w3, accessValueHooks: a2().accessValue, getInstance: s2 });
        }
        return [e4, t3, n4];
      }, [z3, d3, b3, w3, a2, s2]), M2 = W2[0], j2 = W2[1], N2 = W2[2];
      Object.assign(s2(), { rows: M2, initialRows: [].concat(M2), flatRows: j2, rowsById: N2 }), g2(a2().useInstanceAfterData, s2());
      var D3 = t2.useMemo(function() {
        return p2(a2().visibleColumns, z3, { instance: s2() }).map(function(e4) {
          return x(e4, y3);
        });
      }, [a2, z3, s2, y3].concat(p2(a2().visibleColumnsDeps, [], { instance: s2() })));
      z3 = t2.useMemo(function() {
        var e4 = [].concat(D3);
        return z3.forEach(function(t3) {
          e4.find(function(e5) {
            return e5.id === t3.id;
          }) || e4.push(t3);
        }), e4;
      }, [z3, D3]), s2().allColumns = z3;
      var V2 = t2.useMemo(function() {
        return p2(a2().headerGroups, B2(D3, y3), s2());
      }, [a2, D3, y3, s2].concat(p2(a2().headerGroupsDeps, [], { instance: s2() })));
      s2().headerGroups = V2;
      var _2 = t2.useMemo(function() {
        return V2.length ? V2[0].headers : [];
      }, [V2]);
      s2().headers = _2, s2().flatHeaders = V2.reduce(function(e4, t3) {
        return [].concat(e4, t3.headers);
      }, []), g2(a2().useInstanceBeforeDimensions, s2());
      var L2 = D3.filter(function(e4) {
        return e4.isVisible;
      }).map(function(e4) {
        return e4.id;
      }).sort().join("_");
      D3 = t2.useMemo(function() {
        return D3.filter(function(e4) {
          return e4.isVisible;
        });
      }, [D3, L2]), s2().visibleColumns = D3;
      var X2 = ue(_2), U2 = X2[0], $2 = X2[1], J2 = X2[2];
      return s2().totalColumnsMinWidth = U2, s2().totalColumnsWidth = $2, s2().totalColumnsMaxWidth = J2, g2(a2().useInstance, s2()), [].concat(s2().flatHeaders, s2().allColumns).forEach(function(e4) {
        e4.render = R(s2(), e4), e4.getHeaderProps = f2(a2().getHeaderProps, { instance: s2(), column: e4 }), e4.getFooterProps = f2(a2().getFooterProps, { instance: s2(), column: e4 });
      }), s2().headerGroups = t2.useMemo(function() {
        return V2.filter(function(e4, t3) {
          return e4.headers = e4.headers.filter(function(e5) {
            return e5.headers ? function e6(t4) {
              return t4.filter(function(t5) {
                return t5.headers ? e6(t5.headers) : t5.isVisible;
              }).length;
            }(e5.headers) : e5.isVisible;
          }), !!e4.headers.length && (e4.getHeaderGroupProps = f2(a2().getHeaderGroupProps, { instance: s2(), headerGroup: e4, index: t3 }), e4.getFooterGroupProps = f2(a2().getFooterGroupProps, { instance: s2(), headerGroup: e4, index: t3 }), true);
        });
      }, [V2, s2, a2]), s2().footerGroups = [].concat(s2().headerGroups).reverse(), s2().prepareRow = t2.useCallback(function(e4) {
        e4.getRowProps = f2(a2().getRowProps, { instance: s2(), row: e4 }), e4.allCells = z3.map(function(t3) {
          var n4 = e4.values[t3.id], o3 = { column: t3, row: e4, value: n4 };
          return o3.getCellProps = f2(a2().getCellProps, { instance: s2(), cell: o3 }), o3.render = R(s2(), t3, { row: e4, cell: o3, value: n4 }), o3;
        }), e4.cells = D3.map(function(t3) {
          return e4.allCells.find(function(e5) {
            return e5.column.id === t3.id;
          });
        }), g2(a2().prepareRow, e4, { instance: s2() });
      }, [a2, s2, z3, D3]), s2().getTableProps = f2(a2().getTableProps, { instance: s2() }), s2().getTableBodyProps = f2(a2().getTableBodyProps, { instance: s2() }), g2(a2().useFinalInstance, s2()), s2();
    }, Object.defineProperty(e2, "__esModule", { value: true });
  });
})(reactTable_production_min, reactTable_production_min.exports);
{
  reactTable.exports = reactTable_production_min.exports;
}
const COLUMN_ID$1 = "SELECTION";
const COLUMN_WIDTH$1 = 50;
const reducer = (newState, action) => {
  if (action.type === "deselectAllRows") {
    return __spreadProps(__spreadValues({}, newState), {
      selectedRowIds: {}
    });
  }
  return newState;
};
function addEntireRowSelectionProps(props, {
  instance,
  row
}) {
  const {
    toggleRowSelected
  } = row;
  const {
    dispatch: dispatch2
  } = instance;
  return [__spreadProps(__spreadValues({}, props), {
    onClick: () => {
      dispatch2({
        type: "deselectAllRows"
      });
      toggleRowSelected();
    }
  })];
}
function adaptGetToggleRowSelectedProps(props, {
  instance
}) {
  const _a2 = props, {
    onChange: wrappedOnChange
  } = _a2, rest = __objRest(_a2, [
    "onChange"
  ]);
  return [__spreadProps(__spreadValues({}, rest), {
    onChange: (e2) => {
      dispatch({
        type: "deselectAllRows"
      });
      wrappedOnChange(e2);
    }
  })];
}
function getHeaderProps$1(props, {
  column
}) {
  if (column.id === COLUMN_ID$1) {
    return [props, {
      style: {
        maxWidth: COLUMN_WIDTH$1,
        width: COLUMN_WIDTH$1
      }
    }];
  }
  return [props];
}
function getCellProps$1(props, {
  cell
}) {
  if (cell.column.id === COLUMN_ID$1) {
    return [props, {
      style: {
        textAlign: "right",
        maxWidth: COLUMN_WIDTH$1,
        width: COLUMN_WIDTH$1
      }
    }];
  }
  return [props];
}
function prependSelectionColumn(columns) {
  return [{
    id: COLUMN_ID$1,
    Cell: ({
      row
    }) => {
      const _a2 = row.getToggleRowSelectedProps(), {
        indeterminate: _
      } = _a2, rest = __objRest(_a2, [
        "indeterminate"
      ]);
      return /* @__PURE__ */ jsx("div", {
        children: /* @__PURE__ */ jsx("input", __spreadValues({
          type: "radio"
        }, rest))
      });
    }
  }, ...columns];
}
function useRowSingleSelect(hooks) {
  reactTable.exports.useRowSelect(hooks);
  hooks.getRowProps.push(addEntireRowSelectionProps);
  hooks.getToggleRowSelectedProps.push(adaptGetToggleRowSelectedProps);
  hooks.getHeaderProps.push(getHeaderProps$1);
  hooks.getCellProps.push(getCellProps$1);
  hooks.visibleColumns.push(prependSelectionColumn);
  hooks.stateReducers.push(reducer);
}
useRowSingleSelect.pluginName = reactTable.exports.useRowSelect.pluginName;
const COLUMN_ID = "ACTION_MENU";
const COLUMN_WIDTH = 70;
function getHeaderProps(props, {
  column
}) {
  if (column.id === COLUMN_ID) {
    return [props, {
      style: {
        maxWidth: COLUMN_WIDTH,
        width: COLUMN_WIDTH
      }
    }];
  }
  return [props];
}
function getCellProps(props, {
  cell
}) {
  if (cell.column.id === COLUMN_ID) {
    return [props, {
      style: {
        textAlign: "right",
        maxWidth: COLUMN_WIDTH,
        width: COLUMN_WIDTH
      }
    }];
  }
  return [props];
}
function appendActionMenuColumn(columns, {
  instance
}) {
  const {
    actionMenuItems = []
  } = instance;
  return [...columns, {
    id: COLUMN_ID,
    maxWidth: 70,
    Cell: ({
      row
    }) => {
      const [open, setOpen] = useState(false);
      return /* @__PURE__ */ jsx(DropdownMenu, {
        open,
        onToggle: setOpen,
        popperOptions: {
          placement: "bottom-end",
          modifiers: [{
            name: "eventListeners",
            enabled: open
          }]
        },
        trigger: (toggle, ref, open2) => /* @__PURE__ */ jsx(Button$1, {
          size: "sm",
          kind: open2 ? "utility" : "ghost",
          ref,
          onClick: toggle,
          children: /* @__PURE__ */ jsx(More, {})
        }),
        children: actionMenuItems.map(({
          text,
          handler
        }, i) => /* @__PURE__ */ jsx(DropdownMenu.Item, {
          onClick: () => handler(row),
          children: text
        }, i))
      });
    }
  }];
}
function useActionMenu(hooks) {
  hooks.getCellProps.push(getCellProps);
  hooks.getHeaderProps.push(getHeaderProps);
  hooks.visibleColumns.push(appendActionMenuColumn);
}
useActionMenu.pluginName = "useActionMenu";
const TableV2 = createStyled("table", {
  target: "ejhl7w10"
})({
  name: "1f2zpi4",
  styles: "&&{width:100%;border-spacing:0;border-collapse:collapse;}"
});
TableV2.Body = Body;
TableV2.Cell = Cell$1;
TableV2.Container = Container$2;
TableV2.Foot = Foot;
TableV2.Head = Head;
TableV2.HeadCell = HeadCell;
TableV2.Row = Row;
TableV2.RowSpacer = RowSpacer;
TableV2.SortLabel = SortLabel;
TableV2.Toolbar = Toolbar;
TableV2.useTable = reactTable.exports.useTable;
TableV2.useFilters = reactTable.exports.useFilters;
TableV2.useGlobalFilter = reactTable.exports.useGlobalFilter;
TableV2.useSortBy = reactTable.exports.useSortBy;
TableV2.usePagination = reactTable.exports.usePagination;
TableV2.useRowState = reactTable.exports.useRowState;
TableV2.useRowSingleSelect = useRowSingleSelect;
TableV2.useActionMenu = useActionMenu;
TableV2.useFlexLayout = reactTable.exports.useFlexLayout;
TableV2.useBlockLayout = reactTable.exports.useBlockLayout;
TableV2.useAbsoluteLayout = reactTable.exports.useAbsoluteLayout;
var AutosizeInput$1 = {};
Object.defineProperty(AutosizeInput$1, "__esModule", {
  value: true
});
var _extends = Object.assign || function(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key2 in source) {
      if (Object.prototype.hasOwnProperty.call(source, key2)) {
        target[key2] = source[key2];
      }
    }
  }
  return target;
};
var _createClass = function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps)
      defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react$1 = React__default;
var _react2 = _interopRequireDefault$1(_react$1);
var _propTypes = propTypes$2.exports;
var _propTypes2 = _interopRequireDefault$1(_propTypes);
function _interopRequireDefault$1(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0)
      continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i))
      continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self2, call) {
  if (!self2) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self2;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
  if (superClass)
    Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var sizerStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  visibility: "hidden",
  height: 0,
  overflow: "scroll",
  whiteSpace: "pre"
};
var INPUT_PROPS_BLACKLIST = ["extraWidth", "injectStyles", "inputClassName", "inputRef", "inputStyle", "minWidth", "onAutosize", "placeholderIsMinWidth"];
var cleanInputProps = function cleanInputProps2(inputProps) {
  INPUT_PROPS_BLACKLIST.forEach(function(field) {
    return delete inputProps[field];
  });
  return inputProps;
};
var copyStyles = function copyStyles2(styles2, node) {
  node.style.fontSize = styles2.fontSize;
  node.style.fontFamily = styles2.fontFamily;
  node.style.fontWeight = styles2.fontWeight;
  node.style.fontStyle = styles2.fontStyle;
  node.style.letterSpacing = styles2.letterSpacing;
  node.style.textTransform = styles2.textTransform;
};
var isIE = typeof window !== "undefined" && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
var generateId = function generateId2() {
  return isIE ? "_" + Math.random().toString(36).substr(2, 12) : void 0;
};
var AutosizeInput = function(_Component) {
  _inherits(AutosizeInput2, _Component);
  _createClass(AutosizeInput2, null, [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var id = props.id;
      return id !== state.prevId ? { inputId: id || generateId(), prevId: id } : null;
    }
  }]);
  function AutosizeInput2(props) {
    _classCallCheck(this, AutosizeInput2);
    var _this = _possibleConstructorReturn(this, (AutosizeInput2.__proto__ || Object.getPrototypeOf(AutosizeInput2)).call(this, props));
    _this.inputRef = function(el) {
      _this.input = el;
      if (typeof _this.props.inputRef === "function") {
        _this.props.inputRef(el);
      }
    };
    _this.placeHolderSizerRef = function(el) {
      _this.placeHolderSizer = el;
    };
    _this.sizerRef = function(el) {
      _this.sizer = el;
    };
    _this.state = {
      inputWidth: props.minWidth,
      inputId: props.id || generateId(),
      prevId: props.id
    };
    return _this;
  }
  _createClass(AutosizeInput2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      this.copyInputStyles();
      this.updateInputWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.inputWidth !== this.state.inputWidth) {
        if (typeof this.props.onAutosize === "function") {
          this.props.onAutosize(this.state.inputWidth);
        }
      }
      this.updateInputWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "copyInputStyles",
    value: function copyInputStyles() {
      if (!this.mounted || !window.getComputedStyle) {
        return;
      }
      var inputStyles = this.input && window.getComputedStyle(this.input);
      if (!inputStyles) {
        return;
      }
      copyStyles(inputStyles, this.sizer);
      if (this.placeHolderSizer) {
        copyStyles(inputStyles, this.placeHolderSizer);
      }
    }
  }, {
    key: "updateInputWidth",
    value: function updateInputWidth() {
      if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === "undefined") {
        return;
      }
      var newInputWidth = void 0;
      if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
        newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
      } else {
        newInputWidth = this.sizer.scrollWidth + 2;
      }
      var extraWidth = this.props.type === "number" && this.props.extraWidth === void 0 ? 16 : parseInt(this.props.extraWidth) || 0;
      newInputWidth += extraWidth;
      if (newInputWidth < this.props.minWidth) {
        newInputWidth = this.props.minWidth;
      }
      if (newInputWidth !== this.state.inputWidth) {
        this.setState({
          inputWidth: newInputWidth
        });
      }
    }
  }, {
    key: "getInput",
    value: function getInput() {
      return this.input;
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "renderStyles",
    value: function renderStyles() {
      var injectStyles = this.props.injectStyles;
      return isIE && injectStyles ? _react2.default.createElement("style", { dangerouslySetInnerHTML: {
        __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
      } }) : null;
    }
  }, {
    key: "render",
    value: function render3() {
      var sizerValue = [this.props.defaultValue, this.props.value, ""].reduce(function(previousValue, currentValue) {
        if (previousValue !== null && previousValue !== void 0) {
          return previousValue;
        }
        return currentValue;
      });
      var wrapperStyle = _extends({}, this.props.style);
      if (!wrapperStyle.display)
        wrapperStyle.display = "inline-block";
      var inputStyle = _extends({
        boxSizing: "content-box",
        width: this.state.inputWidth + "px"
      }, this.props.inputStyle);
      var inputProps = _objectWithoutProperties(this.props, []);
      cleanInputProps(inputProps);
      inputProps.className = this.props.inputClassName;
      inputProps.id = this.state.inputId;
      inputProps.style = inputStyle;
      return _react2.default.createElement("div", { className: this.props.className, style: wrapperStyle }, this.renderStyles(), _react2.default.createElement("input", _extends({}, inputProps, { ref: this.inputRef })), _react2.default.createElement("div", { ref: this.sizerRef, style: sizerStyle }, sizerValue), this.props.placeholder ? _react2.default.createElement("div", { ref: this.placeHolderSizerRef, style: sizerStyle }, this.props.placeholder) : null);
    }
  }]);
  return AutosizeInput2;
}(_react$1.Component);
AutosizeInput.propTypes = {
  className: _propTypes2.default.string,
  defaultValue: _propTypes2.default.any,
  extraWidth: _propTypes2.default.oneOfType([
    _propTypes2.default.number,
    _propTypes2.default.string
  ]),
  id: _propTypes2.default.string,
  injectStyles: _propTypes2.default.bool,
  inputClassName: _propTypes2.default.string,
  inputRef: _propTypes2.default.func,
  inputStyle: _propTypes2.default.object,
  minWidth: _propTypes2.default.oneOfType([
    _propTypes2.default.number,
    _propTypes2.default.string
  ]),
  onAutosize: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  placeholderIsMinWidth: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  value: _propTypes2.default.any
};
AutosizeInput.defaultProps = {
  minWidth: 1,
  injectStyles: true
};
var _default = AutosizeInput$1.default = AutosizeInput;
const Truncated = createStyled("span", {
  target: "e173uesl0"
})({
  name: "o3idik",
  styles: "&&{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}"
});
const Container$1 = /* @__PURE__ */ createStyled(Input$1, {
  target: "e173uesl1"
})("&&{cursor:text;padding:0;&:focus-within{border-color:", style("input.valid.focusBorder"), ";}&.disabled{border-color:", color("paleGrey"), ";background-color:", color("offWhite"), ";cursor:not-allowed;}& > div{pointer-events:none;max-width:100%;", padding("xxs"), ";input{background:transparent;font-size:inherit;line-height:inherit;outline:0;border:0;padding:0;max-width:100%;}}&& .stylist-tag{vertical-align:top;transform:translateY(25%);margin:0 0 ", spacer(1), " ", spacer(1), ";max-width:98%;}}");
function TagInput({
  value = [],
  onChange = () => {
  },
  placeholder = "",
  disabled = false
}) {
  const [inputValue, setInputValue] = useState("");
  const inputEl = useRef(null);
  const containerEl = useRef(null);
  const handleContainerClick = (e2) => {
    var _a2;
    if (e2.target === containerEl.current) {
      (_a2 = inputEl.current) == null ? void 0 : _a2.focus();
    }
  };
  const handleInputChange = (e2) => {
    if (e2.target.value.includes(",")) {
      if (!value.includes(e2.target.value)) {
        onChange([...value, ...e2.target.value.split(",").filter(Boolean)]);
      }
      setInputValue("");
    } else {
      setInputValue(e2.target.value);
    }
  };
  const handleInputKeyDown = (e2) => {
    if (e2.key === "Enter" && inputValue.length) {
      if (!value.includes(inputValue)) {
        onChange([...value, inputValue]);
      }
      setInputValue("");
    } else if (e2.key === "Backspace" && !inputValue.length && value.length) {
      onChange(value.slice(0, value.length - 1));
    }
  };
  const handleTagDelete = (tag) => onChange(value.filter((t2) => t2 !== tag));
  const handleClickOutside = (e2) => {
    if (containerEl.current && inputValue.length) {
      if (!value.includes(inputValue)) {
        onChange([...value, inputValue]);
      }
      setInputValue("");
    }
  };
  return /* @__PURE__ */ jsxs(Container$1, {
    as: "div",
    onClick: handleContainerClick,
    ref: containerEl,
    className: disabled ? "disabled" : "",
    children: [value.map((tag) => /* @__PURE__ */ jsx(Tag, {
      id: tag,
      deletable: !disabled,
      onDelete: handleTagDelete,
      children: /* @__PURE__ */ jsx(Truncated, {
        children: tag
      })
    }, tag)), /* @__PURE__ */ jsx(_default, {
      inputRef: (ref) => inputEl.current = ref,
      value: inputValue,
      placeholder: (value == null ? void 0 : value.length) ? "" : placeholder,
      onChange: handleInputChange,
      onKeyDown: handleInputKeyDown,
      disabled,
      onBlur: handleClickOutside
    })]
  });
}
var CSSTransition = { exports: {} };
var addClass = { exports: {} };
var hasClass = { exports: {} };
(function(module2, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = hasClass2;
  function hasClass2(element, className) {
    if (element.classList)
      return !!className && element.classList.contains(className);
    else
      return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
  }
  module2.exports = exports["default"];
})(hasClass, hasClass.exports);
(function(module2, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = addClass2;
  var _hasClass = hasClass.exports;
  var _hasClass2 = _interopRequireDefault2(_hasClass);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function addClass2(element, className) {
    if (element.classList)
      element.classList.add(className);
    else if (!(0, _hasClass2.default)(element, className))
      if (typeof element.className === "string")
        element.className = element.className + " " + className;
      else
        element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
  }
  module2.exports = exports["default"];
})(addClass, addClass.exports);
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
var removeClass = function removeClass2(element, className) {
  if (element.classList)
    element.classList.remove(className);
  else if (typeof element.className === "string")
    element.className = replaceClassName(element.className, className);
  else
    element.setAttribute("class", replaceClassName(element.className && element.className.baseVal || "", className));
};
(function(module2, exports) {
  exports.__esModule = true;
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _propTypes3 = propTypes$2.exports;
  var PropTypes2 = _interopRequireWildcard2(_propTypes3);
  var _addClass = addClass.exports;
  var _addClass2 = _interopRequireDefault2(_addClass);
  var _removeClass = removeClass;
  var _removeClass2 = _interopRequireDefault2(_removeClass);
  var _react3 = React__default;
  var _react22 = _interopRequireDefault2(_react3);
  var _Transition3 = Transition$1;
  var _Transition22 = _interopRequireDefault2(_Transition3);
  var _PropTypes = PropTypes$1;
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _interopRequireWildcard2(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};
      if (obj != null) {
        for (var key2 in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key2))
            newObj[key2] = obj[key2];
        }
      }
      newObj.default = obj;
      return newObj;
    }
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var addClass$1 = function addClass2(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c2) {
      return (0, _addClass2.default)(node, c2);
    });
  };
  var removeClass$1 = function removeClass3(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c2) {
      return (0, _removeClass2.default)(node, c2);
    });
  };
  _extends2({}, _Transition22.default.propTypes, {
    classNames: _PropTypes.classNamesShape,
    onEnter: PropTypes2.func,
    onEntering: PropTypes2.func,
    onEntered: PropTypes2.func,
    onExit: PropTypes2.func,
    onExiting: PropTypes2.func,
    onExited: PropTypes2.func
  });
  var CSSTransition2 = function(_React$Component) {
    _inherits2(CSSTransition3, _React$Component);
    function CSSTransition3() {
      var _temp, _this, _ret;
      _classCallCheck2(this, CSSTransition3);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn2(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function(node, appearing) {
        var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
        _this.removeClasses(node, "exit");
        addClass$1(node, className);
        if (_this.props.onEnter) {
          _this.props.onEnter(node);
        }
      }, _this.onEntering = function(node, appearing) {
        var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
        _this.reflowAndAddClass(node, activeClassName);
        if (_this.props.onEntering) {
          _this.props.onEntering(node);
        }
      }, _this.onEntered = function(node, appearing) {
        var _this$getClassNames3 = _this.getClassNames("enter"), doneClassName = _this$getClassNames3.doneClassName;
        _this.removeClasses(node, appearing ? "appear" : "enter");
        addClass$1(node, doneClassName);
        if (_this.props.onEntered) {
          _this.props.onEntered(node);
        }
      }, _this.onExit = function(node) {
        var _this$getClassNames4 = _this.getClassNames("exit"), className = _this$getClassNames4.className;
        _this.removeClasses(node, "appear");
        _this.removeClasses(node, "enter");
        addClass$1(node, className);
        if (_this.props.onExit) {
          _this.props.onExit(node);
        }
      }, _this.onExiting = function(node) {
        var _this$getClassNames5 = _this.getClassNames("exit"), activeClassName = _this$getClassNames5.activeClassName;
        _this.reflowAndAddClass(node, activeClassName);
        if (_this.props.onExiting) {
          _this.props.onExiting(node);
        }
      }, _this.onExited = function(node) {
        var _this$getClassNames6 = _this.getClassNames("exit"), doneClassName = _this$getClassNames6.doneClassName;
        _this.removeClasses(node, "exit");
        addClass$1(node, doneClassName);
        if (_this.props.onExited) {
          _this.props.onExited(node);
        }
      }, _this.getClassNames = function(type) {
        var classNames = _this.props.classNames;
        var className = typeof classNames !== "string" ? classNames[type] : classNames + "-" + type;
        var activeClassName = typeof classNames !== "string" ? classNames[type + "Active"] : className + "-active";
        var doneClassName = typeof classNames !== "string" ? classNames[type + "Done"] : className + "-done";
        return {
          className,
          activeClassName,
          doneClassName
        };
      }, _temp), _possibleConstructorReturn2(_this, _ret);
    }
    CSSTransition3.prototype.removeClasses = function removeClasses(node, type) {
      var _getClassNames = this.getClassNames(type), className = _getClassNames.className, activeClassName = _getClassNames.activeClassName, doneClassName = _getClassNames.doneClassName;
      className && removeClass$1(node, className);
      activeClassName && removeClass$1(node, activeClassName);
      doneClassName && removeClass$1(node, doneClassName);
    };
    CSSTransition3.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
      node && node.scrollTop;
      addClass$1(node, className);
    };
    CSSTransition3.prototype.render = function render3() {
      var props = _extends2({}, this.props);
      delete props.classNames;
      return _react22.default.createElement(_Transition22.default, _extends2({}, props, {
        onEnter: this.onEnter,
        onEntered: this.onEntered,
        onEntering: this.onEntering,
        onExit: this.onExit,
        onExiting: this.onExiting,
        onExited: this.onExited
      }));
    };
    return CSSTransition3;
  }(_react22.default.Component);
  CSSTransition2.propTypes = {};
  exports.default = CSSTransition2;
  module2.exports = exports["default"];
})(CSSTransition, CSSTransition.exports);
var ReplaceTransition = { exports: {} };
var TransitionGroup = { exports: {} };
var ChildMapping = {};
ChildMapping.__esModule = true;
ChildMapping.getChildMapping = getChildMapping;
ChildMapping.mergeChildMappings = mergeChildMappings;
var _react = React__default;
function getChildMapping(children, mapFn) {
  var mapper = function mapper2(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };
  var result = /* @__PURE__ */ Object.create(null);
  if (children)
    _react.Children.map(children, function(c2) {
      return c2;
    }).forEach(function(child) {
      result[child.key] = mapper(child);
    });
  return result;
}
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};
  function getValueForKey(key2) {
    return key2 in next ? next[key2] : prev[key2];
  }
  var nextKeysPending = /* @__PURE__ */ Object.create(null);
  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }
  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }
  return childMapping;
}
(function(module2, exports) {
  exports.__esModule = true;
  var _extends2 = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key2 in source) {
        if (Object.prototype.hasOwnProperty.call(source, key2)) {
          target[key2] = source[key2];
        }
      }
    }
    return target;
  };
  var _propTypes3 = propTypes$2.exports;
  var _propTypes22 = _interopRequireDefault2(_propTypes3);
  var _react3 = React__default;
  var _react22 = _interopRequireDefault2(_react3);
  var _ChildMapping = ChildMapping;
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _objectWithoutProperties2(obj, keys) {
    var target = {};
    for (var i in obj) {
      if (keys.indexOf(i) >= 0)
        continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i))
        continue;
      target[i] = obj[i];
    }
    return target;
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  var values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k2) {
      return obj[k2];
    });
  };
  ({
    component: _propTypes22.default.any,
    children: _propTypes22.default.node,
    appear: _propTypes22.default.bool,
    enter: _propTypes22.default.bool,
    exit: _propTypes22.default.bool,
    childFactory: _propTypes22.default.func
  });
  var defaultProps3 = {
    component: "div",
    childFactory: function childFactory(child) {
      return child;
    }
  };
  var TransitionGroup2 = function(_React$Component) {
    _inherits2(TransitionGroup3, _React$Component);
    function TransitionGroup3(props, context) {
      _classCallCheck2(this, TransitionGroup3);
      var _this = _possibleConstructorReturn2(this, _React$Component.call(this, props, context));
      _this.state = {
        children: (0, _ChildMapping.getChildMapping)(props.children, function(child) {
          return (0, _react3.cloneElement)(child, {
            onExited: _this.handleExited.bind(_this, child),
            in: true,
            appear: _this.getProp(child, "appear"),
            enter: _this.getProp(child, "enter"),
            exit: _this.getProp(child, "exit")
          });
        })
      };
      return _this;
    }
    TransitionGroup3.prototype.getChildContext = function getChildContext() {
      return {
        transitionGroup: { isMounting: !this.appeared }
      };
    };
    TransitionGroup3.prototype.getProp = function getProp(child, prop2) {
      var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.props;
      return props[prop2] != null ? props[prop2] : child.props[prop2];
    };
    TransitionGroup3.prototype.componentDidMount = function componentDidMount() {
      this.appeared = true;
    };
    TransitionGroup3.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this2 = this;
      var prevChildMapping = this.state.children;
      var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
      var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);
      Object.keys(children).forEach(function(key2) {
        var child = children[key2];
        if (!(0, _react3.isValidElement)(child))
          return;
        var hasPrev = key2 in prevChildMapping;
        var hasNext = key2 in nextChildMapping;
        var prevChild = prevChildMapping[key2];
        var isLeaving = (0, _react3.isValidElement)(prevChild) && !prevChild.props.in;
        if (hasNext && (!hasPrev || isLeaving)) {
          children[key2] = (0, _react3.cloneElement)(child, {
            onExited: _this2.handleExited.bind(_this2, child),
            in: true,
            exit: _this2.getProp(child, "exit", nextProps),
            enter: _this2.getProp(child, "enter", nextProps)
          });
        } else if (!hasNext && hasPrev && !isLeaving) {
          children[key2] = (0, _react3.cloneElement)(child, { in: false });
        } else if (hasNext && hasPrev && (0, _react3.isValidElement)(prevChild)) {
          children[key2] = (0, _react3.cloneElement)(child, {
            onExited: _this2.handleExited.bind(_this2, child),
            in: prevChild.props.in,
            exit: _this2.getProp(child, "exit", nextProps),
            enter: _this2.getProp(child, "enter", nextProps)
          });
        }
      });
      this.setState({ children });
    };
    TransitionGroup3.prototype.handleExited = function handleExited(child, node) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
      if (child.key in currentChildMapping)
        return;
      if (child.props.onExited) {
        child.props.onExited(node);
      }
      this.setState(function(state) {
        var children = _extends2({}, state.children);
        delete children[child.key];
        return { children };
      });
    };
    TransitionGroup3.prototype.render = function render3() {
      var _props = this.props, Component2 = _props.component, childFactory = _props.childFactory, props = _objectWithoutProperties2(_props, ["component", "childFactory"]);
      var children = values(this.state.children).map(childFactory);
      delete props.appear;
      delete props.enter;
      delete props.exit;
      if (Component2 === null) {
        return children;
      }
      return _react22.default.createElement(Component2, props, children);
    };
    return TransitionGroup3;
  }(_react22.default.Component);
  TransitionGroup2.childContextTypes = {
    transitionGroup: _propTypes22.default.object.isRequired
  };
  TransitionGroup2.propTypes = {};
  TransitionGroup2.defaultProps = defaultProps3;
  exports.default = TransitionGroup2;
  module2.exports = exports["default"];
})(TransitionGroup, TransitionGroup.exports);
(function(module2, exports) {
  exports.__esModule = true;
  var _propTypes3 = propTypes$2.exports;
  var _propTypes22 = _interopRequireDefault2(_propTypes3);
  var _react3 = React__default;
  var _react22 = _interopRequireDefault2(_react3);
  var _reactDom3 = require$$2;
  var _TransitionGroup3 = TransitionGroup.exports;
  var _TransitionGroup22 = _interopRequireDefault2(_TransitionGroup3);
  function _interopRequireDefault2(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
  }
  function _objectWithoutProperties2(obj, keys) {
    var target = {};
    for (var i in obj) {
      if (keys.indexOf(i) >= 0)
        continue;
      if (!Object.prototype.hasOwnProperty.call(obj, i))
        continue;
      target[i] = obj[i];
    }
    return target;
  }
  function _classCallCheck2(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _possibleConstructorReturn2(self2, call) {
    if (!self2) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return call && (typeof call === "object" || typeof call === "function") ? call : self2;
  }
  function _inherits2(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
    if (superClass)
      Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }
  ({
    in: _propTypes22.default.bool.isRequired,
    children: function children(props, propName) {
      if (_react22.default.Children.count(props[propName]) !== 2)
        return new Error('"' + propName + '" must be exactly two transition components.');
      return null;
    }
  });
  var ReplaceTransition2 = function(_React$Component) {
    _inherits2(ReplaceTransition3, _React$Component);
    function ReplaceTransition3() {
      var _temp, _this, _ret;
      _classCallCheck2(this, ReplaceTransition3);
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return _ret = (_temp = (_this = _possibleConstructorReturn2(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn2(_this, _ret);
    }
    ReplaceTransition3.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
      var _child$props;
      var children = this.props.children;
      var child = _react22.default.Children.toArray(children)[idx];
      if (child.props[handler])
        (_child$props = child.props)[handler].apply(_child$props, originalArgs);
      if (this.props[handler])
        this.props[handler]((0, _reactDom3.findDOMNode)(this));
    };
    ReplaceTransition3.prototype.render = function render3() {
      var _props = this.props, children = _props.children, inProp = _props.in, props = _objectWithoutProperties2(_props, ["children", "in"]);
      var _React$Children$toArr = _react22.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
      delete props.onEnter;
      delete props.onEntering;
      delete props.onEntered;
      delete props.onExit;
      delete props.onExiting;
      delete props.onExited;
      return _react22.default.createElement(_TransitionGroup22.default, props, inProp ? _react22.default.cloneElement(first, {
        key: "first",
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered
      }) : _react22.default.cloneElement(second, {
        key: "second",
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      }));
    };
    return ReplaceTransition3;
  }(_react22.default.Component);
  var _initialiseProps = function _initialiseProps2() {
    var _this2 = this;
    this.handleEnter = function() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return _this2.handleLifecycle("onEnter", 0, args);
    };
    this.handleEntering = function() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return _this2.handleLifecycle("onEntering", 0, args);
    };
    this.handleEntered = function() {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return _this2.handleLifecycle("onEntered", 0, args);
    };
    this.handleExit = function() {
      for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return _this2.handleLifecycle("onExit", 1, args);
    };
    this.handleExiting = function() {
      for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }
      return _this2.handleLifecycle("onExiting", 1, args);
    };
    this.handleExited = function() {
      for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      return _this2.handleLifecycle("onExited", 1, args);
    };
  };
  ReplaceTransition2.propTypes = {};
  exports.default = ReplaceTransition2;
  module2.exports = exports["default"];
})(ReplaceTransition, ReplaceTransition.exports);
var _CSSTransition = CSSTransition.exports;
var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
var _ReplaceTransition = ReplaceTransition.exports;
var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);
var _TransitionGroup = TransitionGroup.exports;
var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
var _Transition = Transition$1;
var _Transition2 = _interopRequireDefault(_Transition);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}
var reactTransitionGroup = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};
const defaultStyle = (height, timeout) => ({
  height,
  transition: `height ${timeout}ms linear 0s`,
  overflow: "hidden"
});
const transitionStyles = {
  entering: {},
  entered: {
    overflow: "auto"
  },
  exiting: {
    height: 0
  },
  exited: {
    height: 0
  }
};
const Collapse = (_Hb) => {
  var _Ib = _Hb, {
    children,
    expandedHeight,
    isOpen,
    timeout = 200
  } = _Ib, props = __objRest(_Ib, [
    "children",
    "expandedHeight",
    "isOpen",
    "timeout"
  ]);
  const [containerRef, setRef3] = useState(null);
  if (!expandedHeight) {
    expandedHeight = containerRef == null ? void 0 : containerRef.scrollHeight;
  }
  return /* @__PURE__ */ jsx(reactTransitionGroup.Transition, {
    in: isOpen,
    timeout,
    children: (state) => /* @__PURE__ */ jsx("div", __spreadProps(__spreadValues({}, props), {
      ref: setRef3,
      style: __spreadValues(__spreadValues({}, defaultStyle(expandedHeight, timeout)), transitionStyles[state]),
      children
    }))
  });
};
Collapse.propTypes = {
  isOpen: PropTypes$2.bool,
  expandedHeight: PropTypes$2.number,
  timeout: PropTypes$2.number,
  children: PropTypes$2.node
};
const HeadingButton = createStyled("div", {
  target: "elk0l2f0"
})(borderRadius$1("default"), ";background-color:", color("offWhite"), ";", padding("xs"), ";font-weight:bold;cursor:pointer;&:hover{background-color:", color("paleGrey"), ";border-color:", color("paleGrey"), ";}");
const ChevronWithMargin = /* @__PURE__ */ createStyled(Chevron$1, {
  target: "elk0l2f1"
})("margin-right:", spacer(3), ";");
const TOGGLE_KEYS = ["Enter", " "];
const Summary = (_Jb) => {
  var _Kb = _Jb, {
    children,
    isOpen,
    ariaLevel = 3,
    onChange = () => {
    }
  } = _Kb, props = __objRest(_Kb, [
    "children",
    "isOpen",
    "ariaLevel",
    "onChange"
  ]);
  const handleKeyboard = (event) => TOGGLE_KEYS.includes(event.key) && onChange(!isOpen);
  return /* @__PURE__ */ jsx("div", {
    role: "heading",
    "aria-level": ariaLevel,
    children: /* @__PURE__ */ jsxs(HeadingButton, __spreadProps(__spreadValues({
      role: "button",
      "aria-expanded": isOpen,
      tabIndex: 0,
      onKeyDown: handleKeyboard,
      onClick: () => onChange(!isOpen)
    }, props), {
      children: [/* @__PURE__ */ jsx(ChevronWithMargin, {
        size: "xs",
        direction: isOpen ? "up" : "down"
      }), children]
    }))
  });
};
Summary.propTypes = {
  isOpen: PropTypes$2.bool,
  onChange: PropTypes$2.func,
  ariaLevel: PropTypes$2.number,
  children: PropTypes$2.node
};
const Content = createStyled("div", {
  target: "eay9sw70"
})(padding("sm"), ";");
const Details = (_Lb) => {
  var _Mb = _Lb, {
    children
  } = _Mb, props = __objRest(_Mb, [
    "children"
  ]);
  return /* @__PURE__ */ jsx(Collapse, __spreadProps(__spreadValues({}, props), {
    children: /* @__PURE__ */ jsx(Content, {
      children
    })
  }));
};
Details.propTypes = {
  isOpen: PropTypes$2.bool,
  expandedHeight: PropTypes$2.number,
  timeout: PropTypes$2.number,
  children: PropTypes$2.node
};
const Container = createStyled("div", {
  target: "ejo2crp0"
})(borderRadius$1("default"), ";background-color:", color("offWhite"), ";");
const Accordion = (_Nb) => {
  var _Ob = _Nb, {
    children,
    isOpen,
    expandedHeight,
    timeout
  } = _Ob, props = __objRest(_Ob, [
    "children",
    "isOpen",
    "expandedHeight",
    "timeout"
  ]);
  return /* @__PURE__ */ jsx(Container, __spreadProps(__spreadValues({}, props), {
    children: Children.map(children, (child) => isValidElement(child) ? cloneElement(child, {
      isOpen,
      expandedHeight,
      timeout
    }) : child)
  }));
};
Accordion.propTypes = {
  isOpen: PropTypes$2.bool,
  expandedHeight: PropTypes$2.number,
  timeout: PropTypes$2.number,
  children: PropTypes$2.node
};
Accordion.Summary = Summary;
Accordion.Details = Details;
const required = (prop2) => {
  throw new Error(`Missing required prop \`${prop2}\``);
};
const createStaticDataSource = ({
  items = required("items"),
  filter = required("filter")
}) => ({
  children,
  inputValue
}) => children({
  loading: false,
  items: items.filter((item) => !inputValue || filter(item, inputValue))
});
const useNotifications = () => {
  return useContext(NotificationsContext);
};
export { Accordion, Alert, AlertCircle as AlertCircleIcon, AlertCircleV2 as AlertCircleIconV2, AlertTriangle as AlertTriangleIcon, AppSelect as AppSelectIconV2, Archive as ArchiveIcon, Arrow as ArrowIcon, Autocomplete, Avatar$1 as Avatar, Badge$1 as Badge, BellFill as BellFillIcon, Bell as BellIcon, Bookmark as BookmarkIcon, Box, Button$1 as Button, ButtonLink, Calendar as CalendarIcon, Cancel$2 as CancelIcon, Caret$2 as CaretIcon, Chat as ChatIcon, CheckCircle as CheckCircleIcon, Check as CheckIcon, Checkbox$1 as Checkbox, Chevron$1 as ChevronIcon, Chevron as ChevronV2, CloseButton, Code, Col, Collapse, Container$h as Container, CookieBanner, Copy as CopyIcon, DefaultCookiePolicy, DiagonalDividerHorizontal$1 as DiagonalDividerHorizontal, DiagonalDivider as DiagonalDividerVertical, Dialog, DigitalDiariesLogo, DigitalInterviewsLogo, Disc as DiscIcon, Download as DownloadIcon, Drawer, Dropdown, DropdownMenu, Edit as EditIcon, ExternalButtonLink, ExternalLink as ExternalLinkIcon, ExternalLinkIconV2, FeatherSVG, File as FileIcon, FilePlus as FilePlusIcon, index$1 as Form, ForstaLogo, GlobalHeader, Grid, Hamburger as HamburgerIcon, Hash$1 as HashIcon, HeaderAvatar, Help as HelpIcon, HelpIconV2, Home as HomeIcon, Image$1 as ImageIcon, Info as InfoIcon, Input$1 as Input, InterVuLogo, Key, LayoutSidebar, LayoutWithStandardHeader, LayoutWithVertical, ListBox, LiveVideoLogo, Loader$2 as Loader, Lock, Lock$1 as LockIcon, Maximize as MaximizeIcon, MediaQuery, Minimize as MinimizeIcon, MobileFiendly as MobileFriendly, Modal$1 as Modal, Modal as ModalV2, More as MoreIcon, Navbar, NavbarSecondary, Notifications, NotificationsProvider, PanelManagementLogo, Play as PlayIcon, Plus as PlusIcon, Popover, QuestionMarkCircleIcon, index as RadioButton, Refresh as RefreshIcon, Rotate as RotateIcon, Row$2 as Row, Save as SaveIcon, Search as SearchIcon, SecondaryLink, Settings as SettingsIcon, Share as ShareIcon, Slash as SlashIcon, Sort as SortIcon, Star as StarIcon, SurveysLogo, SwitchInput, Table, TableV2, Tabs, Tag, TagInput, Textarea, Theme, Thumb as ThumbIcon, Tooltip, Trash as TrashIcon, Upload as UploadIcon, Uploader$1 as Uploader, User as UserIcon, UserPlus as UserPlusIcon, Users as UsersIcon, VIStreamlineLogo, VideoInsightsLegacyLogo, VideoInsightsLogo, WithBadge, borderBottomLeftRadius, borderBottomRightRadius, borderRadius$1 as borderRadius, borderTopLeftRadius, borderTopRightRadius, color, createStaticDataSource, fontSize, fontWeight, global$1 as global, gradientEnd, gradientStart, margin$1 as margin, mediaDn, mediaUp, padding, rem, responsiveContainer, shadow$1 as shadow, spacer, style, themes as theme, transparentize, typography$1 as typography, useCombobox, useMultipleSelection, useNotifications, usePopper$1 as usePopper, useSelect, withNotifier };



// WEBPACK FOOTER //
// ./node_modules/stylist/dist/stylist.es.js